function isDesktop() {
    return $(window).outerWidth() > 1100;
}

function isTablet() {
    return $(window).outerWidth() <= 1100;
}

function isPhone() {
    return $(window).outerWidth() <= 768;
}

window['cordova'] = true;

(function () {
    'use strict';

    angular.module('app', [
        'ngCookies',
        'ngSanitize',
        'ngAnimate',
        'pascalprecht.translate',
        'ui.bootstrap', 
        'ui.select',
        'angularFileUpload',
        'moment-picker',
        'com.2fdevs.videogular',
        'com.2fdevs.videogular.plugins.controls',
        'angular-loading-bar',
        'rzModule',
        'satellizer',
        'duScroll',
        '720kb.socialshare',
        'ngTouch',
        'monospaced.elastic',
        'angular-confirm',
        'ui.router',
        'checklist-model',
        'ui.tree',
        'textAngular',

        'form', 'loading', 'delete', 'togglePassword', 'tooltipError', 'dateField', 'fileUploadButton', 'audioPlayer', 'audioPopover', 'hover', 'reportButton', 'audioButton',
        'languageService', 'authService', 'userService', 'profileService',
        'auth', 'settings', 'koran', 'muslimator', 'courses', 'user'

    ])

    .component('app', {
        templateUrl: 'app/views/main.html',
        controller: function (config, LanguageService, $timeout, $uibModal, AuthService, ProfileService, ProjectService, NotificationService, HelpService, $window, $document, $scope, $rootScope, AccessService, $state) {
            'ngInject';
            var $ctrl = this;

            $ctrl.accessService = AccessService;
            $ctrl.projectService = ProjectService;
            $ctrl.config = config;
            $ctrl.languageService = LanguageService;
            $ctrl.profileService = ProfileService;
            $ctrl.notificationService = NotificationService;
            $ctrl.helpService = HelpService;
            $ctrl.projectSelectorTemplate = 'app/views/projectSelector.html';
            $ctrl.profileMenuTemplate = 'app/views/profileMenu.html';
            $ctrl.notificationTemplate = 'app/views/notification.html';
            $ctrl.sprintTemplate = 'app/views/sprint.html';

            $ctrl.changeLanguage = function() {
                $window.location.href = '/'+LanguageService.currentLanguage;
            };
            $ctrl.scrollTop = function() {
                $document.scrollTo(angular.element('body'),0,500);
            };

            $ctrl.openSidebarLeft = function() {
                $ctrl.showSidebarRight = false;
                $ctrl.showSidebarLeft = true;
                $ctrl.showBackdrop = true;
                angular.element('body').addClass('has-backdrop');
            };
            $ctrl.closeSidebarLeft = function() {
                $ctrl.showSidebarLeft = false;
                $ctrl.showBackdrop = $ctrl.showSidebarRight;
                angular.element('body').removeClass('has-backdrop');
            };
            $ctrl.openSidebarRight = function() {
                $ctrl.showSidebarLeft = false;
                $ctrl.showSidebarRight = true;
                $ctrl.showBackdrop = true;
                angular.element('body').addClass('has-backdrop');
            };
            $ctrl.closeSidebarRight = function() {
                $ctrl.showSidebarRight = false;
                $ctrl.showBackdrop = $ctrl.showSidebarLeft;
                angular.element('body').removeClass('has-backdrop');
            };
            $ctrl.addMaterialRequestModal = function() {
                $uibModal.open({
                    component: 'addMaterialRequestModal',
                    windowClass: 'fullscreen-mobile'
                });
            };

            this.$postLink = function () {

                $document.on('click','.sidebar-left a, .sidebar-right a',function() {
                    // setTimeout(function() {
                        $ctrl.closeSidebarLeft();
                        $ctrl.closeSidebarRight();
                    // },10);
                });
                
                $document.on('click touchstart', function(e) {
                    var $sbl = angular.element('.sidebar-left'),
                        $sblb = angular.element('.sidebar-left-button'),
                        $sbr = angular.element('.sidebar-right'),
                        $sbrb = angular.element('.sidebar-right-button');
                    if (
                        ($ctrl.showSidebarLeft || $ctrl.showSidebarRight)
                        && (!$sbl[0] || $sbl[0] != e.target && !$sbl[0].contains(e.target)) && (!$sblb[0] || $sblb[0] != e.target && !$sblb[0].contains(e.target)) 
                        && (!$sbr[0] || $sbr[0] != e.target && !$sbr[0].contains(e.target)) && (!$sbrb[0] || $sbrb[0] != e.target && !$sbrb[0].contains(e.target))
                    ) {
                        $ctrl.closeSidebarLeft();
                        $ctrl.closeSidebarRight();
                        $scope.$digest();
                    }
                });

                $document.scroll(function(){
                    var offset;
                    if ($rootScope.isDesktop) {
                        // offset = 90; // desktop
                        offset = 290; // desktop
                    } else if ($rootScope.isPhone) {
                        // offset = 60; // phone
                        offset = 260; // phone
                    } else {
                        // offset = 86; // tablet
                        offset = 286; // tablet
                    }

                    if ($document.scrollTop() >= offset) {
                        angular.element('.affix').addClass('fixed');
                    } else {
                        angular.element('.affix').removeClass('fixed');
                    }
                });

            };

            $rootScope.isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !$window.MSStream;
            $rootScope.isAndroid = /(android)/i.test(navigator.userAgent);
            $rootScope.isDesktop = (angular.element($window).outerWidth() > 1100);
            $rootScope.isTablet = (angular.element($window).outerWidth() <= 1100);
            $rootScope.isPhone = (angular.element($window).outerWidth() <= 768);
            $(window).resize(function() {
                var _isTablet = $rootScope.isTablet, _isPhone = $rootScope.isPhone, _isDesktop = $rootScope.isDesktop;
                $rootScope.isDesktop = (angular.element($window).outerWidth() > 1100);
                $rootScope.isTablet = (angular.element($window).outerWidth() <= 1100);
                $rootScope.isPhone = (angular.element($window).outerWidth() <= 768);
                if (_isTablet != $rootScope.isTablet || _isPhone != $rootScope.isPhone || _isDesktop != $rootScope.isDesktop) {
                    $rootScope.$digest();
                }
            });

            $rootScope.isLoggedIn = function() {
                return AuthService.isLoggedIn();
            };

            $rootScope.userId = function() {
                return ProfileService.currentUser && ProfileService.currentUser.id;
            };

            $rootScope.$state = $state;
            $rootScope.languageService = LanguageService;
        }
    })

    .animation('.animation-slide', [function() {
      return {
        enter: function(element, doneFn) {
          jQuery(element).slideDown(100, doneFn);
        },
        leave: function(element, doneFn) {
          jQuery(element).slideUp(100, doneFn);
        }
      }
    }]);

})();

(function () {
    'use strict';

    angular.module('app')

    .component('speedCheck',{
        bindings: {
            data:'<',
            descr:'<?',
            onActiveTask:'&?',
            onAnswer:'&?',
            onFinish:'&',
            onResult:'&'
        },
        templateUrl: 'app/components/_partials/training/speedCheck/speedCheck.html',
        controller: Component
    });

    function Component($timeout, $interval, moment, $document) {
        'ngInject';
        var timeout = 180;

        this.timer = moment.duration(timeout,'s');
        this.getTimer = function() {
            var _ms = this.timer.asMilliseconds();
            return moment.utc(_ms).format("mm:ss");
        };
        this.getTimerPercent = function() {
            var _s = this.timer.asSeconds();
            return Math.ceil((timeout-_s)*10000/timeout)/100;
        };
        var stop = $interval(function() {
            this.timer.subtract(1,'s');
            if (this.timer.asSeconds() == 0) {
                $interval.cancel(stop);
                this.finishTraining();
                this.seeResult();
            }
        }.bind(this), 1000);


        this.result = {correct:0,wrong:0};
        this.currentTask = 1;

        this.$onInit = function() {
            // console.log('init');
            this.tasks = createTasks(this.data);
            // console.log(this.data, this.tasks);
            if (this.onActiveTask) {
                this.onActiveTask({index: this.currentTask-1});
            }
        };

        this.$onDestroy = function() {
            // console.log('destroy');
        };
        
        this.getTask = function() {
            return this.tasks[this.currentTask-1];
        };

        this.nextTask = function() {
            if (!this.tasks[this.currentTask]) {
                this.tasks = this.tasks.concat(createTasks(this.data));
            }
            this.currentTask++;

            if (this.onActiveTask) {
                this.onActiveTask({index: this.currentTask-1});
            }
            $document.scrollTop(0);
            angular.element('.container-page-responsive').scrollTop(0);
        };

        this.seeResult = function() {
            this.onResult({correct:this.correct,wrong:this.wrong});
            $document.scrollTop(0);
            angular.element('.container-page-responsive').scrollTop(0);
        };

        this.checkAnswer = function(task, answer) {
            if (angular.isDefined(task.answer)) return false;
            task.answer = answer;
            var corA = this.data.filter(function(d){
                return task.phrase==d.phrase;
            })[0];
            if (corA && (corA.translation == task.translation && answer === true || corA.translation != task.translation && answer === false)) {
                task.correct = true;
                this.result.correct++;
            } else {
                task.correct = false;
                this.result.wrong++;
            }
            if (corA) {
                task.corA = corA.translation;
            }
            if (this.onAnswer) {
                this.onAnswer({task: task, answer: answer});
            }
            $timeout(function() {
                this.nextTask();
            }.bind(this), 1000);
        };

        this.finishTraining = function() {
            this.correct = this.tasks.filter(function(t) {return t.correct;}).length,
            this.wrong = this.tasks.filter(function(t) {return !t.correct;}).length;
            this.onFinish({correct:this.correct,wrong:this.wrong});
        };
        
        function createTasks(data) {
            var _data = _.shuffle(data), _corData = [], _wroData = [];
            _data.forEach(function(d) {
                var _d = angular.copy(d);
                if (_corData.length <= _wroData.length) {
                    _corData.push(_d);
                } else {

                    // Ищем случайный ошибочный ответ
                    do {
                        var i = _.random(0,_data.length-1);
                        var _wroTr = _data[i].translation;
                    } while (_data[i].length > 1 && _wroTr == _d.translation);

                    _d.translation = _wroTr;
                    _wroData.push(_d);
                }
            });

            var tasks = [];
            while (_corData.length > 0 || _wroData.length > 0) {
                var _tasks = [];
                if (_corData.length > 0) {
                    _tasks.push(_corData.pop());
                }
                if (_wroData.length > 0) {
                    _tasks.push(_wroData.pop());
                }
                if (_corData.length >= _wroData.length) {
                    if (_corData.length > 0) _tasks.push(_corData.pop());   
                } else {
                    if (_wroData.length > 0) _tasks.push(_wroData.pop());   
                }
                tasks = tasks.concat(_.shuffle(_tasks));
            }

            return tasks;
        }
        
    }

    

})();

(function () {
    'use strict';

    angular.module('app')

    .component('translationPhrase',{
        bindings: {
            data:'<',
            descr:'<?',
            onActiveTask:'&?',
            onAnswer:'&?',
            onFinish:'&',
            onResult:'&'
        },
        templateUrl: 'app/components/_partials/training/translationPhrase/translationPhrase.html',
        controller: Component
    });

    function Component(translateFilter, $document) {
        'ngInject';
        var answersCount = 5;

        this.result = {correct:0,wrong:0};
        this.currentTask = 1;

        this.$onInit = function() {
            // console.log('init');
            this.tasks = createTasks(this.data, answersCount);
            if (this.onActiveTask) {
                this.onActiveTask({index: this.currentTask-1});
            }
        };

        this.$onDestroy = function() {
            // console.log('destroy');
        };
        
        this.getTask = function() {
            return this.tasks[this.currentTask-1];
        };
        
        this.prevTask = function() {
            this.currentTask = Math.max(1, this.currentTask-1);
        };

        this.nextTask = function() {
            this.currentTask = Math.min(this.tasks.length, this.currentTask+1);
            if (this.onActiveTask) {
                this.onActiveTask({index: this.currentTask-1});
            }
            $document.scrollTop(0);
            angular.element('.container-page-responsive').scrollTop(0);
        };

        this.seeResult = function() {
            this.onResult({correct:this.correct,wrong:this.wrong});
            $document.scrollTop(0);
            angular.element('.container-page-responsive').scrollTop(0);
        };

        this.checkAnswer = function(task, answer) {
            if (angular.isDefined(task.answer)) return false;
            task.answer = answer;
            var corA = this.data[task.dataIndex];
            if (corA && corA.phrase == answer) {
                task.correct = true;
            } else {
                task.correct = false;
            }
            if (corA) {
                task.corA = corA.phrase;
            }
            if (this.onAnswer) {
                this.onAnswer({task: task, answer: answer});
            }
            if (this.checkFinish()) {
                this.finishTraining();
            }
        };

        this.checkFinish = function() {
            return this.tasks.filter(function(t) {return angular.isUndefined(t.answer);}).length == 0;
        };

        this.finishTraining = function() {
            this.correct = this.tasks.filter(function(t) {return t.correct;}).length,
            this.wrong = this.tasks.filter(function(t) {return !t.correct;}).length;
            this.onFinish({correct:this.correct,wrong:this.wrong});
        };
        
        function createTasks(data, answersCount) {
            var tasks = [], dontKnow = [translateFilter('i_dont_know')], allVariants;
            data.forEach(function(d, i) {
                allVariants = _.uniq(data.filter(function (dd) {
                    return dd != d && dd.phrase != d.phrase;
                }).map(function (dd) {
                    return dd.phrase;
                }));
                tasks.push({
                    translation: d.translation,
                    audio: d.audio,
                    variants: _.shuffle([d.phrase].concat(_.sample(allVariants, answersCount-1))).concat(dontKnow),
                    dataIndex: i
                });
            });
            return tasks;
        }

    }

    

})();

(function () {
    'use strict';

    angular.module('app')

    .component('trainingResult',{
        bindings: {
            correct:'<',
            wrong:'<?',
            best:'<?',
            training:'<?',
            title:'<',
            points:'<'
        },
        templateUrl: 'app/components/_partials/training/result/result.html',
        controller: Component
    });

    function Component() {
        'ngInject';
        this.isGood = function() {
            return angular.isDefined(this.wrong) && (this.correct + this.wrong) && this.correct / (this.correct + this.wrong) > 0.5;
        };
        this.isBad = function() {
            return angular.isDefined(this.wrong) && !this.isGood();
        };
        this.isDefault = function() {
            return angular.isUndefined(this.wrong);
        };
        this.isBest = function() {
            return angular.isDefined(this.best) && this.correct > this.best;
        };
    }

    

})();

(function () {
    'use strict';

    angular.module('app')

    .component('questionAnswer',{
        bindings: {
            data:'<',
            descr:'<?',
            onActiveTask:'&?',
            onAnswer:'&?',
            onFinish:'&',
            onResult:'&'
        },
        templateUrl: 'app/components/_partials/training/questionAnswer/questionAnswer.html',
        controller: Component
    });

    function Component(translateFilter, $document) {
        'ngInject';

        this.result = {correct:0,wrong:0};
        this.currentTask = 1;

        this.$onInit = function() {
            this.tasks = createTasks(this.data);
            if (this.onActiveTask) {
                this.onActiveTask({index: this.currentTask-1});
            }
        };

        this.$onDestroy = function() {
            
        };
        
        this.getTask = function() {
            return this.tasks[this.currentTask-1];
        };
        
        this.prevTask = function() {
            this.currentTask = Math.max(1, this.currentTask-1);
        };

        this.nextTask = function() {
            this.currentTask = Math.min(this.tasks.length, this.currentTask+1);
            if (this.onActiveTask) {
                this.onActiveTask({index: this.currentTask-1});
            }
            $document.scrollTop(0);
            angular.element('.container-page-responsive').scrollTop(0);
        };

        this.seeResult = function() {
            this.onResult({correct:this.correct,wrong:this.wrong});
            $document.scrollTop(0);
            angular.element('.container-page-responsive').scrollTop(0);
        };

        this.checkAnswer = function(task, answer) {
            if (angular.isDefined(task.answer)) return false;
            task.answer = answer;
            var corA = this.data[task.dataIndex];
            if (corA && corA.variants[corA.answer] == answer) {
                task.correct = true;
            } else {
                task.correct = false;
            }
            if (corA) {
                task.corA = corA.variants[corA.answer];
            }
            if (this.onAnswer) {
                this.onAnswer({task: task, answer: answer});
            }
            if (this.checkFinish()) {
                this.finishTraining();
            }
        };

        this.checkFinish = function() {
            return this.tasks.filter(function(t) {return angular.isUndefined(t.answer);}).length == 0;
        };

        this.finishTraining = function() {
            this.correct = this.tasks.filter(function(t) {return t.correct;}).length,
            this.wrong = this.tasks.filter(function(t) {return !t.correct;}).length;
            this.onFinish({correct:this.correct,wrong:this.wrong});
        };
        
        function createTasks(data) {
            var tasks = [];
            data.forEach(function(d, i) {
                tasks.push({
                    question: d.question,
                    variants: _.shuffle(d.variants),
                    image: d.image,
                    dataIndex: i
                });
            });
            return tasks;
        }

    }

    

})();

(function () {
    'use strict';

    angular.module('app')

    .component('phraseTranslation',{
        bindings: {
            data:'<',
            descr:'<?',
            onActiveTask:'&?',
            onAnswer:'&?',
            onFinish:'&',
            onResult:'&'
        },
        templateUrl: 'app/components/_partials/training/phraseTranslation/phraseTranslation.html',
        controller: Component
    });

    function Component(translateFilter, $document) {
        'ngInject';
        var answersCount = 5;

        this.result = {correct:0,wrong:0};
        this.currentTask = 1;

        this.$onInit = function() {
            // console.log('init');
            this.tasks = createTasks(this.data, answersCount);
            if (this.onActiveTask) {
                this.onActiveTask({index: this.currentTask-1});
            }
        };

        this.$onDestroy = function() {
            // console.log('destroy');
        };
        
        this.getTask = function() {
            return this.tasks[this.currentTask-1];
        };
        
        this.prevTask = function() {
            this.currentTask = Math.max(1, this.currentTask-1);
        };

        this.nextTask = function() {
            this.currentTask = Math.min(this.tasks.length, this.currentTask+1);
            if (this.onActiveTask) {
                this.onActiveTask({index: this.currentTask-1});
            }
            $document.scrollTop(0);
            angular.element('.container-page-responsive').scrollTop(0);
        };

        this.seeResult = function() {
            this.onResult({correct:this.correct,wrong:this.wrong});
            $document.scrollTop(0);
            angular.element('.container-page-responsive').scrollTop(0);
        };

        this.checkAnswer = function(task, answer) {
            if (angular.isDefined(task.answer)) return false;
            task.answer = answer;
            var corA = this.data[task.dataIndex];
            if (corA && corA.translation == answer) {
                task.correct = true;
            } else {
                task.correct = false;
            }
            if (corA) {
                task.corA = corA.translation;
            }
            if (this.onAnswer) {
                this.onAnswer({task: task, answer: answer});
            }
            if (this.checkFinish()) {
                this.finishTraining();
            }
        };

        this.checkFinish = function() {
            return this.tasks.filter(function(t) {return angular.isUndefined(t.answer);}).length == 0;
        };

        this.finishTraining = function() {
            this.correct = this.tasks.filter(function(t) {return t.correct;}).length,
            this.wrong = this.tasks.filter(function(t) {return !t.correct;}).length;
            this.onFinish({correct:this.correct,wrong:this.wrong});
        };
        
        function createTasks(data, answersCount) {
            var tasks = [], dontKnow = [translateFilter('i_dont_know')], allVariants;
            data.forEach(function(d, i) {
                allVariants = _.uniq(data.filter(function (dd) {
                    return dd != d && dd.translation != d.translation;
                }).map(function (dd) {
                    return dd.translation;
                }));
                tasks.push({
                    phrase: d.phrase,
                    audio: d.audio,
                    variants: _.shuffle([d.translation].concat(_.sample(allVariants, answersCount-1))).concat(dontKnow),
                    dataIndex: i
                });
            });
            return tasks;
        }

    }

    

})();

(function () {
    'use strict';

    angular.module('app')

    .component('phraseConstructor',{
        bindings: {
            data:'<',
            descr:'<?',
            onActiveTask:'&?',
            onAnswer:'&?',
            onFinish:'&',
            onResult:'&'
        },
        templateUrl: 'app/components/_partials/training/phraseConstructor/phraseConstructor.html',
        controller: Component
    });

    function Component($document) {
        'ngInject';
        var answersCount = 5;

        this.result = {correct:0,wrong:0};
        this.currentTask = 1;

        this.$onInit = function() {
            // console.log('init');
            this.tasks = createTasks(this.data, answersCount);
            if (this.onActiveTask) {
                this.onActiveTask({index: this.currentTask-1});
            }
        };

        this.$onDestroy = function() {
            // console.log('destroy');
        };
        
        this.getTask = function() {
            return this.tasks[this.currentTask-1];
        };
        
        this.prevTask = function() {
            this.currentTask = Math.max(1, this.currentTask-1);
        };

        this.nextTask = function() {
            this.currentTask = Math.min(this.tasks.length, this.currentTask+1);
            if (this.onActiveTask) {
                this.onActiveTask({index: this.currentTask-1});
            }
            $document.scrollTop(0);
            angular.element('.container-page-responsive').scrollTop(0);
        };

        this.seeResult = function() {
            this.onResult({correct:this.correct,wrong:this.wrong});
            $document.scrollTop(0);
            angular.element('.container-page-responsive').scrollTop(0);
        };

        this.checkAnswer = function(task, answer) {
            if (angular.isDefined(task.answer)) return false;
            task.answer = answer;
            var corA = this.data[task.dataIndex];
            if (corA && corA.phrase == answer) {
                task.correct = true;
            } else {
                task.correct = false;
            }
            if (corA) {
                task.corA = corA.phrase;
            }
            if (this.onAnswer) {
                this.onAnswer({task: task, answer: answer});
            }
            if (this.checkFinish()) {
                this.finishTraining();
            }
        };

        this.checkFinish = function() {
            return this.tasks.filter(function(t) {return angular.isUndefined(t.answer);}).length == 0;
        };

        this.finishTraining = function() {
            this.correct = this.tasks.filter(function(t) {return t.correct;}).length,
            this.wrong = this.tasks.filter(function(t) {return !t.correct;}).length;
            this.onFinish({correct:this.correct,wrong:this.wrong});
        };

        this.partsFilter = function(value, index, array) {
            return this.getTask().constructed.indexOf(value)==-1;
        };
        
        function createTasks(data, answersCount) {
            var tasks = [];
            // console.log(data);
            data.forEach(function(d, i) {
                tasks.push({
                    translation: d.translation,
                    audio: d.audio,
                    parts: _.shuffle(d.phrase && d.phrase.split(' ') || []),
                    constructed: [],
                    dataIndex: i
                });
            });
            return tasks;
        }

    }

    

})();

(function () {
    'use strict';

    angular.module('app')

    .component('phraseCards',{
        bindings: {
            data:'<',
            descr:'<?',
            onActiveTask:'&?',
            onAnswer:'&?',
            onFinish:'&',
            onResult:'&'
        },
        templateUrl: 'app/components/_partials/training/phraseCards/phraseCards.html',
        controller: Component
    });

    function Component($document) {
        'ngInject';
        var answersCount = 5;

        this.result = {correct:0,wrong:0};
        this.currentTask = 1;
        
        this.$onInit = function() {
            // console.log('init');
            this.tasks = createTasks(this.data, answersCount);
            if (this.onActiveTask) {
                this.onActiveTask({index: this.currentTask-1});
            }
        };

        this.$onDestroy = function() {
            // console.log('destroy');
        };
        
        this.getTask = function() {
            return this.tasks[this.currentTask-1];
        };
        
        this.prevTask = function() {
            this.currentTask = Math.max(1, this.currentTask-1);
        };

        this.nextTask = function() {
            this.currentTask = Math.min(this.tasks.length, this.currentTask+1);
            if (this.onActiveTask) {
                this.onActiveTask({index: this.currentTask-1});
            }
            $document.scrollTop(0);
            angular.element('.container-page-responsive').scrollTop(0);
        };

        this.seeResult = function() {
            this.onResult({correct:this.correct,wrong:this.wrong});
            $document.scrollTop(0);
            angular.element('.container-page-responsive').scrollTop(0);
        };

        this.checkAnswer = function(task, answer) {
            if (angular.isDefined(task.answer)) return false;
            task.answer = answer;
            task.correct = !!answer;
            if (this.onAnswer) {
                this.onAnswer({task: task, answer: answer});
            }
            if (this.checkFinish()) {
                this.finishTraining();
            }
        };

        this.checkFinish = function() {
            return this.tasks.filter(function(t) {return angular.isUndefined(t.answer);}).length == 0;
        };

        this.finishTraining = function() {
            this.correct = this.tasks.filter(function(t) {return t.correct;}).length,
            this.wrong = this.tasks.filter(function(t) {return !t.correct;}).length;
            this.onFinish({correct:this.correct,wrong:this.wrong});
        };
        
        function createTasks(data, answersCount) {
            var tasks = [];
            // console.log(data);
            data.forEach(function(d) {
                tasks.push({
                    translation: d.translation,
                    phrase: d.phrase,
                    audio: d.audio
                });
            });
            return tasks;
        }

    }

    

})();

(function () {
    'use strict';

    angular.module('app')

    .component('nextPhrase',{
        bindings: {
            data:'<',
            descr:'<?',
            onActiveTask:'&?',
            onAnswer:'&?',
            onFinish:'&',
            onResult:'&'
        },
        templateUrl: 'app/components/_partials/training/nextPhrase/nextPhrase.html',
        controller: Component
    });

    function Component(translateFilter, $document) {
        'ngInject';
        var answersCount = 5;

        this.result = {correct:0,wrong:0};
        this.currentTask = 1;

        this.$onInit = function() {
            // console.log('init');
            this.tasks = createTasks(this.data, answersCount);
            if (this.onActiveTask) {
                this.onActiveTask({index: this.currentTask-1});
            }
        };

        this.$onDestroy = function() {
            // console.log('destroy');
        };
        
        this.getTask = function() {
            return this.tasks[this.currentTask-1];
        };
        
        this.prevTask = function() {
            this.currentTask = Math.max(1, this.currentTask-1);
        };

        this.nextTask = function() {
            this.currentTask = Math.min(this.tasks.length, this.currentTask+1);
            if (this.onActiveTask) {
                this.onActiveTask({index: this.currentTask-1});
            }
            $document.scrollTop(0);
            angular.element('.container-page-responsive').scrollTop(0);
        };

        this.seeResult = function() {
            this.onResult({correct:this.correct,wrong:this.wrong});
            $document.scrollTop(0);
            angular.element('.container-page-responsive').scrollTop(0);
        };

        this.checkAnswer = function(task, answer) {
            if (angular.isDefined(task.answer)) return false;
            task.answer = answer;
            var corA = this.data[task.dataIndex];
            if (corA && corA.nextPhrase == answer) {
                task.correct = true;
            } else {
                task.correct = false;
            }
            if (corA) {
                task.corA = corA.nextPhrase;
            }
            if (this.onAnswer) {
                this.onAnswer({task: task, answer: answer});
            }
            if (this.checkFinish()) {
                this.finishTraining();
            }
        };

        this.checkFinish = function() {
            return this.tasks.filter(function(t) {return angular.isUndefined(t.answer);}).length == 0;
        };

        this.finishTraining = function() {
            this.correct = this.tasks.filter(function(t) {return t.correct;}).length,
            this.wrong = this.tasks.filter(function(t) {return !t.correct;}).length;
            this.onFinish({correct:this.correct,wrong:this.wrong});
        };
        
        function createTasks(data, answersCount) {
            var tasks = [], dontKnow = [translateFilter('i_dont_know')], allVariants;
            data.forEach(function(d, i) {
                allVariants = _.uniq(data.filter(function (dd) {
                    return dd != d && dd.nextPhrase != d.nextPhrase;
                }).map(function (dd) {
                    return dd.nextPhrase;
                }));
                tasks.push({
                    phrase: d.phrase,
                    audio: d.audio,
                    variants: _.shuffle([d.nextPhrase].concat(_.sample(allVariants, answersCount-1))).concat(dontKnow),
                    dataIndex: i
                });
            });
            return tasks;
        }

    }

    

})();

(function () {
    'use strict';

    angular.module('app')

    .component('missedPhrase',{
        bindings: {
            data:'<',
            descr:'<?',
            onActiveTask:'&?',
            onAnswer:'&?',
            onFinish:'&',
            onResult:'&'
        },
        templateUrl: 'app/components/_partials/training/missedPhrase/missedPhrase.html',
        controller: Component
    });

    function Component(translateFilter, $document) {
        'ngInject';
        var answersCount = 5;

        this.result = {correct:0,wrong:0};
        this.currentTask = 1;

        this.$onInit = function() {
            // console.log('init');
            this.tasks = _.shuffle(createTasks(this.data, answersCount));
            if (this.onActiveTask) {
                this.onActiveTask({index: this.currentTask-1});
            }
        };

        this.$onDestroy = function() {
            // console.log('destroy');
        };
        
        this.getTask = function() {
            return this.tasks[this.currentTask-1];
        };
        
        this.prevTask = function() {
            this.currentTask = Math.max(1, this.currentTask-1);
        };

        this.nextTask = function() {
            this.currentTask = Math.min(this.tasks.length, this.currentTask+1);
            if (this.onActiveTask) {
                this.onActiveTask({index: this.currentTask-1});
            }
            $document.scrollTop(0);
            angular.element('.container-page-responsive').scrollTop(0);
        };

        this.seeResult = function() {
            this.onResult({correct:this.correct,wrong:this.wrong});
            $document.scrollTop(0);
            angular.element('.container-page-responsive').scrollTop(0);
        };

        this.checkAnswer = function(task, answer) {
            if (angular.isDefined(task.answer)) return false;
            task.answer = answer;
            var corA = this.data[task.dataIndex];
            if (corA && corA.phrase == answer) {
                task.correct = true;
            } else {
                task.correct = false;
            }
            if (corA) {
                task.corA = corA.phrase;
            }
            if (this.onAnswer) {
                this.onAnswer({task: task, answer: answer});
            }
            if (this.checkFinish()) {
                this.finishTraining();
            }
        };

        this.checkFinish = function() {
            return this.tasks.filter(function(t) {return angular.isUndefined(t.answer);}).length == 0;
        };

        this.finishTraining = function() {
            this.correct = this.tasks.filter(function(t) {return t.correct;}).length,
            this.wrong = this.tasks.filter(function(t) {return !t.correct;}).length;
            this.onFinish({correct:this.correct,wrong:this.wrong});
        };
        
        function createTasks(data, answersCount) {
            var tasks = [], dontKnow = [translateFilter('i_dont_know')], allVariants;
            data.forEach(function(d, i) {
                allVariants = _.uniq(data.filter(function (dd) {
                    return dd != d && dd.phrase != d.phrase;
                }).map(function (dd) {
                    return dd.phrase;
                }));
                tasks.push({
                    prevPhrase: d.prevPhrase,
                    nextPhrase: d.nextPhrase,
                    variants: _.shuffle([d.phrase].concat(_.sample(allVariants, answersCount-1))).concat(dontKnow),
                    dataIndex: i
                });
            });
            return tasks;
        }

    }

    

})();

(function () {
    'use strict';

    angular.module('app')

    .component('listening',{
        bindings: {
            data:'<',
            descr:'<?',
            onActiveTask:'&?',
            onAnswer:'&?',
            onFinish:'&',
            onResult:'&'
        },
        templateUrl: 'app/components/_partials/training/listening/listening.html',
        controller: Component
    });

    function Component(translateFilter, $document) {
        'ngInject';
        var answersCount = 5;

        this.result = {correct:0,wrong:0};
        this.currentTask = 1;

        this.$onInit = function() {
            // console.log('init');
            this.tasks = createTasks(this.data, answersCount);
            if (this.onActiveTask) {
                this.onActiveTask({index: this.currentTask-1});
            }
        };

        this.$onDestroy = function() {
            // console.log('destroy');
        };
        
        this.getTask = function() {
            return this.tasks[this.currentTask-1];
        };
        
        this.prevTask = function() {
            this.currentTask = Math.max(1, this.currentTask-1);
        };

        this.nextTask = function() {
            this.currentTask = Math.min(this.tasks.length, this.currentTask+1);
            if (this.onActiveTask) {
                this.onActiveTask({index: this.currentTask-1});
            }
            $document.scrollTop(0);
            angular.element('.container-page-responsive').scrollTop(0);
        };

        this.seeResult = function() {
            this.onResult({correct:this.correct,wrong:this.wrong});
            $document.scrollTop(0);
            angular.element('.container-page-responsive').scrollTop(0);
        };

        this.checkAnswer = function(task, answer) {
            if (angular.isDefined(task.answer)) return false;
            task.answer = answer;
            var corA = this.data[task.dataIndex];
            if (corA && corA.translation == answer) {
                task.correct = true;
            } else {
                task.correct = false;
            }
            if (corA) {
                task.corA = corA.translation;
            }
            if (this.onAnswer) {
                this.onAnswer({task: task, answer: answer});
            }
            if (this.checkFinish()) {
                this.finishTraining();
            }
        };

        this.checkFinish = function() {
            return this.tasks.filter(function(t) {return angular.isUndefined(t.answer);}).length == 0;
        };

        this.finishTraining = function() {
            this.correct = this.tasks.filter(function(t) {return t.correct;}).length,
            this.wrong = this.tasks.filter(function(t) {return !t.correct;}).length;
            this.onFinish({correct:this.correct,wrong:this.wrong});
        };
        
        function createTasks(data, answersCount) {
            var tasks = [], dontKnow = [translateFilter('i_dont_know')], allVariants;
            data.forEach(function(d, i) {
                allVariants = _.uniq(data.filter(function (dd) {
                    return dd != d && dd.translation != d.translation;
                }).map(function (dd) {
                    return dd.translation;
                }));
                tasks.push({
                    phrase: d.phrase,
                    audio: d.audio,
                    variants: _.shuffle([d.translation].concat(_.sample(allVariants, answersCount-1))).concat(dontKnow),
                    dataIndex: i
                });
            });
            return tasks;
        }

    }

    

})();

(function () {
    'use strict';

    angular.module('app')

    .component('trainingConfirmModal',{
        bindings: {
            resolve:'<',
            close:'&',
            dismiss:'&'
        },
        templateUrl: 'app/components/_partials/training/confirmModal/confirmModal.html',
        controller: Component
    });

    function Component() {
        'ngInject';
        
    }

})();

(function () {
    'use strict';

    angular.module('koran',[]);

})();

(function () {
    'use strict';

    angular.module('koran')

    .component('koranTrainingTranslationAyat',{
        bindings: {
            'sura': '<',
            'ayats': '<',
            'openTraining': '&'
        },
        templateUrl: 'app/components/koran/training/translationAyat.html',
        controller: Component
    });

    function Component($uibModal, ActivityService, Flash, translateFilter, $stateParams) {
        'ngInject';
        
        var $ctrl = this;

        $ctrl.$onInit = function () {
            var id = $stateParams.id, start = $stateParams.start, end = $stateParams.end;

            $ctrl.start = start;
            $ctrl.end = end;

            $ctrl.data = $ctrl.ayats.map(function(ayat) {
                return {
                    phrase: ayat.arab_text,
                    translation: ayat.text,
                    audio: ayat.audio_text_url
                };
            });

            ActivityService.addLogStartTrainingSura(id, 'translation_ayat');

        };

        this.uiCanExit = function() {
            if (!this.result) {
                var modalInstance = $uibModal.open({
                    component: 'trainingConfirmModal'
                });
                return modalInstance.result;
            }
            return true;
        };

        this.onFinish = function(correct, wrong) {
            this.result = {
                correct: correct,
                wrong: wrong,
                points: calculatePoints(correct, wrong)
            };
            ActivityService.addLogFinishTrainingSura($ctrl.sura.id, 'translation_ayat', this.result.points).then(function (res) {
                if (res.points > 0) {
                    Flash.create('success', '+'+translateFilter('points_number',{number: res.points}, 'messageformat'), 3000);
                }
            });
        };

        this.onResult = function(correct, wrong) {
            this.showResult = true;
        };

        this.resultTitle = function() {
            return [translateFilter('sura_name',this.sura), translateFilter('ayats_interval',this)].join(', ');
        };

        function calculatePoints(correct, wrong) {
            return correct;
        }

    }

})();

(function () {
    'use strict';

    angular.module('koran')

    .component('koranTrainingSpeed',{
        bindings: {
            'sura': '<',
            'ayats': '<',
            'openTraining': '&'
        },
        templateUrl: 'app/components/koran/training/speed.html',
        controller: Component
    });

    function Component($uibModal, ActivityService, Flash, translateFilter, $stateParams) {
        'ngInject';
        
        var $ctrl = this;
        this.best = 0;

        $ctrl.$onInit = function () {
            var id = $stateParams.id, start = $stateParams.start, end = $stateParams.end;

            $ctrl.start = start;
            $ctrl.end = end;

            $ctrl.data = $ctrl.ayats.map(function(ayat) {
                return {
                    phrase: ayat.arab_text,
                    translation: ayat.text,
                    audio: ayat.audio_text_url
                };
            });

            ActivityService.getLog({
                resource: 'sura',
                resource_id: id,
                action: 'finish_training_ayat_speed',
                'per-page': 1,
                sort_points: 1
            }).then(function(res) {
                if (res.data.length) {
                    this.best = res.data[0].points;
                }
            }.bind(this));

            ActivityService.addLogStartTrainingSura(id, 'ayat_speed');
        };

        this.uiCanExit = function() {
            if (!this.result) {
                var modalInstance = $uibModal.open({
                    component: 'trainingConfirmModal'
                });
                return modalInstance.result;
            }
            return true;
        };

        this.onFinish = function(correct, wrong) {
            this.result = {
                correct: correct,
                wrong: wrong,
                points: calculatePoints(correct, wrong)
            };
            ActivityService.addLogFinishTrainingSura($ctrl.sura.id, 'ayat_speed', this.result.points).then(function (res) {
                if (res.points > 0) {
                    Flash.create('success', '+'+translateFilter('points_number',{number: res.points}, 'messageformat'), 3000);
                }
            });
        };

        this.onResult = function(correct, wrong) {
            this.showResult = true;
        };

        this.resultTitle = function() {
            return [translateFilter('sura_name',this.sura), translateFilter('ayats_interval',this)].join(', ');
        };

        function calculatePoints(correct, wrong) {
            return correct;
        }

    }

})();

(function () {
    'use strict';

    angular.module('koran')

    .component('koranTrainingNextAyat',{
        bindings: {
            'sura': '<',
            'ayats': '<',
            'openTraining': '&'
        },
        templateUrl: 'app/components/koran/training/nextAyat.html',
        controller: Component
    });

    function Component($uibModal, ActivityService, Flash, translateFilter, $stateParams) {
        'ngInject';
        
        var $ctrl = this;

        $ctrl.$onInit = function () {
            var id = $stateParams.id, start = $stateParams.start, end = $stateParams.end;

            $ctrl.start = start;
            $ctrl.end = end;

            $ctrl.data = [];
            for (var i=0;i < $ctrl.ayats.length;i++) {
                if (!$ctrl.ayats[i+1]) continue;
                $ctrl.data.push({
                    phrase: $ctrl.ayats[i].arab_text,
                    nextPhrase: $ctrl.ayats[i+1].arab_text,
                    audio: $ctrl.ayats[i].audio_text_url
                });
            }

            ActivityService.addLogStartTrainingSura(id, 'next_ayat');

        };

        this.uiCanExit = function() {
            if (!this.result) {
                var modalInstance = $uibModal.open({
                    component: 'trainingConfirmModal'
                });
                return modalInstance.result;
            }
            return true;
        };

        this.onFinish = function(correct, wrong) {
            this.result = {
                correct: correct,
                wrong: wrong,
                points: calculatePoints(correct, wrong)
            };
            ActivityService.addLogFinishTrainingSura($ctrl.sura.id, 'next_ayat', this.result.points).then(function (res) {
                if (res.points > 0) {
                    Flash.create('success', '+'+translateFilter('points_number',{number: res.points}, 'messageformat'), 3000);
                }
            });
        };

        this.onResult = function(correct, wrong) {
            this.showResult = true;
        };

        this.resultTitle = function() {
            return [translateFilter('sura_name',this.sura), translateFilter('ayats_interval',this)].join(', ');
        };

        function calculatePoints(correct, wrong) {
            return correct;
        }

    }

})();

(function () {
    'use strict';

    angular.module('koran')

    .component('koranTrainingMissedAyat',{
        bindings: {
            'sura': '<',
            'ayats': '<',
            'openTraining': '&'
        },
        templateUrl: 'app/components/koran/training/missedAyat.html',
        controller: Component
    });

    function Component($uibModal, ActivityService, Flash, translateFilter, $stateParams) {
        'ngInject';
        
        var $ctrl = this;

        $ctrl.$onInit = function () {
             var id = $stateParams.id, start = $stateParams.start, end = $stateParams.end;

            $ctrl.start = start;
            $ctrl.end = end;

            $ctrl.data = [];
            for (var i=0;i < $ctrl.ayats.length;i++) {
                $ctrl.data.push({
                    prevPhrase: $ctrl.ayats[i-1] && $ctrl.ayats[i-1].arab_text || '',
                    phrase: $ctrl.ayats[i].arab_text,
                    nextPhrase: $ctrl.ayats[i+1] && $ctrl.ayats[i+1].arab_text || ''
                });
            }

            ActivityService.addLogStartTrainingSura(id, 'missed_ayat');

        };

        this.uiCanExit = function() {
            if (!this.result) {
                var modalInstance = $uibModal.open({
                    component: 'trainingConfirmModal'
                });
                return modalInstance.result;
            }
            return true;
        };

        this.onFinish = function(correct, wrong) {
            this.result = {
                correct: correct,
                wrong: wrong,
                points: calculatePoints(correct, wrong)
            };
            ActivityService.addLogFinishTrainingSura($ctrl.sura.id, 'missed_ayat', this.result.points).then(function (res) {
                if (res.points > 0) {
                    Flash.create('success', '+'+translateFilter('points_number',{number: res.points}, 'messageformat'), 3000);
                }
            });
        };

        this.onResult = function(correct, wrong) {
            this.showResult = true;
        };

        this.resultTitle = function() {
            return [translateFilter('sura_name',this.sura), translateFilter('ayats_interval',this)].join(', ');
        };

        function calculatePoints(correct, wrong) {
            return correct;
        }

    }

})();

(function () {
    'use strict';

    angular.module('koran')

    .component('koranTrainingListening',{
        bindings: {
            'sura': '<',
            'ayats': '<',
            'openTraining': '&'
        },
        templateUrl: 'app/components/koran/training/listening.html',
        controller: Component
    });

    function Component($uibModal, ActivityService, Flash, translateFilter, $stateParams) {
        'ngInject';
        
        var $ctrl = this;

        $ctrl.$onInit = function () {
            var id = $stateParams.id, start = $stateParams.start, end = $stateParams.end;

            $ctrl.start = start;
            $ctrl.end = end;

            $ctrl.data = $ctrl.ayats.map(function(ayat) {
                return {
                    phrase: ayat.arab_text,
                    translation: ayat.text,
                    audio: ayat.audio_text_url
                };
            });

            ActivityService.addLogStartTrainingSura(id, 'ayat_listening');
        };

        this.uiCanExit = function() {
            if (!this.result) {
                var modalInstance = $uibModal.open({
                    component: 'trainingConfirmModal'
                });
                return modalInstance.result;
            }
            return true;
        };

        this.onFinish = function(correct, wrong) {
            this.result = {
                correct: correct,
                wrong: wrong,
                points: calculatePoints(correct, wrong)
            };
            ActivityService.addLogFinishTrainingSura($ctrl.sura.id, 'ayat_listening', this.result.points).then(function (res) {
                if (res.points > 0) {
                    Flash.create('success', '+'+translateFilter('points_number',{number: res.points}, 'messageformat'), 3000);
                }
            });
        };

        this.onResult = function(correct, wrong) {
            this.showResult = true;
        };

        this.resultTitle = function() {
            return [translateFilter('sura_name',this.sura), translateFilter('ayats_interval',this)].join(', ');
        };

        function calculatePoints(correct, wrong) {
            return correct;
        }

    }

})();

(function () {
    'use strict';

    angular.module('koran')

    .component('koranTrainingIndex',{
        bindings: {
            sura: '<',
            openTraining: '&'
        },
        templateUrl: 'app/components/koran/training/index.html',
        controller: Component
    });

    function Component() {
        
    }

})();

(function () {
    'use strict';

    angular.module('koran')

    .component('koranTrainingConstructor',{
        bindings: {
            'sura': '<',
            'ayats': '<',
            'openTraining': '&'
        },
        templateUrl: 'app/components/koran/training/constructor.html',
        controller: Component
    });

    function Component($uibModal, ActivityService, Flash, translateFilter, $stateParams) {
        'ngInject';
        
        var $ctrl = this;

        $ctrl.$onInit = function () {
            var id = $stateParams.id, start = $stateParams.start, end = $stateParams.end;

            $ctrl.start = start;
            $ctrl.end = end;

            $ctrl.data = $ctrl.ayats.map(function(ayat) {
                return {
                    phrase: ayat.arab_text,
                    translation: ayat.text,
                    audio: ayat.audio_text_url
                };
            });

            ActivityService.addLogStartTrainingSura(id, 'ayat_constructor');
        };

        this.uiCanExit = function() {
            if (!this.result) {
                var modalInstance = $uibModal.open({
                    component: 'trainingConfirmModal'
                });
                return modalInstance.result;
            }
            return true;
        };

        this.onFinish = function(correct, wrong) {
            this.result = {
                correct: correct,
                wrong: wrong,
                points: calculatePoints(correct, wrong)
            };
            ActivityService.addLogFinishTrainingSura($ctrl.sura.id, 'ayat_constructor', this.result.points).then(function (res) {
                if (res.points > 0) {
                    Flash.create('success', '+'+translateFilter('points_number',{number: res.points}, 'messageformat'), 3000);
                }
            });
        };

        this.onResult = function(correct, wrong) {
            this.showResult = true;
        };

        this.resultTitle = function() {
            return [translateFilter('sura_name',this.sura), translateFilter('ayats_interval',this)].join(', ');
        };

        function calculatePoints(correct, wrong) {
            return correct;
        }

    }

})();

(function () {
    'use strict';

    angular.module('koran')

    .component('koranTrainingCards',{
        bindings: {
            'sura': '<',
            'ayats': '<',
            'openTraining': '&'
        },
        templateUrl: 'app/components/koran/training/cards.html',
        controller: Component
    });

    function Component($uibModal, ActivityService, Flash, translateFilter, $stateParams) {
        'ngInject';
        
        var $ctrl = this;

        $ctrl.$onInit = function () {
            var id = $stateParams.id, start = $stateParams.start, end = $stateParams.end;

            $ctrl.start = start;
            $ctrl.end = end;

            $ctrl.data = $ctrl.ayats.map(function(ayat) {
                return {
                    phrase: ayat.arab_text,
                    translation: ayat.text,
                    audio: ayat.audio_text_url
                };
            });

            ActivityService.addLogStartTrainingSura(id, 'ayat_cards');
        };

        this.uiCanExit = function() {
            if (!this.result) {
                var modalInstance = $uibModal.open({
                    component: 'trainingConfirmModal'
                });
                return modalInstance.result;
            }
            return true;
        };

        this.onFinish = function(correct, wrong) {
            this.result = {
                correct: correct,
                wrong: wrong,
                points: calculatePoints(correct, wrong)
            };
            ActivityService.addLogFinishTrainingSura($ctrl.sura.id, 'ayat_cards', this.result.points).then(function (res) {
                if (res.points > 0) {
                    Flash.create('success', '+'+translateFilter('points_number',{number: res.points}, 'messageformat'), 3000);
                }
            });
        };

        this.onResult = function(correct, wrong) {
            this.showResult = true;
        };

        this.resultTitle = function() {
            return [translateFilter('sura_name',this.sura), translateFilter('ayats_interval',this)].join(', ');
        };

        function calculatePoints(correct, wrong) {
            return correct;
        }

    }

})();

(function () {
    'use strict';

    angular.module('koran')

    .component('koranTrainingAyatTranslation',{
        bindings: {
            'sura': '<',
            'ayats': '<',
            'openTraining': '&'
        },
        templateUrl: 'app/components/koran/training/ayatTranslation.html',
        controller: Component
    });

    function Component($uibModal, ActivityService, Flash, translateFilter, $stateParams) {
        'ngInject';

        var $ctrl = this;

        $ctrl.$onInit = function () {
            var id = $stateParams.id, start = $stateParams.start, end = $stateParams.end;

            $ctrl.start = start;
            $ctrl.end = end;

            $ctrl.data = $ctrl.ayats.map(function(ayat) {
                return {
                    phrase: ayat.arab_text,
                    translation: ayat.text,
                    audio: ayat.audio_text_url
                };
            });

            ActivityService.addLogStartTrainingSura(id, 'ayat_translation');
        };

        this.uiCanExit = function() {
            if (!this.result) {
                var modalInstance = $uibModal.open({
                    component: 'trainingConfirmModal'
                });
                return modalInstance.result;
            }
            return true;
        };

        this.onFinish = function(correct, wrong) {
            this.result = {
                correct: correct,
                wrong: wrong,
                points: calculatePoints(correct, wrong)
            };
            ActivityService.addLogFinishTrainingSura($ctrl.sura.id, 'ayat_translation', this.result.points).then(function (res) {
                if (res.points > 0) {
                    Flash.create('success', '+'+translateFilter('points_number',{number: res.points}, 'messageformat'), 3000);
                }
            });
        };

        this.onResult = function(correct, wrong) {
            this.showResult = true;
        };

        this.resultTitle = function() {
            return [translateFilter('sura_name',this.sura), translateFilter('ayats_interval',this)].join(', ');
        };

        function calculatePoints(correct, wrong) {
            return correct;
        }

    }

})();

(function () {
    'use strict';

    angular.module('koran')

    .component('ayatSelectorModal',{
        bindings: {
            resolve:'<',
            close:'&',
            dismiss:'&'
        },
        templateUrl: 'app/components/koran/training/ayatSelectorModal.html',
        controller: Component
    });

    function Component(KoranService) {
        'ngInject';
        var size = 10;
        this.intervals = [];
        this.$onInit = function() {
            KoranService.getAyats(this.resolve.id).then(function (ayats) {
                if (!ayats.length) return;
                for (var i=1;i<=ayats.length;i=i+size) {
                    this.intervals.push({start:i,end:Math.min(i+size-1,ayats.length)});
                }
            }.bind(this));
            this.select = function(start, end) {
                this.close({$value:{start:start,end:end}});
            };
            KoranService.getSura(this.resolve.id).then(function (sura) {
                this.sura = sura;
            }.bind(this));
        };
    }

})();

(function () {
    'use strict';

    angular.module('app')

    .component('userSearchResult',{
        bindings: {
            params: '<?',
            exclude: '<?',
            perPage: '<?',
            cols: '<?',
            sprint: '<?'
        },
        templateUrl: 'app/components/_partials/userSearchResult/userSearchResult.html',
        controller: Component
    });

    function Component(UserService, SprintService, HelperService, $scope, $rootScope) {
        'ngInject';
        var $ctrl = this;
        
        this.getGenderText = HelperService.getGenderText;
        
        this.load = function (page) {
            page = page || 1;
            if (page == 1) {
                $ctrl.users = [];
            }
            $ctrl.loading = true;
            return UserService.getAll(angular.merge({ page: page, exclude: $ctrl.exclude, 'per-page': $ctrl.perPage || 20 }, $ctrl.params)).then(function(res) {
                $ctrl.users = $ctrl.users.concat(res.data);
                $ctrl.pagination = res.pagination;
                $ctrl.loading = false;
            });
        };

        
        this.$onInit = function () {
            // this.load();
        };

        $scope.$watch(function () { return $ctrl.params; }, function (params) {
            $ctrl.load();
        }, true);
    }

})();
(function () {
	'use strict';

	angular.module('app')
	.component('userPreview', {
		templateUrl: 'app/components/_partials/userPreview/userPreview.html',
		controller: Component,
		bindings: {
			userId: '<?',
			user: '<?'
		}
	})
	.component('userPreviewAvatar', {
		templateUrl: 'app/components/_partials/userPreview/userPreviewAvatar.html',
		controller: Component,
		bindings: {
			userId: '<?',
			user: '<?'
		}
	})
	.component('userPreviewShort', {
		templateUrl: 'app/components/_partials/userPreview/userPreviewShort.html',
		controller: Component,
		bindings: {
			userId: '<?',
			user: '<?'
		}
	})
	.component('userPreviewFacebook', {
		templateUrl: 'app/components/_partials/userPreview/userPreviewFacebook.html',
		controller: Component,
		bindings: {
			userId: '<?',
			user: '<?'
		}
	})
	.component('userPreviewProfile', {
		templateUrl: 'app/components/_partials/userPreview/userPreviewProfile.html',
		controller: Component,
		bindings: {
			userId: '<?',
			user: '<?'
		}
	});

	function Component(AuthService, ProfileService, UserService, SprintService, $uibModal, $state) {
		'ngInject';
		
		this.authService = AuthService;
		this.profileService = ProfileService;

		var $ctrl = this;

		this.userMeta = function (user) {
			if (!user) return;

			var m1 = this.userCity(user), m2 = [], r = [];
			if (user.gender) m2.push(user.genderText.toLowerCase());
			if (user.age) m2.push(user.age);
			m2 = m2.join(', ');

			if (m1) r.push(m1);
			if (m2) r.push(m2);

			return r.join(' / ');
		}

		this.userCity = function (user) {
			if (!user) return;
			var m1 = [];
			if (user.city) m1.push(user.city);
			if (user.country) m1.push(user.country);
			return m1.join(', ');
		};

		this.$onInit = function () {
			if ($ctrl.user) {
				$ctrl.userId = $ctrl.user.id;
				ProfileService.profileReady().then(function (currentUserId) {
					$ctrl.you = ($ctrl.userId == currentUserId);
				});
			} else if ($ctrl.userId) {
				ProfileService.profileReady().then(function (currentUserId) {
					$ctrl.you = ($ctrl.userId == currentUserId);
				});
				UserService.getUser($ctrl.userId).then(function (res) {
					$ctrl.user = res;
				});
			} else {
				ProfileService.profileReady().then(function () {
					$ctrl.userId = ProfileService.currentUser.id;
					$ctrl.user = ProfileService.currentUser;
					$ctrl.you = true;
				});
			}
		};

		$ctrl.add = function (id) {
			if (!id || !checkAuth()) return;
			SprintService.addSprinter(parseInt(id)).then(function() {
				
			});
		};
		$ctrl.isAdded = function (id) {
			if (!SprintService.initializedOwn) {
				SprintService.getSprintersOwn(true);
			}
			return SprintService.sprintersOwnIds.indexOf(parseInt(id))!=-1;
		};

		function checkAuth() {
            if (!AuthService.isLoggedIn()) {
                $uibModal.open({
                    component: 'confirmAuthModal'
                }).result.then(function (res) {
                    if (res) {
                        $state.go('auth.login');
                    }
                });
                return false;
            }
            return true;
        }
		
	}

})();

(function () {'use strict';
	angular.module('app')
	.component('userName', {
		bindings: {
			'id': '<'
		},
		template: '<span>{{$ctrl.user.name}}</span>',
		controller: Component
	});

	function Component(UserService) {
		'ngInject';
		this.$onInit = function() {
			UserService.getUser(this.id).then(function (res) {
				this.user = res;
			}.bind(this))
		};
	}

})();

(function () {
    'use strict';

    angular.module('app')

    .component('userList',{
        bindings: {
            items: '<',
            filter: '<?',
            cols: '<?'
        },
        templateUrl: 'app/components/_partials/userList/userList.html',
        controller: Component
    })
    .component('userListSprint',{
        bindings: {
            items: '<',
            filter: '<?',
            cols: '<?'
        },
        templateUrl: 'app/components/_partials/userList/userListSprint.html',
        controller: Component
    });

    function Component(SprintService) {
        'ngInject';
        var $ctrl = this;
        
        $ctrl.add = function (id) {
            SprintService.addSprinter(id).then(function() {
                $ctrl.onChange && $ctrl.onChange();
            });
        };
        $ctrl.isAdded = function (id) {
            return SprintService.sprintersOwnIds.indexOf(id)!=-1;
        };

        this.$onInit = function () {
            this.class = 'col-md-'+($ctrl.cols && parseInt(12/$ctrl.cols) || 12);
        };

    }

})();
(function () {
    'use strict';

    angular.module('koran')

    .component('timezoneModal',{
        bindings: {
            resolve:'<',
            close:'&',
            dismiss:'&'
        },
        templateUrl: 'app/components/_partials/timezoneModal/timezoneModal.html',
        controller: Component
    });

    function Component(moment, $element, $timeout) {
        'ngInject';

        this.loading = true;
        $timeout(function() {
            this.timezones = moment.tz.names().map(function(tz) {
                var m = moment.tz(tz);
                return {
                    text: 'UTC'+m.format('Z')+' '+tz,
                    value: tz,
                    offset: m.utcOffset(),
                };
            }).sort(function(a,b) {
                return a.offset > b.offset ? 1 : a.offset < b.offset ? -1 : (a.text > b.text ? 1 : a.text < b.text ? -1 : 0);
            });
            this.loading = false;
        }.bind(this), 200);

        this.$onInit = function() {
            
        };

        this.$postLink = function() {
            $timeout(function() {
                $element.find('.search').focus();
                $element.find('.list').scrollToElement($element.find('.selected'));
            }, 500);
        };

        this.select = function(t) {
            this.close({$value:t});
        };
    }

})();

(function () {'use strict';
	angular.module('app')
	.component('suraName', {
		bindings: {
			'id': '<'
		},
		template: '<span>{{$ctrl.sura.name}}</span>',
		controller: Component
	});

	function Component(KoranService) {
		'ngInject';
		this.$onInit = function() {
			KoranService.getSura(this.id).then(function (res) {
				this.sura = res;
			}.bind(this))
		};
	}

})();

(function () {'use strict';
	angular.module('reportButton',[])
	.component('reportButton', {
		bindings: {
			'variants': '<reportVariants',
			'inputLabel': '<?reportInputLabel',
			'inputRequired': '<?reportInputRequired'
		},
		template: '\
			<a ng-if="!$root.isPhone" uib-popover-template="$ctrl.templatePopover" popover-trigger="\'outsideClick\'" popover-placement="bottom-left" popover-append-to-body="false" popover-is-open="$ctrl.isOpen" popover-class="fullscreen-mobile">\
				<i class="icon-cancel"></i>\
				<span>{{"complain"|translate}}</span>\
			</a>\
			<a ng-if="$root.isPhone" ng-click="$ctrl.openModal()">\
				<i class="icon-cancel"></i>\
				<span>{{"complain"|translate}}</span>\
			</a>\
		',
		controller: Component
	});

	function Component($element, ReportService, Flash, $uibModal) {
		'ngInject';
		var $ctrl = this;
		this.templatePopover = 'app/components/_partials/reportButton/reportButtonPopover.html';
		this.templateModal = 'app/components/_partials/reportButton/reportButtonModal.html';
		this.selectVariant = function (variant) {
			this.selectedVariant = variant;
			angular.element('.report-form input[type=text]').focus();
		};
		this.send = function () {
			ReportService.send({
				type: this.selectedVariant.key,
				text: this.text
			}).then(function () {
				Flash.create('success', 'your_report_is_sent', 3000);
				$ctrl.isOpen = false;
			}, function (error) {
				Flash.create('warning', error, 3000);
				$ctrl.isOpen = false;
			});
		};
		this.openModal = function() {
			var modalInstance = $uibModal.open({
				templateUrl: this.templateModal,
				controller: function() {
					this.selectedVariant = $ctrl.selectedVariant;
					this.send = $ctrl.send;
					this.selectVariant = $ctrl.selectVariant;
					this.variants = $ctrl.variants;
					this.inputLabel = $ctrl.inputLabel;
					this.close = function() {
						modalInstance.close();
					};
				},
				controllerAs: '$ctrl',
				windowClass: 'fullscreen-mobile'
			});
		};
		
	}

})();

(function () {
	'use strict';

	angular.module('app')
	.component('sprintLeader', {
		templateUrl: 'app/components/_partials/sprintLeader/sprintLeader.html',
		controller: Component,
		bindings: {
			onNavigate: '&?'
		}
	});

	function Component(SprintService, ProfileService, UserService) {
		'ngInject';
		var $ctrl = this;
		
		$ctrl.loading = true;
		SprintService.getLeader().then(function (userId) {
			UserService.getUser(userId).then(function (user) {
				$ctrl.user = user;
				$ctrl.loading = false;
			}, function () {
				$ctrl.user = null;
				$ctrl.loading = false;
			});
		});

		ProfileService.profileReady().then(function(currentUserId) {
			$ctrl.you = currentUserId;
		});
	}

})();

(function () {
	'use strict';

	angular.module('app')
	.component('sprintCount', {
		templateUrl: 'app/components/_partials/sprintCount/sprintCount.html',
		controller: Component
	});

	function Component(SprintService) {
		'ngInject';
		var $ctrl = this;

		if (!SprintService.initializedOwn) {
			SprintService.getSprintersOwn();
		}
		$ctrl.ownCount = function() {return SprintService.sprintersOwnIds.length;};

		if (!SprintService.initializedOuter) {
			SprintService.getSprintersOuter();
		}
		$ctrl.outerCount = function() {return SprintService.sprintersOuterIds.length;};

	}

})();

(function () {
  'use strict';

  angular.module('app')
    .component('oauth', {
      templateUrl: 'app/components/_partials/oauth/oauth.html',
      controller: Component,
      bindings: {

      }
    }).factory('oauthResponse', oauthResponse);

  function Component($auth, oauthResponse) {
    'ngInject';
    var $ctrl = this;
    $ctrl.authenticate = function (provider) {
      $ctrl.dataLoading = true;
      $auth.authenticate(provider, {
          returnData: 1
        }).then(function (response) {
          // Signed in
          $ctrl.dataLoading = false;
          $ctrl.errorMessage = false;
          if (!response.data.success) {
            $ctrl.errorMessage = true;
					}
					
					oauthResponse.handler(response.data);

        })
        .catch(function (response) {
          // Something went wrong.
          $ctrl.errorMessage = true;
          $ctrl.dataLoading = false;
        });
    };
	}
	
	function oauthResponse(AuthService, Storage, HistoryService, $location, $state) {
		'ngInject';
		return {
			handler: function (data) {
				if (data.success) {
					if (data.access_token) {
						AuthService.setCredentials(data.access_token);
	
						var path = HistoryService.findReferer(null, 'auth');
						$location.path(!/^\/\S+\/quran$/.test(path) && path || '/');
	
					} else {
						AuthService.oauthData = data;
						$state.go('auth.oauthConfirm');
					}
				}

				if (data.oauth_client == 'facebook' && data.oauth_access_token) {
					Storage.setItem('fb_token', data.oauth_access_token);
				}
			}
		};
	}

})();

(function () {
	'use strict';

	angular.module('app')
	.component('progressToday', {
		templateUrl: 'app/components/_partials/progressToday/progressToday.html',
		controller: Component,
		bindings: {
			user: '<'
		}
	});

	function Component() {
		
	}

})();

(function () {
    'use strict';

    angular.module('app')

    .component('materialSearchResult',{
        bindings: {
            params: '<?',
            perPage: '<?',
            addToCourse: '<?',
            onAddToCourse: '&?',
            courseMaterials: '<?',
            onChangeParams: '&?',
            onStartLoading: '&?',
            onFinishLoading: '&?'
        },
        templateUrl: 'app/components/_partials/materialSearchResult/materialSearchResult.html',
        controller: Component
    });

    function Component($scope, SubjectService, CategoryService, SourceService, MaterialService) {
        'ngInject';
        var $ctrl = this;
        
        this.load = function (page) {
            page = page || 1;
            $ctrl.loading = true;
            $ctrl.onStartLoading && $ctrl.onStartLoading();            
            return MaterialService.getAll(angular.merge({ page: page, 'per-page': this.perPage || 12 }, this.params), true).then(function(res) {
                if (page == 1) {
                    $ctrl.materials = [];
                    $ctrl.pagination = {totalCount:0};
                }
                $ctrl.materials = $ctrl.materials.concat(res.data);
                $ctrl.pagination = res.pagination;
                $ctrl.loading = false;
                $ctrl.onFinishLoading && $ctrl.onFinishLoading({totalCount: $ctrl.pagination.totalCount});
            });
        };

        this.unsetParam = function (param, value) {
            this.params[param] = _.filter(this.params[param], function (p) { return p != value; });
        };

        this.searchQueryDelete = function (keyword) {
            this.params['title[]'] = this.params['title[]'].filter(function (s) { return s!=keyword; });
            this.params['name[]'] = this.params['title[]'];
        };
        
        this.$onInit = function () {

        };

        SubjectService.getAll().then(function(res) {
            $ctrl.subjects = res.map(function(r) {return {text:r.title,value:r.id};});
        });

        CategoryService.getAll().then(function(res) {
            $ctrl.categories = res.map(function(r) {return {text:r.title,value:r.id};});
        });
        
        SourceService.getAll().then(function(res) {
            $ctrl.sources = res.map(function(r) {return {text:r.title,value:r.id};});
        });

        $scope.$watch('$ctrl.params', function (params) {
            $ctrl.load();
            $ctrl.currentSubjects = _.filter($ctrl.subjects, function (s) { return params['subject_id[]'] && params['subject_id[]'].indexOf(s.value)!=-1; });
            $ctrl.currentSources = _.filter($ctrl.sources, function (s) { return params['source_id[]'] && params['source_id[]'].indexOf(s.value)!=-1; });
            $ctrl.currentCategories = _.filter($ctrl.categories, function (s) { return params['category_id[]'] && params['category_id[]'].indexOf(s.value)!=-1; });
            $ctrl.currentRating = _.find($ctrl.sortRatingOptions, function (s) { return params.sort_rating == s.value; });
            $ctrl.onChangeParams && $ctrl.onChangeParams({params: params});
        }, true);
    }

})();
(function () {
    'use strict';
    angular.module('app')

    .component('materialSearchForm',{
        bindings: {
            params: '<?',
            onSubmit: '&?',
            totalCount: '<?',
            loading: '<?',
            autocomplete: '<?'
        },
        templateUrl: 'app/components/_partials/materialSearchForm/materialSearchForm'+(isDesktop()?'.$desktop':'.$mobile')+'.html',
        controller: Component
    });

    function Component($uibModal, $rootScope, $q, $scope, MaterialService, UserService, SubjectService, CategoryService, SourceService, ProfileService) {
        'ngInject';
        var $ctrl = this, _searchQuery;
        
        this.searchOpen = false;
        this.searchResults = {};

        SubjectService.getAll().then(function(res) {
            $ctrl.subjects = res.map(function(r) {return {text:r.title,value:r.id};});
        });

        CategoryService.getAll().then(function(res) {
            $ctrl.categories = res.map(function(r) {return {text:r.title,value:r.id};});
        });
        
        SourceService.getAll().then(function(res) {
            $ctrl.sources = res.map(function(r) {return {text:r.title,value:r.id};});
        });

        this.$onInit = function () {
            $rootScope.materialSearchFormCtrl = $ctrl;
            $(document).on('keydown','#materials-autocomplete-input, #materials-autocomplete-results a',this.searchKeyDown);
            $(document).on('click',this.searchClose);
            this.sortRatingOptions = [
                {text: 'high_rating', value: 1},
                {text: 'low_rating', value: -1}
            ];
        };

        this.$onDestroy = function () {
            delete $rootScope.materialSearchFormCtrl;
            $(document).off('keydown','#materials-autocomplete-input, #materials-autocomplete-results a',this.searchKeyDown);
            $(document).off('click',this.searchClose);
        };


        // Getter/setter
        this.searchQuery = function (q) {
            if (q !== undefined) {
                _searchQuery = q;
                this.applySearchQuery();
            } else {
                return _searchQuery;
            }
        };

        // Getter/setter
        this.searchQueryResults = function (q) {
            if (q !== undefined) {
                _searchQuery = q;
                this.searchResults = {};
                this.searchOpen = false;
                if (_searchQuery.length > 1) {
                    var p1 = MaterialService.getAll(angular.merge({'per-page':5}, this.params, {'title[]': _searchQuery.split(' '), sort_likes: 1}), true).then(function(res) {
                        $ctrl.searchResults.materials = res.data;
                        $ctrl.searchResults.materials_count = res.pagination.totalCount;
                    });
                    var p2 = UserService.getAll(angular.merge({'per-page':4, exclude: ProfileService.currentUser.id}, this.params, {'name[]': _searchQuery.split(' '), sort_points: 1}), true).then(function(res) {
                        $ctrl.searchResults.users = res.data;
                        $ctrl.searchResults.usersCount = res.pagination.totalCount;
                    });
                    $q.all([p1,p2]).then(function () {
                        $ctrl.searchOpen = true;
                    });
                }
            } else {
                return _searchQuery;
            }
        };

        this.readSearchQuery = function () {
            _searchQuery = this.params['title[]'] && this.params['title[]'].join(' ');            
        };
        this.applySearchQuery = function () {
            this.params['title[]'] = _searchQuery && _searchQuery.split(' ');
            this.params['name[]'] = _searchQuery && _searchQuery.split(' ');
            this.searchOpen = false;
        };
        this.searchReset = function () {
            this.params = {};
            _searchQuery = '';
        };
        this.searchKeyUp = function (e) {
            if (e.keyCode == 13) {
                this.applySearchQuery();
            }
        };
        this.searchKeyDown = function (e) {
            var res, count, index;
            switch (e.keyCode) {
                case 38: // up arrow
                    e.preventDefault();
                    e.stopPropagation();
                    res = $('#materials-autocomplete-results');
                    count = res.find('a').length;
                    if (count > 0) {
                        index = res.find('a:focus').index('#materials-autocomplete-results a');
                        res.find('a').get(index > 0 ? index-1 : count-1).focus();
                    }
                    break;
                case 40: // down arrow
                    e.preventDefault();
                    e.stopPropagation();
                    res = $('#materials-autocomplete-results');
                    count = res.find('a').length;
                    if (count > 0) {
                        index = res.find('a:focus').index('#materials-autocomplete-results a');
                        res.find('a').get(index < count-1 ? index+1 : 0).focus();
                    }
                    break;
            }
        };
        this.searchClose = function (event) {
            if (event.target != $('#materials-autocomplete-input')[0] && !$(event.target).closest('.materials-autocomplete').length) {
                $ctrl.searchOpen = false;
                $scope.$digest();
            }
        };

        $rootScope.$watch(function () { return $ctrl.params; }, function (params) {
            $ctrl.paramsCount = _.filter($ctrl.params, function (p, k) { return k != 'name[]' && (_.isArray(p) && p.length > 0 || !_.isArray(p) && p); }).length;
            $ctrl.readSearchQuery();
            $ctrl.currentSubjects = _.filter($ctrl.subjects, function (s) { return params['subject_id[]'] && params['subject_id[]'].indexOf(s.value)!=-1; });
            $ctrl.currentSources = _.filter($ctrl.sources, function (s) { return params['source_id[]'] && params['source_id[]'].indexOf(s.value)!=-1; });
            $ctrl.currentCategories = _.filter($ctrl.categories, function (s) { return params['category_id[]'] && params['category_id[]'].indexOf(s.value)!=-1; });
            $ctrl.currentRating = _.find($ctrl.sortRatingOptions, function (s) { return params.sort_rating == s.value; });
            $ctrl.onSubmit({params:params});
        }, true);

        this.openModalSearch = function() {
			var modalInstance = $uibModal.open({
                templateUrl: 'app/components/_partials/materialSearchForm/searchModal.html',
				controller: function() {
                    this.active = 'format';
					this.submit = function() {
						modalInstance.close();
                    };
                    this.close = function() {
                        modalInstance.dismiss();
                    };
                    setTimeout(function () {
                        $('#search-modal-query').focus();
                    }, 500);
				},
				controllerAs: '$ctrl',
				windowClass: 'fullscreen-mobile'
            });
        };
    }

})();

(function () {
    'use strict';

    angular.module('app')

    .component('materialRecommend',{
        bindings: {
            
        },
        templateUrl: 'app/components/_partials/materialRecommend/materialRecommend.html',
        controller: Component
    });

    function Component(MaterialService) {
        'ngInject';
        var $ctrl = this;
        
        this.load = function (page) {
            page = page || 1;
            if (page == 1) {
                $ctrl.items = [];
            }
            $ctrl.loading = true;
            return MaterialService.getRecommend({ page: page, 'per-page': 12 }).then(function(res) {
                if (!$ctrl.items.length && res.data.length > 0 && res.data[0].status != 'finished') {
                    $ctrl.show = true;
                }
                $ctrl.pagination = res.pagination;
                $ctrl.items = $ctrl.items.concat(res.data);
                $ctrl.loading = false;
            });
        };

        
        this.$onInit = function () {
            this.load();
        };

    }

})();
(function () {
    'use strict';

    angular.module('app')

    .component('materialList',{
        bindings: {
            items: '<',
            filter: '<?',
            ps: '<',
            addToCourse: '<?',
            onAddToCourse: '&?',
            courseMaterials: '<?'
        },
        templateUrl: 'app/components/_partials/materialList/materialList.html',
        controller: Component
    })
    .component('materialListShort',{
        bindings: {
            items: '<',
            filter: '<?',
            ps: '<'
        },
        templateUrl: 'app/components/_partials/materialList/materialListShort.html',
        controller: Component
    });

    function Component($rootScope) {
        var $ctrl = this;
        var p1, p2, p3;
        this.$onInit = function () {
            // Обновление данных у уже найденных материалов (sticky state)
            p1 = $rootScope.$on('materialStatusChange', function (event, args) {
                var material = _.find($ctrl.items, function (m) { return m.id == args.id; });
                if (material) {
                    material.status = args.status;
                }
            });
            p2 = $rootScope.$on('materialOpen', function (event, args) {
                var material = _.find($ctrl.items, function (m) { return m.id == args.id; });
                if (material) {
                    material.views++;
                }
            });
            p3 = $rootScope.$on('likeChange', function (event, args) {
                if (args.resource == 'material') {
                    var material = _.find($ctrl.items, function (m) { return m.id == args.resourceId; });
                    if (material) {
                        material.likes = args.value;
                    }
                }
            });
        };

        this.$onDestroy = function () {
            p1();
            p2();
            p3();
        };

        this.inCourse = function (m) {
            if (!this.courseMaterials || !this.courseMaterials.length) {
                return false;
            }
            return _.find(this.courseMaterials, function (cm) {
                return cm.id == m.id;
            });
        };
    }

})();

(function () {'use strict';
	angular.module('app')
	.component('materialName', {
		bindings: {
			'id': '<'
		},
		template: '<span>{{$ctrl.material.title}}</span>',
		controller: Component
	});

	function Component(MaterialService) {
		'ngInject';
		this.$onInit = function() {
			MaterialService.getMaterial(this.id).then(function (res) {
				this.material = res;
			}.bind(this))
		};
	}

})();

(function () {
    'use strict';
    angular.module('app')

    .component('materialForm',{
        bindings: {
            model: '<?',
            loading: '<?',
            onSubmit: '&',
            onCancel: '&',
            onImageDelete: '&'
        },
        templateUrl: 'app/components/_partials/materialForm/materialForm.html',
        controller: Component
    })

    .directive('materialUrlCheck', function($q, MaterialService) {
        'ngInject';
        return {
            require: 'ngModel',
            scope: {
                type: '<materialUrlCheck',
                currentId: '<?materialUrlCheckCurrentId'
            },
            link: function(scope, elm, attrs, ctrl) {
                ctrl.$validators.material_url = function (modelValue, viewValue) {
                    if (!viewValue) {
                        return true;
                    }
                    return MaterialService.urlCheckValid(viewValue, scope.type);
                };
                ctrl.$asyncValidators.material_url_busy = function (modelValue, viewValue) {
                    if (!viewValue) {
                        return $q.when();
                    }
                    return MaterialService.urlCheckAvail(viewValue, scope.currentId);
                };
            }
        };
    })

    .directive('embedCodeCheck', function() {
        return {
            require: 'ngModel',
            link: function(scope, elm, attrs, ctrl) {
                ctrl.$validators.embed_code = function (modelValue, viewValue) {
                    return !viewValue || viewValue.toLowerCase().indexOf('<script') == -1;
                };
            }
        };
    });

    function Component(MaterialService, $q, EmbedService, $scope, $timeout, SubjectService, CategoryService, SourceService) {
        'ngInject';
        var $ctrl = this;

        this.data = {type:'video',embed_type:'url'};

        this.lengthData = {
            hours: '00',
            minutes: '00',
            seconds: '00'
        };

        this.$onInit = function () {
            if (this.model) {
                this.data = angular.copy(this.model);
            }
        };

        this.submit = function () {
            this.onSubmit({model: this.data});
        };

        SubjectService.getAll().then(function(res) {
            $ctrl.subjects = res.map(function(r) {return {text:r.title,value:r.id};});
        });

        CategoryService.getAll().then(function(res) {
            $ctrl.categories = res.map(function(r) {return {text:r.title,value:r.id};});
        });
        
        SourceService.getAll().then(function(res) {
            $ctrl.sources = res.map(function(r) {return {text:r.title,value:r.id};});
            $ctrl.sources = [{text:'no_select',value:null}].concat($ctrl.sources);
        });

        this.imageUploaderConfig = MaterialService.imageUploaderConfig;

        this.imageDelete = function () {
            if (!$ctrl.data.image_path) {
                $ctrl.data.image = null;
                return false;
            }
            MaterialService.deleteImage($ctrl.data.image_path).finally(function () {
                $ctrl.model && $ctrl.onImageDelete && $ctrl.onImageDelete();
                $ctrl.data.image = null;
                $ctrl.data.image_path = null;
                $ctrl.data.image_base_url = null;
            });
        };
        
        this.imageUploaded = function (fileObj) {
            if (fileObj.error) return false;
            $ctrl.data.image_path = fileObj.path;
            $ctrl.data.image_base_url = fileObj.base_url;
            $ctrl.data.image = fileObj.url;
        };

        this.onUrlChange = function (fieldCtrl) {
            fieldCtrl.$setValidity('material_url_work',true);
            var url = this.data.url;
            if (!url) {
                $ctrl.data.length = 0;
                $ctrl.data.image = null;
                return;
            }
            $ctrl.embedLoading = true;
            EmbedService.getUrlData(url).then(function(res) {
                if ($ctrl.data.type != 'text') {
                    $ctrl.data.length = res.length;
                }
                if (res.image && !$ctrl.data.image) {
                    $ctrl.data.image = res.image;
                    $ctrl.data.image_path = null;
                    $ctrl.data.image_base_url = null;
                }
            }, function(err) {
                $ctrl.data.length = 0;
                $ctrl.data.image = null;
                fieldCtrl.$setValidity('material_url_work',false);
            }).finally(function() {
                $ctrl.embedLoading = false;
            });
        };

        this.checkUrl = function () {
            return false;
        };

        $scope.$watch('$ctrl.data.length',function(l) {
            if (!l) {
                $ctrl.lengthData = {
                    hours: '00',
                    minutes: '00',
                    seconds: '00'
                };
                return;
            }
            var d = moment.duration(l, 'seconds');
            $ctrl.lengthData = {
                hours: ('00'+d.hours()).slice(-2),
                minutes: ('00'+d.minutes()).slice(-2),
                seconds: ('00'+d.seconds()).slice(-2)
            };
        });

        $scope.$watch('$ctrl.lengthData',function(ldata) {
            if (!ldata) {
                $ctrl.data.length = 0;
                return;
            }
            $ctrl.data.length = parseInt(ldata.hours)*3600 + parseInt(ldata.minutes)*60 + parseInt(ldata.seconds);
        }, true);

        $scope.$watch('$ctrl.data.type',function(t, old) {
            if (t == 'text') {
                $ctrl.data.length = 1;
            }
            if (old == 'text') {
                $ctrl.data.length = 0;
            }
        });
    }

})();

(function () {
    'use strict';

    angular.module('app')

    .component('materialFinishRecommend',{
        bindings: {
            materialId: '<',
            forceTitle: '@?'
        },
        templateUrl: 'app/components/_partials/materialFinishRecommend/materialFinishRecommend.html',
        controller: Component
    });

    function Component(MaterialService) {
        'ngInject';
        var $ctrl = this;
        
        this.load = function (page) {
            page = page || 1;
            if (page == 1) {
                $ctrl.items = [];
            }
            $ctrl.loading = true;
            return MaterialService.getFinishRecommend($ctrl.materialId, { page: page, 'per-page': 12 }).then(function(res) {
                $ctrl.pagination = res.pagination;
                $ctrl.items = $ctrl.items.concat(res.data);
                $ctrl.loading = false;
            });
        };

        
        this.$onInit = function () {
            this.load();
        };

    }

})();
(function () {
    'use strict';

    angular.module('app')

    .component('materialBest',{
        bindings: {
            
        },
        templateUrl: 'app/components/_partials/materialBest/materialBest.html',
        controller: Component
    });

    function Component(MaterialService) {
        'ngInject';
        var $ctrl = this;
        
        this.load = function (page) {
            page = page || 1;
            if (page == 1) {
                $ctrl.items = [];
            }
            $ctrl.loading = true;
            return MaterialService.getBest({ page: page, 'per-page': 12 }).then(function(res) {
                $ctrl.pagination = res.pagination;
                $ctrl.items = $ctrl.items.concat(res.data);
                $ctrl.loading = false;
            });
        };

        
        this.$onInit = function () {
            this.load();
        };

    }

})();
(function () {
    'use strict';

    angular.module('user',[]);
    
})();

(function () {
	'use strict';

	angular.module('user')
	.component('log', {
		templateUrl: 'app/components/_partials/log/log.html',
		controller: Component,
		bindings: {
			data: '<',
			showUser: '<?',
			ps: '<'
		}
	});

	function Component(ActivityService, UserService, translateFilter, $scope, moment) {
		'ngInject';
		var $ctrl = this;
		this.log = [];
		$scope.$watchCollection('$ctrl.data',function (data) {
			this.log = this.combineData(this.data);
		}.bind(this));
		this.combineData = function (data) {
			var combineTable = {}, combined = [];
			data.forEach(function(d) {
				d.date = this.getDate(d);
				combineTable[d.date] = combineTable[d.date] || {};
				combineTable[d.date][d.user_id] = combineTable[d.date][d.user_id] || {};
				combineTable[d.date][d.user_id][d.resource] = combineTable[d.date][d.user_id][d.resource] || {};
				combineTable[d.date][d.user_id][d.resource][d.category] = combineTable[d.date][d.user_id][d.resource][d.category] || [];
				combineTable[d.date][d.user_id][d.resource][d.category].push(d);
			}.bind(this));
			Object.keys(combineTable).forEach(function (date) {
				Object.keys(combineTable[date]).forEach(function (user_id) {
					Object.keys(combineTable[date][user_id]).forEach(function (resource) {
						Object.keys(combineTable[date][user_id][resource]).forEach(function (category) {
							combined.push({
								date: date,
								user_id: user_id,
								resource: resource,
								category: category,
								items: combineTable[date][user_id][resource][category],
								gender: combineTable[date][user_id][resource][category][0] && combineTable[date][user_id][resource][category][0]['gender']
							});
						});
					});
				});
			});
			return combined;
		};
		this.getDate = function(l) {
			var m = moment.unix(l.created_at);
			$ctrl.ps && m.tz($ctrl.ps.timezone);
			return m.calendar(null, {
				sameDay: '['+translateFilter('today')+'], D MMMM YYYY',
				nextDay: '['+translateFilter('tomorrow')+'], D MMMM YYYY',
				nextWeek: 'dddd, D MMMM YYYY',
				lastDay: '['+translateFilter('yesterday')+'], D MMMM YYYY',
				lastWeek: 'dddd, D MMMM YYYY',
				sameElse: 'D MMMM YYYY'
			});
		};
	}

})();

(function () {
	'use strict';

	angular.module('app')
	.component('guide', {
		templateUrl: 'app/components/_partials/guide/guide.html',
		controller: Component,
		bindings: {
			steps: '<',
			show: '<',
			onClose: '&'
		}
	});

	function Component($timeout, $scope, $document) {
		'ngInject';
		
		this.stepTemplate = 'app/components/_partials/guide/guideStep.html';

		$scope.$watch('$ctrl.show', function(show) {
			$timeout(function(){
				angular.element('.guide-bg').css({height:$document.outerHeight()+'px'});
			});
			// angular.element('body').css({overflow:show ? 'hidden' : 'visible'});
			if (show) {
				angular.element(document).on('keydown',function(e) {
					if (e.keyCode == 27) {
						this.close();
					}
				}.bind(this));
			} else {
				angular.element(document).off('keydown');
			}
		}.bind(this));

		$scope.$watch('$ctrl.steps', function() {
			this.stepNum = 0;
			this.open = true;
			this.initStep();
		}.bind(this), true);

		this.$onInit = function () {
			
		};

		this.currentStep = function() {
			return this.steps && this.steps[this.stepNum];
		};
		this.initStep = function () {
			if (!this.currentStep()) return;
			var $t = angular.element(this.currentStep().selector);
			if (!$t.length) return;
			this.placeholderStyle = {
				left: $t.offset().left+'px',
				top: $t.offset().top+'px',
				width: $t.outerWidth(),
				height: $t.outerHeight()
			};
		};

		this.goToStep = function (n) {
			this.open = false;
			if (this.currentStep().onHide) {
				this.currentStep().onHide();
			}
			$timeout(function() {
				this.stepNum = n;
				this.initStep();
				this.open = true;
				$timeout(function() {
					// Центруем стрелку у popover
					var $t = angular.element(this.currentStep().selector),
						$e = angular.element('.guide-popover');
					if ($e.length) {
						if ($e.hasClass('bottom-right') || $e.hasClass('top-right')) {
							$e.find('.arrow').css({right:Math.ceil($t.outerWidth()/2)});
						} else if ($e.hasClass('bottom-left') || $e.hasClass('top-left')) {
							$e.find('.arrow').css({left:Math.ceil($t.outerWidth()/2)});
						}
						$document.scrollToElementAnimated($e, angular.element('body').outerHeight()/2);
					}
				}.bind(this),40);
			}.bind(this), 50);
		};
		this.next = function () {
			this.goToStep(Math.min(this.stepNum+1, this.steps.length-1));
		};
		this.prev = function () {
			this.goToStep(Math.max(this.stepNum-1, 0));
		};

		this.close = function() {
			this.goToStep(0);
			this.onClose();
		};

		
	}

})();

(function () {
    'use strict';

    angular.module('app')

    .component('likesCounter',{
        bindings: {
            resource: '@',
            resourceId: '<',
            value: '='
        },
        templateUrl: 'app/components/_partials/likesCounter/likesCounter.html',
        controller: Component
    });

    function Component(MaterialService, CourseService, AuthService, $state, $uibModal, $rootScope) {
        'ngInject';
        var $ctrl = this;

        $ctrl.liked = false;
        $ctrl.disliked = false;

        $ctrl.like = function() {
            if (!checkAuth()) {
                return false;
            }
            if (this.resource == 'material') {
                MaterialService.changeLike(this.resourceId, !$ctrl.liked && 1 || 0).then(function() {
                    $ctrl.liked = !$ctrl.liked;
                    if ($ctrl.disliked) {
                        $ctrl.disliked = false;
                        $ctrl.value++;
                    }
                    if ($ctrl.liked) {
                        // like
                        $ctrl.value++;
                    } else {
                        // unlike
                        $ctrl.value--;
                    }
                    $rootScope.$emit('likeChange', {resource: $ctrl.resource, resourceId: $ctrl.resourceId, value: $ctrl.value});
                });
            }
            if (this.resource == 'course') {
                CourseService.changeLike(this.resourceId, !$ctrl.liked && 1 || 0).then(function() {
                    $ctrl.liked = !$ctrl.liked;
                    if ($ctrl.disliked) {
                        $ctrl.disliked = false;
                        $ctrl.value++;
                    }
                    if ($ctrl.liked) {
                        // like
                        $ctrl.value++;
                    } else {
                        // unlike
                        $ctrl.value--;
                    }
                    $rootScope.$emit('likeChange', {resource: $ctrl.resource, resourceId: $ctrl.resourceId, value: $ctrl.value});
                });
            }
        };
        $ctrl.dislike = function() {
            if (!checkAuth()) {
                return false;
            }
            if (this.resource == 'material') {
                MaterialService.changeLike(this.resourceId, !$ctrl.disliked && -1 || 0).then(function() {
                    $ctrl.disliked = !$ctrl.disliked;
                    if ($ctrl.liked) {
                        $ctrl.liked = false;
                        $ctrl.value--;
                    }
                    if ($ctrl.disliked) {
                        // dislike
                        $ctrl.value--;
                    } else {
                        // undislike
                        $ctrl.value++;
                    }
                });
            }
            if (this.resource == 'course') {
                CourseService.changeLike(this.resourceId, !$ctrl.disliked && -1 || 0).then(function() {
                    $ctrl.disliked = !$ctrl.disliked;
                    if ($ctrl.liked) {
                        $ctrl.liked = false;
                        $ctrl.value--;
                    }
                    if ($ctrl.disliked) {
                        // dislike
                        $ctrl.value--;
                    } else {
                        // undislike
                        $ctrl.value++;
                    }
                });
            }
        };

        this.$onInit = function () {
            if (AuthService.isLoggedIn() && this.resource == 'material') {
                MaterialService.getLike(this.resourceId).then(function(v) {
                    $ctrl.liked = (v == 1);
                    $ctrl.disliked = (v == -1);
                });
            }
            if (AuthService.isLoggedIn() && this.resource == 'course') {
                CourseService.getLike(this.resourceId).then(function(v) {
                    $ctrl.liked = (v == 1);
                    $ctrl.disliked = (v == -1);
                });
            }
        };

        function checkAuth() {
            if (!AuthService.isLoggedIn()) {
                $uibModal.open({
                    component: 'confirmAuthModal'
                }).result.then(function (res) {
                    if (res) {
                        $state.go('auth.login');
                    }
                });
                return false;
            }
            return true;
        }

    }

})();
(function () {
	'use strict';

	angular.module('app')
	.component('helpQa', {
		templateUrl: 'app/components/_partials/helpQa/helpQa.html',
		controller: Component,
		bindings: {
			category: '<?'
		}
	});

	function Component(HelpService, ProfileService, moment) {
		'ngInject';
		this.open = null;
		this.qa = [];
		this.$onInit = function () {
			HelpService.getAll({category:this.category}).then(function (res) {
				this.qa = res;
			}.bind(this));	
		};
		this.toggle = function (h) {
			this.open = (this.open == h.id ? null : h.id);
		};
		this.show = function (h) {
			return h.id == this.open;
		};
	}

})();

(function () {
    'use strict';

    angular.module('app')

    .component('followModal',{
        bindings: {
            close:'&',
            dismiss:'&'
        },
        templateUrl: 'app/components/_partials/followModal/followModal.html',
        controller: Component
    });

    function Component(config, ConfigService) {
        'ngInject';
        ConfigService.getItem('facebook_url').then(function(facebookUrl) {
            this.facebookIframeSrc = 'https://www.facebook.com/plugins/follow.php?href='+encodeURI(facebookUrl)+'&layout=standard&size=small&show_faces=true&appId='+config.facebookAppId;
        }.bind(this));
        this.$postLink = function() {
            setTimeout(function() {
                gapi.ytsubscribe.go('.g-ytsubscribe');
            },200);
        };
    }

})();

(function () {
	'use strict';
	angular.module('form', [])

	.component('message', {
		bindings: {
			type: '@',
			theme: '@?',
			cssClass: '@?',
			timeout: '<?',
			onHide: '&?'
		},
		transclude: true,
		template: '<div class="flash-message {{$ctrl.cssClass}} {{$ctrl.cssClassPrefix}}{{$ctrl.type}}" ng-if="$ctrl.show" ng-transclude></div>',
		controller: function ($timeout) {
			'ngInject';
			var $ctrl = this;
			this.show = true;
			this.cssClassPrefix = 'text text-';
			this.$onInit = function () {
				if ($ctrl.theme) {
					$ctrl.cssClassPrefix = $ctrl.cssClassPrefix.replace(/text/g,$ctrl.theme);
				}
				if ($ctrl.timeout) {
					$timeout($ctrl.hide, $ctrl.timeout);
				}
			};
			this.hide = function () {
				$ctrl.show = false;
				if ($ctrl.onHide) {
					$timeout($ctrl.onHide, 500); // 0.5s задержка для анимации
				}
			};
		}
	})

	.directive('password', function() {
		return {
			require: 'ngModel',
			link: function(scope, elm, attrs, ctrl) {
				ctrl.$validators.password = passwordValidator;
			}
		};
	})
	.directive('integer', function() {
		return {
			require: 'ngModel',
			scope: {
				min: '<?',
				max: '<?'
			},
			link: function(scope, elm, attrs, ctrl) {
				ctrl.$validators.integer = function (modelValue, viewValue) {
					if (!modelValue) {
						return true;
					}

					if (/^\-?\d+$/.test(viewValue)) {
						var valid = true;
						if (scope.min != undefined && viewValue < scope.min) {
							valid = false;
						}
						if (scope.max != undefined && viewValue > scope.max) {
							valid = false;
						}
						return valid;
					}

					return false;
				};
			}
		};
	})
	.directive('emailBusyCheck', function($q, AuthService) {
		return {
			require: 'ngModel',
			link: function(scope, elm, attrs, ctrl) {
				ctrl.$asyncValidators.email_busy = function (modelValue, viewValue) {
                    if (!viewValue) {
                        return $q.when();
                    }
                    return AuthService.emailCheckAvail(viewValue);
                };
			}
		};
	})
	.directive('formGroupMinimal', function() {
		return {
			require: {
				form: '^^form'
			},
			restrict: 'E',
			template: '\
				<div class="form-group form-group-minimal {{$ctrl.fgClass}}" ng-class="{\'has-error\':$ctrl.hasError() && $ctrl.showError()}" uib-tooltip-html="$ctrl.getTooltip()|translate">\
					<ng-transclude></ng-transclude>\
					<div ng-if="$ctrl.maxlength" class="length">{{ $ctrl.maxlength - $ctrl.form[$ctrl.name].$viewValue.length }}</div>\
				</div>\
			',
			transclude: true,
			bindToController: {
				name: '@',
				tooltip: '<?',
				maxlength: '<?',
				fgClass: '@',
				showDirty: '<?'
			},
			scope: true,
			controller: function($scope, $element, $attrs) {
				this.showError = function () {
					return this.showDirty ? this.form[this.name].$dirty : !!this.form[this.name].$viewValue;
				};
				this.hasError = function () {
					return this.form[this.name].$invalid;
				};
				this.getTooltip = function () {
					if (this.tooltip) {
						return this.tooltip;
					}
					if (this.showError()) {
						return getFieldError(this.form[this.name]);
					}
					return null;
				};
				this.$postLink = function () {
					$element.find('input, textarea').addClass('form-control');
				};
			},
			controllerAs: '$ctrl'
		};
	})
	.component('fieldTextMinimal', getComponentConfig('text','minimal'))
	.component('fieldEmailMinimal', getComponentConfig('email','minimal'))
	.component('fieldPasswordMinimal', getComponentConfig('password','minimal'))
	.component('fieldTextareaMinimal', getComponentConfig('textarea','minimal'))
	.component('fieldSelectMinimal', getComponentConfig('select','minimal'))
	.component('fieldDateMinimal', getComponentConfig('date','minimal'));

	function getComponentConfig(type, theme) {
		return {
			require: {
				form: '^form'
			},
			bindings: {
				ngModel: '=',
				ngModelOptions: '<?',
				name: '@',
				ngRequired: '<?',
				ngDisabled: '<?',
				ngMaxlength: '<?',
				ngChange: '&?',
				label: '@?',
				class: '@?',
				rows: '@?',
				options: '<?',
				tooltip: '<?'
			},
			template: getTemplateFn(theme)(type),
			controller: function ($timeout) {
				'ngInject';
				var $ctrl = this;
				this.emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
				this.$onInit = function () {
				};
				this.$onChanges = function () {

				};
				this.$postLink = function () {
					$timeout(function () {
						// Передаем правила валидации (если они есть) в родительское поле
						if ($ctrl.subform && $ctrl.subform[$ctrl.name].$validators.password) {
							$ctrl.form[$ctrl.name].$validators.password = $ctrl.subform[$ctrl.name].$validators.password;
						}
						if ($ctrl.subform && $ctrl.subform[$ctrl.name].$validators.email) {
							$ctrl.form[$ctrl.name].$validators.email = $ctrl.subform[$ctrl.name].$validators.email;
						}
						if ($ctrl.subform && $ctrl.subform[$ctrl.name].$validators.pattern) {
							$ctrl.form[$ctrl.name].$validators.pattern = $ctrl.subform[$ctrl.name].$validators.pattern;
						}
						if ($ctrl.subform && $ctrl.subform[$ctrl.name].$validators.maxlength) {
							$ctrl.form[$ctrl.name].$validators.maxlength = $ctrl.subform[$ctrl.name].$validators.maxlength;
						}
						if ($ctrl.subform && $ctrl.subform[$ctrl.name].$validators.required) {
							$ctrl.form[$ctrl.name].$validators.required = $ctrl.subform[$ctrl.name].$validators.required;
						}
					}, 50);
				};
				this.showError = function () {
					return $ctrl.subform.$dirty || $ctrl.form[$ctrl.name].$dirty;
				};
				this.hasError = function () {
					return $ctrl.form[$ctrl.name].$invalid;
				};
				this.getError = function () {
					var field = $ctrl.form[$ctrl.name];
					if (field) {
						if (field.$error.maxlength) return 'field_maxlength_error';
						if (field.$error.required) return 'field_required_error';
						if (field.$error.email || field.$error.pattern && field.$validators.email) return 'email_format_error';
						if (Object.keys(field.$error).length>0) return Object.keys(field.$error)[0];
					}
					return null;
				};
				this.getTooltip = function () {
					if ($ctrl.tooltip) {
						return $ctrl.tooltip;
					}
					if ($ctrl.showError()) {
						return getFieldError($ctrl.form[$ctrl.name]);
					}
					return null;
				};
			}
		};
	}

	function getTemplateFn(theme) {
		switch (theme) {
			case 'minimal':
				return getTemplateMinimal;
			default:
				return getTemplateDefault;
		}
	}

	function getTemplateMinimal(type) {
		var tpl;
		switch (type) {
			case 'password':
				tpl = '<div class="form-group {{$ctrl.class}}" ng-class="{\'has-error\':$ctrl.hasError() && $ctrl.showError()}" uib-tooltip-html="$ctrl.getTooltip()|translate" ng-form="$ctrl.subform"><input name="{{$ctrl.name}}" type="password" class="form-control" ng-model="$ctrl.ngModel" ng-model-options="$ctrl.ngModelOptions" ng-required="$ctrl.ngRequired" ng-disabled="$ctrl.ngDisabled" ng-change="$ctrl.ngChange({value:$ctrl.ngModel})" placeholder="{{$ctrl.label}}" toggle-password autocomplete="off" password ng-model-options="{ allowInvalid: true }" ng-maxlength="$ctrl.ngMaxlength" /></div>';
				break;
			case 'email':
				tpl = '<div class="form-group {{$ctrl.class}}" ng-class="{\'has-error\':$ctrl.hasError() && $ctrl.showError()}" uib-tooltip-html="$ctrl.getTooltip()|translate" ng-form="$ctrl.subform"><input name="{{$ctrl.name}}" type="email" class="form-control" ng-model="$ctrl.ngModel" ng-model-options="$ctrl.ngModelOptions" ng-required="$ctrl.ngRequired" ng-disabled="$ctrl.ngDisabled" ng-change="$ctrl.ngChange({value:$ctrl.ngModel})" placeholder="{{$ctrl.label}}" ng-pattern="$ctrl.emailPattern" ng-model-options="{ allowInvalid: true }" /></div>';
				break;
			case 'textarea':
				tpl = '\
					<div class="form-group {{$ctrl.class}}" ng-class="{\'has-error\':$ctrl.hasError() && $ctrl.showError()}" uib-tooltip-html="$ctrl.getTooltip()|translate" ng-form="$ctrl.subform">\
						<textarea name="{{$ctrl.name}}" class="form-control" ng-model="$ctrl.ngModel" ng-model-options="$ctrl.ngModelOptions" ng-required="$ctrl.ngRequired" ng-disabled="$ctrl.ngDisabled" ng-change="$ctrl.ngChange({value:$ctrl.ngModel})" placeholder="{{$ctrl.label}}" rows="{{$ctrl.rows}}" ng-maxlength="$ctrl.ngMaxlength"></textarea>\
						<div ng-if="$ctrl.ngMaxlength" class="length">{{ $ctrl.ngMaxlength - parseInt($ctrl.ngModel.length) }}</div>\
					</div>\
				';
				break;
			case 'date':
				tpl = '<div class="form-group {{$ctrl.class}} form-group-icon-left" ng-class="{\'has-error\':$ctrl.hasError() && $ctrl.showError()}" uib-tooltip-html="$ctrl.getTooltip()|translate" ng-form="$ctrl.subform" moment-picker="$ctrl.ngModel"><i class="icon icon-gray icon-calendar"></i><input name="{{$ctrl.name}}" type="text" class="form-control" ng-model="$ctrl.ngModel" ng-model-options="$ctrl.ngModelOptions" ng-model-options="{ updateOn: \'change blur\' }" ng-required="$ctrl.ngRequired" ng-disabled="$ctrl.ngDisabled" ng-change="$ctrl.ngChange({value:$ctrl.ngModel})" placeholder="{{$ctrl.label}}" /></div>';
				break;
			case 'select':
				tpl = '\
					<div class="form-group {{$ctrl.class}}" ng-class="{\'has-error\':$ctrl.hasError() && $ctrl.showError()}" uib-tooltip-html="$ctrl.getTooltip()|translate" ng-form="$ctrl.subform">\
						<ui-select ng-model="$ctrl.ngModel" ng-model-options="$ctrl.ngModelOptions" name="{{$ctrl.name}}" ng-required="$ctrl.ngRequired" ng-disabled="$ctrl.ngDisabled" ng-change="$ctrl.ngChange({value:$ctrl.ngModel})" search-enabled="true">\
							<ui-select-match placeholder="{{$ctrl.label}}">{{$select.selected.text|translate}}</ui-select-match>\
							<ui-select-choices repeat="item.value as item in $ctrl.options|filter:{text:$select.search}">{{item.text|translate}}</ui-select-choices>\
						</ui-select>\
					</div>\
				';
				break;
			default:
				tpl = '\
					<div class="form-group {{$ctrl.class}}" ng-class="{\'has-error\':$ctrl.hasError() && $ctrl.showError()}" uib-tooltip-html="$ctrl.getTooltip()|translate" ng-form="$ctrl.subform">\
						<input name="{{$ctrl.name}}" type="text" class="form-control" ng-model="$ctrl.ngModel" ng-model-options="$ctrl.ngModelOptions" ng-required="$ctrl.ngRequired" ng-disabled="$ctrl.ngDisabled" ng-change="$ctrl.ngChange({value:$ctrl.ngModel})" placeholder="{{$ctrl.label}}" ng-maxlength="$ctrl.ngMaxlength" />\
						<div ng-if="$ctrl.ngMaxlength" class="length">{{ $ctrl.ngMaxlength - parseInt($ctrl.ngModel.length) }}</div>\
					</div>\
				';
		}
		return tpl;
	}

	function getTemplateDefault() {
		return 'TEMPLATE';
	}

	function getFieldError(field) {
		if (field) {
			if (field.$error.maxlength) return 'field_maxlength_error';
			if (field.$error.required) return 'field_required_error';
			if (field.$error.email || field.$error.pattern && field.$validators.email) return 'email_format_error';
			if (field.$error.email_busy) return 'email_busy_error';
			if (field.$error.password) return 'password_format_error';
			if (field.$error.url) return 'url_format_error';
			if (Object.keys(field.$error).length>0) return Object.keys(field.$error)[0];
		}
		return null;
	}

	function passwordValidator(modelValue, viewValue) {
		if (!modelValue) {
			return true;
		}
		return /^[^\s]{6,}$/.test(viewValue);
	}

})();

(function () {
    'use strict';

    angular.module('app')

    .component('fbFriends',{
        bindings: {

        },
        templateUrl: 'app/components/_partials/fbFriends/fbFriends.html',
        controller: Component
    });

    function Component($http, ProfileService, UserService, SprintService, $auth, $q, Storage) {
        'ngInject';
        var $ctrl = this;

        this.load = function (page) {
            page = page || 1;
            if (page == 1) {
                $ctrl.users = [];
            }
            $ctrl.loading = true;
            if (!$ctrl.ids || !$ctrl.ids.length) {
                $ctrl.users = [];
                $ctrl.pagination = false;
                $ctrl.loading = false;
                return;
            }
            return UserService.getAll({ page: page, fb_user_ids: $ctrl.ids && $ctrl.ids.join(','), 'per-page':5 }).then(function(res) {
                $ctrl.users = $ctrl.users.concat(res.data);
                $ctrl.pagination = res.pagination;
                $ctrl.loading = false;
            });
        };

        this.$onInit = function () {
            this.init();
        };

        this.init = function() {
            this.fbFriends().then(function(ids) {
                // console.log('ids',ids);
                // ids.push('10211650630162662');
                $ctrl.ids = ids;
                $ctrl.load();
            });
        };

        this.fbFriends = function() {
            var token = Storage.getItem('fb_token');
            // console.log('t',token);
            if (!token) {
                // Не подключен facebook
                return $q.reject();
            }
            return ProfileService.profileReady().then(function() {
                var userId = ProfileService.profileData.fb_user_id;
                // console.log('u', userId);

                $ctrl.fbConnected = (userId != null);
                if (!$ctrl.fbConnected) {
                    return $q.reject();
                }
                return $http.get('https://graph.facebook.com/v3.1/'+userId+'/permissions',{params:{access_token:token}}).then(function(res) {
                    // console.log('permissions',res);
                    if (!_.find(res.data.data, function (d) { return d.permission == 'user_friends' && d.status == 'granted'; })) {
                        return $q.reject();
                    }
                    return $http.get('https://graph.facebook.com/v3.1/'+userId+'/friends',{params:{access_token:token}}).then(function(res) {
                        // console.log('friends',res);
                        return res.data.data.map(function(u) {return u.id;});
                    });
                }).catch(function() {
                    $ctrl.fbConnected = false;
                    // $ctrl.fbConnect();
                });
            });
        };

        this.fbConnect = function() {
            // $ctrl.dataLoading = true;
            // console.log('connect');
            $auth.authenticate('facebook-connect').then(function(response) {
                // console.log('connect response', response);
                // Signed in
                // $ctrl.dataLoading = false;
                // $ctrl.errorMessage = false;
                if (!response.data.success) {
                    // $ctrl.errorMessage = true;
                } else {
                    if (response.data.oauth_access_token) {
                        Storage.setItem('fb_token',response.data.oauth_access_token);
                        ProfileService.saveProfile({ fb_user_id: response.data.fb_user_id });
                        $ctrl.init();
                    }
                }
                
              })
              .catch(function(response) {
                // console.log('connect err', response);
                // Something went wrong.
                // $ctrl.errorMessage = true;
                // $ctrl.dataLoading = false;
              });
        };

    }

})();

(function () {
	'use strict';
	angular.module('app')

	.component('flashMessage', {
		bindings: {
			type: '@',
			theme: '@?',
			cssClass: '@?',
			timeout: '<?',
			close: '<?',
			onHide: '&?'
		},
		transclude: true,
		template: '<div class="flash-message {{$ctrl.cssClass}} {{$ctrl.cssClassPrefix}}{{$ctrl.type}}" ng-if="$ctrl.show"><button type="button" class="close" ng-if="$ctrl.close" ng-click="$ctrl.hide()"><i class="icon-close"></i></button><div ng-transclude></div></div>',
		controller: function ($timeout) {
			'ngInject';
			var $ctrl = this;
			this.show = true;
			this.cssClassPrefix = 'text text-';
			this.$onInit = function () {
				if ($ctrl.theme) {
					$ctrl.cssClassPrefix = $ctrl.cssClassPrefix.replace(/text/g,$ctrl.theme);
				}
				if ($ctrl.timeout) {
					$timeout($ctrl.hide, $ctrl.timeout);
				}
			};
			this.hide = function () {
				$ctrl.show = false;
				if ($ctrl.onHide) {
					$timeout($ctrl.onHide, 500); // 0.5s задержка для анимации
				}
			};
		}
	})

	.component('flashMessages', {
		bindings: {
			position: '@',
		},
		template: '<div ng-repeat="message in $ctrl.messages[$ctrl.position]"><flash-message theme="alert" type="{{message.type}}" on-hide="$ctrl.onHide($index)" timeout="message.timeout" close="true">{{message.content|translate}}</flash-message></div>',
		controller: function (Flash) {
			'ngInject';
			this.messages = Flash.messages;
			this.onHide = function (index) {
				Flash.dismiss(this.position, index);
			};
		}
	});

})();

(function () {
    'use strict';

    angular.module('app')

    .component('favoriteButton',{
        bindings: {
            resource: '@',
            resourceId: '<'
        },
        templateUrl: 'app/components/_partials/favoriteButton/favoriteButton.html',
        controller: Component
    })
    .component('favoriteButtonSmall',{
        bindings: {
            resource: '@',
            resourceId: '<'
        },
        templateUrl: 'app/components/_partials/favoriteButton/favoriteButtonSmall.html',
        controller: Component
    })
    .component('favoriteButtonSmall2',{
        bindings: {
            resource: '@',
            resourceId: '<'
        },
        templateUrl: 'app/components/_partials/favoriteButton/favoriteButtonSmall2.html',
        controller: Component
    });

    function Component(FavoriteService, AuthService, $uibModal, $state) {
        'ngInject';
        var $ctrl = this;
        this.toggleFavorite = function () {
            if (!checkAuth()) {
                return false;
            }
            if (this.favorite) {
                FavoriteService.deleteFavorite(this.resource, this.resourceId);
            } else {
                FavoriteService.addFavorite(this.resource, this.resourceId);
            }
            this.favorite = !this.favorite;
        };
        this.$onInit = function() {
            FavoriteService.getFavorite(this.resource, this.resourceId).then(function(f) {
                $ctrl.favorite = f;
            });
        };

        function checkAuth() {
            if (!AuthService.isLoggedIn()) {
                $uibModal.open({
                    component: 'confirmAuthModal'
                }).result.then(function (res) {
                    if (res) {
                        $state.go('auth.login');
                    }
                });
                return false;
            }
            return true;
        }

    }

})();
(function () {
    'use strict';

    angular.module('app')

    .component('embedContent',{
        bindings: {
            url: '<',
            autoplay: '<'
        },
        templateUrl: 'app/components/_partials/embedContent/embedContent.html',
        controller: Component
    });

    function Component(EmbedService, config, $q, $element) {
        'ngInject';
        var $ctrl = this;
        
        this.$onInit = function () {
            this.service = EmbedService.getUrlService(this.url);
            this.code = EmbedService.getUrlCode(this.url);

            $q.when(EmbedService.getUrlData(this.url)).then(function(res) {
                $ctrl.data = res;
            });
            
        };

        this.$postLink = function () {
            setTimeout(function() {

                // Facebook SDK reload
                if (typeof FB != 'undefined') {
                    FB.XFBML.parse();
                }

                $element.find('iframe').on('load', function () {
                    $element.find('.loading').css({display:'none'}); 
                });
                
            }, 50);
        };

    }

})();
(function () {
    'use strict';

    angular.module('app')

    .component('courseRecommend',{
        bindings: {
            
        },
        templateUrl: 'app/components/_partials/courseRecommend/courseRecommend.html',
        controller: Component
    });

    function Component(CourseService) {
        'ngInject';
        var $ctrl = this;
        
        this.load = function (page) {
            page = page || 1;
            if (page == 1) {
                $ctrl.items = [];
            }
            $ctrl.loading = true;
            return CourseService.getRecommend({ page: page, 'per-page': 12 }).then(function(res) {
                if (!$ctrl.items.length && res.data.length > 0 && res.data[0].status != 'finished') {
                    $ctrl.show = true;
                }
                $ctrl.pagination = res.pagination;
                $ctrl.items = $ctrl.items.concat(res.data);
                $ctrl.loading = false;
            });
        };

        
        this.$onInit = function () {
            this.load();
        };

    }

})();
(function () {
    'use strict';

    angular.module('app')

    .component('courseProgram',{
        bindings: {
            materials: '<',
            trainings: '<'
        },
        templateUrl: 'app/components/_partials/courseProgram/courseProgram.html',
        controller: Component
    });

    function Component() {
        var $ctrl = this;
        this.$onInit = function () {
            this.materialTrainings = {};
            this.trainings.forEach(function (t) {
                if ($ctrl.materialTrainings[t.material_id]) {
                    $ctrl.materialTrainings[t.material_id].push(t);
                } else {
                    $ctrl.materialTrainings[t.material_id] = [t];
                }
            });
        };
    }

})();

(function () {
    'use strict';
    angular.module('app')

    .component('courseMaterialsForm',{
        bindings: {
            materials: '<?',
            trainings: '<?',
            onSubmitMaterials: '&',
            onDeleteTraining: '&'
        },
        templateUrl: 'app/components/_partials/courseMaterialsForm/courseMaterialsForm.html',
        controller: Component
    });

    function Component() {
        'ngInject';
        var $ctrl = this;

        this.$onInit = function () {
            this.materialTrainings = {};
            this.trainings.forEach(function (t) {
                if ($ctrl.materialTrainings[t.material_id]) {
                    $ctrl.materialTrainings[t.material_id].push(t);
                } else {
                    $ctrl.materialTrainings[t.material_id] = [t];
                }
            });
        };

        this.submit = function () {
            this.onSubmitMaterials({materials: this.materials});
        };

        this.dragOptions = {
            dropped: function () {
                setTimeout(function () {
                    $ctrl.submit();
                }, 100);
            }
        };

        this.delete = function (index) {
            this.materials.splice(index, 1);
            this.submit();
        };

        this.deleteTraining = function (trainingId) {
            this.onDeleteTraining({trainingId:trainingId});
        };

    }

})();

(function () {
    'use strict';

    angular.module('app')

    .component('courseList',{
        bindings: {
            items: '<',
            filter: '<?',
            ps: '<'
        },
        templateUrl: 'app/components/_partials/courseList/courseList.html',
        controller: Component
    })
    .component('courseListShort',{
        bindings: {
            items: '<',
            filter: '<?',
            ps: '<'
        },
        templateUrl: 'app/components/_partials/courseList/courseListShort.html',
        controller: Component
    });

    function Component($rootScope) {
        var $ctrl = this;
        var p1, p2, p3;
        this.$onInit = function () {
            // Обновление данных у уже найденных курсов (sticky state)
            p1 = $rootScope.$on('courseStatusChange', function (event, args) {
                var course = _.find($ctrl.items, function (m) { return m.id == args.id; });
                if (course) {
                    course.status = args.status;
                }
            });
            p2 = $rootScope.$on('courseOpen', function (event, args) {
                var course = _.find($ctrl.items, function (m) { return m.id == args.id; });
                if (course) {
                    course.views++;
                }
            });
            p3 = $rootScope.$on('likeChange', function (event, args) {
                if (args.resource == 'course') {
                    var course = _.find($ctrl.items, function (m) { return m.id == args.resourceId; });
                    if (course) {
                        course.likes = args.value;
                    }
                }
            });
        };

        this.$onDestroy = function () {
            p1();
            p2();
            p3();
        };
    }

})();

(function () {
    'use strict';
    angular.module('app')

    .component('courseDetailsForm',{
        bindings: {
            model: '<?',
            onImageDelete: '&',
            categories: '<',
            subjects: '<'
        },
        templateUrl: 'app/components/_partials/courseDetailsForm/courseDetailsForm.html',
        controller: Component
    });

    function Component(CourseService) {
        'ngInject';
        var $ctrl = this;

        this.data = {};

        this.$onInit = function () {
            // this.data = angular.copy(this.model);
            this.data = this.model;
        };

        this.imageUploaderConfig = CourseService.imageUploaderConfig;

        this.imageDelete = function () {
            if (!$ctrl.data.image_path) {
                $ctrl.data.image = null;
                return false;
            }
            $ctrl.onImageDelete && $ctrl.onImageDelete({path: $ctrl.data.image_path});
            $ctrl.data.image = null;
            $ctrl.data.image_path = null;
            $ctrl.data.image_base_url = null;
        };
        
        this.imageUploaded = function (fileObj) {
            if (fileObj.error) return false;
            $ctrl.data.image_path = fileObj.path;
            $ctrl.data.image_base_url = fileObj.base_url;
            $ctrl.data.image = fileObj.url;
        };

    }

})();

(function () {
    'use strict';

    angular.module('app')

    .component('courseBest',{
        bindings: {
            
        },
        templateUrl: 'app/components/_partials/courseBest/courseBest.html',
        controller: Component
    });

    function Component(CourseService) {
        'ngInject';
        var $ctrl = this;
        
        this.load = function (page) {
            page = page || 1;
            if (page == 1) {
                $ctrl.items = [];
            }
            $ctrl.loading = true;
            return CourseService.getBest({ page: page, 'per-page': 12 }).then(function(res) {
                $ctrl.pagination = res.pagination;
                $ctrl.items = $ctrl.items.concat(res.data);
                $ctrl.loading = false;
            });
        };

        
        this.$onInit = function () {
            this.load();
        };

    }

})();
(function () {
    'use strict';

    angular.module('app')

    .component('confirmAuthModal',{
        bindings: {
            resolve:'<',
            close:'&',
            dismiss:'&'
        },
        templateUrl: 'app/components/_partials/confirmAuthModal/confirmAuthModal.html',
        controller: Component
    });

    function Component() {
        'ngInject';
        
    }

})();

(function () {
    'use strict';

    angular.module('app')

    .component('bannerTop',{
        bindings: {
            position: '@'
        },
        templateUrl: 'app/components/_partials/bannerTop/bannerTop.html',
        controller: Component
    });

    function Component(BannerService, $interval, $uibModal) {
        'ngInject';
        var $ctrl = this,
            intervalPromise;
        
        this.$onInit = function () {
            BannerService.getAll({position:this.position}).then(function (res) {
                $ctrl.banners = res;
                if ($ctrl.banners.length > 1) {
                    intervalPromise = $interval(function () {
                        $ctrl.next();
                    }, 5000);
                }
            });
        };

        this.current = 0;
        this.next = function () {
            this.current = this.current < this.banners.length-1 ? this.current+1 : 0;
        };
        this.prev = function () {
            this.current = this.current > 0 ? this.current-1 : this.banners.length-1;
        };
        this.stop = function () {
            intervalPromise && $interval.cancel(intervalPromise);
        };

        this.playVideo = function (url) {
            $uibModal.open({
              template: '<div class="modal-header"><button type="button" class="close" ng-click="$dismiss()"><i class="icon-close"></i></button></div><embed-content url="$ctrl.url" autoplay="true"></embed-content>',
              controller: function() {
                this.url = url;
              },
              controllerAs: '$ctrl',
              size: 'lg',
              windowClass: 'modal-outer'
            });
        };

    }

})();
(function () {
	'use strict';

	angular.module('app')
	.component('banner', {
		transclude: true,
		template: '<div ng-if="!$ctrl.closed && !$ctrl.modal" ng-show="$ctrl.show"><button type="button" class="close" ng-if="$ctrl.closeButton" ng-click="$ctrl.close()"><i ng-class="$ctrl.closeIcon"></i></button><ng-transclude></ng-transclude></div>',
		controller: Component,
		bindings: {
			id: '@?',
			timeout: '<?',
			onClose: '&?',
			closeButton: '<?',
			modal: '<?',
			closeIconClass: '@?'
		}
	});

	function Component($timeout, $uibModal, Storage) {
		'ngInject';
		this.$onInit = function () {
			this.closeIcon = this.closeIconClass || 'icon-close';
			this.closed = this.id && !!Storage.getItem(this.id+'_closed');
			if (!this.timeout) {
				this.showBanner();
			} else {
				$timeout(function() {
					this.showBanner();
				}.bind(this), this.timeout);
			}
		};

		this.showBanner = function () {
			// if (this.modal) {
			if (this.modal && !this.closed) {
				var modalInstance = $uibModal.open(this.modal);
                modalInstance.result.then(function (res) {
                	this.close();
                    return res;
                }.bind(this),function (res) {
                    this.close();
                    return false;
                }.bind(this));
			} else {
				this.show = true;
			}
		};

		this.close = function() {
			this.id && Storage.setItem(this.id+'_closed',1);
			this.closed = true;
			this.show = false;
			this.onClose && this.onClose();
		};

		
	}

})();

(function () {'use strict';
	angular.module('audioButton',['com.2fdevs.videogular'])
	.component('audioButton', {
		bindings: {
			'srcSingle': '<?src',
			'srcList': '<?',
			'onReady': '&?',
			'onPlay': '&?',
			'onStop': '&?',
			'onComplete': '&?',
			'pauseOnStop': '<?',
			'vgapi': '=?'
		},
		templateUrl: 'app/components/_partials/audioButton/audioButton.html',
		controller: Component
	});

	function Component($scope, $timeout) {
		'ngInject';
		this.listIndex = 0;

		this.getSrc = function () {
			if (this.srcSingle) {
				return this.srcSingle;
			}
			if (this.srcList && this.srcList[this.listIndex]) {
				return this.srcList[this.listIndex];
			}
			return [];
		};

		this.play = function () {
            this.vgapi.isCompleted = false;
            this.vgapi.play();
            this.onPlay && this.onPlay({index:this.listIndex});
		};

		this.stop = function () {
			if (!this.pauseOnStop) {
                this.vgapi.stop();
			} else {
                this.vgapi.pause();
			}
            this.onStop && this.onStop({index:this.listIndex});
		};

		this.next = function () {
			if (this.srcList && this.srcList.length-1 > this.listIndex) {
                // Если это плейлист, то играем следующий источник
                this.listIndex++;
                this.src = this.srcList[this.listIndex];
                $timeout(this.play.bind(this), 100);
			} else {
				this.stop();
                this.listIndex = 0;
                this.src = this.srcList[this.listIndex];
			}
		};

		$scope.$watch(function () {
			return this.vgapi.isCompleted;
		}.bind(this), function (isCompleted) {
			if (isCompleted) {
                this.onComplete && this.onComplete({index:this.listIndex});
				this.next();
			}
		}.bind(this));

		$scope.$watch(function () {
			return this.srcSingle || this.srcList;
		}.bind(this), function () {
            this.src = this.getSrc();
		}.bind(this));

		this.$onInit = function () {
			this.src = this.getSrc();
		};
	}

})();

(function () {
    'use strict';

    angular.module('app')

    .component('addMaterialRequestModal',{
        bindings: {
            resolve:'<',
            close:'&',
            dismiss:'&'
        },
        templateUrl: 'app/components/_partials/addMaterialRequestModal/addMaterialRequestModal.html',
        controller: Component
    });

    function Component($http, config, Flash, translateFilter) {
        'ngInject';
        var $ctrl = this;

        this.dataLoading = false;
        
        this.$onInit = function() {
            
        };

        this.$postLink = function() {
            
        };

        this.submit = function() {
            this.sendRequest().finally(function() {
                $ctrl.close();
            });
        };

        this.sendRequest = function () {
            $ctrl.dataLoading = true;
            $ctrl.data.action = 'add_material';
            return $http.post(config.api + '/request', $ctrl.data).then(function (response) {
                if (response.data.success) {
                    Flash.success(translateFilter('request_is_sent'));
                }
            }).finally(function() {
                $ctrl.dataLoading = false;
            });
        };

    }

})();
(function () {
	'use strict';

	angular.module('app')
	.component('sprintIndex', {
		templateUrl: 'app/components/sprint/sprintIndex.html',
		controller: Component,
		bindings: {
			ps: '<'
		}
	});

	function Component(SprintService, ActivityService, UserService, $rootScope, $state) {
		'ngInject';
		var $ctrl = this;
		this.log = [];
		this.loadingLeader = true;
		this.loadingLog = true;

		SprintService.getSprintersOwn(true).then(function(res) {
			this.sprinters = res;

			var sprinter_ids = this.sprinters.map(function(s) {return s.sprinter_id;});
			sprinter_ids.push(this.ps.currentUser.id);

			this.load = function (page) {
				page = page || 1;
				ActivityService.getLog({ page: page, user_ids: sprinter_ids.join(','), glob: true, group_by_day: true, actions: [
					'read',
					'new_level',
					'upload',
					'start_video',
					'start_audio',
					'start_text',
					'sprint_add_user',
					'start_training_ayat_cards',
					'start_training_ayat_constructor',
					'start_training_ayat_listening',
					'start_training_ayat_speed',
					'start_training_ayat_translation',
					'start_training_missed_ayat',
					'start_training_next_ayat',
					'start_training_translation_ayat'
				].join(',') }).then(function (res) {
					this.log = this.log.concat(res.data);
					this.pagination = res.pagination;
					this.loadingLog = false;
				}.bind(this));
			};
			this.load();
			
		}.bind(this));

		SprintService.getLeader().then(function (userId) {
			UserService.getUser(userId).then(function (user) {
				$ctrl.leader = user;
				$ctrl.loadingLeader = false;
			}, function () {
				$ctrl.leader = null;
				$ctrl.loadingLeader = false;
			});
		});

		this.search = function (params) {
			$rootScope.searchParams = params;
			$state.go('sprint.friends.search');
		};
	}

})();

(function () {
	'use strict';

	angular.module('app')
	.component('sprintFriendsSearch', {
		templateUrl: 'app/components/sprint/sprintFriendsSearch.html',
		controller: Component,
		bindings: {
			hideClose: '<?'
		}
	});

	function Component($rootScope, ProfileService) {
		'ngInject';
		var $ctrl = this;
		this.params = $rootScope.searchParams; delete $rootScope['searchParams'];
		this.ps = ProfileService;
	}

})();

(function () {
	'use strict';

	angular.module('app')
	.component('sprintFriendsOwn', {
		templateUrl: 'app/components/sprint/sprintFriendsOwn.html',
		controller: Component
	});

	function Component(SprintService) {
		'ngInject';
		var $ctrl = this;
		this.load = function () {
			SprintService.getSprintersOwn(true).then(function(res) {
				$ctrl.sprinters = res;
				$ctrl.loading = false;
			});
		};
		this.removeSprinter = function (id) {
			SprintService.removeSprinter(id).then(function() {
				
			});
		};
		this.isRemoved = function (id) {
			return SprintService.sprintersOwnIds.indexOf(id)==-1;
		};
		this.$onInit = function () {
			this.loading = true;
			this.load();
		};
	}

})();

(function () {
	'use strict';

	angular.module('app')
	.component('sprintFriendsOuter', {
		templateUrl: 'app/components/sprint/sprintFriendsOuter.html',
		controller: Component
	});

	function Component(SprintService) {
		'ngInject';
		var $ctrl = this;
		this.load = function () {
			SprintService.getSprintersOuter(true).then(function(res) {
				$ctrl.sprinters = res;
				$ctrl.loading = false;
			});
		};
		$ctrl.add = function (id) {
			SprintService.addSprinter(id).then(function() {
				
			});
		};
		$ctrl.isAdded = function (id) {
			return SprintService.sprintersOwnIds.indexOf(id)!=-1;
		};
		this.$onInit = function () {
			this.loading = true;
			this.load();
		};
	}

})();

(function () {
	'use strict';

	angular.module('app')
	.component('friendsSearchForm', {
		templateUrl: 'app/components/sprint/friendsSearchForm.html',
		controller: Component,
		bindings: {
			onSubmit: '&',
			params: '<?'
		}
	});

	function Component(HelperService) {
		'ngInject';

		this.genderOptions = HelperService.gendersSelect(true);
		this.getGenderText = HelperService.getGenderText;
		
		this.submit = function () {
			this.onSubmit({
				params: this.params
			});
		};
        
	}

})();

(function () {
	'use strict';

	angular.module('user')

	.component('diagram', {
		templateUrl: 'app/components/user/diagram.html',
		controller: Component,
		bindings: {
			ps: '<'
		}
	});

	function Component(ActivityService, ProfileService, $q, moment, UserService, $stateParams) {
		'ngInject';
		var $ctrl = this;
		$ctrl.you = true;

		this.$onInit = function() {

		};

		this.$postLink = function () {
			if ($stateParams.id) {
				UserService.getUser($stateParams.id).then(function(data) {
					$ctrl.user = data;
					prepareData($ctrl.user).then(function(data) { initChart(data); });
				});
				$ctrl.you = ($ctrl.ps.currentUser.id == $stateParams.id);
			} else {
				$ctrl.user = $ctrl.ps.currentUser;
				$ctrl.you = true;
				prepareData($ctrl.user).then(function(data) { initChart(data); });
			}
			this.nextLevel = function() { return $ctrl.user && $ctrl.user.level+1; };
			this.nextLevelExp = function() { return ProfileService.getLevelExp(this.nextLevel()); };
			this.currentExp = function() { return $ctrl.user && $ctrl.user.points; };
		};

		function prepareData(user) {
			var from = moment.unix( Math.max(moment().subtract(3,'months').unix(), user.plan_at || user.created_at) ),
				pointsNow = user.points,
				pointsPlan = user.points_plan;

			 return ActivityService.getLog({ user_id: user.id, from: from.unix(), 'per-page': -1, group_by_day: true }).then(function (res) {
				var logs = res.data;

				// Реальные данные
				var realData = [], planData = [],
					pointsOld = pointsNow,
					accuracy = 5,
					pr = 0,
					step = Math.ceil(moment().diff(from,'days',true)/10), // Делим все доступное время на 10 шагов
					stepDuration = moment.duration(step,'days');

				logs.reverse();
				logs.forEach(function(l) {
					pointsOld -= parseInt(l.total_points);
				});

				var ms = moment(from), // clone
					pr = 0,
					pp = 0,
					i = 0;
				while (ms.isSameOrBefore(moment())) {
					realData.push({ x:ms.toDate(), y:pointsOld+pr });
					planData.push({ x:ms.toDate(), y:pointsOld+pp });
					ms.add(stepDuration);
					while (logs[i] && moment.unix(logs[i].created_at).isSameOrBefore(ms)) {
						pr += parseInt(logs[i].total_points);
						i++;
					}
					pp += step*pointsPlan;
				}
				realData.push({ x:moment().toDate(), y:pointsNow });
				planData.push({ x:moment().toDate(), y:pointsOld+Math.ceil(moment().diff(from,'days',true)*pointsPlan) });

				return {
					realData: realData,
					planData: planData
				};

			});
		}

		function initChart(data) {
			new Chartist.Line('.ct-chart', {
				series: [
					{
						name: 'plan',
						data: data.planData
					},
					{
						name: 'real',
						data: data.realData
					}
				]
			}, {
				axisX: {
					type: Chartist.FixedScaleAxis,
					divisor: data.realData.length-1,
					labelInterpolationFnc: function(value) {
						return moment(value).format(data.realData.length-1 > 5 ? 'D MMM' : 'D MMM HH:00');
					}
				},
				axisY: {
					// type: Chartist.FixedScaleAxis,
					// divisor: 6,
					// labelInterpolationFnc: function(value) {
					//   return Math.round(value);
					// }
				},
				// showPoint: false,
				height: 300,
				// width: 600,
				fullWidth: true,
				plugins: [
					Chartist.plugins.tooltip({
						tooltipFnc: function(name, value) {
							return value.split(',')[1];
						},
						// anchorToPoint: true,
						appendToBody: true
					})
				]
			});
		}
	}

})();

(function () {
	'use strict';

	angular.module('user')

	.component('activityLog', {
		templateUrl: 'app/components/user/activityLog.html',
		controller: Component,
		bindings: {
			ps: '<'
		}
	});

	function Component(ActivityService, $stateParams) {
		'ngInject';
		this.log = [];
		this.load = function (page) {
			page = page || 1;
			ActivityService.getLog({ page: page, user_id: $stateParams.id, group_by_day: true, actions: [
				'read',
				'new_level',
				'upload',
				'start_video',
				'start_audio',
				'start_text',
				'sprint_add_user',
				'start_training_ayat_cards',
				'start_training_ayat_constructor',
				'start_training_ayat_listening',
				'start_training_ayat_speed',
				'start_training_ayat_translation',
				'start_training_missed_ayat',
				'start_training_next_ayat',
				'start_training_translation_ayat',
				'start_course',
				'finish_course'
			].join(',') }, this.ps.timezone).then(function (res) {
				this.log = this.log.concat(res.data);
				this.pagination = res.pagination;
			}.bind(this));
		};
		this.$onInit = function () {
			this.load();
		};
	}

})();

(function () {
	'use strict';

	angular.module('user')

	.component('activity', {
		templateUrl: 'app/components/user/activity.html',
		controller: Component
	});

	function Component($stateParams, HistoryService, $location, $state) {
		'ngInject';
		this.id = $stateParams.id;

		this.close = function () {
            if (HistoryService.findReferer()) {
                $location.url(HistoryService.findReferer(null, 'user'));
            } else {
                $state.go('home');
            }
        };
	}

})();

(function () {
	'use strict';

	angular.module('settings', [])
	.component('settings', {
		templateUrl: 'app/components/settings/settings.html',
		controller: Component
	});

	function Component($state) {
		'ngInject';
		this.getTitle = function() {
			return $state.current.data.title;
		};
	}

})();

(function () {
	'use strict';

	angular.module('settings')
	.component('profileSettings', {
		templateUrl: 'app/components/settings/profile.html',
		controller: Component
	});

	function Component(ProfileService, HelperService, $http, config, $scope, Flash, $uibModal, $timeout, $element, $q) {
		'ngInject';
		var $ctrl = this;

		$ctrl.config = config;
		$ctrl.avatarUploaderConfig = ProfileService.getAvatarUploaderConfig();
		$ctrl.avatarLoading = false;
		$ctrl.dataLoading = false;
		$ctrl.gendersSelect = HelperService.gendersSelect();
		$ctrl.errors = {};
		ProfileService.getProfile().then(function (data) {
			$ctrl.data = data;
		});

		$ctrl.nameSuccess = false;
		$ctrl.namePattern = /^\S{3,25}$/;
		var timeoutPromise;
		$scope.$watch('$ctrl.data.name', function (name, oldName) {
			if (name && name.match(/\s/)) {
				$ctrl.data.name = name = name.replace(/\s/g,'_');
				setTimeout(function() {
					$scope.$digest();
				});
			}
			var hasError = name && !name.match($ctrl.namePattern);
			$scope.form['name'].$setValidity('wrong_nickname_format', !hasError);
			timeoutPromise && $timeout.cancel(timeoutPromise);
			$ctrl.nameSuccess = false;
			if (hasError) {
				$scope.form['name'].$setDirty(hasError);
			} else if (name && oldName) {
				timeoutPromise = $timeout(function() {
					$http.get(config.api + '/profile/check-name',{params:{name:name.trim()}}).then(function(res) {
						if (res && res.data && res.data.success) {
							$ctrl.nameSuccess = true;
						}
						$scope.form['name'].$setValidity('nickname_is_busy', $ctrl.nameSuccess);
						$scope.form['name'].$setDirty(!$ctrl.nameSuccess);
						
						delete $ctrl.errors['name'];
						$scope.form['name'].$setValidity('wrong_name', true);
					})
				}, 1000);
			}
		});

		$scope.$watch('$ctrl.errors', function () {
			angular.forEach($ctrl.errors, function (hasError, field) {
				var error = 'wrong_'+field;
				$scope.form[field].$setValidity(error, !hasError);
				if (hasError) {
					$scope.form[field].$setDirty(hasError);
				}
			});
		}, true);

		$ctrl.onSubmit = function (form) {
			if (form.$invalid) return false;
			$ctrl.dataLoading = true;
			ProfileService.saveProfile($ctrl.data).then(function () {
				$ctrl.data.old_password = $ctrl.data.new_password = '';
				Flash.create('success', 'data_saved', 3000);
				$ctrl.dataLoading = false;
			}, function (errors) {
				errors && errors.forEach(function (e) {
					$ctrl.errors[e.field] = true;
				});
				$ctrl.dataLoading = false;
			});
		};
		$ctrl.avatarDelete = function () {
			$ctrl.data.avatar = null;
			$ctrl.data.avatar_path = null;
			$ctrl.data.avatar_base_url = null;
			ProfileService.deleteAvatar();
		};
		$ctrl.avatarUploaded = function (fileObj) {
			if (fileObj.error) return false;
			$ctrl.data.avatar_path = fileObj.path;
			$ctrl.data.avatar_base_url = fileObj.base_url;
			$ctrl.data.avatar = fileObj.url;
			ProfileService.updateAvatar($ctrl.data.avatar_path, $ctrl.data.avatar_base_url);
		};
		this.timezoneModal = function() {
			$uibModal.open({
				component: 'timezoneModal',
				windowClass: 'fullscreen-mobile',
				resolve: {
                    selected: function() {
                        return $ctrl.data.timezone;
                    }
                }
			}).result.then(function (res) {
                // success
                $ctrl.data.timezone = res;
            }, function () {
                // dismiss
                
            });
		};
	}

})();

(function () {
	'use strict';

	angular.module('settings')
	.component('planSettings', {
		templateUrl: 'app/components/settings/plan.html',
		controller: Component
	});

	function Component(ProfileService, translateFilter, Flash, moment) {
		'ngInject';
		var $ctrl = this;
		this.data = ProfileService.profileData;

		this.save = function () {
			ProfileService.saveProfile({
				"points_plan": $ctrl.data.points_plan,
				"plan_at": moment().unix()
			}).then(function () {
				Flash.success(translateFilter('activity_plan_changed'));
			});
		};

		this.sliderOptions = {
			floor: 0,
			ceil: 200,
			showSelectionBar: true,
			hideLimitLabels: true,
			onEnd: function () {
				$ctrl.save();
			}
		};

		this.setPlan = function (plan) {
			if (plan != $ctrl.data.points_plan) {
				$ctrl.data.points_plan = plan;
				$ctrl.save();
			}
		};
	}

})();

(function () {
	'use strict';

	angular.module('settings')
	.component('notificationSettings', {
		templateUrl: 'app/components/settings/notification.html',
		controller: Component
	});

	function Component(ProfileService) {
		'ngInject';
		var $ctrl = this;
		this.data = ProfileService.profileData;
		this.save = function () {
			ProfileService.saveProfile({
				"email_notification": $ctrl.data.email_notification,
				"email_subscription": $ctrl.data.email_subscription
			});
		};
	}

})();

(function () {'use strict';

	angular.module('app')

	.component('page', {
		bindings: {
			page: '<'
		},
		template: '<div class="container container-page-responsive"><div class="page-header"><h1>{{$ctrl.page.title}}</h1></div><div ng-bind-html="$ctrl.page.body"></div></div>',
		controller: Component
	});


	function Component() {
		
	}

})();
(function () {
	'use strict';

	angular.module('app')
	.component('notifications', {
		templateUrl: 'app/components/notifications/notifications.html',
		controller: Component
	});

	function Component(NotificationService, ProfileService, moment) {
		'ngInject';
		this.notifications = [];
		this.nat = moment().unix();
		this.load = function (page) {
			page = page || 1;
			this.loading = true;
			NotificationService.get({ page: page }).then(function (res) {
				this.notifications = this.notifications.concat(res.data);
				this.pagination = res.pagination;
				this.loading = false;
				ProfileService.saveProfile({ notification_at: this.nat });
			}.bind(this));
		};
		this.date = function(d) {
			return moment.unix(d).format('ll');
		};
		this.isNew = function(created_at) {
			if (!ProfileService.profileData) return false;
			return created_at > ProfileService.profileData.notification_at;
		};
		this.$onInit = function () {
			this.load();
		};
		this.$onDestroy = function() {
			ProfileService.profileData.notification_at = this.nat;
			NotificationService.hasNew = false;
		};
	}

})();

(function () {
    'use strict';

    angular.module('muslimator',[]);

})();

(function () {
    'use strict';

    angular.module('muslimator')

    .component('muslimatorView',{
        bindings: {
            id: '<',
            material: '<',
            ps: '<',
            onClose: '&?',
            onFinish: '&?',
            onInProgress: '&?'
        },
        templateUrl: 'app/components/muslimator/view'+(isDesktop()?'.$desktop':'.$mobile')+'.html',
        controller: Component
    });

    function Component(MaterialService, AccessService, HistoryService, ActivityService, $state, $timeout, $location, Flash, translateFilter, config, AuthService, $uibModal) {
        'ngInject';
        var $ctrl = this;

        this.reportOptions = {
            variants: [
                { key: 'material_length', text: 'report_material_length' },
                { key: 'material_playback', text: 'report_material_playback' },
                { key: 'material_content', text: 'report_material_content' },
                { key: 'material_other', text: 'other' }
            ],
            inputLabel: 'description'
        };
        this.accessService = AccessService;
        // this.loading = true;

        this.delete = function () {
            if (!this.id) return false;
            MaterialService.delete(this.id).then(function() {
                $ctrl.onClose();
            });
        };

        this.finish = function () {
            if (!checkAuth()) {
                return false;
            }
            if ($ctrl.onFinish) {
                $ctrl.onFinish();
            }
            if ($ctrl.material.status == 'finished') {
                return false;
            } else if ($ctrl.material.status == null) {
                // Добавляем лог начала изучения материала, если он ранее не был начат
                ActivityService.addLogStartMaterial($ctrl.material.id, $ctrl.material.type);
            }
            var _s = $ctrl.material.status;
            $ctrl.material.status = 'finished'; // optimistic UI
            MaterialService.changeStatus(this.id, 'finished').then(function() {
                $ctrl.material.views++;
                ActivityService.addLogFinishMaterial($ctrl.material.id, $ctrl.material.type).then(function(res) {
                    if (res.points > 0) {
                        Flash.success('+'+translateFilter('points_number',{number: res.points}, 'messageformat'), 3000);
                        // $state.go('^.index');
                        $ctrl.recommend = true;
                    }
                });
            }, function() {
                $ctrl.material.status = _s;
            });
        };

        this.close = function () {
            if (this.onClose) {
                this.onClose();
            }
        };

        this.calcPoints = function () {
            if (this.material.type == 'video') {
                this.points = config.points.materialVideo * Math.ceil(parseInt(this.material.length) / 600);
            } else if (this.material.type == 'audio') {
                this.points = config.points.materialAudio * Math.ceil(parseInt(this.material.length) / 600);
            } else if (this.material.type == 'text') {
                this.points = config.points.materialText * parseInt(this.material.length);
            }
        };

        this.$onInit = function () {
            this.calcPoints();
            this.readPromise = $timeout(function() {
                if (!$ctrl.material.status && ['video','audio','text'].indexOf($ctrl.material.type) != -1) {
                    MaterialService.changeStatus($ctrl.id, 'in_progress').then(function() {
                        $ctrl.material.status = 'in_progress';
                        ActivityService.addLogStartMaterial($ctrl.material.id, $ctrl.material.type);
                    });
                    if ($ctrl.onInProgress) {
                        $ctrl.onInProgress();
                    }
                }
            }, 60000);
        };

        this.$onDestroy = function () {
            $timeout.cancel(this.readPromise);
        };

        function checkAuth() {
            if (!AuthService.isLoggedIn()) {
                $uibModal.open({
                    component: 'confirmAuthModal'
                }).result.then(function (res) {
                    if (res) {
                        $state.go('auth.login');
                    }
                });
                return false;
            }
            return true;
        }
    }

})();

(function () {
    'use strict';
    angular.module('muslimator')

    .component('muslimatorUpdate',{
        bindings: {
            id: '<',
            model: '<',
            ps: '<',
            onSubmit: '&?'
        },
        templateUrl: 'app/components/muslimator/update.html',
        controller: Component
    });

    function Component(MaterialService, $state, Flash) {
        'ngInject';
        var $ctrl = this;

        
        this.submit = function (data) {
            $ctrl.loading = true;
            MaterialService.update(this.id, data).then(function() {
                Flash.success('data_saved');
                $ctrl.onSubmit();
            }).finally(function() {
                $ctrl.loading = false;
            });
        };

        this.imageDelete = function () {
            MaterialService.update(this.id, {'image_path':'','image_base_url':''});
        };

        
    }

})();

(function () {
    'use strict';
    angular.module('muslimator')

    .component('muslimatorMy',{
        templateUrl: 'app/components/muslimator/my.html',
        controller: Component,
        bindings: {
            ps: '<'
        }
    });

    function Component(MaterialService) {
        'ngInject';
        var $ctrl = this;

        this.load = function (page) {
            page = page || 1;
            if (page == 1) {
                $ctrl.materials = [];
            }
            $ctrl.loading = true;
            MaterialService.getAll({my: 1, page: page}, true).then(function(res) {
                $ctrl.materials = $ctrl.materials.concat(res.data);
                $ctrl.pagination = res.pagination;
                $ctrl.loading = false;
            });
        };

        this.$onInit = function () {
            this.load();
        };
    }

})();

(function () {
    'use strict';

    angular.module('muslimator')

    .component('muslimatorIndex',{
        templateUrl: 'app/components/muslimator/index.html',
        controller: Component,
        bindings: {
            sources: '<',
            categories: '<',
            subjects: '<',
            ps: '<'
        }
    });

    function Component(MaterialService, $state, $stateParams, $scope) {
        'ngInject';
        var $ctrl = this;

        this.params = {
            'name[]': $stateParams.name && $stateParams.name.split(','),
            'title[]': $stateParams.title && $stateParams.title.split(','),
            'source_id[]': $stateParams.source && $stateParams.source.split(',').map(function (id) { return parseInt(id); }),
            'category_id[]': $stateParams.category && $stateParams.category.split(',').map(function (id) { return parseInt(id); }),
            'subject_id[]': $stateParams.subject && $stateParams.subject.split(',').map(function (id) { return parseInt(id); }),
            'type[]': $stateParams.type && $stateParams.type.split(','),
            sort_rating: $stateParams.sort_rating,
            not_finished: $stateParams.not_finished
        };

        $scope.$watch('$ctrl.params', function (params) {
            $ctrl.paramsCount = _.filter(params, function (p, k) { return k != 'name[]' && (_.isArray(p) && p.length > 0 || !_.isArray(p) && p); }).length;
            $ctrl.showSearchResults = $ctrl.paramsCount > 0;
            $state.go('.', {
                name: params['name[]'] && params['name[]'].join(','),
                title: params['title[]'] && params['title[]'].join(','),
                sort_rating: params.sort_rating, 
                not_finished: params.not_finished, 
                source: params['source_id[]'] && params['source_id[]'].join(','), 
                subject: params['subject_id[]'] && params['subject_id[]'].join(','), 
                category: params['category_id[]'] && params['category_id[]'].join(','), 
                type: params['type[]'] && params['type[]'].join(',')
            });
        }, true);

    }

})();

(function () {
    'use strict';

    angular.module('muslimator')

    .component('muslimatorInProgress',{
        templateUrl: 'app/components/muslimator/inProgress.html',
        controller: Component
    });

    function Component(MaterialService) {
        'ngInject';
        var $ctrl = this;
        this.params = {};

        this.load = function (page) {
            page = page || 1;
            if (page == 1) {
                $ctrl.materials = [];
            }
            $ctrl.loading = true;
            return MaterialService.getAll(angular.merge({ page: page, status: 'in_progress' }, this.params), true).then(function(res) {
                $ctrl.materials = $ctrl.materials.concat(res.data);
                $ctrl.pagination = res.pagination;
                $ctrl.loading = false;
            });
        };

        this.$onInit = function () {
            this.load();
        };
    }

})();

(function () {
    'use strict';

    angular.module('muslimator')

    .component('muslimatorFinished',{
        templateUrl: 'app/components/muslimator/finished.html',
        controller: Component
    });

    function Component(MaterialService) {
        'ngInject';
        var $ctrl = this;

        this.params = {};

        this.load = function (page) {
            page = page || 1;
            if (page == 1) {
                $ctrl.materials = [];
            }
            $ctrl.loading = true;
            return MaterialService.getAll(angular.merge({ page: page, status: 'finished' }, this.params), true).then(function(res) {
                $ctrl.materials = $ctrl.materials.concat(res.data);
                $ctrl.pagination = res.pagination;
                $ctrl.loading = false;
            });
        };

        this.$onInit = function () {
            this.load();
        };
    }

})();

(function () {
    'use strict';
    angular.module('muslimator')

    .component('muslimatorFavorite',{
        templateUrl: 'app/components/muslimator/favorite.html',
        controller: Component
    });

    function Component(ProjectService, MaterialService) {
        'ngInject';
        var $ctrl = this;
        $ctrl.projectService = ProjectService;
        $ctrl.tabsTemplate = 'app/views/favoriteTabs.html';

        this.load = function (page) {
            page = page || 1;
            if (page == 1) {
                $ctrl.materials = [];
            }
            $ctrl.loading = true;
            return MaterialService.getAll({page: page, favorite_join: 1}, true).then(function(res) {
                $ctrl.materials = $ctrl.materials.concat(res.data);
                $ctrl.pagination = res.pagination;
                $ctrl.loading = false;
            });
        };

        this.$onInit = function () {
            this.load();
        };
    }

})();

(function () {
    'use strict';
    angular.module('muslimator')

    .component('muslimatorAdd',{
        bindings: {
            onSubmit: '&?',
            onClose: '&?'
        },
        templateUrl: 'app/components/muslimator/add.html',
        controller: Component
    });

    function Component(MaterialService, AccessService, $state, Flash) {
        'ngInject';
        var $ctrl = this;

        this.submit = function (data) {
            $ctrl.loading = true;
            MaterialService.create(data).then(function(model) {
                Flash.success(AccessService.can('moderationOff') ? 'material_is_added' : 'material_is_sent_to_moderation');
                if ($ctrl.onSubmit) {
                    $ctrl.onSubmit({model:model});
                }
            }).finally(function() {
                $ctrl.loading = false;
            });
        };

        this.close = function () {
            this.onClose && this.onClose();
        };
        
    }

})();

(function () {
    'use strict';

    angular.module('courses',[]);

})();

(function () {
    'use strict';

    angular.module('courses')

    .component('coursesView',{
        bindings: {
            id: '<',
            course: '<',
            trainings: '<',
            materials: '<',
            finishedMaterialsCount: '<',
            ps: '<'
        },
        templateUrl: 'app/components/courses/view'+(isDesktop()?'.$desktop':'.$mobile')+'.html',
        controller: Component
    });

    function Component(CourseService, AccessService, HistoryService, ActivityService, $state, $timeout, $location, Flash, translateFilter, config, AuthService, $uibModal) {
        'ngInject';
        var $ctrl = this;

        this.reportOptions = {
            variants: [
                { key: 'material_length', text: 'report_material_length' },
                { key: 'material_playback', text: 'report_material_playback' },
                { key: 'material_content', text: 'report_material_content' },
                { key: 'material_other', text: 'other' }
            ],
            inputLabel: 'description'
        };
        this.accessService = AccessService;
        // this.loading = true;

        this.delete = function () {
            if (!this.id) return false;
            CourseService.delete(this.id).then(function() {
                $state.go('courses.my');
            });
        };

        this.fromSearchResults = $state.current.data.fromSearchResults;
        this.close = function () {
            var urlRef = HistoryService.findReferer(['courses'], ['courses/view','courses/update','courses/add']);
            if (urlRef) {
                $location.url(urlRef);
            } else {
                $state.go('courses.index');
            }
        };

        this.start = function () {
            if (!checkAuth()) {
                return false;
            }
            if (!$ctrl.course.status) {
                ActivityService.addLogStartCourse($ctrl.course.id);
            }
            var notFinishedTrainingMaterials = $ctrl.trainings.filter(function (t) {return t.status!='finished'}).map(function (t) {return t.material_id;});
            var notFinished = $ctrl.materials.filter(function (m) {return m.course_status!='finished' || notFinishedTrainingMaterials.indexOf(m.id) != -1;});
            if (notFinished.length > 0) {
                if (notFinished[0].course_status != 'finished') {
                    $state.go('^.view',{materialId: notFinished[0].id});
                } else {
                    $state.go('^.next',{materialId: notFinished[0].id});
                }
            }
        };

        this.$onInit = function () {
            
        };

        this.$onDestroy = function () {
            
        };

        function checkAuth() {
            if (!AuthService.isLoggedIn()) {
                $uibModal.open({
                    component: 'confirmAuthModal'
                }).result.then(function (res) {
                    if (res) {
                        $state.go('auth.login');
                    }
                });
                return false;
            }
            return true;
        }
    }

})();

(function () {
    'use strict';
    angular.module('courses')

    .component('coursesUpdateMaterials',{
        bindings: {
            id: '<',
            model: '<',
            materials: '<',
            trainings: '<',
            ps: '<'
        },
        templateUrl: 'app/components/courses/updateMaterials.html',
        controller: Component
    });

    function Component(CourseService, $state, Flash, AccessService, $scope) {
        'ngInject';
        var $ctrl = this;

        this.submit = function (materials) {
            this.loading = true;
            CourseService.updateMaterials(this.id, materials.map(function (m) { return m.id; })).then(function () {
                Flash.success('data_saved');
            }).finally(function() {
                $ctrl.loading = false;
            });
        };

        this.materialsValid = function () {
            return this.materials.length >= 4;
        };

        this.publish = function () {
            CourseService.update(this.id, { draft: 0 }).then(function () {
                Flash.success(AccessService.can('moderationOff') ? 'course_published' : 'course_is_sent_to_moderation');
                if ($ctrl.ps.currentUser.id == $ctrl.model.user_id) {
                    $state.go('courses.my');
                } else {
                    $state.go('courses.index');
                }
            }).finally(function() {
                $ctrl.loading = false;
            });
        };

        this.delete = function () {
            CourseService.delete(this.model.id).then(function () {
                if ($ctrl.ps.currentUser.id == $ctrl.model.user_id) {
                    $state.go('courses.my');
                } else {
                    $state.go('courses.index');
                }
            });
        };

        this.deleteTraining = function (trainingId) {
            CourseService.deleteTraining(trainingId).then(function () {
                // Для быстрого UI
                var i = _.findIndex($ctrl.trainings, function (t) { return t.id == trainingId; });
                $ctrl.trainings.splice(i, 1);
                $state.go('.',{},{reload:'courses.update.materials'});
            });
        };

        this.close = function () {
            $state.go('courses.view.program',{id: this.id});
        };
        
    }

})();

(function () {
    'use strict';
    angular.module('courses')

    .component('coursesUpdateDetails',{
        bindings: {
            id: '<',
            model: '<',
            subjects: '<',
            categories: '<',
            ps: '<'
        },
        templateUrl: 'app/components/courses/updateDetails.html',
        controller: Component
    });

    function Component(CourseService, $state, Flash) {
        'ngInject';
        var $ctrl = this;

        this.submit = function () {
            $ctrl.loading = true;
            CourseService.update(this.id, this.model).then(function() {
                Flash.success('data_saved');
            }).finally(function() {
                $ctrl.loading = false;
            });
        };

        this.imageDelete = function (path) {
            CourseService.deleteImage(path).then(function () {
                CourseService.update(this.id, {'image_path':'','image_base_url':''});
            });
        };

        this.delete = function () {
            CourseService.delete(this.id).then(function () {
                if ($ctrl.ps.currentUser.id == $ctrl.model.user_id) {
                    $state.go('courses.my');
                } else {
                    $state.go('courses.index');
                }
            });
        };

        this.close = function () {
            $state.go('courses.view.program',{id: this.id});
        };
        
    }

})();

(function () {
    'use strict';
    angular.module('courses')

    .component('coursesUpdate',{
        bindings: {
            id: '<'
        },
        templateUrl: 'app/components/courses/update.html',
        controller: Component
    });

    function Component(CourseService, $state) {
        'ngInject';
        var $ctrl = this;

        this.isNew = $state.current.data.isNew;
        this.close = function () {
            if (this.isNew) {
                $state.go('courses.my');
            } else {
                $state.go('courses.view.program',{id: this.id});
            }
        };
        
    }

})();

(function () {
    'use strict';

    angular.module('courses')

    .component('coursesTraining',{
        bindings: {
            'training': '<',
            'material': '<'
        },
        templateUrl: 'app/components/courses/training.html',
        controller: Component
    });

    function Component($uibModal, ActivityService, CourseService, Flash, translateFilter, $state, $stateParams) {
        'ngInject';
        
        var $ctrl = this;

        $ctrl.$onInit = function () {
            $ctrl.data = $ctrl.training.questions;
        };

        this.uiCanExit = function() {
            if (!this.result) {
                var modalInstance = $uibModal.open({
                    component: 'trainingConfirmModal'
                });
                return modalInstance.result;
            }
            return true;
        };

        this.onFinish = function(correct, wrong) {
            this.result = {
                correct: correct,
                wrong: wrong,
                points: calculatePoints(correct, wrong)
            };
            CourseService.changeTrainingStatus($ctrl.training.id, 'finished', correct);
            
            ActivityService.addLog({
                resource: 'course',
                resource_id: this.training.course_id,
                action: 'finish_training',
                category: 'training',
                points: correct
            }).then(function (res) {
                if (res.points > 0) {
                    Flash.create('success', '+'+translateFilter('points_number',{number: res.points}, 'messageformat'), 3000);
                }
            });
        };
        
        this.onResult = function(correct, wrong) {
            $state.go('^.next', {materialId: this.material.id, result: this.result}, {reload:true});
        };

        function calculatePoints(correct, wrong) {
            return correct;
        }

    }

})();

(function () {
    'use strict';
    angular.module('courses')

    .component('coursesSearchMaterial',{
        bindings: {
            onAddToCourse: '&',
            materials: '<',
            onClose: '&'
        },
        templateUrl: 'app/components/courses/searchMaterial.html',
        controller: Component
    });

    function Component() {
        'ngInject';
        this.params = {};
        this.close = function () {
            this.onClose && this.onClose();
        };
    }

})();

(function () {
    'use strict';
    angular.module('courses')

    .component('coursesQuestions',{
        bindings: {
            training: '<?',
            questions: '<?',
            material: '<?',
            onSubmit: '&',
            onDelete: '&',
            save: '<?'
        },
        templateUrl: 'app/components/courses/questions.html',
        controller: Component
    });

    function Component(CourseService, $state, $rootScope) {
        'ngInject';
        var $ctrl = this;

        this.data = [];

        this.$onInit = function () {
            this.data = angular.merge(this.questions || [], [{},{},{}]);
            this.data.splice(10);
        };
        
        this.$postLink = function () {
            setTimeout(function () {
                $rootScope.$broadcast('elastic:adjust');
            }, 50);
        };

        this.submit = function () {
            $ctrl.loading = true;
            $ctrl.onSubmit({questions: $ctrl.data});
        };

        this.delete = function () {
            $ctrl.onDelete();
        };

        this.imageUploaderConfig = CourseService.imageUploaderConfigTraining;

        this.imageDelete = function (i) {
            $ctrl.data[i].image = null;
            $ctrl.data[i].image_path = null;
            $ctrl.data[i].image_base_url = null;
        };
        
        this.imageUploaded = function (fileObj, i) {
            if (fileObj.error) return false;
            $ctrl.data[i].image_path = fileObj.path;
            $ctrl.data[i].image_base_url = fileObj.base_url;
            $ctrl.data[i].image = fileObj.url;
        };

        this.hasError = function () {
            return $ctrl.data.filter(function (d) { return d.answer === null || d.answer === undefined }).length > 0;
        };

    }

})();

(function () {
    'use strict';
    angular.module('courses')

    .component('coursesNext',{
        templateUrl: 'app/components/courses/next.html',
        controller: Component,
        bindings: {
            id: '<',
            trainingId: '<?',
            material: '<?',
            onClose: '&?'
        }
    });

    function Component(MaterialService, $state, $stateParams) {
        'ngInject';
        var $ctrl = this;

        this.load = function (page) {
            page = page || 1;
            if (page == 1) {
                $ctrl.materials = [];
            }
            $ctrl.loading = true;
            MaterialService.getCourseMaterials($ctrl.id, {page: page, 'per-page': 6, not_finished: 1}, true).then(function(res) {
                $ctrl.materials = $ctrl.materials.concat(res.data);
                $ctrl.pagination = res.pagination;
                $ctrl.loading = false;
            });
        };

        this.$onInit = function () {
            this.load();
            this.result = $stateParams.result;
        };

        this.close = function () {
            $state.go('^');
            this.onClose && this.onClose();
        };
    }

})();

(function () {
    'use strict';
    angular.module('courses')

    .component('coursesMy',{
        templateUrl: 'app/components/courses/my.html',
        controller: Component,
        bindings: {
            ps: '<'
        }
    });

    function Component(CourseService) {
        'ngInject';
        var $ctrl = this;

        this.load = function (page) {
            page = page || 1;
            if (page == 1) {
                $ctrl.courses = [];
            }
            $ctrl.loading = true;
            CourseService.getAll({my: 1, page: page}, true).then(function(res) {
                $ctrl.courses = $ctrl.courses.concat(res.data);
                $ctrl.pagination = res.pagination;
                $ctrl.loading = false;
            });
        };

        this.$onInit = function () {
            this.load();
        };
    }

})();

(function () {
    'use strict';

    angular.module('courses')

    .component('coursesIndex',{
        templateUrl: 'app/components/courses/index'+(isDesktop()?'.$desktop':'.$mobile')+'.html',
        controller: Component,
        bindings: {
            sources: '<',
            categories: '<',
            subjects: '<',
            ps: '<'
        }
    });

    function Component(CourseService, UserService, $rootScope, SubjectService, CategoryService, SourceService, $state, $stateParams, $scope, $http, $uibModal, $q) {
        'ngInject';
        var $ctrl = this, _searchQuery = $stateParams.title && $stateParams.title.replace(/,/g,' ') || '';

        this.searchOpen = false;
        this.searchResults = {};

        // Getter/setter
        this.searchQuery = function (q) {
            if (q !== undefined) {
                _searchQuery = q;
                this.applySearchQuery();
            } else {
                return _searchQuery;
            }
        };

        // Getter/setter
        this.searchQueryResults = function (q) {
            if (q !== undefined) {
                _searchQuery = q;
                this.searchResults = {};
                this.searchOpen = false;
                if (_searchQuery.length > 1) {
                    var p1 = CourseService.getAll(angular.merge({'per-page':5}, this.params, {'title[]': _searchQuery.split(' '), sort_likes: 1}), true).then(function(res) {
                        $ctrl.searchResults.courses = res.data;
                        $ctrl.searchResults.courses_count = res.pagination.totalCount;
                    });
                    var p2 = UserService.getAll(angular.merge({'per-page':4, exclude: $ctrl.ps.currentUser.id}, this.params, {'name[]': _searchQuery.split(' '), sort_points: 1}), true).then(function(res) {
                        $ctrl.searchResults.users = res.data;
                        $ctrl.searchResults.usersCount = res.pagination.totalCount;
                    });
                    $q.all([p1,p2]).then(function () {
                        $ctrl.searchOpen = true;
                    });
                }
            } else {
                return _searchQuery;
            }
        };

        this.applySearchQuery = function () {
            this.params['title[]'] = _searchQuery && _searchQuery.split(' ');
            this.params['name[]'] = _searchQuery && _searchQuery.split(' ');
            this.searchOpen = false;
        };
        this.searchQueryDelete = function (keyword) {
            _searchQuery = _searchQuery.split(' ').filter(function (s) { return s!=keyword; }).join(' ');
        };
        this.searchReset = function () {
            this.params = {};
            _searchQuery = '';
        };
        this.searchKeyUp = function (e) {
            if (e.keyCode == 13) {
                this.applySearchQuery();
            }
        };
        this.searchKeyDown = function (e) {
            var res, count, index;
            switch (e.keyCode) {
                case 38: // up arrow
                    e.preventDefault();
                    e.stopPropagation();
                    res = $('#courses-autocomplete-results');
                    count = res.find('a').length;
                    if (count > 0) {
                        index = res.find('a:focus').index('#courses-autocomplete-results a');
                        res.find('a').get(index > 0 ? index-1 : count-1).focus();
                    }
                    break;
                case 40: // down arrow
                    e.preventDefault();
                    e.stopPropagation();
                    res = $('#courses-autocomplete-results');
                    count = res.find('a').length;
                    if (count > 0) {
                        index = res.find('a:focus').index('#courses-autocomplete-results a');
                        res.find('a').get(index < count-1 ? index+1 : 0).focus();
                    }
                    break;
            }
        };
        this.searchClose = function (event) {
            if (event.target != $('#courses-autocomplete-input')[0] && !$(event.target).closest('.courses-autocomplete').length) {
                $ctrl.searchOpen = false;
                $scope.$digest();
            }
        };

        this.params = {
            'name[]': $stateParams.name && $stateParams.name.split(','),
            'title[]': $stateParams.title && $stateParams.title.split(','),
            'source_id[]': $stateParams.source && $stateParams.source.split(',').map(function (id) { return parseInt(id); }),
            'category_id[]': $stateParams.category && $stateParams.category.split(',').map(function (id) { return parseInt(id); }),
            'subject_id[]': $stateParams.subject && $stateParams.subject.split(',').map(function (id) { return parseInt(id); }),
            'type[]': $stateParams.type && $stateParams.type.split(','),
            sort_rating: $stateParams.sort_rating,
            not_finished: $stateParams.not_finished
        };

        this.unsetParam = function (param, value) {
            this.params[param] = _.filter(this.params[param], function (p) { return p != value; });
        };

        this.load = function (page) {
            $ctrl.paramsCount = _.filter(this.params, function (p, k) { return k != 'name[]' && (_.isArray(p) && p.length > 0 || !_.isArray(p) && p); }).length;
            $ctrl.showSearchResults = $ctrl.paramsCount > 0;
            page = page || 1;
            $ctrl.loading = true;
            return CourseService.getAll(angular.merge({ page: page, 'per-page': 12 }, this.params), true).then(function(res) {
                if (page == 1) {
                    $ctrl.courses = [];
                    $ctrl.pagination = {totalCount:0};
                }
                $ctrl.courses = $ctrl.courses.concat(res.data);
                $ctrl.pagination = res.pagination;
                $ctrl.loading = false;
            });
        };

        this.$onInit = function () {
            // this.load();
            $(document).on('keydown','#courses-autocomplete-input, #courses-autocomplete-results a',this.searchKeyDown);
            $(document).on('click',this.searchClose);
            this.sortRatingOptions = [
                {text: 'high_rating', value: 1},
                {text: 'low_rating', value: -1}
            ];
        };

        this.$onDestroy = function () {
            $(document).off('keydown','#courses-autocomplete-input, #courses-autocomplete-results a',this.searchKeyDown);
            $(document).off('click',this.searchClose);
        };

        $rootScope.$watch(function () { return $ctrl.params; }, function (params) {
            $ctrl.load();
            $ctrl.currentSubjects = _.filter($ctrl.subjects, function (s) { return params['subject_id[]'] && params['subject_id[]'].indexOf(s.value)!=-1; });
            $ctrl.currentSources = _.filter($ctrl.sources, function (s) { return params['source_id[]'] && params['source_id[]'].indexOf(s.value)!=-1; });
            $ctrl.currentCategories = _.filter($ctrl.categories, function (s) { return params['category_id[]'] && params['category_id[]'].indexOf(s.value)!=-1; });
            $ctrl.currentRating = _.find($ctrl.sortRatingOptions, function (s) { return params.sort_rating == s.value; });
            $state.go('.', {
                // name: params['name[]'] && params['name[]'].join(','),
                name: params['name[]'] && params['name[]'].join(','),
                title: params['title[]'] && params['title[]'].join(','),
                sort_rating: params.sort_rating, 
                not_finished: params.not_finished, 
                source: params['source_id[]'] && params['source_id[]'].join(','), 
                subject: params['subject_id[]'] && params['subject_id[]'].join(','), 
                category: params['category_id[]'] && params['category_id[]'].join(','), 
                type: params['type[]'] && params['type[]'].join(',')
            });
        }, true);

        this.openModalSearch = function() {
			var modalInstance = $uibModal.open({
				templateUrl: 'app/components/courses/_searchModal.html',
				controller: function() {
                    this.$parent = $ctrl;
                    this.active = 'format';
					this.submit = function() {
						modalInstance.close();
                    };
                    this.close = function() {
                        modalInstance.dismiss();
                    };
                    setTimeout(function () {
                        $('#search-modal-query').focus();
                    }, 500);
				},
				controllerAs: '$ctrl',
				windowClass: 'fullscreen-mobile'
            });
        };

    }

})();

(function () {
    'use strict';

    angular.module('courses')

    .component('coursesInProgress',{
        templateUrl: 'app/components/courses/inProgress.html',
        controller: Component
    });

    function Component(CourseService) {
        'ngInject';
        var $ctrl = this;
        this.params = {};

        this.load = function (page) {
            page = page || 1;
            if (page == 1) {
                $ctrl.courses = [];
            }
            $ctrl.loading = true;
            return CourseService.getAll(angular.merge({ page: page, status: 'in_progress' }, this.params), true).then(function(res) {
                $ctrl.courses = $ctrl.courses.concat(res.data);
                $ctrl.pagination = res.pagination;
                $ctrl.loading = false;
            });
        };

        this.$onInit = function () {
            this.load();
        };
    }

})();

(function () {
    'use strict';

    angular.module('courses')

    .component('coursesFinished',{
        templateUrl: 'app/components/courses/finished.html',
        controller: Component
    });

    function Component(CourseService) {
        'ngInject';
        var $ctrl = this;

        this.params = {};

        this.load = function (page) {
            page = page || 1;
            if (page == 1) {
                $ctrl.courses = [];
            }
            $ctrl.loading = true;
            return CourseService.getAll(angular.merge({ page: page, status: 'finished' }, this.params), true).then(function(res) {
                $ctrl.courses = $ctrl.courses.concat(res.data);
                $ctrl.pagination = res.pagination;
                $ctrl.loading = false;
            });
        };

        this.$onInit = function () {
            this.load();
        };
    }

})();

(function () {
    'use strict';
    angular.module('courses')

    .component('coursesFavorite',{
        templateUrl: 'app/components/courses/favorite.html',
        controller: Component
    });

    function Component(ProjectService, CourseService) {
        'ngInject';
        var $ctrl = this;
        $ctrl.projectService = ProjectService;
        $ctrl.tabsTemplate = 'app/views/favoriteTabs.html';

        this.load = function (page) {
            page = page || 1;
            if (page == 1) {
                $ctrl.courses = [];
            }
            $ctrl.loading = true;
            return CourseService.getAll({page: page, favorite_join: 1}, true).then(function(res) {
                $ctrl.courses = $ctrl.courses.concat(res.data);
                $ctrl.pagination = res.pagination;
                $ctrl.loading = false;
            });
        };

        this.$onInit = function () {
            this.load();
        };
    }

})();

(function () {
    'use strict';
    angular.module('courses')

    .component('coursesAdd',{
        bindings: {
            subjects: '<',
            categories: '<'
        },
        templateUrl: 'app/components/courses/add.html',
        controller: Component
    });

    function Component(CourseService, $state) {
        'ngInject';
        var $ctrl = this;

        this.model = {};

        this.submit = function () {
            $ctrl.loading = true;
            CourseService.create($ctrl.model).then(function(res) {
                $state.go('courses.update.materials',{id:res.id});
            }).finally(function() {
                $ctrl.loading = false;
            });
        };

        this.close = function () {
            $state.go('courses.my');
        };

        this.delete = function () {
            $state.go('courses.my');
        };
        
    }

})();

(function () {
    'use strict';

    angular.module('koran')

    .component('suraList',{
        bindings: {
            items: '<',
            filter: '<?'
        },
        templateUrl: 'app/components/koran/suraList.html',
        controller: SuraListComponent
    });

    function SuraListComponent(ActivityService, AuthService, moment, translateFilter) {
        'ngInject';
        this.authService = AuthService;
        var lastRead = {}, lastTraining = {};
        this.lastReadMoment = function (id) {
            if (!lastRead[id]) {
                return translateFilter('not_read');
            } else {
                return moment.unix(lastRead[id]).fromNow();
            }
        };
        this.lastTrainingMoment = function (id) {
            if (!lastTraining[id]) {
                return translateFilter('train_number_avail',{number:6},'messageformat');
            } else {
                return translateFilter('last_training')+' '+moment.unix(lastTraining[id]).fromNow();
            }
        };
        if (AuthService.isLoggedIn()) {
            ActivityService.getLog({
                resource: 'sura',
                category: 'read',
                'per-page': -1,
                group_last: true
            }).then(function (res) {
                if (angular.isArray(res.data)) {
                    res.data.forEach(function (v) {
                        lastRead[v.resource_id] = v.updated_at;
                    });
                }
            });
            ActivityService.getLog({
                resource: 'sura',
                category: 'training',
                'per-page': -1,
                group_last: true
            }).then(function (res) {
                if (angular.isArray(res.data)) {
                    res.data.forEach(function (v) {
                        lastTraining[v.resource_id] = v.updated_at;
                    });
                }
            });
            
        }
    }

})();

(function () {
    'use strict';

    angular.module('koran')

    .component('suraIndex',{
        bindings: {
            suraList: '<'
        },
        templateUrl: 'app/components/koran/suraIndex.html',
        controller: Component
    });

    function Component($timeout, HelpService, $document, $stateParams, ProfileService) {
        'ngInject';

        this.$onInit = function () {
            var scroll = $stateParams.scroll;
            if (scroll) {
                $timeout(function() {
                    $document.scrollToElementAnimated(angular.element('#sura-item-'+scroll), 1000);
                }, 100);
            }
            ProfileService.profileReady().then(function () {
                if (!ProfileService.hasState('demo_sura_list')) {
                    $timeout(HelpService.startGuide, 1000);
                    ProfileService.saveState('demo_sura_list', 1);
                }
            });
        };


        this.numbers = [
            {text:'1-20',number:1},
            {text:'21-40',number:21},
            {text:'41-60',number:41},
            {text:'61-80',number:61},
            {text:'81-100',number:81},
            {text:'101-114',number:101}
        ];

        this.scrollToNumber = function (n) {
            var $e = angular.element('.sura-item-'+n);
            $document.scrollToElementAnimated($e);
        };

    }

})();

(function () {
    'use strict';

    angular.module('koran')

    .component('sura', {
        bindings: {
            id: '<',
            sura: '<',
            ayatList: '<'
        },
        templateUrl: 'app/components/koran/sura.html',
        controller: Component
    });

    var readMode = false;

    function Component(config, AccessService, ActivityService, AuthService, Flash, translateFilter, $uibModal, $stateParams, $state, Storage, ProfileService, HelpService, $timeout) {
        'ngInject';
        var $ctrl = this;
        this.readMode = readMode;
        this.allPlayIndex = null;
        this.accessService = AccessService;
        this.reportOptions = {
            variants: [
                { key: 'ayat_arab', text: 'wrong_ayat_arab' },
                { key: 'ayat_audio', text: 'wrong_ayat_audio' },
                { key: 'ayat_translation', text: 'wrong_ayat_translation' }
            ],
            inputLabel: 'enter_ayat_number'
        };
        this.pageDoneRead = function () {
            if (!checkAuth()) {
                return false;
            }
            this.pageDoneReadLoading = true;
            ActivityService.addLogReadSura(this.sura.id).then(function (res) {
                $ctrl.pageDoneReadLoading = false;
                if (res.points > 0) {
                    Flash.create('success', '+'+translateFilter('points_number',{number: res.points}, 'messageformat'), 3000);
                }
                if (!$ctrl.nextPage()) {
                    Storage.removeItem('sura_state_'+$ctrl.sura.id);
                    $state.go('koran.index',{scroll:$ctrl.sura.id});
                }
            });
        };
        this.changeCurrentPage = function () {
            var page = this.selectorPage;
            if (pageIsValid(page)) {
                this.goToPage(page);
            }
        };
        this.nextPage = function () {
            var page = Math.min(this.sura.total_pages, this.currentPage + 1);
            if (page != this.currentPage) {
                this.goToPage(page);
                return page;
            }
            return false;
        };
        this.prevPage = function () {
            var page = Math.max(1, this.currentPage - 1);
            if (page != this.currentPage) {
                this.goToPage(page);
                return page;
            }
            return false;
        };
        this.goToPage = function (page) {
            $state.go('koran.view',{id: this.sura.id, page: page});
        };
        this.pageModal = function () {
            var modalInstance = $uibModal.open({
                component: 'pageSelectorModal',
                windowClass: 'fullscreen-mobile',
                resolve: {
                    total: function() {
                        return $ctrl.sura.total_pages;
                    }
                }
            });
            modalInstance.result.then(function (res) {
                // success
                $ctrl.goToPage(res);
            }, function () {
                // dismiss
                
            });
        };
        this.nextPageAvail = function () {
            return this.sura && this.sura.total_pages > 1 && this.currentPage < this.sura.total_pages;
        };
        this.prevPageAvail = function () {
            return this.sura && this.sura.total_pages > 1 && this.currentPage > 1;
        };
        this.showTitle = function () {
            return this.sura && this.sura.arab_title && this.currentPage==1;
        };
        this.fixAudioIndex = function (index) {
            // Смещаем индекс для правильной работы плейлиста
            return this.showTitle() ? index+1 : index;
        };
        this.getTitleAudio = function () {
            return config.storage+'/static/sura-title.mp3';
        };
        this.getPagePlayList = function () {
            if (!this.ayatListPage) return [];
            var pl = [];
            if (this.showTitle()) {
                // Если есть заголовок, то добавляем его аудио в плейлист
                pl.push([{src:this.getTitleAudio(),type:'audio/mpeg'}]);
            }
            pl = pl.concat(this.ayatListPage.map(function (a) {
                return [{src:a.audio_text_url,type:'audio/mpeg'}];
            }));
            return pl;
        };
        this.toggleReadMode = function (src, text) {
            if (!this.readMode || !this.readModeText && text || text && text != this.readModeText) {
                this.startReadMode(src, text);
            } else {
                this.readModeSrc = null;
                this.readModeText = null;
            }
        };
        this.startReadMode = function (src, text) {
            this.readMode = readMode = true;
            angular.element('body').addClass('body-read-mode');
            this.allPlayIndex = null;
            this.readModeSrc = src;
            this.readModeText = text;
        };
        this.stopReadMode = function () {
            this.readMode = readMode = false;
            angular.element('body').removeClass('body-read-mode');
            this.readModeSrc = null;
            this.readModeText = null;
        };

        this.$onInit = function () {
            var page = $stateParams.page;

            this.currentPage = parseInt(page) || 1;
            this.selectorPage = this.currentPage;

            if (!page && (page = Storage.getItem('sura_state_'+this.id))) {
                // Переходим на сохраненную страницу
                this.goToPage(page);
            }
            if (page && !pageIsValid(page)) {
                Storage.removeItem('sura_state_'+this.id);
                this.goToPage(1);
            }
            if (page) {
                // Сохраняем страницу
                Storage.setItem('sura_state_'+this.id, page);
            }

            this.ayatListPage = this.ayatList.filter(function (a) {
                return this.currentPage == a.page_number && a.visible;
            }.bind(this));
            this.pagePlayList = this.getPagePlayList();

            ProfileService.profileReady().then(function () {
                if (!ProfileService.hasState('demo_sura')) {
                    $timeout(HelpService.startGuide, 1000);
                    ProfileService.saveState('demo_sura', 1);
                }
            });

        };

        function pageIsValid(page) {
            if (page == 1) return true;
            if (!$ctrl.sura) {
                if (parseInt(page)>=1) {
                    return true;
                }
            } else {
                if (parseInt(page)>=1 && parseInt(page)<=$ctrl.sura.total_pages) {
                    return true;
                }
            }
            return false;
        }

        function checkAuth() {
            if (!AuthService.isLoggedIn()) {
                $uibModal.open({
                    component: 'confirmAuthModal'
                }).result.then(function (res) {
                    if (res) {
                        $state.go('auth.login');
                    }
                });
                return false;
            }
            return true;
        }
    }

})();

(function () {
    'use strict';

    angular.module('koran')

    .component('pageSelectorModal',{
        bindings: {
            resolve:'<',
            close:'&',
            dismiss:'&'
        },
        templateUrl: 'app/components/koran/pageSelectorModal.html',
        controller: Component
    });

    function Component() {
        'ngInject';
        this.$onInit = function() {
            
        };
        this.range = function() {
            return new Array(this.resolve.total);
        };
        this.select = function(page) {
            this.close({$value:page});
        };
    }

})();

(function () {
    'use strict';

    angular.module('koran')

    .component('koranLanding',{
        templateUrl: 'app/components/koran/landing.html',
        controller: Component
    });

    function Component($timeout, $document, $uibModal) {
        'ngInject';
        this.$onInit = function() {
            angular.element('body').addClass('bg-image');
        };
        this.$onDestroy = function() {
            angular.element('body').removeClass('bg-image');
            angular.element('body').removeClass('fp-responsive');
            $.fn.fullpage.destroy('all');
        };
        this.$postLink = function() {
            $('#koran-landing').fullpage({
                navigation: true,
                navigationPosition: 'right',
                scrollingSpeed: 1000,
                responsiveWidth: 1100,
                fitToSectionDelay: 10000000,
                autoScrolling: false,
                lockAnchors: true
            });
        };

        this.down = function() {
            $.fn.fullpage.moveSectionDown && $.fn.fullpage.moveSectionDown();
        };

        this.play = function() {
            $uibModal.open({
              template: '<div class="modal-header"><button type="button" class="close" ng-click="$dismiss()"><i class="icon-close"></i></button></div><embed-content url="\'koran_youtube_url\'|configService" autoplay="true"></embed-content>',
              controller: function() {

              },
              controllerAs: '$ctrl',
              size: 'lg',
              windowClass: 'modal-outer'
            });
        };
    }

})();

(function () {
    'use strict';
    angular.module('koran')

    .component('koranFavorite',{
        bindings: {
            suraList: '<'
        },
        templateUrl: 'app/components/koran/favorite.html',
        controller: Component
    });

    function Component(ProjectService) {
        this.projectService = ProjectService;
    }

})();

(function () {
    'use strict';

    angular.module('koran')

    .component('suraExtra', {
        bindings: {
            id: '<',
            sura: '<'
        },
        templateUrl: 'app/components/koran/extra.html',
        controller: Component
    });

    function Component(KoranService, MaterialService) {
        'ngInject';

        this.$onInit = function () {
            this.load();
        };

        this.load = function (page) {
            page = page || 1;
            if (page == 1) {
                this.materials = [];
            }
            this.loading = true;
            return MaterialService.getAll({sura_id:this.id, page: page}, true).then(function(res) {
                this.materials = this.materials.concat(res.data);
                this.pagination = res.pagination;
                this.loading = false;
            }.bind(this));
        };
    }

})();

(function () {
    'use strict';

    angular.module('app')

    .component('homeProjects',{
        templateUrl: 'app/components/home/projects.html',
        controller: Component
    });

    function Component(ProjectService, $uibModal, ConfigService) {
        'ngInject';
        var $ctrl = this;
        this.$onInit = function() {
            ConfigService.getItem('project_select_url').then(function (v) { $ctrl.project_select_url = v; });
            ConfigService.getItem('koran_youtube_url').then(function (v) { $ctrl.koran_youtube_url = v; });
            ConfigService.getItem('muslimator_youtube_url').then(function (v) { $ctrl.muslimator_youtube_url = v; });
            ConfigService.getItem('courses_youtube_url').then(function (v) { $ctrl.courses_youtube_url = v; });
        };
        this.play = function(url) {
            $uibModal.open({
              template: '<div class="modal-header"><button type="button" class="close" ng-click="$dismiss()"><i class="icon-close"></i></button></div><embed-content url="$ctrl.url" autoplay="true"></embed-content>',
              controller: function() {
                this.url = url;
              },
              controllerAs: '$ctrl',
              size: 'lg',
              windowClass: 'modal-outer'
            });
        };
    }

})();

(function () {
    'use strict';

    angular.module('app')

    .component('homeLanding',{
        templateUrl: 'app/components/home/landing.html',
        controller: Component
    });

    function Component(ConfigService, $uibModal) {
        'ngInject';
        var $ctrl = this;
        this.$onInit = function() {
            ConfigService.getStats().then(function (res) {
               $ctrl.stats = res; 
            });
            ConfigService.getItem('koran_youtube_url').then(function (v) { $ctrl.koran_youtube_url = v; });
            ConfigService.getItem('muslimator_youtube_url').then(function (v) { $ctrl.muslimator_youtube_url = v; });
            ConfigService.getItem('courses_youtube_url').then(function (v) { $ctrl.courses_youtube_url = v; });
        };
        this.$onDestroy = function() {
            $.fn.fullpage.destroy('all');
        };
        this.$postLink = function() {
            $('#fullpage').fullpage({
                navigation: false,
                scrollingSpeed: 1000,
                responsiveWidth: 1100,
                fitToSectionDelay: 10000000,
                autoScrolling: false,
                bigSectionsDestination: 'top',
                lockAnchors: true,
                onLeave: function(index, nextIndex, direction){
                    if (nextIndex == 7) {
                        setTimeout(function () {
                            $('#fullpage .habits').addClass('visible');
                        }, 1000);
                    }
                }            
            });
        };
        this.to = function(section) {
            $.fn.fullpage.moveTo && $.fn.fullpage.moveTo(section);
        };

        this.play = function(url) {
            $uibModal.open({
              template: '<div class="modal-header"><button type="button" class="close" ng-click="$dismiss()"><i class="icon-close"></i></button></div><embed-content url="$ctrl.url" autoplay="true"></embed-content>',
              controller: function() {
                this.url = url;
              },
              controllerAs: '$ctrl',
              size: 'lg',
              windowClass: 'modal-outer'
            });
        };
    }

})();

(function () {'use strict';

	angular.module('app')

	.component('contacts', {
		bindings: {
			page: '<'
		},
		templateUrl: 'app/components/contacts/contacts.html',
		controller: Component
	});

	function Component(config, $http, Flash) {
		'ngInject';
		var $ctrl = this;
		this.dataLoading = false;
		this.onSubmit = function (form) {
			$ctrl.dataLoading = true;
			$http.post(config.api + '/contact', $ctrl.data).then(function (response) {
				$ctrl.dataLoading = false;
				if (response.data.success) {
					$ctrl.data = {};
					form.$setPristine();
					Flash.create('success', 'your_message_is_sent', 3000);
				}
			}, function () {
				$ctrl.dataLoading = false;
			});
		};
	}

})();

(function () {'use strict';

	angular.module('app')

	.component('about', {
		bindings: {
			page: '<'
		},
		templateUrl: 'app/components/about/about.html',
		controller: Component
	});

	function Component() {
		this.$postLink = function() {
            setTimeout(function() {
                gapi.ytsubscribe.go('.g-ytsubscribe');
            },200);
        };
	}

})();
(function () {
	'use strict';

	angular.module('auth',[])

	.component('loginAdmin', {
		controller: function ($window, $stateParams, AuthService) {
			'ngInject';
			this.$onInit = function () {
				AuthService.setCredentials($stateParams.token);
				$window.location.href = '/';
			};
		}
	});

})();

(function () {
	'use strict';
	angular.module('auth')
	.component('registerActivation', {
		controller: function ($state, $stateParams, AuthService, $location, $timeout, Flash, translateFilter) {
			'ngInject';
			AuthService.registerActivate($stateParams.token).then(function (response) {
				if (response.success && response.access_token) {
					AuthService.setCredentials(response.access_token);
					Flash.create('success',translateFilter('registration_complete'),3000);
					$state.go('home');
				} else {
					Flash.create('danger',translateFilter('activation_error'),3000);
					$state.go('home');
				}
			});
		}
	})
	.component('register', {
		templateUrl: 'app/components/auth/register.html',
		controller: RegisterComponent,
		bindings: {
			onSuccess: '&?',
			onNavigate: '&?'
		}
	});


	function RegisterComponent(UserService, $location, Flash, $sce, AuthService, $scope, translateFilter, HistoryService, HelpService, grecaptcha, config) {
		'ngInject';
		var $ctrl = this;
		this.user = {};
		$ctrl.register = function () {
			$ctrl.dataLoading = true;
			$ctrl.errors = null;
			AuthService.register($ctrl.user)
				.then(function (response) {
					if (response.success) {
						if (typeof $ctrl.onSuccess == 'function') $ctrl.onSuccess();

						var path = HistoryService.findReferer(null, 'auth');
						$location.path(!/^\/\S+\/quran$/.test(path) && path || '/');

						if (response.access_token) {
							AuthService.setCredentials(response.access_token, !response.email_confirmed);
						}
						if (response.email_confirmed) {
							Flash.create('success', translateFilter('registration_complete'),3000);
						} else {
							Flash.create('success', translateFilter('activation_email_sent'),9000);
						}
						
						// Для того, чтобы показывался guide новому пользователю вместе с первым шагом
						HelpService.isNewUser = true; 

					} else {
						$ctrl.dataLoading = false;
						if (response.errors && response.errors.email) {
							$scope.form.email.$setValidity('wrong_email', false);
							$scope.form.email.$setDirty(true);
						} else if (response.errors && response.errors.ip_blocked) {
							Flash.create('danger', translateFilter('registration_ip_blocked'),9000);
						} else {
							$ctrl.errors = response.errors;
						}
					}
				});
		};
		$ctrl.close = function() {
			$location.path(HistoryService.findReferer(null, 'auth') || '/');
		};

		var rwId;
		$ctrl.onSubmit = function() {
			grecaptcha().execute(rwId);
		};
		$scope.$watch(function() {return !!grecaptcha();}, function(rcReady) {
			if (!rcReady) return;
			rwId = grecaptcha().render('recaptcha-register', {
				sitekey: config.recaptchaKey,
				size: 'invisible',
				callback: function (response) {
					$ctrl.user.recaptcha = response;
					$ctrl.register();
					grecaptcha().reset(rwId);
				}
			});
		});
	}

})();

(function () {
    'use strict';
    angular.module('auth')

    .component('recoverEmail', {
		templateUrl: 'app/components/auth/recoverEnterEmail.html',
		controller: RecoverEmailComponent,
		bindings: {
			onSuccess: '&?',
			onNavigate: '&?'
		}
	})

	.component('recoverPassword', {
		templateUrl: 'app/components/auth/recoverNewPassword.html',
		controller: RecoverPasswordComponent,
		bindings: {
			onSuccess: '&?',
			onNavigate: '&?'
		}
	});


    function RecoverEmailComponent($state, AuthService, $location, Flash, translateFilter, HistoryService, grecaptcha, $scope, config) {
		'ngInject';
		var $ctrl = this;
		this.data = {};
		this.errors = null;
		this.recover = function () {
			$ctrl.dataLoading = true;
			$ctrl.errors = {};
			AuthService.recover($ctrl.data).then(function (response) {
				$ctrl.dataLoading = false;
				if (response.success) {
					if (typeof $ctrl.onSuccess == 'function') $ctrl.onSuccess();
					$location.path(HistoryService.findReferer(null, 'auth') || '/');
					Flash.create('success',translateFilter('recover_email_sent'),3000);
				} else {
					$ctrl.errors = response.errors;
				}
			});
		};
		this.close = function() {
			$state.go('auth.login');
		};

		var rwId;
		this.onSubmit = function() {
			grecaptcha().execute(rwId);
		};
		$scope.$watch(function() {return !!grecaptcha();}, function(rcReady) {
			if (!rcReady) return;
			rwId = grecaptcha().render('recaptcha-recover', {
				sitekey: config.recaptchaKey,
				size: 'invisible',
				callback: function (response) {
					$ctrl.data.recaptcha = response;
					$ctrl.recover();
					grecaptcha().reset(rwId);
				}
			});
		});
	}

	function RecoverPasswordComponent($state, $stateParams, AuthService) {
		'ngInject';
		var $ctrl = this;
		this.token = $stateParams.token;
		this.errorMessage = false;
		this.onSubmit = function () {
			$ctrl.dataLoading = true;
			$ctrl.errorMessage = false;
			$ctrl.data.token = $ctrl.token;
			AuthService.newPassword($ctrl.data).then(function (response) {
				$ctrl.dataLoading = false;
				if (response.success) {
					if (typeof $ctrl.onSuccess == 'function') $ctrl.onSuccess();
					$state.go('auth.login');
				} else {
					$ctrl.errorMessage = true;
				}
			});
		};
		$ctrl.close = function() {
			$state.go('home');
		};
	}

})();

(function () {
    'use strict';
    angular.module('auth')
    .component('oauthConfirm', {
		templateUrl: 'app/components/auth/oauthConfirm.html',
		controller: Component
	});

    function Component($location, AuthService, HistoryService, Flash, translateFilter) {
		'ngInject';
		var $ctrl = this;
		if (!AuthService.oauthData.user_data) {
			$location.path(HistoryService.findReferer(null, 'auth') || '/');
			return;
		}
		$ctrl.oauthData = AuthService.oauthData;
		$ctrl.showEmailField = !$ctrl.oauthData.user_data.email;
		$ctrl.confirm = function() {
			$ctrl.dataLoading = true;
			$ctrl.errorMessage = false;
			AuthService.oauthRegister().then(function(response) {
				$ctrl.dataLoading = false;
				if (response.success) {
					var path = HistoryService.findReferer(null, 'auth');
					$location.path(!/^\/\S+\/quran$/.test(path) && path || '/');

					if (response.email_confirmed) {
						Flash.create('success', translateFilter('registration_complete'), 3000);
					} else {
						Flash.create('success', translateFilter('activation_email_sent'), 9000);
					}
				} else {
					$ctrl.errorMessage = true;
				}
			});
		};
		$ctrl.decline = function() {
			AuthService.oauthData = {};
			$location.path(HistoryService.findReferer(null, 'auth') || '/');
		};
		$ctrl.close = function() {
			$location.path(HistoryService.findReferer(null, 'auth') || '/');
		};
	}

})();

(function () {
    'use strict';
    angular.module('auth')
    .component('login', {
		templateUrl: 'app/components/auth/login.html',
		controller: LoginComponent,
		bindings: {
			onSuccess: '&?',
			onNavigate: '&?'
		}
	})
    .component('logout', {
		controller: function (AuthService, $location, $timeout, HistoryService) {
			'ngInject';
			AuthService.logout().then(function () {
				$timeout(function () {
                    $location.path(HistoryService.findReferer(null, 'auth') || '/');
				});
			});
		}
	});

    function LoginComponent($location, AuthService, HistoryService, Flash, translateFilter, grecaptcha, $scope, config) {
		'ngInject';
		var $ctrl = this;
		$ctrl.login = function () {
			$ctrl.dataLoading = true;
			$ctrl.errors = null;
			AuthService.login($ctrl.email, $ctrl.password, $ctrl.recaptcha, function (response) {
				$ctrl.dataLoading = false;
				if (response.success) {
					if (typeof $ctrl.onSuccess == 'function') $ctrl.onSuccess();

					var path = HistoryService.findReferer(null, 'auth');
					$location.path(!/^\/\S+\/quran$/.test(path) && path || '/');
					
				} else {
                    if (response.errors && response.errors.confirm) {
                        Flash.create('success',translateFilter('activation_email_sent'),3000);
                    } else {
                        $ctrl.errors = response.errors;
                    }
				}
			});
		};
		$ctrl.close = function() {
			$location.path(HistoryService.findReferer(null, 'auth') || '/');
		};

		var rwId;
		$ctrl.onSubmit = function() {
			grecaptcha().execute(rwId);
		};
		$scope.$watch(function() {return !!grecaptcha();}, function(rcReady) {
			if (!rcReady) return;
			rwId = grecaptcha().render('recaptcha-login', {
				sitekey: config.recaptchaKey,
				size: 'invisible',
				callback: function (response) {
					$ctrl.recaptcha = response;
					$ctrl.login();
					grecaptcha().reset(rwId);
				}
			});
		});
	}

})();

(function () {'use strict';

    angular.module("com.2fdevs.videogular.plugins.controls")
    .run(function ($templateCache) {
            'ngInject';
            $templateCache.put("vg-templates/vg-volume-bar-custom",
                '<div class="bar" ng-repeat="i in [1,2,3,4,5,6,7]" ng-class="{active:i/7<=API.volume}"></div>\
                <div class="volumeClickArea" ng-click="onClickVolume($event)" ng-mousedown="onMouseDownVolume()" ng-mouseup="onMouseUpVolume()" ng-mousemove="onMouseMoveVolume($event)" ng-mouseleave="onMouseLeaveVolume()"></div>');
    })
    .directive("vgVolumeBarCustom", function (VG_UTILS) {
        'ngInject';
        return {
            restrict: "E",
            require: "^videogular",
            templateUrl: function (elem, attrs) {
                return attrs.vgTemplate || 'vg-templates/vg-volume-bar-custom';
            },
            link: function (scope, elem, attr, API) {
                var isChangingVolume = false;
                var volumeBackElem = angular.element(elem[0].getElementsByClassName("volumeClickArea"));
                
                scope.API = API;

                scope.onClickVolume = function onClickVolume(event) {
                    event = VG_UTILS.fixEventOffset(event);
                    var volumeWidth = parseInt(volumeBackElem.prop("offsetWidth"));
                    var value = event.offsetX * 100 / volumeWidth;
                    var volValue = value / 100;
                    API.setVolume(volValue);
                };

                scope.onMouseDownVolume = function onMouseDownVolume() {
                    isChangingVolume = true;
                };

                scope.onMouseUpVolume = function onMouseUpVolume() {
                    isChangingVolume = false;
                };

                scope.onMouseLeaveVolume = function onMouseLeaveVolume() {
                    isChangingVolume = false;
                };

                scope.onMouseMoveVolume = function onMouseMoveVolume(event) {
                    if (isChangingVolume) {
                        event = VG_UTILS.fixEventOffset(event);
                        var volumeWidth = parseInt(volumeBackElem.prop("offsetWidth"));
                        var value = event.offsetX * 100 / volumeWidth;
                        var volValue = value / 100;
                        API.setVolume(volValue);
                    }
                };
            }
        }
    });

})();

(function () {'use strict';

	angular.module('tooltipError', ['pascalprecht.translate'])

	.directive('tooltipError', function ($compile, $timeout) {
		'ngInject';
		return {
			require: '^^form',
			restrict: 'A',
			transclude: true,
			scope: {
				name: '@tooltipError',
				show: '<tooltipErrorShow'
			},
			template: '<div uib-tooltip="{{text|translate}}" ng-transclude></div>',
			link: function (scope, element, attrs, ctrl) {
				scope.$watch(function () {
					return ctrl[scope.name].$error;
				}, function () {
					$timeout(function () {
						scope.text = element.hasClass('has-error') ? getText(ctrl[scope.name]) : '';
					});
					// scope.text = element.hasClass('has-error') ? getText(ctrl[scope.name]) : '';
				}, true);
			}
		};

	});

	function getText(field) {
		if (!field) return '';
		if (field.$error.required) return 'field_required_error';
		if (field.$error.email) return 'email_format_error';
		if (field.$error.wrong_old_password) return 'wrong_old_password';
		if (field.$error.wrong_email) return 'wrong_email';
		return '';
	}

})();

'use strict';

angular.module('togglePassword', [])

.directive('togglePassword', function ($compile) {
	'ngInject';
	return {
		restrict: 'A',
		scope: true,
		link: function (scope, element) {
			scope.passwordInputType = 'password';
			scope.togglePasswordInputType = function () {
				scope.passwordInputType = (scope.passwordInputType == 'password' ? 'text' : 'password');
			};
			element.wrap('<div class="form-group-icon-right"></div>');
			element.attr('type','{{passwordInputType}}');
			element.removeAttr('toggle-password');
			$compile(element)(scope);
			var button = $compile("<a ng-click=\"togglePasswordInputType()\" class=\"icon icon-eye\"></a>")(scope);
			element.after(button);
		}
	};
});

'use strict';

angular.module('loading', ['ngAnimate'])

// .directive('loadingOverlay', function () {
// 	return {
// 		restrict: 'A',
// 		bindToController: {
// 			'loadingOverlay': '<',
// 			'loadingClass': '@'
// 		},
// 		controller: ['$element',function ($element) {
// 			var c = this,
// 				overlay = angular.element('<span class="overlay loading"></span>');
//
// 			if (!this.loadingOverlay) overlay.addClass('hide');
// 			if (this.loadingClass) overlay.addClass(this.loadingClass);
// 			$element.addClass('has-overlay');
//
// 			this.$postLink = function () {
// 				$element.append(overlay);
// 			};
// 			this.$onChanges = function (changes) {
// 				if (changes.loadingOverlay) {
// 					if (changes.loadingOverlay.currentValue) {
// 						overlay.removeClass('hide');
// 					} else {
// 						overlay.addClass('hide');
// 					}
// 				}
// 			};
// 		}],
// 		controllerAs: 'c',
// 	};
// })

.directive('loadingOverlay', function ($animate) {
	'ngInject';
	return {
		restrict: 'A',
		scope: {
			'loadingOverlay': '<',
			'loadingHideContent': '<',
			'loadingClass': '@'
		},
		transclude: true,
		template: '<span class="overlay loading {{loadingClass}}" ng-show="loadingOverlay"></span><span ng-class="classObj" ng-transclude></span>',
		link: function (scope, element) {
			$animate.enabled(element, false);
			element.addClass('has-overlay');
			scope.classObj = {
				'loading-hide-content': scope.loadingHideContent
			};
			scope.$watch('loadingOverlay', function () {
				element.toggleClass('has-loading', Boolean(scope.loadingOverlay));
			});
		}
	};
})

.directive('loadingReplace', function ($animate) {
	'ngInject';
	return {
		restrict: 'A',
		scope: {
			'loadingReplace': '<',
			'loadingClass': '@'
		},
		transclude: true,
		template: '<span class="loading {{loadingClass}}" ng-show="loadingReplace"></span><span ng-show="!loadingReplace" ng-transclude></span>',
		link: function (scope, element) {
			$animate.enabled(element, false);
			scope.$watch('loadingReplace', function () {
				element.toggleClass('has-loading', Boolean(scope.loadingReplace));
			});
		}
	};
});

(function () {'use strict';
	angular.module('hover',[])
	.directive('hoverBehavior', function () {
        'ngInject';
		return {
			require: '^hoverTarget',
			restrict: 'A',
			link: function (scope, element, attrs, hoverTargetCtrl) {
				element.on('mouseenter',function () {
					hoverTargetCtrl.onMouseEnter();
				});
				element.on('mouseleave',function () {
					hoverTargetCtrl.onMouseLeave();
				});
			}
		};
	})
	.directive('hoverTarget', function () {
		'ngInject';
		return {
			restrict: 'A',
			controller: function ($element) {
				'ngInject';
				this.onMouseEnter = function () {
					$element.addClass('hover');
				};
				this.onMouseLeave = function () {
					$element.removeClass('hover');
				};
			}
		};
	});
})();

/* eslint no-unused-vars: 0 */
(function () {'use strict';

	angular.module('fileUploadButton', ['angularFileUpload'])

		.component('fileUploadButton', {
			bindings: {
				'uploaderConfig': '<',
				'btnClass': '@',
				'uploading': '=?',
				'onBeforeUpload': '&',
				'onComplete': '&',
				'onSuccess': '&',
				'onError': '&',
				'filters': '<',
				'imagesOnly': '<'
			},
			transclude: true,
			template: '<div class="file-upload-button">\
							<button class="btn {{$ctrl.btnClass}}" tabindex="-1" ng-transclude></button>\
							<input type="file" nv-file-select="" tabindex="-1" uploader="$ctrl.uploader" accept="{{$ctrl.accept}}" />\
						</div>',
			controller: Component
		});


	function Component(FileUploader, $element) {
		'ngInject';
		var $ctrl = this;

		this.$postLink = function () {
			$element.on('mouseover',function () {
				$element.addClass('btn-hover');
			});
			$element.on('mouseout',function () {
				$element.removeClass('btn-hover');
			});
		};

		this.$onInit = function () {
			this.uploading = false;
			if (this.imagesOnly) {
				this.accept = 'image/*';
			}

			$ctrl.uploader = new FileUploader($ctrl.uploaderConfig);
			if ($ctrl.imagesOnly) {
				$ctrl.uploader.filters.push({
					name: 'imageFilter',
					fn: function(item /*{File|FileLikeObject}*/, options) {
						var type = '|' + item.type.slice(item.type.lastIndexOf('/') + 1) + '|';
						return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
					}
				});
			}
			$ctrl.uploader.onWhenAddingFileFailed = function(item /*{File|FileLikeObject}*/, filter, options) {
				// console.info('onWhenAddingFileFailed', item, filter, options);
			};
			$ctrl.uploader.onAfterAddingFile = function(fileItem) {
				// console.info('onAfterAddingFile', fileItem);
			};
			$ctrl.uploader.onAfterAddingAll = function(addedFileItems) {
				// console.info('onAfterAddingAll', addedFileItems);
				$ctrl.uploader.uploadAll();
			};
			$ctrl.uploader.onBeforeUploadItem = function(item) {
				// console.info('onBeforeUploadItem', item);
				$ctrl.onBeforeUpload();
				$ctrl.uploading = true;
			};
			$ctrl.uploader.onProgressItem = function(fileItem, progress) {
				// console.info('onProgressItem', fileItem, progress);
			};
			$ctrl.uploader.onProgressAll = function(progress) {
				// console.info('onProgressAll', progress);
			};
			$ctrl.uploader.onSuccessItem = function(fileItem, response, status, headers) {
				// console.info('onSuccessItem', fileItem, response, status, headers);
				$ctrl.onSuccess({file: response.files[0]});
			};
			$ctrl.uploader.onErrorItem = function(fileItem, response, status, headers) {
				// console.info('onErrorItem', fileItem, response, status, headers);
			};
			$ctrl.uploader.onCancelItem = function(fileItem, response, status, headers) {
				// console.info('onCancelItem', fileItem, response, status, headers);
			};
			$ctrl.uploader.onCompleteItem = function(fileItem, response, status, headers) {
				// console.info('onCompleteItem', fileItem, response, status, headers);
			};
			$ctrl.uploader.onCompleteAll = function() {
				// console.info('onCompleteAll');
				$ctrl.onComplete();
				$ctrl.uploading = false;
			};
		};

	}

})();
'use strict';

angular.module('delete', [])

.directive('deleteOverlay', function () {
	return {
		restrict: 'A',
		bindToController: {
			'deleteOverlay': '<',
			'deleteAction': '&',
			'deleteIconAsButton': '<',
			'deleteIconClass': '@?'
		},
		controller: function ($element, $scope) {
			'ngInject';
			var c = this;
			this.$postLink = function () {

				$element.addClass('has-overlay');

				var overlay = angular.element('<span class="overlay delete-overlay"></span>'),
					iconClass = c.deleteIconClass || 'icon-close',
					icon = angular.element('<span class="delete-icon '+iconClass+'"></span>'),
					deleteButtonElement = c.deleteIconAsButton ? icon : overlay;

				deleteButtonElement.on('click',function () {
					c.deleteAction();
					$scope.$digest();
				}).addClass('delete-button');

				overlay.append(icon);
				$element.append(overlay);

				$element.on('mouseover',function () {
					if (c.deleteOverlay) overlay.addClass('show');
				}).on('mouseout',function () {
					overlay.removeClass('show');
				});

			};
		},
		controllerAs: 'c'
	};
});

'use strict';

angular.module('dateField', [])

.directive('dateField', function ($compile) {
	'ngInject';
	return {
		restrict: 'A',
		scope: true,
		link: function (scope, element) {
			scope.datepicker_isopen = false;
			scope.datepicker_open = function () {
				scope.datepicker_isopen = true;
			};
			element.removeAttr('date-field');
			element.attr('uib-datepicker-popup','dd.MM.yyyy');
			element.attr('is-open','datepicker_isopen');
			element.attr('show-button-bar','false');
			element.attr('ng-click','datepicker_open()');
			$compile(element)(scope);
		}
	};
});

(function () {'use strict';
	angular.module('audioPopover',[])
	.directive('audioPopover', function ($timeout, $sce, $document) {
        'ngInject';
		return {
			restrict: 'A',
			scope: {
				'src': '<audioPopover',
				'text': '<?audioText',
				'onPlay': '&?'
			},
			transclude: true,
			template: '<span ng-mousemove="onMouseMove($event)" ng-mouseenter="onMouseEnter($event)" ng-mouseleave="onMouseLeave()"><div class="popover" ng-if="isOpen" ng-style="style" ng-mouseenter="onMouseEnterPopover()" ng-mouseleave="onMouseLeavePopover()"><div class="popover-content" ng-include="template"></div></div><span ng-transclude></span></span>',
			link: function (scope, element) {
				var popoverWidth = 420, popoverOffsetX = -50, _lastX = 0;
				scope.template = 'app/directives/audioPopover.html';
                scope.isOpen = false;
				scope.style = {top:'auto',left:'auto'};
				scope.$ctrl = {};

                scope.onMouseEnter = function ($event) {
					if ($event && !scope.isOpen) {
						var x = $event.pageX - element.offsetParent().offset().left;
						x += popoverOffsetX;
						if ($event.pageX + popoverWidth > $document.width()) {
							x -= $event.pageX + popoverWidth + popoverOffsetX - $document.width();
						}
						scope.style.top = calcY(element, $event)+'px';
						scope.style.left = x+'px';
					}
					scope.isOpen = true;
					if (scope.timeoutPromise) {
						$timeout.cancel(scope.timeoutPromise);
					}
					_lastX = $event.pageX;
                };
                scope.onMouseLeave = function () {
                    scope.timeoutPromise = $timeout(function () {
                        scope.isOpen = false;
                    },50);
                };
                scope.onMouseMove = function ($event) {
                	if (scope.isOpen && !scope.popoverIsHover) {
                		var dx = $event.pageX - _lastX;
                		// var dx = $event.originalEvent.movementX;
                		scope.style.left = (parseInt(scope.style.left)+dx)+'px';
                		scope.style.top = calcY(element, $event)+'px';
                	}
                	_lastX = $event.pageX;
                };
                scope.onMouseEnterPopover = function() {
					scope.popoverIsHover = true;
                };
                scope.onMouseLeavePopover = function() {
                	scope.popoverIsHover = false;
                };
			}
		};
	});

	function calcY(element, $event) {
		var rowHeight = 108, rowMargin = 0, eventElementOffsetY = $event.pageY-element.offset().top;
		var y = element[0].offsetTop + (eventElementOffsetY/(rowHeight+rowMargin)^0) * (rowHeight+rowMargin) + rowHeight;
		return y;
	}

})();

(function () {'use strict';
	angular.module('audioPlayer',[])
	.directive('audioPlayer', function ($timeout, $sce, $document) {
        'ngInject';
		return {
			restrict: 'E',
			scope: {
				'src': '<',
				'text': '<?',
				'onPlay': '&?'
			},
			templateUrl: 'app/directives/audioPlayer.html',
			link: function (scope, element) {

				scope.$ctrl = {};

				scope.$watch('src',function (src) {
					scope.sound = {
						sources: [
							{
								src: $sce.trustAsResourceUrl(src),
								type: "audio/mpeg"
							}
						],
						theme: "bower_components/videogular-themes-default/videogular.css"
					};
					scope.$ctrl.vgapi && scope.$ctrl.vgapi.pause();
                });
				scope.$watch('$ctrl.vgapi.currentState',function (state) {
					if (state=='play') {
						scope.onPlay && scope.onPlay();
					}
                });
			}
		};
	});

})();

'use strict';

angular.module('app')

.config(function ($stateProvider) {
    $stateProvider.state({
        parent: 'root',
        name: 'user',
        url: '/user/{id}',
        redirectTo: 'user.log',
        component: 'activity'
    });
    $stateProvider.state({
        parent: 'root',
        name: 'my',
        url: '/my',
        component: 'activity',
        redirectTo: 'my.log',
        data: {
            requireAuth: true
        }
    });
    $stateProvider.state({
        name: 'my.log',
        url: '/log',
        component: 'activityLog',
        onEnter: function (seo) {
            seo.setTitle('activity_log',true);
        }
    });
    $stateProvider.state({
        name: 'user.log',
        url: '/log',
        component: 'activityLog',
        onEnter: function (seo) {
            seo.setTitle('activity_log',true);
        }
    });
    $stateProvider.state({
        name: 'my.diagram',
        url: '/diagram',
        component: 'diagram',
        onEnter: function (seo) {
            seo.setTitle('activity_diagram',true);
        }
    });
    $stateProvider.state({
        name: 'user.diagram',
        url: '/diagram',
        component: 'diagram',
        onEnter: function (seo) {
            seo.setTitle('activity_diagram',true);
        }
    });
});
'use strict';

angular.module('app')

.config(function ($stateProvider) {
    $stateProvider.state({
        parent: 'root',
        name: 'sprint',
        url: '/sprint',
        template: '<div class="container container-page-responsive"><ui-view></ui-view></div>',
        redirectTo: 'sprint.index',
        data: {
            requireAuth: true
        }
    });
    $stateProvider.state({
        name: 'sprint.index',
        url: '',
        component: 'sprintIndex',
        onEnter: function (seo) {
            seo.setTitle('sprint',true);
        }
    });
    $stateProvider.state({
        abstract: true,
        name: 'sprint.friends',
        url: '/friends',
        redirectTo: 'sprint.friends.own'
    });
    $stateProvider.state({
        name: 'sprint.friends.own',
        url: '/own',
        component: 'sprintFriendsOwn',
        onEnter: function (seo) {
            seo.setTitle('in_your_sprint',true);
        }
    });
    $stateProvider.state({
        name: 'sprint.friends.outer',
        url: '/outer',
        component: 'sprintFriendsOuter',
        onEnter: function (seo) {
            seo.setTitle('added_you_in_sprint',true);
        }
    });
    $stateProvider.state({
        name: 'sprint.friends.search',
        url: '/search',
        component: 'sprintFriendsSearch',
        onEnter: function (seo) {
            seo.setTitle('friends_search',true);
        }
    });
});
'use strict';

angular.module('app')

.config(function ($stateProvider) {
    $stateProvider.state({
        parent: 'root',
        name: 'settings',
        url: '/settings',
        component: 'settings',
        redirectTo: 'settings.profile',
        data: {
            requireAuth: true
        }
    });
    $stateProvider.state({
        name: 'settings.profile',
        url: '/profile',
        component: 'profileSettings',
        data: {
            title: 'settings'
        },
        onEnter: function (seo) {
            seo.setTitle('personal_settings',true);
        }
    });
    $stateProvider.state({
        name: 'settings.notifications',
        url: '/notifications',
        component: 'notificationSettings',
        data: {
            title: 'notifications'
        },
        onEnter: function (seo) {
            seo.setTitle('notifications',true);
        }
    });
    $stateProvider.state({
        name: 'settings.plan',
        url: '/plan',
        component: 'planSettings',
        data: {
            title: 'day_plan'
        },
        onEnter: function (seo) {
            seo.setTitle('day_plan',true);
        }
    });
});
'use strict';

angular.module('app')

.config(function ($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.when('', '/');
    $urlRouterProvider.otherwise('/');
    $stateProvider.state({
        abstract: true,
        name: 'root',
        url: '/{language:(?:ru|en)}',
        params: {
            language: null
        },
        onEnter: function ($state, $stateParams, $translate, LanguageService, $http, ProjectService, ConfigService) {
            if (!$stateParams.language || LanguageService.list.map(function(l){return l.code;}).indexOf($stateParams.language)==-1) {
                var lang = $translate.use() || $translate.preferredLanguage() || 'en';
                return $state.target('home', {language:lang});
            }
            $translate.use($stateParams.language);
            LanguageService.currentLanguage = $stateParams.language;
            $http.defaults.headers.common['Accept-Language'] = $stateParams.language;
            LanguageService.resolveLanguage();
            ProjectService.setCurrentProject(ProjectService.defaultProject.id);
            ConfigService.getAll();
        },
        resolve: {
            ps: function (ProfileService) {
                return ProfileService.profileReady().then(function () { return ProfileService; }, function () { return ProfileService; });
            }
        }
    });
});
'use strict';

angular.module('app')

.config(function ($stateProvider) {
    $stateProvider.state({
        parent: 'root',
        name: 'page',
        url: '/page/{key}',
        component: 'page',
        resolve: {
            page: function (PageService, $transition$) {
                return PageService.getPage($transition$.params().key);
            }
        },
        onEnter: function (seo, $transition$) {
            var title = $transition$.injector().get('page').title;
            seo.setTitle(title);
        }
    });
});
'use strict';

angular.module('app')

.config(function ($stateProvider) {
    $stateProvider.state({
        parent: 'root',
        name: 'notifications',
        url: '/notifications',
        template: '<div class="container container-page-responsive"><notifications></notifications></div>',
        onEnter: function (seo) {
            seo.setTitle('notifications',true);
        }
    });
});
'use strict';

angular.module('app')

.run(function ($transitions, seo, $document, langSuffixFilter) {
    $transitions.onSuccess({ to: 'muslimator.index' }, function (trans) {
        seo.setTitle('project_muslimator_long',true);
        seo.setDescription('project_muslimator_descr',true);
        seo.setImage(langSuffixFilter('https://shakird.com/assets/images/illustrations/IMG-5-1@2x.png'), 626, 460);
        setTimeout(function() {
            // Восстанавливаем скролл
            $document.scrollTop(trans.$to().data && trans.$to().data.scrollTop || 0);
        }, 50);
    });
    $transitions.onStart({ from: 'muslimator.index' }, function (trans) {
        // Сохраняем скролл
        trans.$from().data = trans.$from().data || {};
        trans.$from().data.scrollTop = $document.scrollTop();
    });
})

.config(function ($stateProvider) {
    $stateProvider.state({
        parent: 'root',
        abstract: true,
        name: 'muslimator',
        url: '/search',
        onEnter: function (ProjectService) {
            ProjectService.setCurrentProject('muslimator');
        },
        resolve: {
            subjects: function (SubjectService) {
                return SubjectService.getAll().then(function(res) {
                    return res.map(function(r) {return {text:r.title,value:r.id};});
                });
            },
            categories: function (CategoryService) {
                return CategoryService.getAll().then(function(res) {
                    return res.map(function(r) {return {text:r.title,value:r.id};});
                });
            },
            sources: function (SourceService) {
                return SourceService.getAll().then(function(res) {
                    return res.map(function(r) {return {text:r.title,value:r.id};});
                });
            }
        }
    });
    $stateProvider.state({
        name: 'muslimator.redirect',
        redirectTo: function () {
            return 'muslimator.index';
        }
    });
    $stateProvider.state({
        name: 'muslimator.index',
        url: '?title&name&source&category&subject&type&sort_rating&status&not_finished',
        sticky: true,
        views: {
            '!muslimator-index-sticky': 'muslimatorIndex'
        }
    });
    $stateProvider.state({
        name: 'muslimator.inProgress',
        url: '/in-progress',
        component: 'muslimatorInProgress',
        onEnter: function (seo) {
            seo.setTitle('materials_in_progress_title',true);
        },
        data: {
            requireAuth: true
        }
    });
    $stateProvider.state({
        name: 'muslimator.finished',
        url: '/finished',
        component: 'muslimatorFinished',
        onEnter: function (seo) {
            seo.setTitle('materials_finished_title',true);
        },
        data: {
            requireAuth: true
        }
    });
    $stateProvider.state({
        name: 'muslimator.my',
        url: '/my',
        component: 'muslimatorMy',
        onEnter: function (seo, AuthService, AccessService, $state) {
            if (!AccessService.can('addMaterial')) {
                return $state.target('muslimator.index');
            }
            seo.setTitle('materials_my_title',true);
        },
        data: {
            requireAuth: true
        }
    });
    $stateProvider.state({
        name: 'muslimator.add',
        url: '/add',
        component: 'muslimatorAdd',
        resolve: {
            onClose: function ($state) {
                return function () {
                    $state.go('^.my');
                };
            },
            onSubmit: function ($state) {
                return function () {
                    $state.go('^.my');
                };
            }
        },
        onEnter: function (seo, AuthService, AccessService, $state) {
            if (!AccessService.can('addMaterial')) {
                return $state.target('muslimator.index');
            }
            seo.setTitle('adding_material',true);
        },
        data: {
            requireAuth: true
        }
    });
    $stateProvider.state({
        name: 'muslimator.update',
        url: '/update/{id}',
        component: 'muslimatorUpdate',
        resolve: {
            id: function ($stateParams) {
                return $stateParams.id;
            },
            model: function ($stateParams, MaterialService, $q) {
                return MaterialService.getMaterial($stateParams.id, true).catch(function () {
                    return $q.resolve(null);
                });
            },
            onSubmit: function (HistoryService, $location, $state, id) {
                return function () {
                    var urlRef = HistoryService.findReferer(['search','extra','courses']);
                    if (urlRef) {
                        $location.url(urlRef);
                    } else {
                        $state.go('^.view', {materialId: id});
                    }
                };
            }
        },
        onEnter: function (seo, AuthService, AccessService, $state, model) {
            if (!model || !AccessService.can('editMaterial',model)) {
                return $state.target('muslimator.index');
            }
            seo.setTitle('updating_material',true);
        },
        data: {
            requireAuth: true
        }
    });
    $stateProvider.state({
        name: 'muslimator.view',
        url: '/view/{materialId}',
        component: 'muslimatorView',
        resolve: {
            id: function ($stateParams) {
                return $stateParams.materialId;
            },
            material: function ($stateParams, MaterialService, $q) {
                return MaterialService.getMaterial($stateParams.materialId, true).catch(function () {
                    return $q.resolve(null);
                });
            },
            onClose: function (HistoryService, $location, $state) {
                return function () {
                    var urlRef = HistoryService.findReferer(['search'], ['search/view','search/update']);
                    if (urlRef) {
                        $location.url(urlRef);
                    } else {
                        $state.go('^.index');
                    }
                };
            }
        },
        onEnter: function (material, seo, MaterialService, $rootScope, AuthService) {
            if (material) {
                seo.setTitle(material.title);
                seo.setDescription(material.descr);
                seo.setImage(material.image, material.image_width, material.image_height);
                if (AuthService.isLoggedIn()) {
                    MaterialService.viewCountIncrease(material.id).then(function () {
                        material.views++;
                        $rootScope.$emit('materialOpen',{id:material.id});
                    });
                }
            } else {
                seo.setTitle('material_not_found', true);
            }
        }
    });
    $stateProvider.state({
        name: 'muslimator.favorite',
        url: '/favorite',
        component: 'muslimatorFavorite',
        onEnter: function (seo) {
            seo.setTitle('materials_favorite',true);
        },
        data: {
            requireAuth: true
        }
    });
});
'use strict';

angular.module('app')

.run(function ($transitions, seo, $document, langSuffixFilter) {
    $transitions.onSuccess({ to: 'koran.index' }, function (trans) {
        seo.setTitle('project_koran_long',true);
        seo.setDescription('project_koran_descr',true);
        seo.setImage(langSuffixFilter('https://shakird.com/assets/images/illustrations/IMG-3-1@2x.png'), 626, 460);
        setTimeout(function() {
            // Восстанавливаем скролл
            $document.scrollTop(trans.$to().data && trans.$to().data.scrollTop || 0);
        }, 50);
    });
    $transitions.onStart({ from: 'koran.index' }, function (trans) {
        // Сохраняем скролл
        trans.$from().data = trans.$from().data || {};
        trans.$from().data.scrollTop = $document.scrollTop();
    });
})

.config(function ($stateProvider) {
    $stateProvider.state({
        parent: 'root',
        abstract: true,
        name: 'koran',
        url: '/quran',
        onEnter: function (ProjectService) {
            ProjectService.setCurrentProject('koran');
        }
    });
    $stateProvider.state({
        name: 'koran.landing',
        url: '',
        component: 'koranLanding',
        onEnter: function (seo) {
            seo.setTitle('project_koran',true);
        }
    });
    $stateProvider.state({
        name: 'koran.redirect',
        redirectTo: function (trans) {
            if (trans.injector().get('AuthService').isLoggedIn()) {
                return 'koran.index';
            }
            return 'koran.landing';
        }
    });

    $stateProvider.state({
        name: 'koran.index',
        url: '/sura?scroll',
        sticky: true,
        // component: 'suraIndex',
        views: {
            '!koran-index-sticky': 'suraIndex'
        },
        resolve: {
            suraList: function (KoranService) {
                return KoranService.getSuraList();
            }
        }
    });
    $stateProvider.state({
        name: 'koran.view',
        url: '/sura/{id}?page',
        component: 'sura',
        resolve: {
            id: function ($stateParams) {
                return $stateParams.id;
            },
            sura: function (KoranService, $stateParams) {
                return KoranService.getSura($stateParams.id);
            },
            ayatList: function (KoranService, $stateParams) {
                return KoranService.getAyats($stateParams.id);
            }
        },
        onEnter: function (sura, seo) {
            seo.setTitle('sura_name',true,{name:sura.name});
        }
    });
    $stateProvider.state({
        abstract: true,
        name: 'koran.extra',
        url: '/sura/{id}/extra'
    });
    $stateProvider.state({
        name: 'koran.extra.index',
        url: '',
        component: 'suraExtra',
        resolve: {
            id: function ($stateParams) {
                return $stateParams.id;
            },
            sura: function (KoranService, $stateParams) {
                return KoranService.getSura($stateParams.id);
            }
        },
        onEnter: function (sura, seo) {
            seo.setTitle('sura_name',true,{name:sura.name});
        }
    });
    $stateProvider.state({
        name: 'koran.extra.view',
        url: '/{materialId}',
        component: 'muslimatorView',
        resolve: {
            id: function ($stateParams) {
                return $stateParams.materialId;
            },
            material: function ($stateParams, MaterialService) {
                return MaterialService.getMaterial($stateParams.materialId, true);
            },
            onClose: function (HistoryService, $location, $state) {
                return function () {
                    var urlRef = HistoryService.findReferer(['extra']);
                    if (urlRef) {
                        $location.url(urlRef);
                    } else {
                        $state.go('^.index');
                    }
                };
            }
        },
        onEnter: function (material, seo, MaterialService, $rootScope, AuthService) {
            seo.setTitle(material.title);
            seo.setDescription(material.descr);
            seo.setImage(material.image, material.image_width, material.image_height);
            if (AuthService.isLoggedIn()) {
                MaterialService.viewCountIncrease(material.id).then(function () {
                    material.views++;
                    $rootScope.$emit('materialOpen',{id:material.id});
                });
            }
        }
    });
    $stateProvider.state({
        name: 'koran.favorite',
        url: '/favorite',
        component: 'koranFavorite',
        resolve: {
            suraList: function (KoranService) {
                return KoranService.getSuraFavoriteList();
            }
        },
        onEnter: function (seo) {
            seo.setTitle('koran_favorite',true);
        },
        data: {
            requireAuth: true
        }
    });

    $stateProvider.state({
        abstract: true,
        name: 'koran.training',
        url: '/sura/{id}/training',
        redirectTo: 'koran.training.index',
        resolve: {
            sura: function (KoranService, $stateParams) {
                return KoranService.getSura($stateParams.id);
            },
            openTraining: function ($uibModal, AuthService, $state) {
                return function(sura, training) {
                    if (!AuthService.isLoggedIn()) {
                        $uibModal.open({
                            component: 'confirmAuthModal'
                        }).result.then(function (res) {
                            if (res) {
                                $state.go('auth.login');
                            }
                        });
                        return false;
                    }
                    if (sura.ayats_count > 10) {
                        var modalInstance = $uibModal.open({
                            component: 'ayatSelectorModal',
                            windowClass: 'fullscreen-mobile',
                            resolve: {
                                id: function() {
                                    return sura.id;
                                }
                            }
                        });
                        modalInstance.result.then(function (res) {
                            // success
                            $state.go('koran.training.run.'+training, {id:sura.id,start:res.start,end:res.end}, {reload: true});
                        }, function () {
                            // dismiss
                            
                        });
                    } else {
                        $state.go('koran.training.run.'+training, {id:sura.id,start:1,end:sura.ayats_count}, {reload: true});
                    }
                };
            }
        }
    });
    $stateProvider.state({
        name: 'koran.training.index',
        url: '',
        component: 'koranTrainingIndex',
        onEnter: function (sura, seo) {
            seo.setTitle('training_sura_name',true,{name:sura.name});
        }
    });
    $stateProvider.state({
        abstract: true,
        name: 'koran.training.run',
        url: '/{start}/{end}',
        // component: 'koranTraining',
        resolve: {
            ayats: function (KoranService, $stateParams) {
                return KoranService.getAyats($stateParams.id).then(function (res) {
                    if (!$stateParams.start || !$stateParams.end) {
                        return res;
                    }
                    return res.slice($stateParams.start-1, $stateParams.end);
                });
            }
        },
        data: {
            requireAuth: true
        }
    });
    $stateProvider.state({
        name: 'koran.training.run.ayatTranslation',
        url: '/ayat-translation',
        component: 'koranTrainingAyatTranslation',
        onEnter: function (sura, seo) {
            seo.setTitle('training_ayat_translation_sura_name',true,{name:sura.name});
        }
    });
    $stateProvider.state({
        name: 'koran.training.run.translationAyat',
        url: '/translation-ayat',
        component: 'koranTrainingTranslationAyat',
        onEnter: function (sura, seo) {
            seo.setTitle('training_translation_ayat_sura_name',true,{name:sura.name});
        }
    });
    $stateProvider.state({
        name: 'koran.training.run.constructor',
        url: '/constructor',
        component: 'koranTrainingConstructor',
        onEnter: function (sura, seo) {
            seo.setTitle('training_ayat_constructor_sura_name',true,{name:sura.name});
        }
    });
    $stateProvider.state({
        name: 'koran.training.run.listening',
        url: '/listening',
        component: 'koranTrainingListening',
        onEnter: function (sura, seo) {
            seo.setTitle('training_ayat_listening_sura_name',true,{name:sura.name});
        }
    });
    $stateProvider.state({
        name: 'koran.training.run.speed',
        url: '/speed',
        component: 'koranTrainingSpeed',
        onEnter: function (sura, seo) {
            seo.setTitle('training_ayat_speed_sura_name',true,{name:sura.name});
        }
    });
    $stateProvider.state({
        name: 'koran.training.run.cards',
        url: '/cards',
        component: 'koranTrainingCards',
        onEnter: function (sura, seo) {
            seo.setTitle('training_ayat_cards_sura_name',true,{name:sura.name});
        }
    });
    $stateProvider.state({
        name: 'koran.training.run.nextAyat',
        url: '/next-ayat',
        component: 'koranTrainingNextAyat',
        onEnter: function (sura, seo) {
            seo.setTitle('training_next_ayat_sura_name',true,{name:sura.name});
        }
    });
    $stateProvider.state({
        name: 'koran.training.run.missedAyat',
        url: '/missed-ayat',
        component: 'koranTrainingMissedAyat',
        onEnter: function (sura, seo) {
            seo.setTitle('training_missed_ayat_sura_name',true,{name:sura.name});
        }
    });
});
'use strict';

angular.module('app')

.config(function ($stateProvider) {
    $stateProvider.state({
        parent: 'root',
        name: 'home',
        url: '',
        redirectTo: function (trans) {
            if (trans.injector().get('$stateParams').code) {
                return false;
            }
            var AuthService = trans.injector().get('AuthService');
            if (AuthService.isLoggedIn()) {
                return 'home.projects';
            } else {
                return 'home.landing';
            }
            // var ProjectService = trans.injector().get('ProjectService');
            // return ProjectService.currentProject && ProjectService.currentProject.link || ProjectService.defaultProject.link;
        }
    });
    $stateProvider.state({
        name: 'home.projects',
        component: 'homeProjects',
        onEnter: function (seo) {
            seo.setTitle('projects_welcome_title', true);
        }
    });
    $stateProvider.state({
        name: 'home.landing',
        component: 'homeLanding',
        data: {
            hideHeader: true
        }
    });
});
'use strict';

angular.module('app')

.run(function ($transitions, seo, $document, langSuffixFilter) {
    $transitions.onStart({ to: 'courses.view.**', from: function (s) { return s.name.indexOf('courses.view')==-1; } }, function (trans) {
        // Сохраняем, что мы пришли из поисковых результатов
        trans.$to().data.fromSearchResults = (trans.$from().name == 'courses.index');
    });
    $transitions.onStart({ to: 'courses.update.**', from: 'courses.add' }, function (trans) {
        // Сохраняем, что мы пришли из добавления курса
        trans.$to().data.isNew = true;
    });
    $transitions.onSuccess({ to: 'courses.index' }, function (trans) {
        seo.setTitle('project_courses_long',true);
        seo.setDescription('project_courses_descr',true);
        seo.setImage(langSuffixFilter('https://shakird.com/assets/images/illustrations/IMG-2-1@2x.png'), 626, 460);
        setTimeout(function() {
            // Восстанавливаем скролл
            $document.scrollTop(trans.$to().data && trans.$to().data.scrollTop || 0);
        }, 50);
    });
    $transitions.onStart({ from: 'courses.index' }, function (trans) {
        // Сохраняем скролл
        trans.$from().data = trans.$from().data || {};
        trans.$from().data.scrollTop = $document.scrollTop();
    });

    $transitions.onStart({ from: 'courses.update.materials.search', to: 'courses.update.materials.view' }, function (trans) {
        // Сохраняем скролл
        trans.$from().data = trans.$from().data || {};
        trans.$from().data.scrollTop2 = $document.scrollTop();
    });
    $transitions.onSuccess({ from: 'courses.update.materials.view', to: 'courses.update.materials.search' }, function (trans) {
        setTimeout(function() {
            // Восстанавливаем скролл
            $document.scrollTop(trans.$to().data && trans.$to().data.scrollTop2 || 0);
        }, 50);
    });
})

.config(function ($stateProvider) {
    $stateProvider.state({
        parent: 'root',
        abstract: true,
        name: 'courses',
        url: '/courses',
        onEnter: function (ProjectService) {
            ProjectService.setCurrentProject('courses');
        },
        resolve: {
            subjects: function (SubjectService) {
                return SubjectService.getAll().then(function(res) {
                    return res.map(function(r) {return {text:r.title,value:r.id};});
                });
            },
            categories: function (CategoryService) {
                return CategoryService.getAll().then(function(res) {
                    return res.map(function(r) {return {text:r.title,value:r.id};});
                });
            },
            sources: function (SourceService) {
                return SourceService.getAll().then(function(res) {
                    return res.map(function(r) {return {text:r.title,value:r.id};});
                });
            }
        }
    });
    $stateProvider.state({
        name: 'courses.redirect',
        redirectTo: function () {
            return 'courses.index';
        }
    });
    $stateProvider.state({
        name: 'courses.index',
        url: '?title&name&source&category&subject&type&sort_rating&status&not_finished',
        sticky: true,
        views: {
            '!courses-index-sticky': 'coursesIndex'
        },
        resolve: {
            
        }
    });
    $stateProvider.state({
        name: 'courses.inProgress',
        url: '/in-progress',
        component: 'coursesInProgress',
        onEnter: function (seo) {
            seo.setTitle('courses_in_progress_title',true);
        },
        data: {
            requireAuth: true
        }
    });
    $stateProvider.state({
        name: 'courses.finished',
        url: '/finished',
        component: 'coursesFinished',
        onEnter: function (seo) {
            seo.setTitle('courses_finished_title',true);
        },
        data: {
            requireAuth: true
        }
    });
    $stateProvider.state({
        name: 'courses.my',
        url: '/my',
        component: 'coursesMy',
        onEnter: function (seo, AuthService, AccessService, $state) {
            if (!AccessService.can('addMaterial')) {
                return $state.target('courses.index');
            }
            seo.setTitle('courses_my_title',true);
        },
        data: {
            requireAuth: true
        }
    });
    $stateProvider.state({
        name: 'courses.add',
        url: '/add',
        component: 'coursesAdd',
        onEnter: function (seo, AuthService, AccessService, $state) {
            if (!AccessService.can('addMaterial')) {
                return $state.target('courses.index');
            }
            seo.setTitle('adding_course',true);
        },
        data: {
            requireAuth: true
        }
    });
    $stateProvider.state({
        name: 'courses.update',
        url: '/update/{id}',
        component: 'coursesUpdate',
        data: {
            isNew: false,
            requireAuth: true
        },
        redirectTo: function () {
            return 'courses.update.details';
        },
        resolve: {
            id: function ($stateParams) {
                return $stateParams.id;
            },
            model: function ($stateParams, CourseService, $q) {
                return CourseService.getCourse($stateParams.id, true).catch(function () {
                    return $q.resolve(null);
                });
            },
            materials: function ($stateParams, MaterialService) {
                return MaterialService.getCourseMaterials($stateParams.id, {'per-page':-1}, true).then(function (res) { return res.data; });
            },
            trainings: function (CourseService, $stateParams) {
                return CourseService.getTrainings($stateParams.id, true);
            }
        },
        onEnter: function (seo, AuthService, AccessService, CourseService, $state, model) {
            if (!model || !AccessService.can('editCourse',model)) {
                return $state.target('courses.index');
            }
            seo.setTitle('updating_course',true);
        }
    });
    $stateProvider.state({
        name: 'courses.update.details',
        component: 'coursesUpdateDetails',
        resolve: {
            
        }
    });
    $stateProvider.state({
        name: 'courses.update.materials',
        component: 'coursesUpdateMaterials',
        resolve: {
            
        }
    });
    $stateProvider.state({
        name: 'courses.update.materials.new',
        url: '/new',
        views: {
            'page@courses.update': 'muslimatorAdd'
        },
        resolve: {
            onSubmit: function (CourseService, $state, materials, id) {
                return function (model) {
                    materials.push(model);
                    CourseService.updateMaterials(id, materials.map(function (m) { return m.id; })).then(function () {
                        $state.go('courses.update.materials');
                    });
                };
            },
            onClose: function ($state) {
                return function () {
                    $state.go('^');
                };
            }
        }
    });
    $stateProvider.state({
        name: 'courses.update.materials.search',
        url: '/search',
        sticky: true,
        views: {
            'sticky@courses.update': 'coursesSearchMaterial'
        },
        resolve: {
            onAddToCourse: function (CourseService, materials, id) {
                return function (model) {
                    materials.push(model);
                    CourseService.updateMaterials(id, materials.map(function (m) { return m.id; }));
                };
            },
            onClose: function ($state) {
                return function () {
                    $state.go('^');
                };
            }
        }
    });
    $stateProvider.state({
        name: 'courses.update.materials.view',
        url: '/material/{materialId}',
        views: {
            'page@courses.update': 'muslimatorView'
        },
        resolve: {
            id: function ($stateParams) {
                return $stateParams.materialId;
            },
            material: function ($stateParams, MaterialService) {
                return MaterialService.getMaterial($stateParams.materialId);
            },
            onClose: function ($state) {
                return function () {
                    $state.go('^.search');
                };
            }
        }
    });
    $stateProvider.state({
        name: 'courses.update.materials.training',
        url: '/training/{materialId}',
        resolve: {
            material: function ($stateParams, MaterialService) {
                return MaterialService.getMaterial($stateParams.materialId);
            }
        }
    });
    $stateProvider.state({
        name: 'courses.update.materials.training.new',
        url: '/new',
        views: {
            'page@courses.update': 'coursesQuestions'
        },
        resolve: {
            onSubmit: function ($state, id, $stateParams, CourseService) {
                return function (questions) {
                    var training = {
                        course_id: id,
                        material_id: $stateParams.materialId,
                        questions: questions
                    };
                    CourseService.createTraining(training).then(function () {
                        $state.go('^.^', {}, {reload:true});
                    });
                };
            },
            onDelete: function ($state) {
                return function () {
                    $state.go('^.^');
                };
            }
        }
    });
    $stateProvider.state({
        name: 'courses.update.materials.training.update',
        url: '/{trainingId}',
        views: {
            'page@courses.update': 'coursesQuestions'
        },
        resolve: {
            training: function ($stateParams, CourseService) {
                return CourseService.getTraining($stateParams.trainingId, true);
            },
            questions: function (training) {
                return training && training.questions;
            },
            onSubmit: function ($state, training, CourseService) {
                return function (questions) {
                    training.questions = questions;
                    CourseService.updateTraining(training.id, training).then(function () {
                        $state.go('^.^', {}, {reload:true});
                    });
                };
            },
            onDelete: function ($state, training, CourseService) {
                return function () {
                    CourseService.deleteTraining(training.id).then(function () {
                        $state.go('^.^', {}, {reload:true});
                    });
                };
            }
        }
    });
    $stateProvider.state({
        name: 'courses.view',
        url: '/view/{id}',
        data: {
            fromSearchResults: null
        },
        redirectTo: function () {
            return 'courses.view.program';
        },
        resolve: {
            id: function ($stateParams) {
                return $stateParams.id;
            },
            course: function ($stateParams, CourseService, $q) {
                return CourseService.getCourse($stateParams.id, true).catch(function () {
                    return $q.resolve(null);
                });
            },
            trainings: function (CourseService, $stateParams) {
                return CourseService.getTrainings($stateParams.id, true);
            }
        }
    });
    $stateProvider.state({
        name: 'courses.view.program',
        component: 'coursesView',
        resolve: {
            materials: function ($stateParams, MaterialService) {
                return MaterialService.getCourseMaterials($stateParams.id, {'per-page':-1}, true).then(function (res) { return res.data; });
            },
            finishedMaterialsCount: function (materials) {
                return materials.filter(function (m) {return m.course_status == 'finished';}).length;
            }
        },
        onEnter: function (course, seo, CourseService, $rootScope, AuthService) {
            if (course) {
                seo.setTitle(course.title);
                seo.setDescription(course.descr);
                seo.setImage(course.image, course.image_width, course.image_height);
                if (AuthService.isLoggedIn()) {
                    CourseService.viewCountIncrease(course.id).then(function () {
                        course.views++;
                        $rootScope.$emit('courseOpen',{id:course.id});
                    });
                }
            } else {
                seo.setTitle('course_not_found', true);
            }
        }
    });
    $stateProvider.state({
        name: 'courses.view.view',
        url: '/material/{materialId}',
        component: 'muslimatorView',
        resolve: {
            id: function ($stateParams) {
                return $stateParams.materialId;
            },
            material: function ($stateParams, MaterialService) {
                return MaterialService.getMaterial($stateParams.materialId, true);
            },
            onClose: function ($state) {
                return function () {
                    $state.go('^');
                };
            },
            onInProgress: function ($state, $stateParams, CourseService, course, ActivityService) {
                return function () {
                    CourseService.changeMaterialStatus($stateParams.id, $stateParams.materialId, 'in_progress').then(function () {
                        if (!course.status) {
                            ActivityService.addLogStartCourse(course.id);
                        }
                    });
                };
            },
            onFinish: function ($state, $stateParams, CourseService, course, ActivityService) {
                return function () {
                    CourseService.changeMaterialStatus($stateParams.id, $stateParams.materialId, 'finished').then(function () {
                        CourseService.getCourse($stateParams.id, true).then(function (_course) {
                            if (_course.status == 'finished' && _course.status != course.status) {
                                ActivityService.addLogFinishCourse(course.id);
                                $state.go('^.program', {}, {reload:true});
                            } else {
                                $state.go('^.next', {materialId: $stateParams.materialId}, {reload:true});
                            }
                        });
                    });
                };
            }
        },
        onEnter: function (material, seo, MaterialService, $rootScope, AuthService) {
            seo.setTitle(material.title);
            seo.setDescription(material.descr);
            seo.setImage(material.image, material.image_width, material.image_height);
            if (AuthService.isLoggedIn()) {
                MaterialService.viewCountIncrease(material.id).then(function () {
                    material.views++;
                    $rootScope.$emit('materialOpen',{id:material.id});
                });
            }
        }
    });
    $stateProvider.state({
        name: 'courses.view.next',
        url: '/next',
        params: {
            materialId: null,
            result: null
        },
        component: 'coursesNext',
        resolve: {
            id: function ($stateParams) {
                return $stateParams.id;
            },
            trainingId: function (trainings, $stateParams) {
                if (!$stateParams.materialId) {
                    return null;
                }
                var t = _.find(trainings, function (t) { return t.material_id == $stateParams.materialId});
                return t && t.id;
            },
            material: function ($stateParams, MaterialService) {
                return $stateParams.materialId && MaterialService.getMaterial($stateParams.materialId);
            }
        },
        onEnter: function (course, $state) {
            if (course.status == 'finished') {
                return $state.target('courses.view.program',{id:course.id},{reload:true});
            }
        },
        data: {
            requireAuth: true
        }
    });
    $stateProvider.state({
        name: 'courses.view.training',
        url: '/training/{trainingId}',
        component: 'coursesTraining',
        data: {
            requireAuthModal: true,
            requireAuth: true
        },
        resolve: {
            training: function (CourseService, $stateParams) {
                return CourseService.getTraining($stateParams.trainingId, true);
            },
            material: function (training, MaterialService) {
                return MaterialService.getMaterial(training.material_id);
            }
        },
        onEnter: function () {
            
        }
    });
    $stateProvider.state({
        name: 'courses.favorite',
        url: '/favorite',
        component: 'coursesFavorite',
        onEnter: function (seo) {
            seo.setTitle('courses_favorite',true);
        },
        data: {
            requireAuth: true
        }
    });
});
'use strict';

angular.module('app')

.config(function ($stateProvider) {
    $stateProvider.state({
        parent: 'root',
        name: 'contacts',
        url: '/contacts',
        component: 'contacts',
        resolve: {
            page: function (PageService) {
                return PageService.getPage('contacts');
            }
        },
        onEnter: function (seo) {
            seo.setTitle('contacts',true);
        }
    });
});
'use strict';

angular.module('app')

.config(function ($stateProvider) {

    $stateProvider.state({
        parent: 'root',
        abstract: true,
        name: 'auth',
        url: '/auth',
        redirectTo: 'auth.login'
    });
    $stateProvider.state({
        name: 'auth.login',
        url: '/login',
        component: 'login',
        onEnter: function (seo) {
            seo.setTitle('authorization',true);
        }
    });
    $stateProvider.state({
        name: 'auth.loginAdmin',
        url: '/login/{token}',
        component: 'loginAdmin'
    });
    $stateProvider.state({
        name: 'auth.register',
        url: '/register',
        component: 'register',
        onEnter: function (seo) {
            seo.setTitle('registration',true);
        }
    });
    $stateProvider.state({
        name: 'auth.registerActivation',
        url: '/register/{token}',
        component: 'registerActivation',
        onEnter: function (seo) {
            seo.setTitle('registration',true);
        }
    });
    $stateProvider.state({
        name: 'auth.recover',
        url: '/recover',
        component: 'recoverEmail',
        onEnter: function (seo) {
            seo.setTitle('forgot_password',true);
        }
    });
    $stateProvider.state({
        name: 'auth.recoverPassword',
        url: '/recover/{token}',
        component: 'recoverPassword',
        onEnter: function (seo) {
            seo.setTitle('change_password',true);
        }
    });
    $stateProvider.state({
        name: 'auth.logout',
        url: '/logout',
        component: 'logout'
    });
    $stateProvider.state({
        name: 'auth.oauthConfirm',
        url: '/oauth-confirm',
        component: 'oauthConfirm',
        onEnter: function (seo) {
            seo.setTitle('registration',true);
        }
    });

    $stateProvider.state({
        name: 'oauthRedirect', // root state
        url: '/oauth-redirect?provider&code',
        template: '<div class="text-center"><div class="loading"></div></div>',
        onEnter: function (config, $stateParams, $timeout, $http, oauthResponse, $location) {
            $timeout(function () {
                // Если всплывающее окно не закрылось (браузер facebook), то считаем его обычным окном, авторизуем и делаем редирект
                var provider = $stateParams.provider;
                var code = $stateParams.code;
                
                $http.post(config.api + '/auth/oauth?authclient=' + provider, {
                    code: code,
                    redirectUri: window.location.origin + '/oauth-redirect?provider=' + provider
                }).then(function (res) {
                    if (!res.data.success) {
                        $location.path('/');
                    }
                    oauthResponse.handler(res.data);
                });
                
            }, 1500);
        }
    });

});
'use strict';

angular.module('app')

.config(function ($stateProvider) {
    $stateProvider.state({
        parent: 'root',
        name: 'about',
        url: '/about',
        component: 'about',
        resolve: {
            page: function (PageService) {
                return PageService.getPage('about');
            }
        },
        onEnter: function (seo) {
            seo.setTitle('about_us',true);
        }
    });
});
(function () {
    'use strict';

    angular
        .module('userService', [])
        .factory('UserService', UserService);

    function UserService($http, config, $httpParamSerializer, $q) {
        'ngInject';

        return {
            getAll: getAll,
            getUser: getUser,
            getCurrentUser: getCurrentUser
        };

        function getAll(params, actual, timezone) {
            params = params || {};
            // params['per-page'] = 20;
            if (timezone) {
                params.timezone = timezone;
            }
            return $http.get(config.api + '/user', {params: params, cache:!actual}).then(handleGetSuccess, handleError('Error getting all users')).then(function (res) {
                var users = [];
                if (res && angular.isArray(res.data)) {
                    res.data.forEach(function (r) {
                        users.push(new User(r));
                    });
                }
                return {
                    pagination: res.pagination,
                    data: users
                };
            });
        }

        function getUser(id, actual, timezone) {
            if (!id) {
                return $q.reject();
            }
            var params = {};
            if (timezone) {
                params.timezone = timezone;
            }
            return $http.get(config.api + '/user/' + id, {params:params, cache:!actual}).then(function (res) {
                return new User(res.data);
            });
        }

        function getCurrentUser(actual) {
            return $http.get(config.api + '/user/current', {cache:!actual}).then(function (res) {
                return new User(res.data);
            });
        }

        // private functions

        function handleGetSuccess(res) {
            return {
                pagination: {
                    pageCount: parseInt(res.headers('X-Pagination-Page-Count')),
                    currentPage: parseInt(res.headers('X-Pagination-Current-Page')),
                    perPage: parseInt(res.headers('X-Pagination-Per-Page')),
                    totalCount: parseInt(res.headers('X-Pagination-Total-Count'))
                },
                data: res.data
            };
        }

        function handleError(error) {
            return function () {
                return $q.reject(error);
            };
        }
    }

    // entities

    function User(data) {
        this.id = data.id;
        this.level = data.level;
        this.points = data.points;
        this.points_plan = data.points_plan;
        this.today_points = data.today_points;
        this.plan_at = data.plan_at;
        this.created_at = data.created_at;
        angular.merge(this, data.profile);
    }
    Object.defineProperty(User.prototype, 'age', {
        get: function () {
            var _injector = angular.element(document).injector(),
                config = _injector.get('config'),
                moment = _injector.get('moment');
            var roundingDefault = moment.relativeTimeRounding();
            moment.relativeTimeRounding(Math.floor);
            var res = this.birthday && moment(this.birthday, config.dateFormat).fromNow(true)
            moment.relativeTimeRounding(roundingDefault);
            return res;
        }
    });
    Object.defineProperty(User.prototype, 'genderText', {
        get: function () {
            var _injector = angular.element(document).injector();
            return _injector.get('HelperService').getGenderText(this.gender);
        }
    });


})();

(function () {
    'use strict';
    angular
        .module('app')
        .factory('SubjectService', Service);

    function Service($q, $http, config) {
        'ngInject';

        return {
            getAll: getAll,
            getOne: getOne
        };

        function getAll() {
            return $http.get(config.api + '/subject', {cache: true}).then(handleSuccess, handleError);
        }

        function getOne(id) {
            return getAll().then(function (items) {
                return _.find(items, function (i) { return i.id == id; });
            });
        }


        // private functions

        function handleSuccess(res) {
            return res.data;
        }

        function handleError(res) {
            return $q.reject(res.data.message);
        }

    }


})();

(function () {
    'use strict';
    angular
        .module('app')
        .factory('Storage', Storage);

    function Storage($cookies) {

        var lsAvailable = checkStorageAvailable('localStorage'),
            ssAvailable = checkStorageAvailable('sessionStorage');

        return {
            getItem: getItem,
            setItem: setItem,
            removeItem: removeItem
        };

        function getItem(name) {
            return lsAvailable && localStorage.getItem(name) || ssAvailable && sessionStorage.getItem(name) || $cookies.get(name);
        }

        function setItem(name, value, isSession) {
            isSession && ssAvailable && sessionStorage.setItem(name, value) || !isSession && lsAvailable && localStorage.setItem(name, value) || $cookies.put(name, value);
        }

        function removeItem(name) {
            lsAvailable && localStorage.removeItem(name);
            ssAvailable && sessionStorage.removeItem(name);
            $cookies.remove(name);
        }

        function checkStorageAvailable(type) {
            try {
                var storage = window[type],
                    x = '__storage_test__';
                storage.setItem(x, x);
                storage.removeItem(x);
                return true;
            }
            catch(e) {
                return false;
            }
        }

    }


})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('SprintService', SprintService);

    function SprintService($http, config, ProfileService, UserService, ActivityService, $q) {
        'ngInject';

        var service = {
            initializedOwn: false,
            initializedOuter: false,
            sprintersOwnIds: [],
            sprintersOuterIds: [],
            getLeader: getLeader,
            getSprintersOwn: getSprintersOwn,
            getSprintersOuter: getSprintersOuter,
            addSprinter: addSprinter,
            removeSprinter: removeSprinter
        };

        return service;

        function getLeader() {
            return $http.get(config.api+'/sprint/leader').then(handleSuccess, handleError('Error getting sprint leader')).then(function(res) {
                return res.user_id;
            });
        }

        function getSprintersOwn(actual) {
            service.initializedOwn = true;
            return ProfileService.profileReady().then(function (id) {
                return $http.get(config.api+'/sprint',{params:{user_id:id}, cache:!actual}).then(handleSuccess, handleError('Error getting own sprinters')).then(function(res) {
                    service.sprintersOwnIds = res.map(function(r) {return r.sprinter_id;});
                    return res;
                });
            });
        }

        function getSprintersOuter(actual) {
            service.initializedOuter = true;
            return ProfileService.profileReady().then(function (id) {
                return $http.get(config.api+'/sprint',{params:{sprinter_id:id}, cache:!actual}).then(handleSuccess, handleError('Error getting outer sprinters')).then(function(res) {
                    service.sprintersOuterIds = res.map(function(r) {return r.user_id;});
                    return res;
                });
            });
        }

        function addSprinter(id) {
            return $http.post(config.api+'/sprint',{sprinter_id:id}).then(handleSuccess, handleError('Error adding a sprinter')).then(function(res) {
                if (service.sprintersOwnIds.indexOf(id)==-1) {
                    service.sprintersOwnIds.push(id);
                }
                ActivityService.addLog({
                    resource: 'user',
                    resource_id: id,
                    action: 'sprint_add_user',
                    category: 'sprint_add_user'
                });
                return res;
            });
        }

        function removeSprinter(id) {
            return $http.delete(config.api+'/sprint/'+id).then(handleSuccess, handleError('Error removing a sprinter')).then(function(res) {
                if (res.success) {
                    if (service.sprintersOwnIds.indexOf(id)!=-1) {
                        service.sprintersOwnIds.splice(service.sprintersOwnIds.indexOf(id), 1);
                    }
                    return $q.resolve();
                }
                return $q.reject('Error removing a sprinter');
            });
        }


        // private functions

        function handleSuccess(res) {
            return res.data;
        }

        function handleError(error) {
            return function () {
                return $q.reject(error);
            };
        }
    }

})();

(function () {
    'use strict';
    angular
        .module('app')
        .factory('SourceService', Service);

    function Service($q, $http, config) {
        'ngInject';

        return {
            getAll: getAll,
            getOne: getOne
        };

        function getAll() {
            return $http.get(config.api + '/source', {cache: true}).then(handleSuccess, handleError);
        }

        function getOne(id) {
            return getAll().then(function (items) {
                return _.find(items, function (i) { return i.id == id; });
            });
        }


        // private functions

        function handleSuccess(res) {
            return res.data;
        }

        function handleError(res) {
            return $q.reject(res.data.message);
        }

    }


})();

(function () {
    'use strict';
    angular.module('app')
        .service('seo', seo)
        .run(function (seo, $rootScope) {
            'ngInject';
            $rootScope.seo = seo;
        });

    var defaultTitle, defaultDescription, defaultImage;

    function seo(config, $translate, ConfigService, langSuffixFilter, LanguageService, $location) {
        'ngInject';
        var title = config.name,
            description,
            image, imageWidth, imageHeight;

        // $timeout(function() {
        //     setDefaultTitle();
        //     setDefaultDescription();
        // });
        
        return {
            setDefaultTitle: setDefaultTitle,
            getTitle: function () {
                return title;
            },
            setTitle: function (text, translate, translateParams, translateInterpolation) {
                if (translate) {
                    $translate(text, translateParams, translateInterpolation).then(function (t) {
                        title = t;
                    });
                } else {
                    title = text;
                }
            },
            setDefaultDescription: setDefaultDescription,
            getDescription: function() {
                return description;
            },
            setDescription: function (text, translate, translateParams, translateInterpolation) {
                if (translate) {
                    $translate(text, translateParams, translateInterpolation).then(function (t) {
                        description = t;
                    });
                } else {
                    description = text;
                }
            },
            setDefaultImage: setDefaultImage,
            getImage: function() {
                return image;
            },
            getImageWidth: function() {
                return imageWidth;
            },
            getImageHeight: function() {
                return imageHeight;
            },
            setImage: function (text, width, height) {
                image = text;
                imageWidth = width;
                imageHeight = height;
            },
            getLangUrl: function (lang) {
                if (!lang) {
                    return $location.url();
                } else {
                    return $location.url().replace(/^\/(en|ru)(.*)/,'/'+lang+'$2');
                }
            }
        };

        function setDefaultTitle() {
            if (defaultTitle) {
                title = defaultTitle;
            } else {
                ConfigService.getItem('site_title').then(function (t) { 
                    defaultTitle = title = t; 
                });
            }
        }

        function setDefaultDescription() {
            if (defaultDescription) {
                description = defaultDescription;
            } else {
                ConfigService.getItem('site_description').then(function (t) { 
                    defaultDescription = description = t;
                });
            }
        }

        function setDefaultImage() {
            if (defaultImage) {
                image = defaultImage;
            } else {
                LanguageService.languageReady().then(function () {
                    defaultImage = image = langSuffixFilter('https://shakird.com/assets/images/devices.png');
                });
            }
            imageWidth = 597;
            imageHeight = 374;
        }
    }

})();

(function () {
    'use strict';
    angular
        .module('app')
        .factory('ReportService', ReportService);

    function ReportService($http, config, ProjectService, $location, $q) {
        'ngInject';

        return {
            send: send
        };

        function send(data) {
            return $http.post(config.api + '/report', angular.extend({
                url: $location.absUrl(),
                project: ProjectService.currentProject.id
            }, data)).then(handleSuccess, handleError);
        }


        // private functions

        function handleSuccess(res) {
            if (res.data.success) {
                return $q.resolve();
            }
            return $q.reject('Error sending report');
        }

        function handleError(res) {
            return $q.reject(res.data.message);
        }

    }


})();

(function () {
    'use strict';
    angular.module('app')
        .service('ProjectService', ProjectService);

    function ProjectService(config, translateFilter) {
        'ngInject';
        var koranProject = new Project('koran', 'project_koran', 'koran.redirect', 'koran.favorite'),
            muslimatorProject = new Project('muslimator', 'project_muslimator', 'muslimator.redirect', 'muslimator.favorite'),
            coursesProject = new Project('courses', 'project_courses', 'courses.redirect', 'courses.favorite'),
            projects = [ koranProject, muslimatorProject, coursesProject ],
            currentProject;

        return {
            projects: projects,
            get currentProject() {
                return currentProject;
            },
            defaultProject: coursesProject,
            setCurrentProject: function (id) {
                for (var i in projects) {
                    if (projects[i].id == id) {
                        currentProject = projects[i];
                        break;
                    }
                }
            }
        };

        function Project(id, name, link, favLink) {
            this.id = id;
            this.link = link;
            this.favLink = favLink;
            Object.defineProperty(this, 'name', {
                get: function () {
                    return translateFilter(name);
                }
            });
        }

    }


})();

(function() {
    'use strict';

    angular
        .module('profileService', ['authService','userService'])
        .factory('ProfileService', ProfileService);


    function ProfileService($http, config, AuthService, UserService, $rootScope, $interval, $q, moment) {
        'ngInject';
        var _profileData = {}, _currentUser = {}, _todayPoints = 0, _timezone = moment.tz.guess();

        return {
            get currentUser() {
                return _currentUser;
            },
            profileData: _profileData,
            get todayPoints() {
                return _todayPoints;
            },
            get timezone() {
                return _timezone;
            },

            profileReady: profileReady,
            loadProfile: loadProfile,
            loadCurrentUser: loadCurrentUser,

            getProfile: getProfile,
            saveProfile: saveProfile,
            saveState: saveState,
            hasState: hasState,
            deleteAvatar: deleteAvatar,
            updateAvatar: updateAvatar,

            getLevelTable: getLevelTable,
            getLevelExp: getLevelExp,

            getAvatarUploaderConfig: function () {
                return {
                    url: config.api + '/profile/avatar-upload',
                    headers: AuthService.getHeaders()
                };
            },

            init: init
        };

        function init() {
            if (AuthService.isLoggedIn()) {
                loadProfile();
                loadCurrentUser();
            } else {
                for (var i in _profileData) delete _profileData[i];
                _currentUser = {};
                _todayPoints = 0;
            }
        }

        function initChange(data) {
            loadProfile(data);
            loadCurrentUser();
        }

        function loadProfile(data) {
            if (data) {
                angular.merge(_profileData, data);
                return $q.resolve(data);
            }
            return getProfile().then(function (data) {
                if (data) {
                    angular.merge(_profileData, data);
                }
                return data;
            });
        }

        function loadCurrentUser() {
            return UserService.getCurrentUser(true).then(function (res) {
                if (_currentUser.level && res.level != _currentUser.level) {
                    $rootScope.$emit('newLevel',{level:res.level});
                }
                _currentUser = res;

                if (res.points_plan && res.today_points >= res.points_plan && _todayPoints < res.points_plan) $rootScope.$emit('planComplete');
                else if (res.points_plan && res.today_points >= res.points_plan/2 && _todayPoints < res.points_plan/2) $rootScope.$emit('halfPlanComplete');
                else if (res.points_plan && res.today_points >= res.points_plan/4 && _todayPoints < res.points_plan/4) $rootScope.$emit('quarterPlanComplete');
                _todayPoints = res.today_points;
                _timezone = res.timezone;

                return res;
            });
        }

        function profileReady() {
            return $q(function(resolve, reject) {
                if (!AuthService.isLoggedIn()) {
                    reject('Not logged in');
                }
                var _interval = setInterval(function () {
                    if (_profileData.id && _currentUser.id) {
                        resolve(_currentUser.id);
                        clearInterval(_interval);
                    }
                }, 10);
            });
        }

        function getProfile() {
            return $http.get(config.api + '/profile').then(function (response) {
                if (response) {
                    var data = response.data;
                    data.email_notification = !!data.email_notification;
                    data.email_subscription = !!data.email_subscription;
                    return data;
                }
                return null;
            });
        }

        function saveProfile(data) {
            return $http.put(config.api + '/profile', data).then(handleSuccess).then(function (res) {
                initChange(res);
                return res;
            }, function (res) {
                return $q.reject(res.data);
            });
        }

        function hasState(sname) {
            return _profileData.state && _profileData.state[sname] !== undefined;
        }
        
        function saveState(sname, svalue) {
            if (!_profileData.state || angular.isArray(_profileData.state)) {
                _profileData.state = {};
            }
            _profileData.state[sname] = svalue;
            if (AuthService.isLoggedIn()) {
                saveProfile({state: _profileData.state});
            }
        }

        function deleteAvatar() {
            if (!_profileData.avatar_path) {
                return $q.reject();
            }
            return $http.delete(config.api+'/profile/avatar-delete?path=' + _profileData.avatar_path).then(function (res) {
                if (res.data.success) {
                    updateAvatar('','');
                }
                return $q.reject('Error deleting avatar');
            }, handleError('Error deleting avatar'));
        }

        function updateAvatar(path, base_url) {
            return saveProfile({
                'avatar_base_url': base_url,
                'avatar_path': path
            });
        }

        function getLevelTable(maxLevel) {
            maxLevel = maxLevel || 0;
            var levels05 = [0,100,1000,2500,5000,8000], // уровни 0-5
                levels = [0],
                l = 0;
            while (l < maxLevel) {
                l++;
                if (l < levels05.length) {
                    levels[l] = levels05[l];
                } else {
                    levels[l] = levels[l-1] + (levels[l-1] - levels[l-2] + 1000); // добавляем разницу между уровнями + 1000
                }
            }
            return levels;
        }

        function getLevelExp(level) {
            var lt = getLevelTable(level);
            return lt[lt.length-1];
        }



        // private functions

        function handleSuccess(res) {
            return res.data;
        }

        function handleError(error) {
            return function () {
                return $q.reject(error);
            };
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('PageService', PageService);

    function PageService($http, config) {
        'ngInject';
        var service = {};

        service.getAll = getAll;
        service.getPage = getPage;

        return service;

        function getAll() {
            return $http.get(config.api+'/page',{cache:true}).then(handleSuccess, handleError('Error getting all pages'));
        }

        function getPage(key) {
            return getAll().then(function (data) {
                return _.find(data, function (d) { return d.slug == key; });
            });
        }

        // private functions

        function handleSuccess(res) {
            return res.data;
        }

        function handleError(error) {
            return function () {
                return { success: false, message: error };
            };
        }
    }

})();

(function () {
    'use strict';
    angular
        .module('app')
        .factory('NotificationService', NotificationService);

    function NotificationService($http, config, $httpParamSerializer, Flash, translateFilter, $interval, ProfileService, AuthService, moment) {
        'ngInject';
        var hasNew = false, isFirstCheck = true, lastCheckAt;

        ProfileService.profileReady().then(function() {
            checkNew();
            $interval(checkNew, 30000);
        });

        return {
            get: get,
            get hasNew() {
                return hasNew;
            },
            set hasNew(value) {
                hasNew = value;
            },
            checkNew: checkNew
        };

        function get(params) {
            lastCheckAt = moment().unix();
            return $http.get(config.api + '/notification?per-page=5&' + $httpParamSerializer(params) ).then(handleGetSuccess, handleError('Error getting notificatons'));
        }

        function checkNew() {
            if (!AuthService.isLoggedIn() || !ProfileService.profileData) return false;
            if (!lastCheckAt) lastCheckAt = ProfileService.profileData.notification_at;
            get({ from: lastCheckAt }).then(function(res) {
                hasNew = (res.data.length > 0);
                if (!isFirstCheck) {
                    res.data.forEach(function(d) {
                        Flash.create('success',d.title,3000);
                    });
                }
                lastCheckAt = moment().unix();
                isFirstCheck = false;
            });
        }

        // private functions

        function handleGetSuccess(res) {
            return {
                pagination: {
                    pageCount: parseInt(res.headers('X-Pagination-Page-Count')),
                    currentPage: parseInt(res.headers('X-Pagination-Current-Page')),
                    perPage: parseInt(res.headers('X-Pagination-Per-Page')),
                    totalCount: parseInt(res.headers('X-Pagination-Total-Count'))
                },
                data: res.data
            };
        }

        function handleError(error) {
            return function () {
                return { success: false, message: error };
            };
        }

    }


})();

(function () {
    'use strict';
    angular
        .module('app')
        .factory('MaterialService', MaterialService);

    function MaterialService($http, config, $q, AuthService, $rootScope, translateFilter) {
        'ngInject';

        var service = {
            getAll: getAll,
            getBest: getBest,
            getRecommend: getRecommend,
            getFinishRecommend: getFinishRecommend,
            getMaterial: getMaterial,
            create: create,
            update: update,
            delete: deleteMaterial,
            deleteImage: deleteImage,
            imageUploaderConfig: {
                url: config.api + '/material/image-upload',
                headers: AuthService.getHeaders()
            },
            urlCheckAvail: urlCheckAvail,
            urlCheckValid: urlCheckValid,
            changeLike: changeLike,
            getLike: getLike,
            changeStatus: changeStatus,
            viewCountIncrease: viewCountIncrease,
            getCourseMaterials: getCourseMaterials
        };

        return service;

        function getAll(params, actual) {
            params = params || {};
            // params['per-page'] = 9;
            return $http.get(config.api + '/material', {params: params, cache:!actual}).then(handleGetSuccess, handleError('Error getting materials'));
        }

        function getBest(params) {
            return $http.get(config.api + '/material/best', {params: params}).then(handleGetSuccess, handleError('Error getting materials'));
        }

        function getRecommend(params) {
            return $http.get(config.api + '/material/recommend', {params: params}).then(handleGetSuccess, handleError('Error getting materials'));
        }

        function getFinishRecommend(id, params) {
            params.id = id;
            return $http.get(config.api + '/material/finish-recommend', {params: params}).then(handleGetSuccess, handleError('Error getting materials'));
        }

        function getMaterial(id, actual) {
            if (!id) {
                return $q.reject();
            }
            return $http.get(config.api + '/material/' + id, {cache:!actual}).then(handleSuccess, handleError('Error getting material by id')).then(function (res) {
                return new Material(res);
            });
        }

        function deleteImage(path) {
            return $http.delete(config.api+'/material/image-delete?path='+path).then(handleSuccess, handleError('Error deleting image')).then(function (res) {
                if (res.success) {
                    return $q.resolve();
                }
                return $q.reject();
            });
        }

        function update(id, data) {
            return $http.put(config.api + '/material/' + id, data).then(handleSuccess, handleError('Error updating material'));
        }

        function create(data) {
            return $http.post(config.api + '/material', data).then(handleSuccess, handleError('Error creating material')).then(function(res) {
                $rootScope.$emit('pointsChanged');
                return res;
            });
        }

        function deleteMaterial(id) {
            return $http.delete(config.api + '/material/' + id).then(handleSuccess, handleError('Error deleting material'));
        }

        function urlCheckValid(url, type) {
            if (type == 'video') {
                return /(youtu\.be|youtube\.com|vimeo\.com|facebook\.com)/.test(url);
            }

            if (type == 'audio') {
                return /soundcloud\.com/.test(url);
            }

            if (type == 'text') {
                return /facebook\.com/.test(url);
            }

            return false;
        }

        function urlCheckAvail(url, current_id) {
            return $http.get(config.api + '/material/check-url', {params:{url:url,current_id:current_id}}).then(handleSuccess, handleError('Error checking material url')).then(function (res) {
                if (res.success) {
                    return $q.resolve();
                }
                return $q.reject(res.id);
            });
        }

        function changeStatus(id, s) {
            return $http.put(config.api + '/material/change-status', {status:s}, {params:{id:id}}).then(handleSuccess, handleError('Error changing status')).then(function (res) {
                if (res.success) {
                    $rootScope.$emit('materialStatusChange', {id:id, status:s});
                    return $q.resolve();
                }
                return $q.reject();
            });
        }

        function changeLike(id, v) {
            return $http.put(config.api + '/material/change-like', {value:v}, {params:{id:id}}).then(handleSuccess, handleError('Error setting like')).then(function (res) {
                if (res.success) {
                    return $q.resolve();
                }
                return $q.reject();
            });
        }

        function getLike(id) {
            return $http.get(config.api + '/material/like', {params:{id:id}}).then(handleSuccess, handleError('Error setting like')).then(function (res) {
                if (res.success) {
                    return $q.resolve(res.value);
                }
                return $q.reject();
            });
        }

        function viewCountIncrease(id) {
            return $http.post(config.api + '/material/view-count-increase', {}, {params:{id:id}}).then(handleSuccess, handleError('Error increasing views count')).then(function (res) {
                if (res.success) {
                    return $q.resolve();
                }
                return $q.reject();
            });
        }

        function getCourseMaterials(id, params, actual) {
            params = params || {};
            params.id = id;
            // params['per-page'] = 9;
            return $http.get(config.api + '/course/materials', {params: params, cache:!actual}).then(handleGetSuccess, handleError('Error getting course materials'));
        }


        // private functions

        function handleGetSuccess(res) {
            return {
                pagination: {
                    pageCount: parseInt(res.headers('X-Pagination-Page-Count')),
                    currentPage: parseInt(res.headers('X-Pagination-Current-Page')),
                    perPage: parseInt(res.headers('X-Pagination-Per-Page')),
                    totalCount: parseInt(res.headers('X-Pagination-Total-Count'))
                },
                data: res.data.map(function (r) { return new Material(r); })
            };
        }

        function handleSuccess(res) {
            return res.data;
        }

        function handleError(error) {
            return function () {
                return $q.reject(error);
            };
        }

        // entities

        function Material(data) {
            angular.merge(this, data);
            this.date = moment.unix(this.created_at).toDate();
            if (this.type == 'video' || this.type == 'audio') {
                var d = moment.duration(parseInt(this.length), 'seconds');
                this.length_text = (d.hours() ? ('00'+d.hours()).slice(-2)+':' : '')+('00'+d.minutes()).slice(-2)+':'+('00'+d.seconds()).slice(-2);
            } else if (this.type == 'text') {
                this.length_text = translateFilter('pages_number',{number:this.length},'messageformat');
            }
            this.user = {
                id: this.user_id,
                name: this.user_name,
                level: this.user_level,
                avatar: this.user_avatar
            };
        }

    }

})();

(function () {
	'use strict';

	angular.module('languageService', [])

	.factory('LanguageService', LanguageService);

	function LanguageService($q, $http) {
		var deferred = $q.defer();

		var service = {
			list: [
				{
					name: 'English',
					code: 'en'
				},
				{
					name: 'Русский',
					code: 'ru'
				}
			],
			defaultLanguage: 'ru',
			currentLanguage: null,

			languageReady: function () {
				return deferred.promise;
			},
			resolveLanguage: function () {
				deferred.resolve();
			}
		};

		return service;
	}

})();

(function () {
    'use strict';
    angular
        .module('app')
        .factory('KoranService', KoranService);

    function KoranService($http, $q, config, FavoriteService) {
        'ngInject';
        var service = {};

        service.getSuraList = getSuraList;
        service.getSuraFavoriteList = getSuraFavoriteList;
        service.getSura = getSura;
        service.getAyats = getAyats;

        return service;

        function getSuraList() {
            return $http.get(config.api+'/koran/sura',{cache:true}).then(handleSuccess, handleError('Error getting sura list')).then(function (res) {
                var suraList = [], _prevSura;
                if (angular.isArray(res)) {
                    res.forEach(function (data) {
                        var _sura = new Sura(data);
                        _sura.prevSura = _prevSura && {id:_prevSura.id, name:_prevSura.name};
                        suraList.push(_sura);
                        if (_prevSura) _prevSura.nextSura = {id:_sura.id, name:_sura.name};
                        _prevSura = _sura;
                    });
                }
                return suraList;
            });
        }

        function getSuraFavoriteList() {
            var promiseSura = getSuraList();
            var promiseFavorites = FavoriteService.getFavorites('sura');
            return $q.all([promiseSura, promiseFavorites]).then(function (resArray) {
                var resSura = resArray[0];
                var resFavorites = resArray[1];
                return resSura.filter(function (sura) {
                    return angular.isArray(resFavorites) && resFavorites.indexOf(sura.id)>=0;
                });
            });
        }

        function getSura(id) {
            return getSuraList().then(function (res) {
                if (angular.isArray(res)) {
                    for (var i in res) {
                        if (res[i].id == id) {
                            return res[i];
                        }
                    }
                }
            });
        }

        function getAyats(id) {
            return $http.get(config.api+'/koran/ayat?sura_id='+id, { cache:true }).then(handleSuccess, handleError('Error getting sura ayats'))
                .then(function (res) {
                    return res.map(function (data) { return new Ayat(data); });
                });
        }


        // private functions

        function handleSuccess(res) {
            return res.data;
        }

        function handleError(error) {
            return function () {
                return { success: false, message: error };
            };
        }

    }




    // entities

    function Sura(data) {
        angular.merge(this, data);
    }
    Object.defineProperty(Sura.prototype, 'numberedName', {
        get: function () {
            return this.number+'. '+this.name;
        }
    });

    function Ayat(data) {
        angular.merge(this, data);
    }

})();

(function () {
    'use strict';
    angular
        .module('app')
        .factory('HistoryService', HistoryService);

    function HistoryService() {
        'ngInject';
        var history = [];
        return {
            history: history,
            push: function (path) {
                history.push(path);
            },
            pushUrl: function (url) {
                // var reg = /.+?\:\/\/.+?(\/.+?)(?:#|\?|$)/,
                var reg = /.+?\:\/\/.+?(\/.*)/,
                    match = reg.exec(url);
                this.push(match ? match[1] : '/');
            },
            referrer: function () {
                if (history.length < 2) return null;
                return history[history.length-2];
            },
            findReferer: function (str, skip) {
                if (history.length < 2) return null;
                str = str && !_.isArray(str) ? [str] : str;
                skip = skip && !_.isArray(skip) ? [skip] : skip;
                for (var i = history.length-2; i>=0; i--) {
                    if (str && _.every(str, function (s) { return history[i].indexOf(s)==-1; })) {
                        continue;
                    }
                    if (skip && _.find(skip, function (s) { return history[i].indexOf(s)!=-1; })) {
                        continue;
                    }
                    return history[i];
                }
                return null;
            }
        };
    }


})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('HelperService', HelperService);

    function HelperService(translateFilter) {
        'ngInject';

        return {
            gendersSelect: gendersSelect,
            getGenderText: getGenderText
        };

        function gendersSelect(all) {
            return all ? [{text:'all',value:null},{text:'male',value:1},{text:'female',value:0}] : [{text:'male',value:1},{text:'female',value:0}];
        }

        function getGenderText(id) {
            if (id === null) {
                return translateFilter('all');
            }
            return translateFilter(id ? 'male' : 'female');
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('HelpService', HelpService);

    function HelpService($http, config, $httpParamSerializer, translateFilter, $timeout) {
        'ngInject';
        var service = {
            isNewUser: false,
            showGuide: false,
            showGuideHint: false,
            guideSteps: []
        };

        service.getAll = getAll;
        service.startGuide = startGuide;
        service.guideClose = guideClose;

        return service;

        function getAll(params) {
            return $http.get(config.api+'/help?' + $httpParamSerializer(params),{cache:true}).then(handleSuccess, handleError('Error getting all pages'));
        }

        function startGuide() {
            if (service.showGuide) return;
            service.guideSteps = getGuideSteps(service.isNewUser);
            service.showGuide = true;
            service.isNewUser = false;
        }

        function guideClose() {
            service.showGuide = false;
            $timeout(function() {
                service.showGuideHint = true;
            }, 100);
            $timeout(function() {
                service.showGuideHint = false;
            }, 3000);
        }

        function getGuideSteps(showRegisterStep) {
            var stepsFiltered = [];
            var steps = [
                {
                    text: translateFilter('guide_step_reg'),
                    placement:'auto bottom-left',
                    selector:'.header-logo',
                    template:'app/components/_partials/guide/guideStepReg.html',
                    onHide: function () {
                        stepsFiltered.splice(0,1);
                    }
                },
                {
                    text: translateFilter('guide_step_sura_read'),
                    placement:'auto top',
                    selector:'.sura-item .name'
                },
                {
                    text: translateFilter('guide_step_sura_train'),
                    placement:'auto top',
                    selector:'.sura-item .training'
                },
                {
                    text: translateFilter('guide_step_sura_extra'),
                    placement:'auto top',
                    selector:'.sura-item .extra'
                },
                {
                    text: translateFilter('guide_step_sura_ayat'),
                    placement:'auto bottom',
                    selector:'.sura-content .ayat'
                },
                {
                    text: translateFilter('guide_step_sura_fav'),
                    placement:'auto bottom',
                    selector:'.sura-page-header .fav-link'
                },
                {
                    text: translateFilter('guide_step_sura_report'),
                    placement:'auto bottom',
                    selector:'.sura-page-header report-button a'
                },
                {
                    text: translateFilter('guide_step_sura_audio'),
                    placement:'auto top',
                    selector:'.sura-actions .audio'
                },
                {
                    text: translateFilter('guide_step_sura_nav'),
                    placement:'auto top',
                    selector:'.sura-actions .nav-buttons'
                },
                {
                    text: translateFilter('guide_step_sura_done'),
                    placement:'auto top',
                    selector:'.sura-actions .btn-done-points'
                },
                {
                    text: translateFilter('guide_step_progress'),
                    placement:'auto bottom',
                    selector:'.header-right .profile-progress-header'
                },
                {
                    text: translateFilter('guide_step_profile'),
                    placement:'auto bottom',
                    selector:'.header-right .avatar'
                },
                {
                    text: translateFilter('guide_step_friends'),
                    placement:'auto bottom',
                    selector:'.header-right .icon-friends'
                },
                {
                    text: translateFilter('guide_step_notif'),
                    placement:'auto bottom',
                    selector:'.header-right .icon-ring'
                },
                {
                    text: translateFilter('guide_step_fav'),
                    placement:'auto bottom',
                    selector:'.header-right .icon-star'
                },
                {
                    text: translateFilter('guide_step_finish'),
                    placement:'auto bottom',
                    selector:'.header-right .icon-friends'
                }
            ];
            
            for (var i in steps) {
                if (i == 0 && !showRegisterStep) continue;
                if (!angular.element(steps[i].selector+':visible').length) continue;
                stepsFiltered.push(steps[i]);
            }

            return stepsFiltered;
        }

        // private functions

        function handleSuccess(res) {
            return res.data;
        }

        function handleError(error) {
            return function () {
                return { success: false, message: error };
            };
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('Flash', FlashService);

    function FlashService() {

        var messages = {center:[],right:[]};

        return {
            messages: messages,
            success: success,
            error: error,
            danger: danger,
            info: info,
            create: create,
            dismiss: dismiss
        };

        function create(type, content, timeout, position) {
            position = position || 'center';
            messages[position].push({
                type: type,
                content: content,
                timeout: timeout
            });
        }

        function dismiss(position, index) {
            messages[position].splice(index, 1);
        }

        function success(content, timeout, position) {
            timeout = timeout || 3000;
            create('success', content, timeout, position);
        }

        function error(content, timeout, position) {
            timeout = timeout || 3000;
            create('error', content, timeout, position);
        }

        function danger(content, timeout, position) {
            timeout = timeout || 3000;
            create('danger', content, timeout, position);
        }

        function info(content, timeout, position) {
            timeout = timeout || 5000;
            create('info', content, timeout, position);
        }

    }

})();

(function () {
    'use strict';
    angular
        .module('app')
        .factory('FavoriteService', FavoriteService);

    function FavoriteService($http, config, $cacheFactory, $httpParamSerializer, $q, AuthService) {
        'ngInject';

        return {
            getFavorites: getFavorites,
            getFavorite: getFavorite,
            addFavorite: addFavorite,
            deleteFavorite: deleteFavorite
            // toggleFavorite: toggleFavorite
        };

        function getFavorites(resource) {
            if (!AuthService.isLoggedIn()) {
                return $q.when([]);
            }
            return $http.get(config.api+'/favorite', { params: { resource: resource }, cache: true }).then(handleSuccess, handleError('Error getting favorites')).then(function (res) {
                var ids = [];
                if (angular.isArray(res)) {
                    res.forEach(function (data) {
                        ids.push(data.resource_id);
                    });
                }
                return ids;
            });
        }

        function getFavorite(resource, id) {
            return getFavorites(resource).then(function (res) {
                return res.indexOf(id)!==-1;
            });
        }

        function addFavorite(resource, id) {
            $cacheFactory.get('$http').remove(config.api+'/favorite?' + $httpParamSerializer({ resource: resource }));
            return $http.post(config.api + '/favorite', { resource: resource, resource_id: id }).then(handleSuccess, handleError('Error adding favorite'));
        }

        function deleteFavorite(resource, id) {
            $cacheFactory.get('$http').remove(config.api+'/favorite?' + $httpParamSerializer({ resource: resource }));
            return $http.delete(config.api + '/favorite', { params: { resource: resource, id: id } }).then(handleSuccess, handleError('Error deleting favorite'));
        }

        // private functions

        function handleSuccess(res) {
            return res.data;
        }

        function handleError(error) {
            return function () {
                return { success: false, message: error };
            };
        }

    }


})();

(function () {
    'use strict';
    angular
        .module('app')
        .factory('EmbedService', Service);

    function Service($q, $http, config, moment) {
        'ngInject';

        return {
            getUrlData: getUrlData,
            getUrlService: getUrlService,
            getUrlCode: getUrlCode
        };

        function getUrlData(url) {
            var service = getUrlService(url);
            if (service == 'youtube') {
                var id = getUrlCode(url);
                return $http.get('https://www.googleapis.com/youtube/v3/videos', {
                    params: {
                        id: id,
                        part: 'contentDetails',
                        key: config.googleApiKey
                    },
                    headers: {
                        'Authorization': undefined
                    }
                }).then(function(res) {
                    var d = res.data.items[0].contentDetails.duration;
                    return {
                        length: moment.duration(d).asSeconds(),
                        image: 'https://i.ytimg.com/vi/'+id+'/maxresdefault.jpg'
                    };
                }, function(err) {

                });
            }
            if (service == 'facebook') {
                return $q.resolve({
                    length: 0,
                    image: null
                });
            }
            if (service == 'vimeo') {
                return $http.get('https://vimeo.com/api/oembed.json', {
                    params: {
                        url: url
                    },
                    headers: {
                        'Authorization': undefined
                    }
                }).then(function(res) {
                    return {
                        length: res.data.duration,
                        image: res.data.thumbnail_url
                    };
                }, function(err) {

                });
            }
            if (service == 'soundcloud') {
                return $q.resolve({
                    length: 0,
                    image: null
                });
            }
            return $q.reject();
        }

        function getUrlService(url) {
            if (url.match(/https?:\/\/(www\.)?(youtube\.com|youtu\.be)/)) {
                return 'youtube';
            }
            if (url.match(/https?:\/\/(www\.)?facebook\.com/)) {
                return 'facebook';
            }
            if (url.match(/https?:\/\/(www\.)?vimeo\.com/)) {
                return 'vimeo';
            }
            if (url.match(/https?:\/\/(www\.)?soundcloud\.com/)) {
                return 'soundcloud';
            }
            return null;
        }

        function getUrlCode(url) {
            var service = getUrlService(url);
            if (service == 'youtube') {
                var m = url.match(/https?:\/\/(www\.)?((youtube\.com\/watch\?v=([^"&?\/ ]+))|(youtu\.be\/([^"&?\/ ]+)))/i);
                return m && (m[4] || m[6]);
            }
            if (service == 'facebook') {
                return url;
            }
            if (service == 'vimeo') {
                var m = url.match(/https?:\/\/(www\.)?vimeo\.com\/([0-9a-z]+)/i);
                return m && m[2];
            }
            if (service == 'soundcloud') {
                return url;
            }
            return null;
        }

    }


})();

(function () {
    'use strict';
    angular
        .module('app')
        .factory('CourseService', CourseService);

    function CourseService($http, config, $q, AuthService, $rootScope, translateFilter) {
        'ngInject';

        var service = {
            new: {model:{},materials:[],trainings:[]},
            current: {model:{},materials:[],trainings:[]},

            getAll: getAll,
            getBest: getBest,
            getRecommend: getRecommend,
            getCourse: getCourse,
            create: create,
            update: update,
            delete: deleteCourse,
            deleteImage: deleteImage,
            imageUploaderConfig: {
                url: config.api + '/course/image-upload',
                headers: AuthService.getHeaders()
            },
            imageUploaderConfigTraining: {
                url: config.api + '/training/image-upload',
                headers: AuthService.getHeaders()
            },
            changeLike: changeLike,
            getLike: getLike,
            viewCountIncrease: viewCountIncrease,
            updateMaterials: updateMaterials,
            changeMaterialStatus: changeMaterialStatus,
            getTrainings: getTrainings,
            getTraining: getTraining,
            getQuestions: getQuestions,
            createTraining: createTraining,
            updateTraining: updateTraining,
            deleteTraining: deleteTraining,
            changeTrainingStatus: changeTrainingStatus
        };

        return service;        

        function getAll(params, actual) {
            params = params || {};
            // params['per-page'] = 9;
            return $http.get(config.api + '/course', {params: params, cache:!actual}).then(handleGetSuccess, handleError('Error getting courses'));
        }

        function getBest(params) {
            return $http.get(config.api + '/course/best', {params: params}).then(handleGetSuccess, handleError('Error getting courses'));
        }

        function getRecommend(params) {
            return $http.get(config.api + '/course/recommend', {params: params}).then(handleGetSuccess, handleError('Error getting courses'));
        }

        function getCourse(id, actual) {
            if (!id) {
                return $q.reject();
            }
            return $http.get(config.api + '/course/' + id, {cache:!actual}).then(handleSuccess, handleError('Error getting course by id')).then(function (res) {
                return new Course(res);
            });
        }

        function deleteImage(path) {
            return $http.delete(config.api+'/course/image-delete?path='+path).then(handleSuccess, handleError('Error deleting image')).then(function (res) {
                if (res.success) {
                    return $q.resolve();
                }
                return $q.reject();
            });
        }

        function update(id, data) {
            return $http.put(config.api + '/course/' + id, data).then(handleSuccess, handleError('Error updating course'));
        }

        function create(data) {
            return $http.post(config.api + '/course', data).then(handleSuccess, handleError('Error creating course')).then(function(res) {
                // $rootScope.$emit('pointsChanged');
                return res;
            });
        }

        
        function deleteCourse(id) {
            return $http.delete(config.api + '/course/' + id).then(handleSuccess, handleError('Error deleting course'));
        }
        
        function changeLike(id, v) {
            return $http.put(config.api + '/course/change-like', {value:v}, {params:{id:id}}).then(handleSuccess, handleError('Error setting like')).then(function (res) {
                if (res.success) {
                    return $q.resolve();
                }
                return $q.reject();
            });
        }
        
        function getLike(id) {
            return $http.get(config.api + '/course/like', {params:{id:id}}).then(handleSuccess, handleError('Error setting like')).then(function (res) {
                if (res.success) {
                    return $q.resolve(res.value);
                }
                return $q.reject();
            });
        }
        
        function viewCountIncrease(id) {
            return $http.post(config.api + '/course/view-count-increase', {}, {params:{id:id}}).then(handleSuccess, handleError('Error increasing views count')).then(function (res) {
                if (res.success) {
                    return $q.resolve();
                }
                return $q.reject();
            });
        }
        
        function updateMaterials(id, materials) {
            var params = {id:id};
            return $http.put(config.api + '/course/update-materials', {materials: materials}, {params:params}).then(handleSuccess, handleError('Error updating course materials'));
        }

        function changeMaterialStatus(id, materialId, s) {
            var params = {id:id, material_id:materialId};
            return $http.put(config.api + '/course/change-status', {status:s}, {params:params}).then(handleSuccess, handleError('Error changing status'));
        }

        function getTrainings(course_id, actual) {
            var params = {course_id: course_id, 'per-page':-1};
            return $http.get(config.api + '/training', {params:params, cache:!actual}).then(handleSuccess, handleError('Error getting course trainings'));
        }
        
        function getTraining(training_id, actual) {
            var params = {expand: 'questions'};
            return $http.get(config.api + '/training/' + training_id, {params:params, cache:!actual}).then(handleSuccess, handleError('Error getting course training'));
        }

        function getQuestions(training_id, actual) {
            return getTraining(training_id, actual).then(function (res) { return res.questions; });
        }

        function createTraining(data) {
            return $http.post(config.api + '/training', data).then(handleSuccess, handleError('Error creating course trainings'));
        }

        function updateTraining(training_id, data) {
            return $http.put(config.api + '/training/' + training_id, data).then(handleSuccess, handleError('Error updating course trainings'));
        }

        function deleteTraining(training_id) {
            return $http.delete(config.api + '/training/' + training_id).then(handleSuccess, handleError('Error deleting course training'));
        }

        function changeTrainingStatus(training_id, status, result) {
            var params = {id:training_id};
            return $http.put(config.api + '/training/change-status', {status:status, result:result}, {params:params}).then(handleSuccess, handleError('Error changing status'));
        }

        
        // private functions
        
        function handleGetSuccess(res) {
            return {
                pagination: {
                    pageCount: parseInt(res.headers('X-Pagination-Page-Count')),
                    currentPage: parseInt(res.headers('X-Pagination-Current-Page')),
                    perPage: parseInt(res.headers('X-Pagination-Per-Page')),
                    totalCount: parseInt(res.headers('X-Pagination-Total-Count'))
                },
                data: res.data.map(function (r) { return new Course(r); })
            };
        }
        
        function handleSuccess(res) {
            return res.data;
        }
        
        function handleError(error) {
            return function () {
                return $q.reject(error);
            };
        }

        // entities

        function Course(data) {
            angular.merge(this, data);
            this.date = moment.unix(this.created_at).toDate();
            if (this.length_video > 0) {
                var d = moment.duration(parseInt(this.length_video), 'seconds');
                this.length_video_text = (d.hours() ? ('00'+d.hours()).slice(-2)+':' : '')+('00'+d.minutes()).slice(-2)+':'+('00'+d.seconds()).slice(-2);
            }
            if (this.length_audio > 0) {
                var d = moment.duration(parseInt(this.length_audio), 'seconds');
                this.length_audio_text = (d.hours() ? ('00'+d.hours()).slice(-2)+':' : '')+('00'+d.minutes()).slice(-2)+':'+('00'+d.seconds()).slice(-2);
            }
            if (this.length_text > 0) {
                this.length_text_text = translateFilter('pages_number_short',{number:this.length_text},'messageformat');
            }
            this.user = {
                id: this.user_id,
                name: this.user_name,
                level: this.user_level,
                avatar: this.user_avatar
            };
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app')
        .factory('ConfigService', ConfigService);

    function ConfigService($http, config, $q, LanguageService) {
        'ngInject';
        var service = {};

        service.getAll = getAll;
        service.getItem = getItem;
        service.getStats = getStats;

        return service;

        function getAll() {
            return LanguageService.languageReady().then(function () {
                return $http.get(config.api+'/config',{cache:true}).then(handleSuccess, handleError('Error getting all config'));
            });
        }

        function getItem(key) {
            return $q(function(resolve, reject) {
                getAll().then(function(data) {
                    if (angular.isArray(data)) {
                        for (var i in data) {
                            if (data[i].key == key) {
                                resolve(data[i].value);
                                return;
                            }
                        }
                    }
                    reject();
                }, reject);
            });
        }

        function getStats() {
            return $http.get(config.api+'/config/stats',{cache:true}).then(handleSuccess, handleError('Error getting stats'));
        }

        // private functions

        function handleSuccess(res) {
            return res.data;
        }

        function handleError(error) {
            return function () {
                return { success: false, message: error };
            };
        }
    }

})();

(function () {
    'use strict';
    angular
        .module('app')
        .factory('CategoryService', Service);

    function Service($q, $http, config) {
        'ngInject';

        return {
            getAll: getAll,
            getOne: getOne
        };

        function getAll() {
            return $http.get(config.api + '/category', {cache: true}).then(handleSuccess, handleError);
        }

        function getOne(id) {
            return getAll().then(function (items) {
                return _.find(items, function (i) { return i.id == id; });
            });
        }


        // private functions

        function handleSuccess(res) {
            return res.data;
        }

        function handleError(res) {
            return $q.reject(res.data.message);
        }

    }


})();

(function () {
    'use strict';
    angular
        .module('app')
        .factory('BannerService', Service);

    function Service($q, $http, config) {
        'ngInject';

        return {
            getAll: getAll
        };

        function getAll(params) {
            return $http.get(config.api + '/banner',{params:params, cache: true}).then(handleSuccess, handleError);
        }


        // private functions

        function handleSuccess(res) {
            return res.data;
        }

        function handleError(res) {
            return $q.reject(res.data.message);
        }

    }


})();

(function() {
    'use strict';

    angular
        .module('authService', [])
        .factory('AuthService', AuthService)
        .run(function ($http, AuthService) {
            AuthService.setHttpHeaders(AuthService.getHeaders());
        });

    function AuthService($http, config, $q, moment, Storage, $rootScope) {
        'ngInject';
        var service = {}, _isLoggedIn = null;

        service.getHeaders = getHeaders;
        service.setHttpHeaders = setHttpHeaders;
        service.isLoggedIn = isLoggedIn;
        service.login = login;
        service.logout = logout;
        service.register = register;
        service.registerActivate = registerActivate;
        service.setCredentials = setCredentials;
        service.recover = recover;
        service.newPassword = newPassword;
        service.oauthRegister = oauthRegister;
        service.oauthData = {};
        service.emailCheckAvail = emailCheckAvail;

        service.getAvatarUploaderConfig = function () {
            return {
                url: config.api + '/profile/avatar-upload',
                headers: getHeaders()
            };
        };

        return service;



        function isLoggedIn() {
            if (_isLoggedIn === null) {
                _isLoggedIn = !!Storage.getItem('access_token');
            }
            return _isLoggedIn;
        }

        function login(identity, password, recaptcha, callback) {
            $http.post(config.api + '/auth/login', {
                    identity: identity,
                    password: password,
                    recaptcha: recaptcha
                }).then(handleSuccess, handleError('Error log in user'))
                .then(function(response) {
                    if (response.success) {
                        setCredentials(response.access_token);
                    }
                    callback(response);
                });
        }

        function logout() {
            return $q(function (resolve) {
                clearCredentials();
                resolve();
            });
        }

        function register(user) {
            user.timezone = moment.tz.guess();
            return $http.post(config.api + '/auth/register', user).then(handleSuccess, handleError('Error registering user'))
            .then(function (response) {
                if (response.success) {
                    $rootScope.$emit('registrationEmail');
                }
                return response;
            });
        }

        function registerActivate(token) {
            return $http.post(config.api + '/auth/activation', {token: token}).then(handleSuccess, handleError('Error activating user'));
        }

        function recover(data) {
            return $http.post(config.api + '/auth/recover', data).then(handleSuccess, handleError('Error recovering password'));
        }

        function newPassword(data) {
            return $http.post(config.api + '/auth/new-password', data).then(handleSuccess, handleError('Error setting new password'));
        }

        function setCredentials(token, isSession) {
            _isLoggedIn = true;
            Storage.setItem('access_token', token, isSession);
            setHttpHeaders(getHeaders());
        }

        function clearCredentials() {
            _isLoggedIn = false;
            Storage.removeItem('access_token');
            setHttpHeaders(getHeaders());
        }

        function oauthRegister() {
            this.oauthData.profile_data.timezone = moment.tz.guess();
            return $http.post(config.api + '/auth/oauth-register', this.oauthData).then(handleSuccess, handleError('Error oauth register'))
            .then(function(response) {
                if (response.success) {
                    setCredentials(response.access_token, !response.email_confirmed);
                    if (service.oauthData.user_data.oauth_client == 'facebook') {
                        $rootScope.$emit('registrationFacebook');
                    }
                    if (service.oauthData.user_data.oauth_client == 'google') {
                        $rootScope.$emit('registrationGoogle');
                    }
                }
                return response;
            });
        }

        function emailCheckAvail(email) {
            return $http.get(config.api + '/auth/check-email', {params:{email:email}}).then(handleSuccess, handleError('Error checking material url')).then(function (res) {
                if (!res.success) {
                    return $q.reject(res.id);
                }
                return $q.resolve();
            });
        }

        function getHeaders() {
            var headers = {};
            if (Storage.getItem('access_token')) {
                angular.extend(headers, {
                    Authorization: 'Bearer ' + Storage.getItem('access_token')
                });
            }
            return headers;
        }

        function setHttpHeaders(headers) {
            delete $http.defaults.headers.common.Authorization;
            angular.extend($http.defaults.headers.common, headers);
        }




        // private functions

        function handleSuccess(res) {
            return res.data;
        }

        function handleError(error) {
            return function () {
                return { success: false, message: error };
            };
        }

    }

})();

(function () {
    'use strict';
    angular
        .module('app')
        .factory('ActivityService', ActivityService);

    function ActivityService($http, $q, $rootScope, config, FavoriteService, Flash, translateFilter) {
        'ngInject';

        $rootScope.$on('newLevel', function () {
            Flash.create('success',translateFilter('notification_new_level'),3000);
        });
        $rootScope.$on('planComplete', function () {
            Flash.create('success positive',translateFilter('notification_plan_complete'),7000,'right');
        });
        $rootScope.$on('halfPlanComplete', function () {
            Flash.create('primary positive',translateFilter('notification_half_plan_complete'),7000,'right');
        });
        $rootScope.$on('quarterPlanComplete', function () {
            Flash.create('warning positive',translateFilter('notification_quarter_plan_complete'),7000,'right');
        });
        $rootScope.$on('newLevel', function (event, args) {
            addLog({
                resource: 'level',
                resource_id: args.level,
                action: 'new_level',
                category: 'new_level'
            });
        });

        return {
            getLog: getLog,
            addLog: addLog,
            addLogReadSura: function (id) {
                return addLog({
                    resource: 'sura',
                    resource_id: id,
                    action: 'read',
                    category: 'read'
                });
            },
            addLogFinishTrainingSura: function(id, training, points) {
                return addLog({
                    resource: 'sura',
                    resource_id: id,
                    action: 'finish_training_'+training,
                    category: 'training',
                    points: points
                });
            },
            addLogStartTrainingSura: function(id, training) {
                return addLog({
                    resource: 'sura',
                    resource_id: id,
                    action: 'start_training_'+training,
                    category: 'training'
                });
            },
            addLogStartMaterial: function (id, type) {
                return addLog({
                    resource: 'material',
                    resource_id: id,
                    action: 'start_'+type,
                    category: 'start_'+type
                });
            },
            addLogFinishMaterial: function (id, type) {
                return addLog({
                    resource: 'material',
                    resource_id: id,
                    action: 'finish_'+type,
                    category: 'finish_'+type
                });
            },
            addLogStartCourse: function (id) {
                return addLog({
                    resource: 'course',
                    resource_id: id,
                    action: 'start_course',
                    category: 'start_course'
                });
            },
            addLogFinishCourse: function (id) {
                return addLog({
                    resource: 'course',
                    resource_id: id,
                    action: 'finish_course',
                    category: 'finish_course'
                });
            }
        };

        function getLog(params, timezone) {
            params = params || {};
            if (timezone) {
                params.timezone = timezone;
            }
            return $http.get(config.api + '/activity', {params:params}).then(handleGetSuccess, handleError('Error getting activity'));
        }

        function addLog(data) {
            return $http.post(config.api + '/activity', data).then(handleSuccess, handleError('Error adding activity')).then(function (res) {
                $rootScope.$emit('pointsChanged');
                return res;
            });
        }

        // private functions

        function handleGetSuccess(res) {
            return {
                pagination: {
                    pageCount: parseInt(res.headers('X-Pagination-Page-Count')),
                    currentPage: parseInt(res.headers('X-Pagination-Current-Page')),
                    perPage: parseInt(res.headers('X-Pagination-Per-Page')),
                    totalCount: parseInt(res.headers('X-Pagination-Total-Count'))
                },
                data: res.data
            };
        }

        function handleSuccess(res) {
            return res.data;
        }

        function handleError(error) {
            return function () {
                return $q.reject(error);
            };
        }

    }


})();

(function () {
    'use strict';
    angular
        .module('app')
        .factory('AccessService', AccessService);

    function AccessService($http, config, ProfileService, moment) {
        'ngInject';
        var data = [];
        return {
            init: init,
            can: can
        };

        function can(permission, model) {
            if (permission == 'editMaterial') {
                return can('manager') || model && ProfileService.currentUser && (model.user_id == ProfileService.currentUser.id) && (moment().unix() - model.created_at < 86400);
            }
            if (permission == 'editCourse') {
                return can('manager') || model && ProfileService.currentUser && (model.user_id == ProfileService.currentUser.id) && (moment().unix() - model.created_at < 86400 || model.draft == 1);
            }
            return data.indexOf(permission) !== -1;
        }

        function init() {
            return $http.get(config.api + '/permission').then(function (res) {
                data = res.data;
            }, handleError('Error getting permissions'));
        }


        // private functions

        function handleError(error) {
            return function () {
                return { success: false, message: error };
            };
        }

    }


})();

(function () {
    'use strict';

    angular.module('app')

    .filter('withoutLastWord', WithoutLastWordFilter);

    function WithoutLastWordFilter() {
        'ngInject';
        return function(text) {
            if (!text) return '';
            var ta = text.trim().split(' ');
            ta.pop();
            return ta.join(' ');
        };
    }

})();

(function () {
    'use strict';

    angular.module('app')

    .filter('trustUrl', UrlFilter);

    function UrlFilter($sce) {
        'ngInject';
        return function(text) {
            return $sce.trustAsResourceUrl(text);
        };
    }

})();

(function () {
    'use strict';

    angular.module('app')

    .filter('trustHtml', HtmlFilter);

    function HtmlFilter($sce) {
        'ngInject';
        return function(text) {
            return $sce.trustAsHtml(text);
        };
    }

})();

(function () {
    'use strict';

    angular.module('app')

    .filter('lastWord', LastWordFilter);

    function LastWordFilter() {
        'ngInject';
        return function(text) {
            if (!text) return '';
            return text.trim().split(' ').pop();
        };
    }

})();

(function () {
    'use strict';

    angular.module('app')

    .filter('langSuffix', LangSuffixFilter);

    function LangSuffixFilter(LanguageService) {
    	'ngInject';
        function filter(url) {
        	if (!LanguageService.currentLanguage || LanguageService.currentLanguage == LanguageService.defaultLanguage) {
        		return url;
        	} else {
        		return url.replace(new RegExp('(.*?)(\.[a-z0-9]+)$','i'), '$1-'+LanguageService.currentLanguage+'$2');
        	}
        };
        filter.$stateful = true;

        return filter;
    }

})();

(function () {
    'use strict';

    angular.module('app')

    .filter('dateMoment', function (moment) {
        'ngInject';
        return function (date, format, timezone) {
          var m = moment(date);
          if (timezone) {
            m.tz(timezone);
          }
          return m.format(format);
        };
    });

})();

(function () {
    'use strict';

    angular.module('app')

    .filter('crop', CropFilter);

    function CropFilter() {
        'ngInject';
        return function(input, limit, respectWordBoundaries, suffix){
            if (input === null || input === undefined || limit === null || limit === undefined || limit === '') {
                return input;
            }
            if (angular.isUndefined(respectWordBoundaries)) {
                respectWordBoundaries = true;
            }
            if (angular.isUndefined(suffix)) {
                suffix = '...';
            }
    
            if (input.length <= limit) {
                return input;
            }
    
            limit = limit - suffix.length;
    
            var trimmedString = input.substr(0, limit);
            if (respectWordBoundaries) {
                return trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" "))) + suffix;
            }
            return trimmedString + suffix;
        };
    }

})();

(function () {
    'use strict';

    var data = {}, isWaiting = false;

    angular.module('app')

    .filter('config', ConfigFilter)
    .filter('configService', ConfigServiceFilter);

    function ConfigFilter(config) {
        'ngInject';
        return function(v) {
            if (v.indexOf('.')!=-1) {
                var res = config;
                v.split('.').forEach(function(p) {
                    res = res[p];
                });
                return res;
            }
            return config[v];
        };
    }

    function ConfigServiceFilter(ConfigService) {
        'ngInject';

        function filter(v) {
        	if (data[v]===undefined && !isWaiting) {
        		isWaiting = true;
        		ConfigService.getItem(v).then(function(res) {data[v] = res; isWaiting = false;});
        	}
    		return data[v];
        };
        filter.$stateful = true;

        return filter;
    }

})();

(function () {
    'use strict';

    angular.module('app')

    .filter('avatar', AvatarFilter);

    function AvatarFilter() {
        return function(src) {
            return src || 'assets/images/avatar-default.png';
        };
    }

})();

(function () {
    'use strict';

    angular.module('app')

    .filter('arabNumber', ArabNumberFilter);

    function ArabNumberFilter() {
        var digits = ['٠','١','٢','٣','٤','٥','٦','٧','٨','٩'];
        return function(text) {
            text += '';
            return text.replace(/[0-9]/g, function(w){
                return digits[+w];
            });
        };
    }

})();

(function () {
    'use strict';

    angular.module('app')

    .run(ApplicationInit)
    .run(ProfileInit)
    .run(HistoryInit)
    .run(ConfirmInit)
    .run(AccessInit)
    .run(RouterInit)
    .run(TargetInit);

    angular.module('app').value('grecaptcha',function(){return global_recaptcha;});


    function ApplicationInit($rootScope, momentPicker, config, moment) {
        'ngInject';
        $rootScope.$on('$translateChangeSuccess', function (event, data) {
            moment.locale(data.language);
            momentPicker.locale = data.language;
            momentPicker.format = config.dateFormat;
        });
    }

    function ProfileInit(ProfileService, $rootScope, AuthService) {
        $rootScope.$watch(AuthService.isLoggedIn, ProfileService.init);
        $rootScope.$on('pointsChanged', ProfileService.init);
    }

    function AccessInit($rootScope, AccessService, AuthService, $interval) {
        'ngInject';
        $rootScope.$watch(AuthService.isLoggedIn, function (isLoggedIn) {
            AccessService.init();
            if (isLoggedIn) {
                $interval(function () {
                    AccessService.init();
                }, 30000);
            }
        });
    }

    function HistoryInit($rootScope, HistoryService) {
        'ngInject';
        $rootScope.$on('$locationChangeSuccess',function (event, newUrl) {
            HistoryService.pushUrl(newUrl);
        });
    }

    function ConfirmInit($confirmModalDefaults, $translate) {
        'ngInject';
        $confirmModalDefaults.templateUrl = 'app/views/confirm.html';
        $translate(['confirmation','yes','no']).then(function (t) {
            $confirmModalDefaults.defaultLabels.title = t.confirmation;
            $confirmModalDefaults.defaultLabels.ok = t.yes;
            $confirmModalDefaults.defaultLabels.cancel = t.no;
        });
    }

    function RouterInit($state, $transitions, $document, $rootScope, seo, AuthService, $uibModal, ProfileService, HelpService, $timeout) {
        $transitions.onBefore({}, function (trans) {
            if (!trans.to().data) {
                return true;
            }
            var language = trans.injector().get('$stateParams').language;
            if (trans.to().data.requireAuthModal && !AuthService.isLoggedIn() && trans.from().name) {
                return $uibModal.open({
                    component: 'confirmAuthModal'
                }).result.then(function (res) {
                    if (res) {
                        return $state.target('auth.login',{language:language});
                    }
                    return false;
                }, function () {
                    return false;
                });
            } else if (trans.to().data.requireAuth && !AuthService.isLoggedIn()) {
                return $state.target('auth.login',{language:language});
            }
            return true;
        });
        $transitions.onStart({}, function () {
            $rootScope.loading = true;
            seo.setDefaultTitle();
            seo.setDefaultDescription();
            seo.setDefaultImage();
        });
        $transitions.onSuccess({}, function () {
            $rootScope.loading = false;
            $document.scrollTop(0);
            
            ProfileService.profileReady().then(function () {
                if (HelpService.isNewUser) {
                    $timeout(HelpService.startGuide, 1000);
                }
            });
        });
        $transitions.onError({}, function () {
            return $state.target('home');
        });
    }

    function TargetInit($rootScope) {
        'ngInject';
        $rootScope.$on('registrationEmail',function (event) {
            if (typeof ga != "undefined") {
                ga('send', 'event', { eventCategory: 'registration_mail', eventAction: 'confirm', eventLabel: 'new_user '});
            }
            if (typeof yaCounter44770414 != "undefined") {
                yaCounter44770414.reachGoal('registration_mail');
            }
        });
        $rootScope.$on('registrationGoogle',function (event) {
            if (typeof ga != "undefined") {
                ga('send', 'event', { eventCategory: 'registration_google', eventAction: 'confirm', eventLabel: 'new_user '});
            }
            if (typeof yaCounter44770414 != "undefined") {
                yaCounter44770414.reachGoal('registration_google');
            }
        });
        $rootScope.$on('registrationFacebook',function (event) {
            if (typeof ga != "undefined") {
                ga('send', 'event', { eventCategory: 'registration_facebook', eventAction: 'confirm', eventLabel: 'new_user '});
            }
            if (typeof yaCounter44770414 != "undefined") {
                yaCounter44770414.reachGoal('registration_facebook');
            }
        });
    }

})();

/* global moment:false */
(function () {
    'use strict';

    var config = {
        name: 'Shakird',
        api: 'https://shakird.com/api'+'/v1',
        storage: 'https://shakird.com/storage',
        recaptchaKey: '6LemxyQUAAAAANjsNNuySiIFYZNGEOZ_jDIi1i6t',
        dateFormat: 'DD.MM.YYYY',
        emailPattern: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
        points: {
            suraRead: 10,
            materialVideo: 10,
            materialAudio: 10,
            materialText: 5
        },
        facebookAppId: '1737813166534231',
        googleApiKey: 'AIzaSyBhTOsSL7Jg59xmSIsJGEBpcXexpxLca7Y'
    };

    angular.module('app')

    .constant('config',config)
    .constant('moment',moment)

    .config(function($locationProvider) {
        'ngInject';
        $locationProvider.html5Mode(true);
    })

    .config(function($uiRouterProvider) {
        var StickyStatesPlugin = window['@uirouter/sticky-states'].StickyStatesPlugin;
        $uiRouterProvider.plugin(StickyStatesPlugin);
    })

    .config(function($qProvider) {
        'ngInject';
        $qProvider.errorOnUnhandledRejections(false);
    })

    .config(function($translateProvider, config) {
        'ngInject';
        $translateProvider
        .usePostCompiling(true)
        .useLocalStorage()
        .useSanitizeValueStrategy(null)
        // .useLoaderCache(true) // не проверял
        .registerAvailableLanguageKeys(['en','ru'], {
            'ru': 'ru',
            'ru_*': 'ru',
            'en': 'en',
            'en_*': 'en',
            '*': 'en'
        })
        .useUrlLoader(config.api + '/translation')
        .determinePreferredLanguage()
        .fallbackLanguage('en')
        .addInterpolation('$translateMessageFormatInterpolation');
    })

    .config(function ($uibTooltipProvider) {
        'ngInject';
        $uibTooltipProvider.options({
            placement: 'bottom',
            appendToBody: true
        });
    })

    .config(function (momentPickerProvider) {
        'ngInject';
        momentPickerProvider.options({
            maxView: "month",
            startView: "month",
            leftArrow: "<i class='icon icon-left-primary'></i>",
            rightArrow: "<i class='icon icon-right-primary'></i>"
        });
    })

    .config(function (msdElasticConfig) {
        'ngInject';
        msdElasticConfig.append = '\n';
    })

    .config(function ($uibModalProvider) {
        $uibModalProvider.options.animation = false;
    })

    .config(function($authProvider) {

        $authProvider.httpInterceptor = false;

        $authProvider.facebook({
          url: config.api+'/auth/oauth?authclient=facebook',
          clientId: '1737813166534231',
          scope: ['email','user_friends'],
          redirectUri: window.location.origin+'/oauth-redirect?provider=facebook'
        });

        // // Optional: For client-side use (Implicit Grant), set responseType to 'token' (default: 'code')
        // $authProvider.facebook({
        //   clientId: 'Facebook App ID',
        //   responseType: 'token'
        // });

        $authProvider.google({
          url: config.api+'/auth/oauth?authclient=google',
          clientId: '775545798683-2enutpgr55i447ah9nbu5kvui03t6dvn.apps.googleusercontent.com',
          redirectUri: window.location.origin+'/oauth-redirect?provider=google'
        });

        // $authProvider.github({
        //   clientId: 'GitHub Client ID'
        // });

        // $authProvider.linkedin({
        //   clientId: 'LinkedIn Client ID'
        // });

        // $authProvider.instagram({
        //   clientId: 'Instagram Client ID'
        // });

        // $authProvider.yahoo({
        //   clientId: 'Yahoo Client ID / Consumer Key'
        // });

        // $authProvider.live({
        //   clientId: 'Microsoft Client ID'
        // });

        // $authProvider.twitch({
        //   clientId: 'Twitch Client ID'
        // });

        // $authProvider.bitbucket({
        //   clientId: 'Bitbucket Client ID'
        // });

        // $authProvider.spotify({
        //   clientId: 'Spotify Client ID'
        // });

        // No additional setup required for Twitter

        // $authProvider.oauth2({
        //   name: 'foursquare',
        //   url: '/auth/foursquare',
        //   clientId: 'Foursquare Client ID',
        //   redirectUri: window.location.origin,
        //   authorizationEndpoint: 'https://foursquare.com/oauth2/authenticate',
        // });

        $authProvider.oauth2({
          name: 'facebook-connect',
          url: config.api+'/auth/fb-connect',
          clientId: '1737813166534231',
          redirectUri: window.location.origin+'/',
          authorizationEndpoint: 'https://www.facebook.com/v3.1/dialog/oauth',
          requiredUrlParams: ['scope'],
          scope: ['email','user_friends'],
          scopePrefix: '',
          scopeDelimiter: ','
        });

      });

})();

angular.module("app").run(["$templateCache", function($templateCache) {$templateCache.put("app/directives/audioPlayer.html","<div class=audio-player> <videogular ng-if=src vg-player-ready=\"$ctrl.vgapi = $API\"> <vg-media vg-src=sound.sources vg-type=audio></vg-media> <vg-controls> <vg-play-pause-button></vg-play-pause-button> <vg-time-display>{{ currentTime | date:\'mm:ss\' }}</vg-time-display> <vg-scrub-bar> <vg-scrub-bar-current-time></vg-scrub-bar-current-time> </vg-scrub-bar> <vg-time-display>{{ (timeLeft || 0) | date:\'mm:ss\' }}</vg-time-display> </vg-controls> </videogular> <hr ng-if=src> <div ng-if=text class=text>{{text}}</div> </div>");
$templateCache.put("app/directives/audioPopover.html","<div class=audio-popover> <audio-player src=src text=text on-play=onPlay()></audio-player> </div>");
$templateCache.put("app/views/appBanner.html","<div class=banner-app> <div class=image> <img ng-if=$root.isIos src=assets/images/ios.png srcset=\"assets/images/ios@2x.png 2x\" alt=\"\"> <img ng-if=$root.isAndroid src=assets/images/android.png srcset=\"assets/images/android@2x.png 2x\" alt=\"\"> </div> <div class=content> <div class=text>{{ \'app_banner_text\' | translate }}</div> <div class=buttons> <a ng-if=$root.isIos ng-href=\"{{\'app_store_url\'|configService}}\" target=_blank><img src=assets/images/app-apple.png alt=\"\"></a> <a ng-if=$root.isAndroid ng-href=\"{{\'google_play_url\'|configService}}\" target=_blank><img src=assets/images/app-google.png alt=\"\"></a> </div> </div> </div>");
$templateCache.put("app/views/authTabs.html","<button type=button class=close ng-click=$ctrl.close() style=margin-right:20px><i class=icon-close></i></button> <ul class=\"nav nav-tabs\"> <li ui-sref-active=active> <a ui-sref=auth.login>{{\'sign_in\'|translate}}</a> </li> <li ui-sref-active=active> <a ui-sref=auth.register>{{\'sign_up\'|translate}}</a> </li> </ul>");
$templateCache.put("app/views/confirm.html","<div class=modal-header> <button type=button class=close ng-click=cancel()><i class=icon-close></i></button> <h2 class=modal-title>{{data.title}}</h2> </div> <div class=modal-body> <p> {{data.text}} </p> <button class=\"btn btn-primary hidden-phone\" type=button ng-click=ok()>{{data.ok}}</button> <button class=\"btn btn-primary btn-invert hidden-phone\" type=button ng-click=cancel()>{{data.cancel}}</button> <button class=\"btn btn-primary btn-block visible-phone\" type=button ng-click=ok()>{{data.ok}}</button> <button class=\"btn btn-primary btn-invert btn-block visible-phone\" type=button ng-click=cancel()>{{data.cancel}}</button> </div>");
$templateCache.put("app/views/favoriteTabs.html","<ul class=\"nav nav-tabs\"> <li ng-repeat=\"project in $ctrl.projectService.projects\" ui-sref-active=active> <a ui-sref={{project.favLink}}>{{project.name}}</a> </li> </ul>");
$templateCache.put("app/views/follow.html","<div class=text>{{\'follow_us_short\'|translate}}</div> <a ng-href=\"{{\'facebook_url\'|configService}}\" target=_blank><img src=assets/images/social/facebook.png alt=\"\"></a> <a ng-href=\"{{\'youtube_url\'|configService}}\" target=_blank><img src=assets/images/social/youtube.png alt=\"\"></a>");
$templateCache.put("app/views/footer.html","<nav class=footer> <a href class=scroll-top ng-click=$ctrl.scrollTop()>{{\'up\'|translate}} <i class=icon-arrow-up></i></a> <div class=container-fluid> <div class=menu-main> <a ui-sref=home({language:$root.languageService.currentLanguage}) ui-sref-opts=\"{reload:true, inherit:false}\">{{ \'home_page\' | translate }}</a> <a ui-sref=about>{{ \'about_us\' | translate }}</a> <a ui-sref=contacts>{{ \'contacts\' | translate }}</a> </div> <div class=\"selector form-group\"> <ui-select ng-model=$ctrl.languageService.currentLanguage ng-change=$ctrl.changeLanguage() search-enabled=false> <ui-select-match placeholder=\"{{ \'language\' | translate }}\">{{$select.selected.name}}</ui-select-match> <ui-select-choices repeat=\"lang.code as lang in $ctrl.languageService.list\" position=up>{{lang.name}}</ui-select-choices> </ui-select> </div> <div class=menu-secondary> <div><a ui-sref=\"page({key:\'agreement\'})\">{{ \'user_agreement\' | translate }}</a></div> <div><a ui-sref=\"page({key:\'privacy\'})\">{{ \'privacy_policy\' | translate }}</a></div> </div> <div class=copyright>&copy; {{ $ctrl.config.name }}, 2021</div> <div class=social> <a ng-href=\"{{\'youtube_url\'|configService}}\" target=_blank><img src=assets/images/social/youtube.png srcset=\"assets/images/social/youtube@2x.png 2x\" alt=\"\"></a> <a ng-href=\"{{\'facebook_url\'|configService}}\" target=_blank><img src=assets/images/social/facebook.png srcset=\"assets/images/social/facebook@2x.png 2x\" alt=\"\"></a> </div> </div> </nav>");
$templateCache.put("app/views/header.html","<div class=sidebar-left ng-show=$ctrl.showSidebarLeft ng-swipe-left=$ctrl.closeSidebarLeft()> <div class=section> <a ui-sref=courses.redirect({language:$root.languageService.currentLanguage}) ui-sref-opts=\"{reload:true, inherit:false}\" ui-sref-active=active class=title>{{ \'project_courses\' | translate }}</a> <a ui-sref=courses.index({language:$root.languageService.currentLanguage}) ui-sref-opts=\"{reload:true, inherit:false}\" ui-sref-active=active>{{ \'courses\' | translate }}</a> <a ng-if=$root.isLoggedIn() ui-sref=courses.inProgress ui-sref-active=active>{{ \'courses_in_progress\' | translate }}</a> <a ng-if=$root.isLoggedIn() ui-sref=courses.finished ui-sref-active=active>{{ \'courses_finished\' | translate }}</a> <a ng-if=\"$root.isLoggedIn() && $ctrl.accessService.can(\'addMaterial\')\" ui-sref=courses.my ui-sref-active=active>{{ \'courses_my\' | translate }}</a> <a ng-if=\"$root.isLoggedIn() && !$ctrl.accessService.can(\'addMaterial\')\" ui-sref=courses.add ui-sref-active=active>{{ \'courses_add\' | translate }}</a> </div> <div class=divider></div> <div class=section> <a ui-sref=muslimator.redirect({language:$root.languageService.currentLanguage}) ui-sref-opts=\"{reload:true, inherit:false}\" ui-sref-active=active class=title>{{ \'project_muslimator\' | translate }}</a> <a ui-sref=muslimator.index({language:$root.languageService.currentLanguage}) ui-sref-opts=\"{reload:true, inherit:false}\" ui-sref-active=active>{{ \'materials\' | translate }}</a> <a ng-if=$root.isLoggedIn() ui-sref=muslimator.inProgress ui-sref-active=active>{{ \'materials_in_progress\' | translate }}</a> <a ng-if=$root.isLoggedIn() ui-sref=muslimator.finished ui-sref-active=active>{{ \'materials_finished\' | translate }}</a> <a ng-if=\"$root.isLoggedIn() && $ctrl.accessService.can(\'addMaterial\')\" ui-sref=muslimator.my ui-sref-active=active>{{ \'materials_my\' | translate }}</a> <a ng-if=\"$root.isLoggedIn() && !$ctrl.accessService.can(\'addMaterial\')\" ui-sref=muslimator.add ui-sref-active=active>{{ \'materials_add\' | translate }}</a> </div> <div class=divider></div> <div class=section> <a ui-sref=koran.redirect class=title>{{\'project_koran\'|translate}}</a> <a ui-sref=koran.index>{{ \'all_suras\' | translate }}</a> <a ui-sref=koran.landing>{{ \'how_it_works\' | translate }}</a> </div> <div class=divider></div> </div> <div class=sidebar-right ng-show=$ctrl.showSidebarRight ng-swipe-right=$ctrl.closeSidebarRight()> <div ng-if=$root.isLoggedIn()> <div class=section> <p> <user-preview></user-preview> </p> <progress-today user=$ctrl.profileService.currentUser ui-sref=my.log></progress-today><!-- <progress-today user=\"$ctrl.profileService.currentUser\" ui-sref=\"my.diagram\"></progress-today> --> </div> <sprint-count></sprint-count> <div class=section> <a ng-href={{$root.$state.href($ctrl.projectService.currentProject.favLink)}}><i class=\"icon-star icon-circle icon-circle-bold icon-lg\"></i>{{\'favorites\'|translate}}</a> <a ui-sref=notifications><i class=\"icon-ring icon-circle icon-circle-bold icon-lg\" ng-class=\"{\'has-new\':$ctrl.notificationService.hasNew}\"></i>{{\'notifications\'|translate}}</a> <a ui-sref=sprint.index><i class=\"icon-friends icon-circle icon-circle-bold icon-lg\"></i>{{\'sprint\'|translate}}</a> </div> <div class=divider></div> <div class=section> <a ui-sref=my.log>{{ \'my_activity_log\' | translate }}</a> <a ui-sref=settings.profile>{{ \'settings\' | translate }}</a><!-- <a href id=\"intercom-menu-link\" ng-click=\"$ctrl.closeSidebarRight()\">{{ \'write_to_manager\' | translate }}</a> --> </div> <div class=divider></div> <div class=section> <a ui-sref=auth.logout>{{ \'sign_out\' | translate }}</a> </div> </div> <div ng-if=!$root.isLoggedIn()> <div class=section> <a ui-sref=auth.login>{{ \'sign_in\' | translate }}</a> <a ui-sref=auth.register>{{ \'sign_up\' | translate }}</a> </div> </div> </div> <nav class=header> <div class=header-left> <div class=project-selector-button> <a href ng-if=!$root.isTablet uib-popover-template=$ctrl.projectSelectorTemplate popover-placement=bottom-left popover-trigger=\"\'outsideClick\'\" popover-is-open=$ctrl.projectSelectorIsOpen popover-append-to-body=false popover-class=project-selector ng-click=\"$ctrl.projectSelectorIsOpen = true\"> <i class=icon-project></i>&nbsp; <i class=icon-angle-down></i> </a> <a href class=sidebar-left-button ng-if=$root.isTablet ng-click=\"$ctrl.showSidebarLeft ? $ctrl.closeSidebarLeft() : $ctrl.openSidebarLeft()\"> <i class=icon-project></i>&nbsp; <i class=icon-angle-down></i> </a> </div> <div class=header-logo> <div id=logo class=text-hide ui-sref=home({language:$root.languageService.currentLanguage}) ui-sref-opts=\"{reload:true, inherit:false}\">{{$ctrl.config.name}}</div> <div class=project-name ui-sref=home({language:$root.languageService.currentLanguage}) ui-sref-opts=\"{reload:true, inherit:false}\">{{$ctrl.projectService.currentProject.name}}</div> <div class=guide-link ng-if=$root.isLoggedIn() ng-click=$ctrl.helpService.startGuide() uib-popover=\"{{\'guide_hint\'|translate}}\" popover-is-open=$ctrl.helpService.showGuideHint popover-trigger=\"\'mouseenter\'\" popover-placement=\"auto right\" popover-class=guide-hint-popover>?</div> </div> <div class=menu ng-if=\"!$root.isTablet && $ctrl.projectService.currentProject.id == \'koran\'\"> <a ui-sref=koran.index>{{ \'all_suras\' | translate }}</a> <a ui-sref=koran.landing>{{ \'how_it_works\' | translate }}</a> </div> <div class=menu ng-if=\"!$root.isTablet && $ctrl.projectService.currentProject.id == \'muslimator\'\"> <a ui-sref=muslimator.index({language:$root.languageService.currentLanguage}) ui-sref-opts=\"{reload:true, inherit:false}\" ui-sref-active=active>{{ \'materials\' | translate }}</a> <a ng-if=$root.isLoggedIn() ui-sref=muslimator.inProgress ui-sref-active=active>{{ \'materials_in_progress\' | translate }}</a> <a ng-if=$root.isLoggedIn() ui-sref=muslimator.finished ui-sref-active=active>{{ \'materials_finished\' | translate }}</a> <a ng-if=\"$root.isLoggedIn() && $ctrl.accessService.can(\'addMaterial\')\" ui-sref=muslimator.my ui-sref-active=active>{{ \'materials_my\' | translate }}</a> <a ng-if=\"$root.isLoggedIn() && !$ctrl.accessService.can(\'addMaterial\')\" ng-click=$ctrl.addMaterialRequestModal()>{{ \'add_material\' | translate }}</a> </div> <div class=menu ng-if=\"!$root.isTablet && $ctrl.projectService.currentProject.id == \'courses\'\"> <a ui-sref=courses.index({language:$root.languageService.currentLanguage}) ui-sref-opts=\"{reload:true, inherit:false}\" ui-sref-active=active>{{ \'courses\' | translate }}</a> <a ng-if=$root.isLoggedIn() ui-sref=courses.inProgress ui-sref-active=active>{{ \'courses_in_progress\' | translate }}</a> <a ng-if=$root.isLoggedIn() ui-sref=courses.finished ui-sref-active=active>{{ \'courses_finished\' | translate }}</a> <a ng-if=\"$root.isLoggedIn() && $ctrl.accessService.can(\'addMaterial\')\" ui-sref=courses.my ui-sref-active=active>{{ \'courses_my\' | translate }}</a> <a ng-if=\"$root.isLoggedIn() && !$ctrl.accessService.can(\'addMaterial\')\" ng-click=$ctrl.addMaterialRequestModal()>{{ \'add_course\' | translate }}</a> </div> </div> <div class=header-right> <div class=menu-icon ng-if=\"!$root.isPhone && $root.isLoggedIn()\"> <a ng-href={{$root.$state.href($ctrl.projectService.currentProject.favLink)}} class=\"icon-star icon-circle icon-circle-bold icon-lg\"></a> <a href class=\"icon-ring icon-circle icon-circle-bold icon-lg\" uib-popover-template=$ctrl.notificationTemplate popover-placement=bottom-right popover-trigger=\"\'outsideClick\'\" popover-class=notification-popover popover-is-open=$ctrl.notificationIsOpen popover-append-to-body=false ng-class=\"{\'has-new\':$ctrl.notificationService.hasNew}\"></a> <span ng-mouseenter=\"$ctrl.sprintIsOpen = true\" ng-mouseleave=\"$ctrl.sprintIsOpen = false\"> <a ui-sref=sprint.index class=\"icon-friends icon-circle icon-circle-bold icon-lg\" uib-popover-template=$ctrl.sprintTemplate popover-placement=bottom-right popover-trigger=\"\'none\'\" popover-class=\"sprint-popover noarrow\" popover-is-open=$ctrl.sprintIsOpen popover-append-to-body=false popover-popup-delay=100></a> </span> </div> <div class=profile-menu-button ng-if=\"!$root.isTablet && $root.isLoggedIn()\" uib-dropdown auto-close=outsideClick is-open=profileDropdownIsOpen> <a uib-dropdown-toggle class=avatar> <img ng-src={{$ctrl.profileService.currentUser.avatar|avatar}} alt=\"\"> <span class=level>{{$ctrl.profileService.currentUser.level}}</span> <span class=border-overlay></span> </a> <ul class=dropdown-menu-right uib-dropdown-menu> <li class=dropdown-header><b>{{$ctrl.profileService.currentUser.name}}</b></li> <li role=separator class=divider></li> <li><a ui-sref=settings.plan ng-click=\"profileDropdownIsOpen = false\">{{ \'day_plan\' | translate }}</a></li> <li><a ui-sref=my.log ng-click=\"profileDropdownIsOpen = false\">{{ \'my_activity_log\' | translate }}</a></li> <li><a ui-sref=settings.notifications ng-click=\"profileDropdownIsOpen = false\">{{ \'notifications\' | translate }}</a></li> <li><a ui-sref=settings.profile ng-click=\"profileDropdownIsOpen = false\">{{ \'settings\' | translate }}</a></li> <li role=separator class=divider></li> <li><a ui-sref=auth.logout ng-click=\"profileDropdownIsOpen = false\">{{ \'sign_out\' | translate }}</a></li> </ul> </div> <div class=\"profile-menu-button sidebar-right-button\" ng-click=\"$ctrl.showSidebarRight ? $ctrl.closeSidebarRight() : $ctrl.openSidebarRight()\" ng-if=$root.isTablet> <div class=avatar ng-if=$root.isLoggedIn()> <img ng-src={{$ctrl.profileService.currentUser.avatar|avatar}} alt=\"\"> <span class=level>{{$ctrl.profileService.currentUser.level}}</span> <span class=border-overlay></span> </div> <div class=avatar ng-if=\"$root.isPhone && !$root.isLoggedIn()\"> <img ng-src=assets/images/account.png alt=\"\"> </div> </div> <progress-today user=$ctrl.profileService.currentUser ng-if=\"!$root.isTablet && $root.isLoggedIn()\" class=profile-progress-header ui-sref=my.log></progress-today><!-- <progress-today user=\"$ctrl.profileService.currentUser\" ng-if=\"!$root.isTablet && $root.isLoggedIn()\" class=\"profile-progress-header\" ui-sref=\"my.diagram\"></progress-today> --> <div class=menu ng-if=\"!$root.isPhone && !$root.isLoggedIn()\"> <a ui-sref=auth.login>{{ \'sign_in\' | translate }}</a> <a ui-sref=auth.register class=\"btn header-button\">{{ \'sign_up\' | translate }}</a> </div> </div> </nav>");
$templateCache.put("app/views/main.html","<guide steps=$ctrl.helpService.guideSteps show=$ctrl.helpService.showGuide on-close=$ctrl.helpService.guideClose()></guide> <banner id=share-banner-corner class=banner-corner close-button=true timeout=240000><ng-include src=\"\'app/views/shareProjectBanner.html\'\"></ng-include></banner><!-- <banner id=\"follow-banner-modal\" modal=\"{component:\'followModal\',size:\'lg\',windowClass:\'modal-banner\'}\" timeout=\"600000\" on-close=\"sfb2 = true\"></banner> --> <banner id=follow-banner-corner class=\"banner-corner banner-corner-follow\" close-button=true timeout=600000 ng-if=sfb2><ng-include src=\"\'app/views/follow.html\'\"></ng-include></banner> <banner ng-if=\"($root.isIos || $root.isAndroid) && $root.isLoggedIn()\" id=app-banner-mobile class=banner-bottom close-button=true close-icon-class=icon-close-bold timeout=180000><ng-include src=\"\'app/views/appBanner.html\'\"></ng-include></banner> <div class=backdrop-main ng-show=$ctrl.showBackdrop></div> <ui-view name=full-page> <div class=wrap ng-class=\"{\'logged-out\':!$root.isLoggedIn()}\"> <ng-include ng-if=!$root.$state.current.data.hideHeader src=\"\'app/views/header.html\'\"></ng-include> <div class=\"flash-messages-wrap affix\"> <flash-messages position=center></flash-messages> <flash-messages position=right></flash-messages> </div> <div class=\"container container-page-responsive text-center\" ng-show=$root.loading><div class=loading></div></div> <ui-view ng-show=!$root.loading></ui-view> <ui-view name=koran-index-sticky ng-show=\"$root.$state.includes(\'koran.index\') && !$root.loading\"></ui-view> <ui-view name=muslimator-index-sticky ng-show=\"$root.$state.includes(\'muslimator.index\') && !$root.loading\"></ui-view> <ui-view name=courses-index-sticky ng-show=\"$root.$state.includes(\'courses.index\') && !$root.loading\"></ui-view> </div> <ng-include ng-if=!$root.$state.current.data.hideFooter src=\"\'app/views/footer.html\'\"></ng-include> </ui-view>");
$templateCache.put("app/views/notification.html","<notifications></notifications>");
$templateCache.put("app/views/profileMenu.html","<div class=profile-menu> <ul> <li><a href>{{$ctrl.profileService.currentUser.name}}</a></li> <li><a ui-sref=settings.profile>{{ \'Settings\' | translate }}</a></li> <li ng-if=\"$ctrl.profileService.currentUser.can(\'manager\')\"><a href=/admin>{{ \'Backend\' | translate }}</a></li> <li><a ui-sref=auth.logout>{{ \'Logout\' | translate }}</a></li> </ul> </div>");
$templateCache.put("app/views/projectSelector.html","<div> <a ui-sref=courses.redirect({language:$root.languageService.currentLanguage}) ui-sref-opts=\"{reload:true, inherit:false}\" ng-click=\"$ctrl.projectSelectorIsOpen=false\"> <i class=\"icon-hat circle\"></i>{{\'project_courses\'|translate}} </a> <a ui-sref=muslimator.redirect({language:$root.languageService.currentLanguage}) ui-sref-opts=\"{reload:true, inherit:false}\" ng-click=\"$ctrl.projectSelectorIsOpen=false\"> <i class=\"icon-play circle\"></i>{{\'project_muslimator\'|translate}} </a> <a ui-sref=koran.redirect({language:$root.languageService.currentLanguage}) ui-sref-opts=\"{reload:true, inherit:false}\" ng-click=\"$ctrl.projectSelectorIsOpen=false\"> <i class=\"icon-book circle\"></i>{{\'project_koran\'|translate}} </a> </div>");
$templateCache.put("app/views/share.html","<h4>{{\'invite_friends_title\'|translate}}</h4> <p>{{\'invite_friends_text\'|translate}}</p> <div class=row-buttons> <button class=\"btn btn-grow btn-social btn-sm btn-facebook\" socialshare socialshare-provider=facebook socialshare-type=share socialshare-via=\"{{\'facebookAppId\'|config}}\" socialshare-title=\"{{\'site_share_title\'|configService}}\" socialshare-description=\"{{\'site_share_description\'|configService}}\" socialshare-media=\"{{\'https://shakird.com/assets/images/devices@2x.png\'|langSuffix}}\" socialshare-url=https://shakird.com/{{$root.languageService.currentLanguage}}><span class=\"fa fa-facebook\"></span>Facebook</button> <button class=\"btn btn-grow btn-social btn-sm btn-twitter\" socialshare socialshare-provider=twitter socialshare-text=\"{{\'site_share_title\'|configService}}\" socialshare-url=https://shakird.com/{{$root.languageService.currentLanguage}}><span class=\"fa fa-twitter\"></span>Twitter</button> </div>");
$templateCache.put("app/views/shareMaterialBanner.html","<div class=banner-share> <div class=content> <h4>{{\'material_share_title\'|translate}}</h4> <p ng-bind-html=\"\'material_share_text\'|translate|trustHtml\"></p> </div> <div class=links> <a href socialshare socialshare-provider=facebook socialshare-type=share socialshare-via=\"{{\'facebookAppId\'|config}}\" socialshare-title={{$ctrl.material.title}} socialshare-media={{$ctrl.material.image}} socialshare-url=https://shakird.com/{{$root.languageService.currentLanguage}}/search/view/{{$ctrl.material.id}}> <img src=assets/images/social/facebook-lg.png alt=\"\"> <div>Facebook</div> </a> <a href socialshare socialshare-provider=twitter socialshare-text={{$ctrl.material.title}} socialshare-url=https://shakird.com/{{$root.languageService.currentLanguage}}/search/view/{{$ctrl.material.id}}> <img src=assets/images/social/twitter-lg.png alt=\"\"> <div>Twitter</div> </a> <a ng-if=\"$root.languageService.currentLanguage == \'en\'\" href socialshare socialshare-provider=google socialshare-text={{$ctrl.material.title}} socialshare-url=https://shakird.com/{{$root.languageService.currentLanguage}}/search/view/{{$ctrl.material.id}}> <img src=assets/images/social/google-lg.png alt=\"\"> <div>Google+</div> </a> <a ng-if=\"$root.languageService.currentLanguage == \'ru\'\" href socialshare socialshare-provider=vk socialshare-text={{$ctrl.material.title}} socialshare-description={{$ctrl.material.descr}} socialshare-media={{$ctrl.material.image}} socialshare-url=https://shakird.com/{{$root.languageService.currentLanguage}}/search/view/{{$ctrl.material.id}}> <img src=assets/images/social/vk.png alt=\"\"> <div>Vk</div> </a> </div><!-- <div class=\"clearfix\"></div> --> </div>");
$templateCache.put("app/views/shareProjectBanner.html","<div class=banner-share> <div class=content> <h4>{{\'share_with_friends_title\'|translate}}</h4> <p ng-bind-html=\"\'share_with_friends_text\'|translate|trustHtml\"></p> </div> <div class=links> <a href socialshare socialshare-provider=facebook socialshare-type=share socialshare-via=\"{{\'facebookAppId\'|config}}\" socialshare-title=\"{{\'site_share_title\'|configService}}\" socialshare-description=\"{{\'site_share_description\'|configService}}\" socialshare-media=\"{{\'https://shakird.com/assets/images/devices@2x.png\'|langSuffix}}\" socialshare-url=https://shakird.com/{{$root.languageService.currentLanguage}}> <img src=assets/images/social/facebook-lg.png alt=\"\"> <div>Facebook</div> </a> <a href socialshare socialshare-provider=twitter socialshare-text=\"{{\'site_share_title\'|configService}}\" socialshare-url=https://shakird.com/{{$root.languageService.currentLanguage}}> <img src=assets/images/social/twitter-lg.png alt=\"\"> <div>Twitter</div> </a> <a ng-if=\"$root.languageService.currentLanguage == \'en\'\" href socialshare socialshare-provider=google socialshare-text=\"{{\'site_share_title\'|configService}}\" socialshare-url=https://shakird.com/{{$root.languageService.currentLanguage}}> <img src=assets/images/social/google-lg.png alt=\"\"> <div>Google+</div> </a> <a ng-if=\"$root.languageService.currentLanguage == \'ru\'\" href socialshare socialshare-provider=vk socialshare-text=\"{{\'site_share_title\'|configService}}\" socialshare-description=\"{{\'site_share_description\'|configService}}\" socialshare-media=\"{{\'https://shakird.com/assets/images/devices@2x.png\'|langSuffix}}\" socialshare-url=https://shakird.com/{{$root.languageService.currentLanguage}}> <img src=assets/images/social/vk.png alt=\"\"> <div>Vk</div> </a> </div><!-- <div class=\"clearfix\"></div> --> </div>");
$templateCache.put("app/views/sprint.html","<div> <sprint-leader on-navigate=\"$ctrl.sprintIsOpen = false\"></sprint-leader> <p><a ui-sref=sprint.index ng-click=\"$ctrl.sprintIsOpen = false\">{{\'goto_sprint\'|translate}}</a></p> </div>");
$templateCache.put("app/components/about/about.html","<div class=\"container container-page-responsive\"> <div class=row> <div class=col-lg-8> <div class=page-header> <h1>{{$ctrl.page.title}}</h1> </div> <div ng-bind-html=$ctrl.page.body|trustHtml></div> </div> <div class=col-lg-4> <h2>{{ \'watch_us_youtube\' | translate }}</h2> <div class=border-block> <div class=g-ytsubscribe data-channelid=\"{{(\'youtube_url\'|configService).split(\'/\')[4]}}\" data-layout=full data-count=default></div> </div> </div> </div> </div>");
$templateCache.put("app/components/contacts/contacts.html","<div class=\"container container-page-responsive\"> <div class=page-header> <h1>{{$ctrl.page.title}}</h1> </div> <div ng-bind-html=$ctrl.page.body></div><!-- <br>\r\n	<h4>{{\'contact_form_text\'|translate}}</h4>\r\n	<div class=\"row\">\r\n		<div class=\"col-md-5 col-sm-8\">\r\n			<div class=\"panel panel-default\">\r\n				<div class=\"panel-body\">\r\n					<p class=\"form-alert text-danger\" ng-if=\"form.$invalid\">{{ \'all_fields_required_error\' | translate }}</p>\r\n					<form name=\"form\" ng-submit=\"$ctrl.onSubmit(form)\" novalidate>\r\n						<form-group-minimal name=\"name\">\r\n		                	<input type=\"text\" ng-required=\"true\" ng-model=\"$ctrl.data.name\" name=\"name\" placeholder=\"{{\'your_name\'|translate}}\">\r\n		                </form-group-minimal>\r\n						<form-group-minimal name=\"email\">\r\n		                    <input type=\"email\" ng-pattern=\"\'emailPattern\'|config\" ng-model=\"$ctrl.data.email\" name=\"email\" ng-required=\"true\" placeholder=\"{{\'email_text\'|translate}}\">\r\n		                </form-group-minimal>\r\n						<form-group-minimal name=\"message\">\r\n				            <textarea name=\"message\" ng-model=\"$ctrl.data.message\" placeholder=\"{{\'your_message\'|translate}}\" ng-required=\"true\" msd-elastic></textarea>\r\n				        </form-group-minimal>\r\n						<div class=\"form-actions\">\r\n							<button type=\"submit\" class=\"btn btn-primary btn-block\" ng-disabled=\"form.$invalid || $ctrl.dataLoading\" loading-replace=\"$ctrl.dataLoading\" loading-class=\"loading-white\">{{\'send_message\'|translate}}</button>\r\n						</div>\r\n					</form>\r\n				</div>\r\n			</div>\r\n		</div>\r\n	</div> --> </div>");
$templateCache.put("app/components/auth/login.html","<div class=container-page-responsive> <ng-include src=\"\'app/views/authTabs.html\'\" class=visible-phone></ng-include> <div class=container> <button type=button class=\"close hidden-phone\" ng-click=$ctrl.close()><i class=icon-close></i></button> <div class=row> <div class=\"col-sm-6 col-sm-offset-3\"> <h2 class=\"modal-title hidden-phone\">{{ \'authorization\' | translate }}</h2> <p class=text-danger ng-if=$ctrl.errors.recaptcha>{{\'recaptcha_error\'|translate}}</p> <p class=text-danger ng-if=\"$ctrl.errors.email || $ctrl.errors.password\">{{\'auth_error\'|translate}}</p> <form novalidate name=form ng-submit=$ctrl.onSubmit() role=form> <form-group-minimal name=email> <input type=email ng-pattern=\"\'emailPattern\'|config\" ng-model=$ctrl.email name=email ng-required=true ng-change=\"$ctrl.errors.email=false\" placeholder=\"{{\'email_text\'|translate}}\"> </form-group-minimal> <form-group-minimal name=password> <input type=password ng-model=$ctrl.password name=password placeholder=\"{{\'password\'|translate}}\" ng-required=true> </form-group-minimal> <div id=recaptcha-login></div> <div class=form-actions> <button type=submit ng-disabled=\"form.$invalid || $ctrl.dataLoading\" class=\"btn btn-primary btn-block\" loading-replace=$ctrl.dataLoading loading-class=loading-white>{{ \'sign_in\' | translate }}</button> <br> <a ui-sref=^.recover ng-click=$ctrl.onNavigate() class=pull-left><b>{{ \'forgot_password\' | translate }}</b></a> <a ui-sref=^.register ng-click=$ctrl.onNavigate() class=pull-right><b>{{ \'registration\' | translate }}</b></a> <div class=clearfix></div> </div> </form> <br> <p class=\"text-center text-muted\"><b>{{\'or_sign_in_with\'|translate}}</b></p> <oauth></oauth> </div> </div> </div> </div>");
$templateCache.put("app/components/auth/oauthConfirm.html","<div class=container-page-responsive> <div class=container> <button type=button class=close ng-click=$ctrl.close()><i class=icon-close></i></button> <br> <br> <div class=row ng-if=$ctrl.showEmailField> <div class=\"col-sm-8 col-md-6 col-md-offset-3 col-sm-offset-2\"> <h2 class=text-center>{{ \'oauth_enter_email\' | translate }}</h2> <form novalidate name=form> <form-group-minimal name=email> <input type=email email-busy-check ng-pattern=\"\'emailPattern\'|config\" ng-model=$ctrl.oauthData.user_data.email name=email ng-required=true placeholder=\"{{\'email_text\'|translate}}\"> </form-group-minimal> </form> </div> </div> <div class=row> <div class=\"col-sm-8 col-sm-offset-2\"> <br> <p class=\"text-muted text-center\"><b>{{\'agree_with\'|translate}} <a href=/pages/agreement target=_blank>{{\'user_agreement\'|translate}}</a></b></p> <br> <div class=\"row-buttons row-buttons-reverse\"> <button type=submit class=\"btn btn-primary btn-block-phone\" ng-click=$ctrl.confirm() ng-disabled=\"$ctrl.dataLoading || !$ctrl.oauthData.user_data.email\">{{ \'confirm_and_register\' | translate }}</button> <button type=button class=\"btn btn-link btn-block-phone\" ng-click=$ctrl.decline()>{{ \'cancel\' | translate }}</button> </div> </div> </div> </div> </div>");
$templateCache.put("app/components/auth/recoverEnterEmail.html","<div class=container-page-responsive> <div class=\"actions-bar top bb visible-phone\"> <button type=button class=close ng-click=$ctrl.close() style=line-height:0.8><i class=icon-close></i></button> <a class=td-none ui-sref=auth.login><i class=icon-arrow-left></i>&nbsp; {{\'back\'|translate}}</a> </div> <div class=container> <button type=button class=\"close hidden-phone\" ng-click=$ctrl.close()><i class=icon-close></i></button> <div class=row> <div class=\"col-sm-6 col-sm-offset-3\"> <h2 class=modal-title>{{\'forgot_password\'|translate}}</h2> <p>{{\'forgot_password_text\'|translate}}</p> <p class=text-danger ng-if=$ctrl.errors.recaptcha>{{\'recaptcha_error\'|translate}}</p> <p class=text-danger ng-if=$ctrl.errors.email>{{\'recover_email_error\'|translate}}</p> <form novalidate name=form ng-submit=$ctrl.onSubmit() role=form> <form-group-minimal name=email> <input type=email ng-pattern=\"\'emailPattern\'|config\" ng-model=$ctrl.data.email name=email ng-required=true ng-change=\"$ctrl.errors.email=false\" placeholder=\"{{\'email_text\'|translate}}\"> </form-group-minimal> <div id=recaptcha-recover></div> <div class=form-actions> <button type=submit ng-disabled=\"form.$invalid || $ctrl.dataLoading\" class=\"btn btn-primary btn-block\" loading-replace=$ctrl.dataLoading loading-class=loading-white>{{\'send_recover_email\'|translate}}</button> <br> <div class=text-center> <a ui-sref=auth.login ng-click=$ctrl.onNavigate()><b>{{ \'cancel\' | translate }}</b></a> </div> </div> </form> </div> </div> </div> </div>");
$templateCache.put("app/components/auth/recoverNewPassword.html","<div class=container-page-responsive> <div class=container> <button type=button class=\"close hidden-phone\" ng-click=$ctrl.close()><i class=icon-close></i></button> <div class=row> <div class=\"col-sm-6 col-sm-offset-3\"> <h2 class=modal-title>{{\'enter_new_password\'|translate}}</h2> <p class=text-danger ng-if=$ctrl.errorMessage>{{\'recover_password_error\'|translate}}</p> <form novalidate name=form ng-submit=$ctrl.onSubmit() role=form> <form-group-minimal name=password> <input type=password ng-model=$ctrl.data.password name=password placeholder=\"{{\'new_password\'|translate}}\" ng-required=true password> </form-group-minimal> <div class=form-actions> <button type=submit ng-disabled=\"form.$invalid || $ctrl.dataLoading\" class=\"btn btn-primary btn-block\" loading-replace=$ctrl.dataLoading loading-class=loading-white>{{\'change_password\'|translate}}</button> </div> </form> </div> </div> </div> </div>");
$templateCache.put("app/components/auth/register.html","<div class=container-page-responsive> <ng-include src=\"\'app/views/authTabs.html\'\" class=visible-phone></ng-include> <div class=container> <button type=button class=\"close hidden-phone\" ng-click=$ctrl.close()><i class=icon-close></i></button> <div class=row> <div class=\"col-sm-6 col-sm-offset-3\"> <h2 class=\"modal-title hidden-phone\">{{ \'registration\' | translate }}</h2> <p class=text-danger ng-if=$ctrl.errors.recaptcha>{{\'recaptcha_error\'|translate}}</p> <p class=text-danger ng-if=\"$ctrl.errors.email || $ctrl.errors.password || $ctrl.errors.agreement\">{{\'register_error\'|translate}}</p> <form novalidate name=form role=form ng-submit=$ctrl.onSubmit()> <form-group-minimal name=email> <input type=email email-busy-check ng-pattern=\"\'emailPattern\'|config\" ng-model=$ctrl.user.email name=email ng-required=true ng-change=\"form.email.$setValidity(\'wrong_email\',true)\" placeholder=\"{{\'email_text\'|translate}}\"> </form-group-minimal> <form-group-minimal name=password> <input type=password ng-model=$ctrl.user.password name=password placeholder=\"{{\'password\'|translate}}\" ng-required=true ng-change=\"$ctrl.errors.password=false\" password> </form-group-minimal> <div class=\"form-group form-group-minimal\" ng-class=\"{ \'has-error\': form.agreement.$dirty && form.agreement.$invalid }\" tooltip-error=agreement> <div class=checkbox> <label> <input type=checkbox name=agreement ng-model=$ctrl.user.agreement required> <div translate=accept_user_agreement_link translate-value-link=\"<a ui-sref=&quot;page({key:\'agreement\'})&quot; target=&quot;_blank&quot;>{{\'user_agreement\'|translate}}</a>\"></div> </label> </div> </div> <div id=recaptcha-register></div> <div class=form-actions> <button type=submit ng-disabled=\"form.$invalid || $ctrl.dataLoading\" loading-replace=$ctrl.dataLoading loading-class=loading-white class=\"btn btn-primary btn-block\">{{ \'sign_up\' | translate }}</button> <br> <div class=text-center> <a ui-sref=auth.login ng-click=$ctrl.onNavigate()><b>{{ \'already_registered\' | translate }}</b></a> </div> </div> </form> <br> <p class=\"text-center text-muted\"><b>{{\'or_sign_up_with\'|translate}}</b></p> <oauth></oauth> </div> </div> </div> </div>");
$templateCache.put("app/components/courses/_coursesAutocomplete.html","<div id=courses-autocomplete-results> <div class=title>{{ \'courses\' | translate }} ({{$ctrl.searchResults.courses_count}})</div> <course-list-short items=$ctrl.searchResults.courses></course-list-short> <br> <div class=title>{{ \'people\' | translate }} ({{$ctrl.searchResults.usersCount}})</div> <user-list items=$ctrl.searchResults.users></user-list> <div class=bottom-panel> <a href ng-click=$ctrl.applySearchQuery()>{{ \'show_all_results\' | translate }}</a> </div> </div>");
$templateCache.put("app/components/courses/_searchModal.html","<div class=material-search-modal-grid> <div class=modal-header> <button type=button class=close ng-click=$ctrl.close()><i class=icon-close></i></button> <h1 class=modal-title>{{\'search\'|translate}}</h1> </div> <div> <ul class=\"nav nav-tabs nav-center\" style=\"margin-bottom: 0px\"> <li class=active> <a href>{{ \'courses\' | translate }}</a> </li> </ul> </div> <div class=column-container> <div class=\"column padded\"> <div class=\"form-group form-group-icon-right\" style=margin-bottom:0><input class=\"form-control ng-pristine ng-valid ng-empty ng-touched\" type=text id=search-modal-query ng-model=$ctrl.$parent.searchQuery ng-model-options={debounce:500,getterSetter:true} placeholder=\"{{ \'search\' | translate }}\"> <i class=\"icon icon-search icon-gray\" style=\"cursor: pointer\" ng-click=$ctrl.submit()></i></div> </div> </div> <div class=\"column-container main\"> <div class=\"column bordered list\"> <ul class=\"nav nav-check\"> <li ng-click=\"$ctrl.active = \'format\'\" ng-class=\"{active: $ctrl.active == \'format\', checked: $ctrl.$parent.params[\'type[]\'].length}\">{{ \'format\' | translate }}</li> <li ng-click=\"$ctrl.active = \'category\'\" ng-class=\"{active: $ctrl.active == \'category\', checked: $ctrl.$parent.params[\'category_id[]\'].length}\">{{ \'type\' | translate }}</li> <li ng-click=\"$ctrl.active = \'subject\'\" ng-class=\"{active: $ctrl.active == \'subject\', checked: $ctrl.$parent.params[\'subject_id[]\'].length}\">{{ \'subject\' | translate }}</li> <li ng-click=\"$ctrl.active = \'source\'\" ng-class=\"{active: $ctrl.active == \'source\', checked: $ctrl.$parent.params[\'source_id[]\'].length}\">{{ \'source\' | translate }}</li> <li ng-click=\"$ctrl.active = \'rating\'\" ng-class=\"{active: $ctrl.active == \'rating\', checked: $ctrl.$parent.params.sort_rating}\">{{ \'rating\' | translate }}</li> <li ng-if=$root.isLoggedIn() ng-click=\"$ctrl.active = \'finished\'\" ng-class=\"{active: $ctrl.active == \'finished\', checked: $ctrl.$parent.params.not_finished}\">{{ \'finished\' | translate }}</li> </ul> </div> <div class=\"column padded bordered list\"> <ul ng-if=\"$ctrl.active == \'format\'\" class=list-check> <li ng-class=\"{checked: $ctrl.$parent.params[\'type[]\'] && $ctrl.$parent.params[\'type[]\'].indexOf(\'video\')!=-1}\"> <label>{{ \'video\' | translate }}<input class=hidden checklist-model=\"$ctrl.$parent.params[\'type[]\']\" value=video type=checkbox></label> </li> <li ng-class=\"{checked: $ctrl.$parent.params[\'type[]\'] && $ctrl.$parent.params[\'type[]\'].indexOf(\'audio\')!=-1}\"> <label>{{ \'audio\' | translate }}<input class=hidden checklist-model=\"$ctrl.$parent.params[\'type[]\']\" value=audio type=checkbox></label> </li> <li ng-class=\"{checked: $ctrl.$parent.params[\'type[]\'] && $ctrl.$parent.params[\'type[]\'].indexOf(\'text\')!=-1}\"> <label>{{ \'text\' | translate }}<input class=hidden checklist-model=\"$ctrl.$parent.params[\'type[]\']\" value=text type=checkbox></label> </li> </ul> <ul ng-if=\"$ctrl.active == \'category\'\" class=list-check> <li ng-repeat=\"c in $ctrl.$parent.categories\" ng-class=\"{checked: $ctrl.$parent.params[\'category_id[]\'] && $ctrl.$parent.params[\'category_id[]\'].indexOf(c.value)!=-1}\"> <label>{{ c.text }}<input class=hidden checklist-model=\"$ctrl.$parent.params[\'category_id[]\']\" checklist-value=c.value type=checkbox></label> </li> </ul> <ul ng-if=\"$ctrl.active == \'subject\'\" class=list-check> <li ng-repeat=\"s in $ctrl.$parent.subjects\" ng-class=\"{checked: $ctrl.$parent.params[\'subject_id[]\'] && $ctrl.$parent.params[\'subject_id[]\'].indexOf(s.value)!=-1}\"> <label>{{ s.text }}<input class=hidden checklist-model=\"$ctrl.$parent.params[\'subject_id[]\']\" checklist-value=s.value type=checkbox></label> </li> </ul> <ul ng-if=\"$ctrl.active == \'source\'\" class=list-check> <li ng-repeat=\"s in $ctrl.$parent.sources\" ng-class=\"{checked: $ctrl.$parent.params[\'source_id[]\'] && $ctrl.$parent.params[\'source_id[]\'].indexOf(s.value)!=-1}\"> <label>{{ s.text }}<input class=hidden checklist-model=\"$ctrl.$parent.params[\'source_id[]\']\" checklist-value=s.value type=checkbox></label> </li> </ul> <ul ng-if=\"$ctrl.active == \'rating\'\" class=list-check> <li ng-repeat=\"r in $ctrl.$parent.sortRatingOptions\" ng-class=\"{checked: $ctrl.$parent.params.sort_rating == r.value}\"> <label>{{ r.text | translate }}<input class=hidden ng-click=\"$ctrl.$parent.params.sort_rating = r.value\" type=checkbox></label> </li> <li ng-class=\"{checked: !$ctrl.$parent.params.sort_rating}\"> <label>{{ \'no_rating\' | translate }}<input class=hidden ng-click=\"$ctrl.$parent.params.sort_rating = null\" type=checkbox></label> </li> </ul> <ul ng-if=\"$ctrl.active == \'finished\'\" class=list-check> <li ng-class=\"{checked: $ctrl.$parent.params.not_finished}\"> <label>{{ \'hide_finished\' | translate }}<input class=hidden ng-click=\"$ctrl.$parent.params.not_finished = $ctrl.$parent.params.not_finished ? null : 1\" type=checkbox></label> </li> </ul> </div> </div> <div class=actions> <button class=\"btn btn-primary btn-invert\" type=button ng-click=\"$ctrl.$parent.searchReset(); $ctrl.submit();\">{{\'clear_all\'|translate}}</button> <button class=\"btn btn-primary\" type=button ng-click=$ctrl.submit(); loading-overlay=$ctrl.$parent.loading loading-hide-content=true loading-class=loading-white>{{\'show\'|translate}} ({{ $ctrl.$parent.pagination && $ctrl.$parent.pagination.totalCount || 0 }})</button> </div> </div>");
$templateCache.put("app/components/courses/add.html","<ui-view name=page> <div class=\"container container-page-responsive\"> <div class=page-header> <button type=button class=close ng-click=$ctrl.close()><i class=icon-close></i></button> <h1>{{\'adding_course\' | translate}}</h1> <div class=\"text-muted text-center-tablet\">{{\'all_fields_required_error\' | translate}}</div> </div> <ul class=\"nav nav-tabs\"> <li class=active> <a href>{{\'course_descr\'|translate}}</a> </li> <li class=disabled> <a href>{{\'course_materials\'|translate}}</a> </li> </ul> <form novalidate name=form ng-submit=$ctrl.submit() role=form> <course-details-form model=$ctrl.model subjects=$ctrl.subjects categories=$ctrl.categories></course-details-form> </form> <div class=actions-bar-bottom> <div class=container> <button ng-disabled=\"form.$invalid || $ctrl.loading\" class=\"btn btn-primary pull-right\" ng-click=$ctrl.submit() loading-overlay=$ctrl.loading loading-class=loading-white loading-hide-content=true>{{ \'goto_course_materials\' | translate }} &nbsp; <i class=icon-arrow-right></i></button> <button class=\"btn btn-link btn-link-narrow\" ng-click=$ctrl.delete() confirm=\"{{\'delete_course_confirm\' | translate}}\" confirm-ok=\"{{\'yes_delete\' | translate}}\" confirm-cancel=\"{{\'cancel_delete\' | translate}}\" confirm-title=\"{{\'delete_confirmation\' | translate}}\">{{ \'delete_course\' | translate }}</button> </div> </div> </div> </ui-view>");
$templateCache.put("app/components/courses/favorite.html","<div class=\"container container-page-responsive\"> <ng-include src=$ctrl.tabsTemplate></ng-include> <h1>{{\'courses_favorite\'|translate}} ({{$ctrl.pagination.totalCount}})</h1> <div class=text-center ng-if=\"$ctrl.loading && !$ctrl.pagination.totalCount\"><div class=loading></div></div> <course-list items=$ctrl.courses ng-if=$ctrl.pagination.totalCount></course-list> <div class=text-center-tablet ng-if=\"$ctrl.pagination.totalCount > 0\"> <button class=\"btn btn-primary btn-block-phone\" ng-if=\"$ctrl.pagination.currentPage < $ctrl.pagination.pageCount\" ng-click=$ctrl.load($ctrl.pagination.currentPage+1) loading-overlay=$ctrl.loading loading-hide-content=true loading-class=loading-white>{{ \'show_more\' | translate }}</button> </div> </div>");
$templateCache.put("app/components/courses/finished.html","<div class=\"container container-page-responsive\"> <div class=page-header> <h1>{{\'courses_finished_title\' | translate}} ({{$ctrl.pagination.totalCount}})</h1> </div> <div class=text-center ng-if=\"$ctrl.loading && !$ctrl.pagination.totalCount\"><div class=loading></div></div> <course-list items=$ctrl.courses ng-if=$ctrl.pagination.totalCount></course-list> <div class=text-center-tablet ng-if=\"$ctrl.pagination.totalCount > 0\"> <button class=\"btn btn-primary btn-block-phone\" ng-if=\"$ctrl.pagination.currentPage < $ctrl.pagination.pageCount\" ng-click=$ctrl.load($ctrl.pagination.currentPage+1) loading-overlay=$ctrl.loading loading-hide-content=true loading-class=loading-white>{{ \'show_more\' | translate }}</button> </div> </div>");
$templateCache.put("app/components/courses/inProgress.html","<div class=\"container container-page-responsive\"> <div class=page-header> <h1>{{\'courses_in_progress_title\' | translate}} ({{$ctrl.pagination.totalCount}})</h1> </div> <div class=text-center ng-if=\"$ctrl.loading && !$ctrl.pagination.totalCount\"><div class=loading></div></div> <course-list items=$ctrl.courses ng-if=$ctrl.pagination.totalCount></course-list> <div class=text-center-tablet ng-if=\"$ctrl.pagination.totalCount > 0\"> <button class=\"btn btn-primary btn-block-phone\" ng-if=\"$ctrl.pagination.currentPage < $ctrl.pagination.pageCount\" ng-click=$ctrl.load($ctrl.pagination.currentPage+1) loading-overlay=$ctrl.loading loading-hide-content=true loading-class=loading-white>{{ \'show_more\' | translate }}</button> </div> </div>");
$templateCache.put("app/components/courses/index.$desktop.html","<div class=container-page-responsive> <banner-top position=courses class=bg-1 ng-if=!$ctrl.showSearchResults></banner-top> <div class=container> <form> <div class=\"form-group form-group-icon-right\"> <input class=form-control id=courses-autocomplete-input type=text autocomplete=off ng-model=$ctrl.searchQueryResults ng-model-options={debounce:500,getterSetter:true} placeholder=\"{{\'search\'|translate}}\" uib-popover-template=\"\'app/components/courses/_coursesAutocomplete.html\'\" popover-is-open=$ctrl.searchOpen popover-class=courses-autocomplete popover-placement=bottom-left popover-trigger=\"\'none\'\" popover-append-to-body=false ng-keyup=$ctrl.searchKeyUp($event)> <i class=\"icon icon-search icon-gray\"></i> </div> <div class=search-actions> <div class=pull-left> <label class=action><input type=checkbox checklist-model=\"$ctrl.params[\'type[]\']\" checklist-value=\"\'video\'\"> {{ \'video\' | translate }}</label> <label class=action><input type=checkbox checklist-model=\"$ctrl.params[\'type[]\']\" checklist-value=\"\'audio\'\"> {{ \'audio\' | translate }}</label> <label class=action><input type=checkbox checklist-model=\"$ctrl.params[\'type[]\']\" checklist-value=\"\'text\'\"> {{ \'text\' | translate }}</label> </div> <div class=pull-right> <span uib-dropdown class=action> <a href uib-dropdown-toggle class=td-none> {{ $ctrl.currentSubjects.length && $ctrl.currentSubjects[0].text || (\'subject\'|translate) || \'\' }} <i class=icon-angle-down></i> </a> <ul uib-dropdown-menu> <li><a href ng-click=\"$ctrl.params[\'subject_id[]\'] = null\">{{\'all\'|translate}}</a></li> <li ng-repeat=\"s in $ctrl.subjects\"><a href ng-click=\"$ctrl.params[\'subject_id[]\'] = [s.value]\">{{s.text|translate}}</a></li> </ul> </span> <span uib-dropdown class=action> <a href uib-dropdown-toggle class=td-none> {{ $ctrl.currentCategories.length && $ctrl.currentCategories[0].text || (\'type\'|translate) || \'\' }} <i class=icon-angle-down></i> </a> <ul uib-dropdown-menu> <li><a href ng-click=\"$ctrl.params[\'category_id[]\'] = null\">{{\'all\'|translate}}</a></li> <li ng-repeat=\"c in $ctrl.categories\"><a href ng-click=\"$ctrl.params[\'category_id[]\'] = [c.value]\">{{c.text|translate}}</a></li> </ul> </span> <span uib-dropdown class=action> <a href uib-dropdown-toggle class=td-none> {{ $ctrl.currentSources.length && $ctrl.currentSources[0].text || (\'source\'|translate) || \'\' }} <i class=icon-angle-down></i> </a> <ul uib-dropdown-menu> <li><a href ng-click=\"$ctrl.params[\'source_id[]\'] = null\">{{\'all\'|translate}}</a></li> <li ng-repeat=\"s in $ctrl.sources\"><a href ng-click=\"$ctrl.params[\'source_id[]\'] = [s.value]\">{{s.text|translate}}</a></li> </ul> </span> <span uib-dropdown class=action> <a href uib-dropdown-toggle class=td-none> {{ $ctrl.currentRating && ($ctrl.currentRating.text|translate) || (\'rating\'|translate) || \'\' }} <i class=icon-angle-down></i> </a> <ul uib-dropdown-menu> <li ng-repeat=\"r in $ctrl.sortRatingOptions\"><a href ng-click=\"$ctrl.params.sort_rating = r.value\">{{r.text|translate}}</a></li> <li><a href ng-click=\"$ctrl.params.sort_rating = null\">{{\'no_rating\'|translate}}</a></li> </ul> </span> <span ng-if=$root.isLoggedIn() uib-dropdown class=action> <a href uib-dropdown-toggle class=td-none> {{ \'more\' | translate }} <i class=icon-angle-down></i> </a> <ul uib-dropdown-menu> <li><a href ng-click=\"$ctrl.params.not_finished = $ctrl.params.not_finished ? null : 1\"> <input type=checkbox ng-checked=\"$ctrl.params.not_finished == 1\"> {{\'hide_finished\'|translate}} </a></li> </ul> </span> </div> <div class=clearfix></div> </div> </form> <div ng-if=$ctrl.showSearchResults> <div class=text-center ng-if=\"$ctrl.loading && !$ctrl.pagination.totalCount\"><div class=loading></div></div> <div ng-if=\"!$ctrl.loading || $ctrl.pagination.totalCount\"> <h1>{{ \'courses\' | translate }} ({{$ctrl.pagination.totalCount+0}})</h1> <div class=search-tags> <button class=\"btn btn-xs btn-primary\" ng-repeat=\"s in $ctrl.currentSubjects\" delete-overlay=true ng-click=\"$ctrl.unsetParam(\'subject_id[]\', s.value)\">{{ s.text }}</button> <button class=\"btn btn-xs btn-primary\" ng-repeat=\"s in $ctrl.currentCategories\" delete-overlay=true ng-click=\"$ctrl.unsetParam(\'category_id[]\', s.value)\">{{ s.text }}</button> <button class=\"btn btn-xs btn-primary\" ng-repeat=\"s in $ctrl.currentSources\" delete-overlay=true ng-click=\"$ctrl.unsetParam(\'source_id[]\', s.value)\">{{ s.text }}</button> <button class=\"btn btn-xs btn-primary\" ng-repeat=\"s in $ctrl.params[\'title[]\']\" delete-overlay=true ng-click=\"$ctrl.searchQueryDelete(s); $ctrl.applySearchQuery();\">{{ s }}</button> <button class=\"btn btn-xs btn-primary\" ng-if=$ctrl.params.sort_rating delete-overlay=true ng-click=\"$ctrl.params.sort_rating = null\"> {{ $ctrl.currentRating.text | translate }} </button> <button class=\"btn btn-xs btn-primary\" ng-if=$ctrl.params.not_finished delete-overlay=true ng-click=\"$ctrl.params.not_finished = null\"> {{ \'hide_finished\' | translate }} </button> </div> <course-list items=$ctrl.courses></course-list> </div> <div class=text-center-tablet ng-if=\"$ctrl.pagination.totalCount > 0\"> <button class=\"btn btn-primary btn-block-phone\" ng-if=\"$ctrl.pagination.currentPage < $ctrl.pagination.pageCount\" ng-click=$ctrl.load($ctrl.pagination.currentPage+1) loading-overlay=$ctrl.loading loading-hide-content=true loading-class=loading-white>{{ \'show_more\' | translate }}</button> </div> <br> <br> <user-search-result params=$ctrl.params exclude=$ctrl.ps.currentUser.id per-page=12 cols=3 sprint=false></user-search-result> </div> <div ng-if=!$ctrl.showSearchResults> <course-recommend style=display:block;margin-bottom:30px></course-recommend> <course-best></course-best> </div> </div> </div>");
$templateCache.put("app/components/courses/index.$mobile.html","<div class=container-page-responsive> <div class=\"actions-bar top bb\" ng-if=$ctrl.showSearchResults> <a class=td-none ng-click=\"$ctrl.params = {}\"><i class=icon-arrow-left></i>&nbsp; {{\'all_materials\'|translate}}</a> </div> <div class=container> <banner-top position=courses class=bg-1 ng-if=!$ctrl.showSearchResults></banner-top> <div ng-if=!$ctrl.showSearchResults> <form> <div class=\"form-group form-group-icon-right\"> <input class=form-control type=text ng-model=$ctrl.searchQuery ng-model-options={debounce:500,getterSetter:true} placeholder=\"{{\'search\'|translate}}\" ng-click=$ctrl.openModalSearch()> <i class=\"icon icon-search icon-gray\"></i> </div> </form> </div> <div ng-if=$ctrl.showSearchResults> <div class=text-center ng-if=\"$ctrl.loading && !$ctrl.pagination.totalCount\"><div class=loading></div></div> <div ng-if=\"!$ctrl.loading || $ctrl.pagination.totalCount\"> <h1>{{ \'courses\' | translate }} ({{$ctrl.pagination.totalCount+0}})</h1> <div> <p class=text-center-tablet ng-if=\"$ctrl.params[\'title[]\']\">{{ \'query_results\' | translate }}: <span class=text-primary><i>«{{ $ctrl.params[\'title[]\'].join(\' \') }}»</i></span></p> <div class=row> <div class=col-xs-6> <button class=\"btn btn-primary btn-invert btn-block\" ng-click=\"$ctrl.searchReset(); $ctrl.openModalSearch();\">{{ \'new_search\' | translate }}</button> </div> <div class=col-xs-6> <button class=\"btn btn-success btn-invert btn-block\" ng-click=$ctrl.openModalSearch()><i class=icon-accept-bold></i> {{ \'filter\' | translate }} ({{ $ctrl.paramsCount }})</button> </div> </div> <br> </div> <course-list items=$ctrl.courses></course-list> </div> <div class=text-center-tablet ng-if=\"$ctrl.pagination.totalCount > 0\"> <button class=\"btn btn-primary btn-block-phone\" ng-if=\"$ctrl.pagination.currentPage < $ctrl.pagination.pageCount\" ng-click=$ctrl.load($ctrl.pagination.currentPage+1) loading-overlay=$ctrl.loading loading-hide-content=true loading-class=loading-white>{{ \'show_more\' | translate }}</button> </div> <br> <br> <user-search-result params=$ctrl.params exclude=$ctrl.ps.currentUser.id per-page=12 cols=3 sprint=false></user-search-result> </div> <div ng-if=!$ctrl.showSearchResults> <course-recommend style=display:block;margin-bottom:30px></course-recommend> <course-best></course-best> </div> </div> </div>");
$templateCache.put("app/components/courses/my.html","<div class=\"container container-page-responsive\"> <div class=page-header> <button class=\"btn btn-primary pull-right\" ui-sref=^.add>{{\'add_course\' | translate}}</button> <h1>{{\'courses_my_title\' | translate}} ({{$ctrl.pagination.totalCount}})</h1> </div> <div class=text-center ng-if=\"$ctrl.loading && !$ctrl.pagination.totalCount\"><div class=loading></div></div> <course-list items=$ctrl.courses ng-if=$ctrl.pagination.totalCount></course-list> <div class=text-center-tablet ng-if=\"$ctrl.pagination.totalCount > 0\"> <button class=\"btn btn-primary btn-block-phone\" ng-if=\"$ctrl.pagination.currentPage < $ctrl.pagination.pageCount\" ng-click=$ctrl.load($ctrl.pagination.currentPage+1) loading-overlay=$ctrl.loading loading-hide-content=true loading-class=loading-white>{{ \'show_more\' | translate }}</button> </div> </div>");
$templateCache.put("app/components/courses/next.html","<div class=container-page-responsive> <div class=\"actions-bar top bb visible-tablet\"> <a class=td-none ng-click=$ctrl.close()><i class=icon-arrow-left></i>&nbsp; {{\'back\'|translate}}</a> </div> <div class=container> <div class=page-header> <button type=button class=\"close hidden-tablet\" ng-click=$ctrl.close()><i class=icon-close></i></button> <div class=row ng-if=\"$ctrl.trainingId && !$ctrl.result\"> <div class=\"col-sm-10 col-sm-offset-1\"> <div class=\"panel panel-default\"> <div class=\"panel-body text-center\"> <h1>{{ \'goto_test_title\' | translate }}</h1> <p>{{ \'goto_test_text\' | translate }}</p> <br> <button class=\"btn btn-primary\" ui-sref=\"^.training({trainingId: $ctrl.trainingId})\">{{ \'goto_test\' | translate }} &nbsp; <i class=icon-arrow-right></i></button> <br><br> </div> </div> </div> </div> <div class=row ng-if=$ctrl.result> <div class=\"col-sm-10 col-sm-offset-1\"> <training-result title=$ctrl.material.title correct=$ctrl.result.correct wrong=$ctrl.result.wrong points=$ctrl.result.points></training-result> </div> </div> <h1>{{\'course_materials_next\' | translate}}</h1> </div> <div class=text-center ng-if=\"$ctrl.loading && !$ctrl.pagination.totalCount\"><div class=loading></div></div> <material-list items=$ctrl.materials ng-if=$ctrl.pagination.totalCount></material-list> <div class=text-center-tablet ng-if=\"$ctrl.pagination.totalCount > 0\"> <button class=\"btn btn-primary btn-block-phone\" ng-if=\"$ctrl.pagination.currentPage < $ctrl.pagination.pageCount\" ng-click=$ctrl.load($ctrl.pagination.currentPage+1) loading-overlay=$ctrl.loading loading-hide-content=true loading-class=loading-white>{{ \'show_more\' | translate }}</button> </div> <banner ng-if=\"!$ctrl.trainingId && !$ctrl.result\" class=\"banner-simple banner-2-col\" close-button=false><ng-include src=\"\'app/views/shareProjectBanner.html\'\"></ng-include></banner> </div> </div>");
$templateCache.put("app/components/courses/questions.html","<div class=container-page-responsive> <div class=\"actions-bar top bb\" ng-if=!$root.isDesktop> <a class=td-none ui-sref=^.^><i class=icon-arrow-left></i>&nbsp; {{\'back\'|translate}}</a> </div> <div class=container> <div class=page-header> <button type=button class=close ui-sref=^.^><i class=icon-close></i></button> <h1 ng-if=!$ctrl.training>{{ \'adding_test\' | translate }}</h1> <h1 ng-if=$ctrl.training>{{ \'updating_test\' | translate }}</h1> <p>{{$ctrl.material.title}}</p> </div> <form novalidate name=form ng-submit=$ctrl.submit() role=form class=questions-form> <div class=row ng-repeat=\"d in $ctrl.data track by $index\" style=\"margin-bottom: 50px\"> <div class=\"col-xs-12 col-sm-8\"> <h4> {{ \'question\' | translate }} {{$index+1}} {{ \'of_count\' | translate:{count:$ctrl.data.length} }} <span style=cursor:pointer class=action ng-if=\"$index > 2\" ng-click=\"$ctrl.data.splice($index, 1)\" confirm=\"{{\'delete_training_question_confirm\' | translate}}\" confirm-ok=\"{{\'yes_delete\' | translate}}\" confirm-cancel=\"{{\'cancel_delete\' | translate}}\" confirm-title=\"{{\'delete_confirmation\' | translate}}\"><i class=icon-close></i></span> </h4> <div class=question> <form-group-minimal name=question_{{$index}} show-dirty=true> <textarea name=question_{{$index}} ng-model=d.question placeholder=\"{{\'enter_question\'|translate}}\" ng-required=true ng-maxlength=500 rows=1 msd-elastic></textarea> </form-group-minimal> </div> <table width=100%> <tr> <td width=40> <div class=\"circle-checkbox checkbox-success\" uib-tooltip=\"{{\'check_as_correct\'|translate}}\" ng-class=\"{selected: d.answer == 0, \'has-error\': d.answer == null && form[\'variants_\'+$index+\'_3\'].$dirty}\" ng-click=\"d.answer = 0\"></div> </td> <td> <form-group-minimal name=variants_{{$index}}_0 show-dirty=true> <textarea name=variants_{{$index}}_0 ng-model=d.variants[0] placeholder=\"{{ \'answer_number\'|translate:{number:1} }}\" ng-required=true ng-maxlength=500 rows=1 msd-elastic></textarea> </form-group-minimal> </td> </tr> <tr> <td width=40> <div class=\"circle-checkbox checkbox-success\" uib-tooltip=\"{{\'check_as_correct\'|translate}}\" ng-class=\"{selected: d.answer == 1, \'has-error\': d.answer == null && form[\'variants_\'+$index+\'_3\'].$dirty}\" ng-click=\"d.answer = 1\"></div> </td> <td> <form-group-minimal name=variants_{{$index}}_1 show-dirty=true> <textarea name=variants_{{$index}}_1 ng-model=d.variants[1] placeholder=\"{{ \'answer_number\'|translate:{number:2} }}\" ng-required=true ng-maxlength=500 rows=1 msd-elastic></textarea> </form-group-minimal> </td> </tr> <tr> <td width=40> <div class=\"circle-checkbox checkbox-success\" uib-tooltip=\"{{\'check_as_correct\'|translate}}\" ng-class=\"{selected: d.answer == 2, \'has-error\': d.answer == null && form[\'variants_\'+$index+\'_3\'].$dirty}\" ng-click=\"d.answer = 2\"></div> </td> <td> <form-group-minimal name=variants_{{$index}}_2 show-dirty=true> <textarea name=variants_{{$index}}_2 ng-model=d.variants[2] placeholder=\"{{ \'answer_number\'|translate:{number:3} }}\" ng-required=true ng-maxlength=500 rows=1 msd-elastic></textarea> </form-group-minimal> </td> </tr> <tr> <td width=40> <div class=\"circle-checkbox checkbox-success\" uib-tooltip=\"{{\'check_as_correct\'|translate}}\" ng-class=\"{selected: d.answer == 3, \'has-error\': d.answer == null && form[\'variants_\'+$index+\'_3\'].$dirty}\" ng-click=\"d.answer = 3\"></div> </td> <td> <form-group-minimal name=variants_{{$index}}_3 show-dirty=true> <textarea name=variants_{{$index}}_3 ng-model=d.variants[3] placeholder=\"{{ \'answer_number\'|translate:{number:4} }}\" ng-required=true ng-maxlength=500 rows=1 msd-elastic></textarea> </form-group-minimal> </td> </tr> </table> </div> <div class=\"col-xs-12 col-sm-4\"> <div class=image-preview loading-overlay=$ctrl.imageLoading[$index] delete-overlay=d.image delete-action=$ctrl.imageDelete($index) delete-icon-class=icon-delete-circle><!-- <img ng-if=\"d.image\" ng-src=\"{{d.image}}\" alt=\"\"> --> <div ng-if=d.image class=img style=\"background-image: url(\'{{d.image}}\')\"></div> <div ng-if=\"!d.image && !$ctrl.imageLoading[$index]\" class=button-overlay> <file-upload-button uploader-config=$ctrl.imageUploaderConfig on-success=\"$ctrl.imageUploaded(file, $index)\" on-before-upload=\"$ctrl.imageLoading[$index] = true\" on-complete=\"$ctrl.imageLoading[$index] = false\" btn-class=\"btn-primary btn-invert\" images-only=true>{{ \'select_file\' | translate }}</file-upload-button> </div> </div><!-- <br> --> <div class=\"text-center text-muted\">{{\'question_image_text\' | translate}}</div> </div> </div> <div class=actions-bar-bottom> <div class=container> <div class=pull-right> <button ng-if=\"$ctrl.data.length < 10\" type=button class=\"btn btn-primary btn-invert\" ng-click=\"$ctrl.data[$ctrl.data.length] = {}\">{{ \'add_question\' | translate }}</button> <button ng-if=$ctrl.training type=submit ng-disabled=\"form.$invalid || $ctrl.loading || $ctrl.hasError()\" class=\"btn btn-primary\" loading-overlay=$ctrl.loading loading-class=loading-white loading-hide-content=true>{{ \'save_changes\' | translate }}</button> <button ng-if=!$ctrl.training type=submit ng-disabled=\"form.$invalid || $ctrl.loading || $ctrl.hasError()\" class=\"btn btn-primary\" loading-overlay=$ctrl.loading loading-class=loading-white loading-hide-content=true>{{ \'add_test\' | translate }}</button> </div> <button type=button class=\"btn btn-link btn-link-narrow\" ng-click=$ctrl.delete() confirm=\"{{\'delete_course_test_confirm\' | translate}}\" confirm-ok=\"{{\'yes_delete\' | translate}}\" confirm-cancel=\"{{\'cancel_delete\' | translate}}\" confirm-title=\"{{\'delete_confirmation\' | translate}}\">{{ \'delete_test\' | translate }}</button> </div> </div> </form> </div> </div>");
$templateCache.put("app/components/courses/searchMaterial.html","<div class=container-page-responsive> <div class=\"actions-bar top bb\" ng-if=\"$root.isTablet && !$ctrl.showSearchResults\"> <a class=td-none ng-click=$ctrl.close()><i class=icon-arrow-left></i>&nbsp; {{\'back\'|translate}}</a> </div> <div class=\"actions-bar top bb\" ng-if=\"$root.isTablet && $ctrl.showSearchResults\"> <a class=td-none ng-click=\"$ctrl.params = {}\"><i class=icon-arrow-left></i>&nbsp; {{\'all_materials\'|translate}}</a> </div> <div class=container> <div class=page-header> <button type=button class=close ng-click=$ctrl.close() ng-if=$root.isDesktop><i class=icon-close></i></button> <h1>{{ \'adding_material\' | translate }}</h1> </div> <material-search-form params=$ctrl.params on-submit=\"$ctrl.params = params\" total-count=$ctrl.totalCount loading=$ctrl.loading></material-search-form> <material-search-result add-to-course=true on-add-to-course=$ctrl.onAddToCourse({model:model}) course-materials=$ctrl.materials params=$ctrl.params per-page=12 on-start-loading=\"$ctrl.loading = true;\" on-finish-loading=\"$ctrl.totalCount = totalCount; $ctrl.loading = false;\" on-change-params=\"$ctrl.params = params\"></material-search-result> </div> <div class=actions-bar-bottom> <div class=container> <div class=pull-right> <button ng-click=$ctrl.close() class=\"btn btn-primary btn-invert\"><i class=icon-arrow-left></i>&nbsp; {{ \'back\' | translate }}</button> </div> </div> </div> </div>");
$templateCache.put("app/components/courses/training.html","<div class=\"container container-page-responsive training-page\"> <div class=page-header> <button type=button class=close ui-sref=^><i class=icon-close></i></button> <div class=task-title>{{$ctrl.material.title}}</div> </div> <question-answer data=$ctrl.data on-finish=\"$ctrl.onFinish(correct, wrong)\" on-result=\"$ctrl.onResult(correct, wrong)\" on-active-task=\"$ctrl.activeTask = index; $ctrl.answered = false;\" on-answer=\"$ctrl.answered = true\" ng-if=\"$ctrl.data.length>0\"></question-answer> </div>");
$templateCache.put("app/components/courses/update.html","<ui-view name=page ng-if=\"!$root.$state.includes(\'courses.update.materials.search\')\"> <div class=container-page-responsive> <div class=\"actions-bar top bb\" ng-if=$root.isTablet> <a class=td-none ng-click=$ctrl.close()><i class=icon-arrow-left></i>&nbsp; {{\'back\'|translate}}</a> </div> <div class=container> <div class=page-header> <button type=button class=close ng-click=$ctrl.close() ng-if=$root.isDesktop><i class=icon-close></i></button> <h1 ng-if=!$ctrl.isNew>{{\'updating_course\' | translate}}</h1> <h1 ng-if=$ctrl.isNew>{{\'adding_course\' | translate}}</h1> <div class=\"text-muted text-center-tablet\">{{\'all_fields_required_error\' | translate}}</div> </div> <ul class=\"nav nav-tabs\"> <li ui-sref-active=active> <a ui-sref=^.details>{{\'course_descr\'|translate}}</a> </li> <li ui-sref-active=active> <a ui-sref=^.materials>{{\'course_materials\'|translate}}</a> </li> </ul> <ui-view></ui-view> </div> </div> </ui-view> <ui-view name=sticky ng-show=\"$root.$state.includes(\'courses.update.materials.search\') && !$root.loading\"></ui-view>");
$templateCache.put("app/components/courses/updateDetails.html","<form novalidate name=form ng-submit=$ctrl.submitDetails() role=form> <course-details-form model=$ctrl.model subjects=$ctrl.subjects categories=$ctrl.categories on-image-delete=$ctrl.imageDelete(path)></course-details-form> </form> <div class=actions-bar-bottom> <div class=container> <div class=pull-right> <button ui-sref=^.materials class=\"btn btn-primary btn-invert\">{{ \'materials\' | translate }} &nbsp; <i class=icon-arrow-right></i></button> <button ng-click=$ctrl.submit() ng-disabled=\"form.$invalid || $ctrl.loading\" class=\"btn btn-primary\" loading-overlay=$ctrl.loading loading-class=loading-white loading-hide-content=true>{{ \'save_changes\' | translate }}</button> </div> <button class=\"btn btn-link btn-link-narrow\" ng-click=$ctrl.delete() confirm=\"{{\'delete_course_confirm\' | translate}}\" confirm-ok=\"{{\'yes_delete\' | translate}}\" confirm-cancel=\"{{\'cancel_delete\' | translate}}\" confirm-title=\"{{\'delete_confirmation\' | translate}}\">{{ \'delete_course\' | translate }}</button> </div> </div>");
$templateCache.put("app/components/courses/updateMaterials.html","<course-materials-form on-submit-materials=$ctrl.submit(materials) on-delete-training=$ctrl.deleteTraining(trainingId) materials=$ctrl.materials trainings=$ctrl.trainings></course-materials-form> <div class=actions-bar-bottom> <div class=container> <div class=pull-right> <button ui-sref=^.details class=\"btn btn-primary btn-invert\"><i class=icon-arrow-left></i>&nbsp; {{ \'update_descr\' | translate }}</button> <button ng-if=$ctrl.model.draft ng-click=$ctrl.publish() ng-disabled=\"!$ctrl.materialsValid() || $ctrl.loading\" class=\"btn btn-primary\" loading-overlay=$ctrl.loading loading-class=loading-white loading-hide-content=true>{{ \'publish_course\' | translate }}</button> </div> <button class=\"btn btn-link btn-link-narrow\" ng-click=$ctrl.delete() confirm=\"{{\'delete_course_confirm\' | translate}}\" confirm-ok=\"{{\'yes_delete\' | translate}}\" confirm-cancel=\"{{\'cancel_delete\' | translate}}\" confirm-title=\"{{\'delete_confirmation\' | translate}}\">{{ \'delete_course\' | translate }}</button> </div> </div>");
$templateCache.put("app/components/courses/view.$desktop.html","<div class=\"container-page-responsive text-center\" ng-if=$ctrl.loading><div class=loading></div></div> <div ng-if=!$ctrl.loading class=\"container container-page-responsive\"> <div> <a class=td-none ng-click=$ctrl.close() ng-if=!$ctrl.fromSearchResults><i class=icon-arrow-left></i>&nbsp; {{\'back\'|translate}}</a> <a class=td-none ng-click=$ctrl.close() ng-if=$ctrl.fromSearchResults><i class=icon-arrow-left></i>&nbsp; {{\'back_to_results\'|translate}}</a> </div> <br> <div class=course-view ng-if=$ctrl.course.id> <div class=\"result-message alert alert-success\" ng-if=\"$ctrl.course.status == \'finished\'\">{{ \'course_finished_text\' | translate }}</div> <div class=row> <div class=col-xs-8> <h1 class=top>{{$ctrl.course.title}}</h1> <likes-counter ng-if=$ctrl.course.id resource=course resource-id=$ctrl.course.id value=$ctrl.course.likes></likes-counter> <div class=page-actions> <span><i class=icon-accept-circle></i> {{$ctrl.course.finishes}}</span> <span><i class=icon-eye></i> {{$ctrl.course.views}}</span> <span><i class=icon-calendar></i> {{$ctrl.course.date|dateMoment:\'ll\':$ctrl.ps.timezone}}</span><!-- <report-button ng-if=\"$ctrl.accessService.ca\\n(\'report\')\" report-variants=\"$ctrl.reportOptions.variants\" report-input-label=\"$ctrl.reportOptions.inputLabel\" report-input-required=\"false\"></report-button> --> <favorite-button ng-if=$root.isLoggedIn() resource=course resource-id=$ctrl.course.id></favorite-button> </div> <h2>{{ \'course_descr\' | translate }}</h2> <div class=descr ng-if=$ctrl.course.descr>{{$ctrl.course.descr}}</div> <h2>{{ \'course_program\' | translate }}</h2> <course-program materials=$ctrl.materials trainings=$ctrl.trainings></course-program> </div> <div class=col-xs-4> <div class=\"border-block text-center\"> <h3 style=margin-top:0px>{{ \'study_any_time\' | translate }}</h3> <p class=text-muted>{{ \'number_of_materials_finished\' | translate:{n1:$ctrl.finishedMaterialsCount,n2:$ctrl.materials.length}:\'messageformat\' }}</p> <button ng-if=\"$ctrl.course.status == \'in_progress\'\" class=\"btn btn-primary btn-block\" ng-click=$ctrl.start()>{{ \'continue_learning\' | translate }}</button> <button ng-if=!$ctrl.course.status class=\"btn btn-primary btn-block\" ng-click=$ctrl.start()>{{ \'start_learning\' | translate }}</button> </div> <div class=border-block> <p class=\"text-muted text-center\"><small>{{\'added_by\' | translate}}</small></p> <user-preview class=compact user-id=$ctrl.course.user_id></user-preview> </div> </div> </div> <div ng-if=\"$ctrl.accessService.can(\'editCourse\',$ctrl.course)\" class=actions-bar-bottom> <div class=container> <button class=\"btn btn-invert btn-primary pull-right\" ui-sref=courses.update({id:$ctrl.course.id})>{{\'edit\' | translate}}</button> <button class=\"btn btn-link btn-link-narrow\" ng-click=$ctrl.delete() confirm=\"{{\'delete_course_confirm\' | translate}}\" confirm-ok=\"{{\'yes_delete\' | translate}}\" confirm-cancel=\"{{\'cancel_delete\' | translate}}\" confirm-title=\"{{\'delete_confirmation\' | translate}}\">{{\'delete_course\' | translate}}</button> </div> </div> </div> <div class=material-not-found ng-if=!$ctrl.course.id> <div class=img> <img src=assets/images/ghost.png alt=\"\"> <div class=title>{{ \'course_not_found\' | translate }}</div> {{ \'course_not_found_text\' | translate }} </div> </div> </div>");
$templateCache.put("app/components/courses/view.$mobile.html","<div class=\"container-page-responsive text-center\" ng-if=$ctrl.loading><div class=loading></div></div> <div ng-if=!$ctrl.loading class=container-page-responsive> <div class=\"actions-bar top bb\"> <a class=td-none ng-click=$ctrl.close() ng-if=!$ctrl.fromSearchResults><i class=icon-arrow-left></i>&nbsp; {{\'back\'|translate}}</a> <a class=td-none ng-click=$ctrl.close() ng-if=$ctrl.fromSearchResults><i class=icon-arrow-left></i>&nbsp; {{\'back_to_results\'|translate}}</a> </div> <div class=container ng-if=$ctrl.course.id> <div class=\"result-message alert alert-success\" ng-if=\"$ctrl.course.status == \'finished\'\">{{ \'course_finished_text\' | translate }}</div> <div class=\"page-header sura-page-header\"> <h1>{{$ctrl.course.title}}</h1> <div class=page-actions> <span><i class=icon-accept-circle></i> {{$ctrl.course.finishes}}</span> <span><i class=icon-check></i> {{$ctrl.course.views}}</span> <span><i class=icon-eye></i> {{$ctrl.course.views}}</span> <span><i class=icon-calendar></i> {{$ctrl.course.date|dateMoment:\'ll\':$ctrl.ps.timezone}}</span> <favorite-button ng-if=$root.isLoggedIn() resource=course resource-id=$ctrl.course.id></favorite-button> </div> </div> <div class=course-view> <div class=row ng-if=!$root.isPhone> <div class=\"col-sm-6 col-md-8 col-xs-12\"> <likes-counter ng-if=$ctrl.course.id resource=course resource-id=$ctrl.course.id value=$ctrl.course.likes></likes-counter> <div class=page-actions><!-- <report-button ng-if=\"$ctrl.accessService.can(\'report\')\" report-variants=\"$ctrl.reportOptions.variants\" report-input-label=\"$ctrl.reportOptions.inputLabel\" report-input-required=\"false\"></report-button> --> <a href ng-if=\"$ctrl.accessService.can(\'editCourse\',$ctrl.course)\" ui-sref=courses.update({id:$ctrl.course.id})>{{\'edit\' | translate}}</a> <a href ng-if=\"$ctrl.accessService.can(\'editCourse\',$ctrl.course)\" ng-click=$ctrl.delete() confirm=\"{{\'delete_course_confirm\' | translate}}\">{{\'delete\' | translate}}</a> </div> </div> <div class=\"col-sm-6 col-md-4 col-xs-12\"> <div class=\"border-block text-center\"> <h3 style=margin-top:0px>{{ \'study_any_time\' | translate }}</h3> <p class=text-muted>{{ \'number_of_materials_finished\' | translate:{n1:$ctrl.finishedMaterialsCount,n2:$ctrl.materials.length}:\'messageformat\' }}</p> <button ng-if=\"$ctrl.course.status == \'in_progress\'\" class=\"btn btn-primary btn-block\" ng-click=$ctrl.start()>{{ \'continue_learning\' | translate }}</button> <button ng-if=!$ctrl.course.status class=\"btn btn-primary btn-block\" ng-click=$ctrl.start()>{{ \'start_learning\' | translate }}</button> </div> <div class=border-block> <p class=\"text-muted text-center\"><small>{{\'added_by\' | translate}}</small></p> <user-preview class=compact user-id=$ctrl.course.user_id></user-preview> </div> </div> </div> <div ng-if=$root.isPhone> <div class=\"border-block text-center\"> <h3 style=margin-top:0px>{{ \'study_any_time\' | translate }}</h3> <p class=text-muted>{{ \'number_of_materials_finished\' | translate:{n1:$ctrl.finishedMaterialsCount,n2:$ctrl.materials.length}:\'messageformat\' }}</p> <button ng-if=\"$ctrl.course.status == \'in_progress\'\" class=\"btn btn-primary btn-block\" ng-click=$ctrl.start()>{{ \'continue_learning\' | translate }}</button> <button ng-if=!$ctrl.course.status class=\"btn btn-primary btn-block\" ng-click=$ctrl.start()>{{ \'start_learning\' | translate }}</button> </div> </div> <h2>{{ \'course_descr\' | translate }}</h2> <div class=descr ng-if=$ctrl.course.descr>{{$ctrl.course.descr}}</div> <h2>{{ \'course_program\' | translate }}</h2> <course-program materials=$ctrl.materials trainings=$ctrl.trainings></course-program> <div ng-if=$root.isPhone> <div class=border-block> <p class=\"text-muted text-center\"><small>{{\'added_by\' | translate}}</small></p> <user-preview class=compact user-id=$ctrl.course.user_id></user-preview> </div> <likes-counter ng-if=$ctrl.course.id resource=course resource-id=$ctrl.course.id value=$ctrl.course.likes></likes-counter> </div> </div> </div> <div class=container ng-if=!$ctrl.course.id> <div class=material-not-found> <div class=img> <img src=assets/images/ghost.png alt=\"\"> <div class=title>{{ \'course_not_found\' | translate }}</div> {{ \'course_not_found_text\' | translate }} </div> </div> </div> </div>");
$templateCache.put("app/components/home/landing.html","<div id=global-landing> <div class=\"gl-header hidden-phone\"> <div> <div> <a href=#top id=logo></a> </div> <ul class=\"nav nav-list nav-center\"> <li> <a href ng-click=\"$ctrl.to(\'courses\')\">{{ \'project_courses\' | translate }}</a> </li> <li> <a href ng-click=\"$ctrl.to(\'quran\')\">{{ \'project_koran\' | translate }}</a> </li> <li> <a href ng-click=\"$ctrl.to(\'search\')\">{{ \'project_muslimator\' | translate }}</a> </li> </ul> <div class=hidden-tablet> <a ui-sref=auth.register class=\"btn btn-primary btn-sm\">{{ \'sign_up\' | translate }}</a> </div> </div> </div> <div id=fullpage> <div class=\"section fp-auto-height-responsive splash-screen screen-1\" data-anchor=top> <div class=gl-container> <div id=logo></div> <ul class=\"nav nav-list\"> <li> <a href ng-click=\"$ctrl.to(\'courses\')\">{{ \'project_courses\' | translate }}</a> </li> <li> <a href ng-click=\"$ctrl.to(\'quran\')\">{{ \'project_koran\' | translate }}</a> </li> <li> <a href ng-click=\"$ctrl.to(\'search\')\">{{ \'project_muslimator\' | translate }}</a> </li> </ul> <h1 ng-bind-html=\"\'sh_slogan1\'|translate|trustHtml\"></h1> <div class=text ng-bind-html=\"(\'sh_descr_stats\'|translate:$ctrl.stats:\'messageformat\')|trustHtml\"></div> <div class=text></div> <div class=button> <button class=\"btn btn-primary\" ui-sref=auth.register>{{ \'sign_up\' | translate }}</button> </div> <div class=auth-text> {{ \'already_registered_q\' | translate }} <a ui-sref=auth.login>{{ \'sign_in\' | translate }}</a> </div> </div> <a class=\"arrow-down hidden-tablet\" href ng-click=\"$ctrl.to(\'how-it-works\')\">{{ \'how_it_works\' | translate }}?</a> </div> <div class=\"section fp-auto-height-responsive splash-screen screen-2\" data-anchor=how-it-works> <div class=gl-container> <div class=\"image hidden-tablet\"> <img ng-src=\"{{\'assets/images/illustrations/IMG-1.png\'|langSuffix}}\" ng-srcset=\"{{\'assets/images/illustrations/IMG-1@2x.png\'|langSuffix}} 2x\" alt=\"\"> </div> <div class=content> <div class=pre-title>{{ \'how_it_works\' | translate }}</div> <div class=\"image visible-tablet\"> <img ng-src=\"{{\'assets/images/illustrations/IMG-1.png\'|langSuffix}}\" ng-srcset=\"{{\'assets/images/illustrations/IMG-1.png\'|langSuffix}} 2x\" alt=\"\"> </div> <h2 ng-bind-html=\"\'gl_screen2_title\'|translate|trustHtml\"></h2> <div class=text ng-bind-html=\"\'gl_screen2_text\'|translate|trustHtml\"></div> </div> </div> <a class=\"arrow-down hidden-tablet\" href ng-click=\"$ctrl.to(\'courses\')\">{{ \'gl_screen2_next\' | translate }}</a> </div> <div class=\"section fp-auto-height-responsive splash-screen screen-3\" data-anchor=courses> <div class=gl-container> <div class=pre-title>{{\'sh_projects\'|translate}}</div> <h1>{{ \'project_courses\' | translate }}</h1> <div class=image> <img ng-src=\"{{\'assets/images/illustrations/IMG-2@2x.png\'|langSuffix}}\" ng-srcset=\"{{\'assets/images/illustrations/IMG-2@2x.png\'|langSuffix}} 2x\" alt=\"\"> </div> <div class=content> <h2 ng-bind-html=\"\'gl_screen3_title\'|translate|trustHtml\"></h2> <div class=text ng-bind-html=\"\'gl_screen3_text\'|translate|trustHtml\"></div> <div class=button> <a href ng-click=$ctrl.play($ctrl.courses_youtube_url) class=\"btn btn-success btn-play\">{{ \'gl_screen3_button\' | translate }}</a> </div> </div> </div> <a class=\"arrow-down hidden-tablet\" href ng-click=\"$ctrl.to(\'quran\')\">{{ \'gl_screen3_next\' | translate }}</a> </div> <div class=\"section fp-auto-height splash-screen screen-4\" data-anchor=quran> <div class=gl-container> <div class=pre-title>{{\'sh_projects\'|translate}}</div> <h1>{{ \'project_koran\' | translate }}</h1> <div class=image1> <img ng-src=\"{{\'assets/images/illustrations/IMG-3.png\'|langSuffix}}\" ng-srcset=\"{{\'assets/images/illustrations/IMG-3@2x.png\'|langSuffix}} 2x\" alt=\"\"> </div> <div class=content1> <h3 ng-bind-html=\"\'gl_screen4_title1\'|translate|trustHtml\"></h3> <div class=text ng-bind-html=\"\'gl_screen4_text1\'|translate|trustHtml\"></div> </div> <div class=image2> <img ng-src=\"{{\'assets/images/illustrations/IMG-4.png\'|langSuffix}}\" ng-srcset=\"{{\'assets/images/illustrations/IMG-4@2x.png\'|langSuffix}} 2x\" alt=\"\"> </div> <div class=content2> <h3 ng-bind-html=\"\'gl_screen4_title2\'|translate|trustHtml\"></h3> <div class=text ng-bind-html=\"\'gl_screen4_text2\'|translate|trustHtml\"></div> <div class=button> <a href ng-click=$ctrl.play($ctrl.koran_youtube_url) class=\"btn btn-warning btn-play\">{{ \'gl_screen4_button\' | translate }}</a> </div> </div> </div> <a class=\"arrow-down hidden-tablet\" href ng-click=\"$ctrl.to(\'search\')\">{{ \'gl_screen4_next\' | translate }}</a> </div> <div class=\"section fp-auto-height-responsive splash-screen screen-5\" data-anchor=search> <div class=gl-container> <div class=pre-title>{{\'sh_projects\'|translate}}</div> <h1>{{ \'project_muslimator\' | translate }}</h1> <div class=image> <img ng-src=\"{{\'assets/images/illustrations/IMG-5.png\'|langSuffix}}\" ng-srcset=\"{{\'assets/images/illustrations/IMG-5@2x.png\'|langSuffix}} 2x\" alt=\"\"> </div> <div class=content> <h3 ng-bind-html=\"\'gl_screen5_title\'|translate|trustHtml\"></h3> <div class=text ng-bind-html=\"\'gl_screen5_text\'|translate|trustHtml\"></div> <div class=button> <a href ng-click=$ctrl.play($ctrl.muslimator_youtube_url) class=\"btn btn-primary btn-play\">{{ \'gl_screen5_button\' | translate }}</a> </div> </div> </div> <a class=\"arrow-down hidden-tablet\" href ng-click=\"$ctrl.to(\'app\')\">{{ \'mobile_app\' | translate }}</a> </div> <div class=\"section fp-auto-height-responsive splash-screen screen-6\" data-anchor=app> <div class=gl-container> <div class=image> <img ng-src=\"{{\'assets/images/illustrations/phones.png\'|langSuffix}}\" ng-srcset=\"{{\'assets/images/illustrations/phones@2x.png\'|langSuffix}} 2x\" alt=\"\"> </div> <div class=content> <h2 ng-bind-html=\"\'mobile_app_sh\'|translate|trustHtml\"></h2> <div class=text ng-bind-html=\"\'mobile_app_descr\'|translate|trustHtml\"></div> <div class=app-buttons> <a ng-if=\"\'app_store_url\'|configService\" ng-href=\"{{\'app_store_url\'|configService}}\" target=_blank><img src=assets/images/app-apple.png alt=\"\"></a> <a ng-if=\"\'google_play_url\'|configService\" ng-href=\"{{\'google_play_url\'|configService}}\" target=_blank><img src=assets/images/app-google.png alt=\"\"></a> <img ng-if=\"!(\'app_store_url\'|configService)\" ng-src=\"{{\'assets/images/app-apple-soon.png\'}}\" alt=\"\" style=opacity:0.5> <img ng-if=\"!(\'google_play_url\'|configService)\" ng-src=\"{{\'assets/images/app-google-soon.png\'}}\" alt=\"\" style=opacity:0.5> </div> </div> </div> <a class=\"arrow-down hidden-tablet\" href ng-click=\"$ctrl.to(\'bottom\')\">{{ \'registration\' | translate }}</a> </div> <div class=\"section fp-auto-height-responsive splash-screen screen-7\" data-anchor=bottom> <div class=gl-container> <a href=#top id=logo></a> <h1 ng-bind-html=\"\'sh_slogan2\'|translate|trustHtml\"></h1> <div class=button> <button class=\"btn btn-primary\" ui-sref=auth.register>{{ \'sign_up\' | translate }}</button> </div> <div class=auth-text> {{ \'already_registered_q\' | translate }} <a ui-sref=auth.login>{{ \'sign_in\' | translate }}</a> </div> <div class=habits ng-class=\"{\'habits-tablet\':$root.isTablet && !$root.isPhone}\"> <h4>{{ \'gl_present_title\' | translate }}</h4> <div class=text>{{ \'gl_present_text\' | translate }}</div> <div class=app-buttons> <a ng-href=\"{{\'habits_app_store_url\'|configService}}\" target=_blank><img src=assets/images/app-apple.png alt=\"\"></a> <a ng-href=\"{{\'habits_google_play_url\'|configService}}\" target=_blank><img src=assets/images/app-google.png alt=\"\"></a> </div> </div> </div> </div> </div> </div>");
$templateCache.put("app/components/home/projects.html","<div class=\"container-page-responsive projects-page\"> <div class=container> <h1>{{ \'projects_welcome_title\' | translate }}</h1> <h3 ng-bind-html=\"\'projects_welcome_text\'|translate|trustHtml\"></h3> <div class=projects> <a class=project ui-sref=courses.redirect> <div class=img> <img ng-src=\"{{\'assets/images/illustrations/IMG-2-1.png\'|langSuffix}}\" alt=\"\"> <div class=play ng-click=\"$ctrl.play($ctrl.courses_youtube_url); $event.stopPropagation(); $event.preventDefault();\"></div> </div> <div class=content> <div class=\"short-title text-success\">{{ \'project_courses_short\' | translate }}</div> <div class=title>{{ \'project_courses_long\' | translate }}</div> <div class=descr>{{ \'project_courses_descr\' | translate }}</div> <button class=\"btn btn-link\"><b>{{ \'goto_project\' | translate }}</b></button> </div> </a> <a class=project ui-sref=muslimator.redirect> <div class=img> <img ng-src=\"{{\'assets/images/illustrations/IMG-5-1.png\'|langSuffix}}\" alt=\"\"> <div class=play ng-click=\"$ctrl.play($ctrl.muslimator_youtube_url); $event.stopPropagation(); $event.preventDefault();\"></div> </div> <div class=content> <div class=\"short-title text-primary\">{{ \'project_muslimator_short\' | translate }}</div> <div class=title>{{ \'project_muslimator_long\' | translate }}</div> <div class=descr>{{ \'project_muslimator_descr\' | translate }}</div> <button class=\"btn btn-link\"><b>{{ \'goto_project\' | translate }}</b></button> </div> </a> <a class=project ui-sref=koran.redirect> <div class=img> <img ng-src=\"{{\'assets/images/illustrations/IMG-3-1.png\'|langSuffix}}\" alt=\"\"> <div class=play ng-click=\"$ctrl.play($ctrl.koran_youtube_url); $event.stopPropagation(); $event.preventDefault();\"></div> </div> <div class=content> <div class=\"short-title text-warning\">{{ \'project_koran_short\' | translate }}</div> <div class=title>{{ \'project_koran_long\' | translate }}</div> <div class=descr>{{ \'project_koran_descr\' | translate }}</div> <button class=\"btn btn-link\">{{ \'goto_project\' | translate }}</button> </div> </a> </div> <a ng-if=$ctrl.project_select_url ng-href={{$ctrl.project_select_url}} class=\"btn btn-primary\">{{ \'project_admin_select\' | translate }}</a> </div> </div>");
$templateCache.put("app/components/notifications/notifications.html","<div class=page-header><h1>{{\'notifications\'|translate}}</h1></div> <div class=menu-notifications> <div ng-if=\"!$ctrl.notifications.length && !$ctrl.loading\">{{\'notifications_not_found\'|translate}}</div> <div class=notif ng-class=\"{ new: $ctrl.isNew(n.created_at) }\" ng-repeat=\"n in $ctrl.notifications\"> <div class=date>{{$ctrl.date(n.created_at)}}</div> <div class=title>{{n.title}}</div> <div class=text ng-bind-html=n.text></div> </div> <div class=text-center loading-replace=$ctrl.loading ng-if=$ctrl.loading></div> <div class=text-center ng-if=\"!$ctrl.loading && $ctrl.pagination.currentPage < $ctrl.pagination.pageCount\"> <button class=\"btn btn-sm btn-default\" ng-click=\"$ctrl.load($ctrl.pagination.currentPage+1); $event.stopPropagation();\">{{ \'show_more\' | translate }}</button> </div> </div>");
$templateCache.put("app/components/muslimator/add.html","<div class=\"container container-page-responsive\"> <div class=page-header> <button type=button class=close ng-click=$ctrl.close()><i class=icon-close></i></button> <h1>{{\'adding_material\' | translate}}</h1> <div class=\"text-muted text-center-tablet\">{{\'all_fields_required_error\' | translate}}</div> </div> <material-form on-submit=$ctrl.submit(model) loading=$ctrl.loading></material-form> </div>");
$templateCache.put("app/components/muslimator/favorite.html","<div class=\"container container-page-responsive\"> <ng-include src=$ctrl.tabsTemplate></ng-include> <h1>{{\'materials_favorite\'|translate}} ({{$ctrl.pagination.totalCount}})</h1> <div class=text-center ng-if=\"$ctrl.loading && !$ctrl.pagination.totalCount\"><div class=loading></div></div> <material-list items=$ctrl.materials ng-if=$ctrl.pagination.totalCount></material-list> <div class=text-center-tablet ng-if=\"$ctrl.pagination.totalCount > 0\"> <button class=\"btn btn-primary btn-block-phone\" ng-if=\"$ctrl.pagination.currentPage < $ctrl.pagination.pageCount\" ng-click=$ctrl.load($ctrl.pagination.currentPage+1) loading-overlay=$ctrl.loading loading-hide-content=true loading-class=loading-white>{{ \'show_more\' | translate }}</button> </div> </div>");
$templateCache.put("app/components/muslimator/finished.html","<div class=\"container container-page-responsive\"> <div class=page-header> <h1>{{\'materials_finished_title\' | translate}} ({{$ctrl.pagination.totalCount}})</h1> </div> <div class=text-center ng-if=\"$ctrl.loading && !$ctrl.pagination.totalCount\"><div class=loading></div></div> <material-list items=$ctrl.materials ng-if=$ctrl.pagination.totalCount></material-list> <div class=text-center-tablet ng-if=\"$ctrl.pagination.totalCount > 0\"> <button class=\"btn btn-primary btn-block-phone\" ng-if=\"$ctrl.pagination.currentPage < $ctrl.pagination.pageCount\" ng-click=$ctrl.load($ctrl.pagination.currentPage+1) loading-overlay=$ctrl.loading loading-hide-content=true loading-class=loading-white>{{ \'show_more\' | translate }}</button> </div> </div>");
$templateCache.put("app/components/muslimator/inProgress.html","<div class=\"container container-page-responsive\"> <div class=page-header> <h1>{{\'materials_in_progress_title\' | translate}} ({{$ctrl.pagination.totalCount}})</h1> </div> <div class=text-center ng-if=\"$ctrl.loading && !$ctrl.pagination.totalCount\"><div class=loading></div></div> <material-list items=$ctrl.materials ng-if=$ctrl.pagination.totalCount></material-list> <div class=text-center-tablet ng-if=\"$ctrl.pagination.totalCount > 0\"> <button class=\"btn btn-primary btn-block-phone\" ng-if=\"$ctrl.pagination.currentPage < $ctrl.pagination.pageCount\" ng-click=$ctrl.load($ctrl.pagination.currentPage+1) loading-overlay=$ctrl.loading loading-hide-content=true loading-class=loading-white>{{ \'show_more\' | translate }}</button> </div> </div>");
$templateCache.put("app/components/muslimator/index.html","<div class=container-page-responsive> <div class=\"actions-bar top bb\" ng-if=\"!$root.isDesktop && $ctrl.showSearchResults\"> <a class=td-none ng-click=\"$ctrl.params = {}\"><i class=icon-arrow-left></i>&nbsp; {{\'all_materials\'|translate}}</a> </div> <div ng-class=\"{\'container\':!$root.isDesktop}\"> <banner-top position=muslimator class=bg-3 ng-class=\"{\'bg-3-en\':$root.languageService.currentLanguage == \'en\'}\" ng-if=!$ctrl.showSearchResults></banner-top> <div ng-class=\"{\'container\':$root.isDesktop}\"> <banner id=muslimator-index-banner class=banner-simple close-button=true ng-if=\"($root.isDesktop || !$ctrl.showSearchResults) && \'muslimator_index_banner\'|configService\"><span ng-bind-html=\"\'muslimator_index_banner\'|configService\"></span></banner> <material-search-form autocomplete=true params=$ctrl.params on-submit=\"$ctrl.params = params\" total-count=$ctrl.totalCount loading=$ctrl.loading></material-search-form> <div ng-if=$ctrl.showSearchResults> <material-search-result params=$ctrl.params per-page=12 on-start-loading=\"$ctrl.loading = true;\" on-finish-loading=\"$ctrl.totalCount = totalCount; $ctrl.loading = false;\" on-change-params=\"$ctrl.params = params\"></material-search-result> <br><br> <user-search-result params=$ctrl.params exclude=$ctrl.ps.currentUser.id per-page=12 cols=3 sprint=false></user-search-result> </div> <div ng-if=!$ctrl.showSearchResults> <material-recommend style=display:block;margin-bottom:30px></material-recommend> <material-best></material-best> </div> </div> </div> </div>");
$templateCache.put("app/components/muslimator/my.html","<div class=\"container container-page-responsive\"> <div class=page-header> <button class=\"btn btn-primary pull-right\" ui-sref=^.add>{{\'add_material\' | translate}}</button> <h1>{{\'materials_my_title\' | translate}} ({{$ctrl.pagination.totalCount}})</h1> </div> <div class=text-center ng-if=\"$ctrl.loading && !$ctrl.pagination.totalCount\"><div class=loading></div></div> <material-list items=$ctrl.materials ng-if=$ctrl.pagination.totalCount></material-list> <div class=text-center-tablet ng-if=\"$ctrl.pagination.totalCount > 0\"> <button class=\"btn btn-primary btn-block-phone\" ng-if=\"$ctrl.pagination.currentPage < $ctrl.pagination.pageCount\" ng-click=$ctrl.load($ctrl.pagination.currentPage+1) loading-overlay=$ctrl.loading loading-hide-content=true loading-class=loading-white>{{ \'show_more\' | translate }}</button> </div> </div>");
$templateCache.put("app/components/muslimator/update.html","<div class=\"container container-page-responsive\"> <div class=page-header> <h1>{{\'updating_material\' | translate}}</h1> <div class=\"text-muted text-center-tablet\">{{\'all_fields_required_error\' | translate}}</div> </div> <material-form ng-if=$ctrl.model model=$ctrl.model on-submit=$ctrl.submit(model) on-image-delete=$ctrl.imageDelete() loading=$ctrl.loading></material-form> </div>");
$templateCache.put("app/components/muslimator/view.$desktop.html","<div class=\"container-page-responsive text-center\" ng-if=$ctrl.loading><div class=loading></div></div> <div ng-if=!$ctrl.loading> <div class=\"container container-page-responsive\"> <button type=button class=\"close close-side\" ng-click=$ctrl.close()><i class=icon-close></i></button> <div class=material-view ng-if=\"$ctrl.material.id && !$ctrl.recommend\"> <div class=content> <embed-content ng-if=\"$ctrl.material.embed_type == \'url\'\" url=$ctrl.material.url></embed-content> <div ng-if=\"$ctrl.material.embed_type == \'code\'\" class=\"embed-code embed-responsive embed-responsive-16by9\" ng-bind-html=$ctrl.material.code|trustHtml></div> </div> <div class=row> <div class=col-xs-9> <h1 class=top>{{$ctrl.material.title}}</h1> <div class=descr ng-if=$ctrl.material.descr>{{$ctrl.material.descr}}</div> <likes-counter ng-if=$ctrl.material.id resource=material resource-id=$ctrl.material.id value=$ctrl.material.likes></likes-counter> <div class=page-actions> <span><i class=icon-eye></i> {{$ctrl.material.views}}</span> <span><i class=icon-calendar></i> {{$ctrl.material.date|dateMoment:\'ll\':$ctrl.ps.timezone}}</span> <report-button ng-if=\"$ctrl.accessService.can(\'report\')\" report-variants=$ctrl.reportOptions.variants report-input-label=$ctrl.reportOptions.inputLabel report-input-required=false></report-button> <favorite-button ng-if=$root.isLoggedIn() resource=material resource-id=$ctrl.material.id></favorite-button> <a href ng-if=\"$ctrl.accessService.can(\'editMaterial\',$ctrl.material)\" ui-sref=muslimator.update({id:$ctrl.material.id})>{{\'edit\' | translate}}</a> <a href ng-if=\"$ctrl.accessService.can(\'editMaterial\',$ctrl.material)\" ng-click=$ctrl.delete() confirm=\"{{\'delete_material_confirm\' | translate}}\">{{\'delete\' | translate}}</a> </div> </div> <div class=col-xs-3> <button class=\"btn btn-default btn-done-circle btn-lg btn-block border-block\" ng-class=\"{selected: $ctrl.material.status == \'finished\'}\" ng-click=$ctrl.finish()> <div class=circle></div> <div class=text> <span class=done ng-if=\"$ctrl.material.type == \'video\'\">{{\'status_viewed\' | translate}}</span> <span class=done ng-if=\"$ctrl.material.type == \'audio\'\">{{\'status_listened\' | translate}}</span> <span class=done ng-if=\"$ctrl.material.type == \'text\'\">{{\'status_read\' | translate}}</span> <span class=points>+ {{\'points_number\' | translate:{number:$ctrl.points}:\'messageformat\'}}</span> </div> </button> <div class=border-block> <p class=\"text-muted text-center\"><small>{{\'added_by\' | translate}}</small></p> <user-preview class=compact user-id=$ctrl.material.user_id></user-preview> </div> </div> </div> </div> <div class=material-not-found ng-if=\"!$ctrl.material.id && !$ctrl.recommend\"> <div class=img> <img src=assets/images/ghost.png alt=\"\"> <div class=title>{{ \'material_not_found\' | translate }}</div> {{ \'material_not_found_text\' | translate }} {{m.id}} </div> <br> <material-finish-recommend material-id=$ctrl.id force-title=\"{{ \'recommended_for_material_not_found\' | translate }}\"></material-finish-recommend> </div> <div ng-if=$ctrl.recommend> <banner class=\"banner-simple banner-2-col\" close-button=false><ng-include src=\"\'app/views/shareMaterialBanner.html\'\"></ng-include></banner> <material-finish-recommend material-id=$ctrl.id></material-finish-recommend> </div> </div> </div>");
$templateCache.put("app/components/muslimator/view.$mobile.html","<div class=\"container-page-responsive text-center\" ng-if=$ctrl.loading><div class=loading></div></div> <div ng-if=!$ctrl.loading> <div class=container-page-responsive> <div class=\"actions-bar top bb\"> <a class=td-none ng-click=$ctrl.close() ng-if=!$ctrl.recommend><i class=icon-arrow-left></i>&nbsp; {{\'back\'|translate}}</a> <a class=td-none ng-click=$ctrl.close() ng-if=$ctrl.recommend><i class=icon-arrow-left></i>&nbsp; {{\'go_to_main_page\'|translate}}</a> </div> <div class=container ng-if=\"$ctrl.material.id && !$ctrl.recommend\"> <div class=\"page-header sura-page-header\"> <h1>{{$ctrl.material.title}}</h1> <div class=page-actions> <span><i class=icon-eye></i> {{$ctrl.material.views}}</span> <span><i class=icon-calendar></i> {{$ctrl.material.date|dateMoment:\'ll\':$ctrl.ps.timezone}}</span> <favorite-button ng-if=$root.isLoggedIn() resource=material resource-id=$ctrl.material.id></favorite-button> </div> </div> <div class=material-view> <div class=content> <embed-content ng-if=\"$ctrl.material.embed_type == \'url\'\" url=$ctrl.material.url></embed-content> <div ng-if=\"$ctrl.material.embed_type == \'code\'\" class=\"embed-code embed-responsive embed-responsive-16by9\" ng-bind-html=$ctrl.material.code|trustHtml></div> </div> <div class=row> <div class=\"col-sm-4 col-xs-12 col-sm-push-8\"> <button class=\"btn btn-default btn-done-circle btn-lg btn-block border-block\" ng-class=\"{selected: $ctrl.material.status == \'finished\'}\" ng-click=$ctrl.finish()> <div class=circle></div> <div class=text> <span class=done ng-if=\"$ctrl.material.type == \'video\'\">{{\'status_viewed\' | translate}}</span> <span class=done ng-if=\"$ctrl.material.type == \'audio\'\">{{\'status_listened\' | translate}}</span> <span class=done ng-if=\"$ctrl.material.type == \'text\'\">{{\'status_read\' | translate}}</span> <span class=points>+ {{\'points_number\' | translate:{number:$ctrl.points}:\'messageformat\'}}</span> </div> </button> <div ng-if=!$root.isPhone class=border-block> <p class=\"text-muted text-center\"><small>{{\'added_by\' | translate}}</small></p> <user-preview class=compact user-id=$ctrl.material.user_id></user-preview> </div> </div> <div class=\"col-sm-8 col-xs-12 col-sm-pull-4\"> <div class=descr ng-if=$ctrl.material.descr>{{$ctrl.material.descr}}</div> <div ng-if=$root.isPhone class=border-block> <p class=\"text-muted text-center\"><small>{{\'added_by\' | translate}}</small></p> <user-preview class=compact user-id=$ctrl.material.user_id></user-preview> </div> <likes-counter ng-if=$ctrl.material.id resource=material resource-id=$ctrl.material.id value=$ctrl.material.likes></likes-counter> <div class=page-actions> <report-button ng-if=\"$ctrl.accessService.can(\'report\')\" report-variants=$ctrl.reportOptions.variants report-input-label=$ctrl.reportOptions.inputLabel report-input-required=false></report-button> <a href ng-if=\"$ctrl.accessService.can(\'editMaterial\',$ctrl.material)\" ui-sref=muslimator.update({id:$ctrl.material.id})>{{\'edit\' | translate}}</a> <a href ng-if=\"$ctrl.accessService.can(\'editMaterial\',$ctrl.material)\" ng-click=$ctrl.delete() confirm=\"{{\'delete_material_confirm\' | translate}}\">{{\'delete\' | translate}}</a> </div> </div> </div> </div> </div> <div class=container ng-if=\"!$ctrl.material.id && !$ctrl.recommend\"> <div class=material-not-found> <div class=img> <img src=assets/images/ghost.png alt=\"\"> <div class=title>{{ \'material_not_found\' | translate }}</div> {{ \'material_not_found_text\' | translate }} {{m.id}} </div> <br> <material-finish-recommend material-id=$ctrl.id force-title=\"{{ \'recommended_for_material_not_found\' | translate }}\"></material-finish-recommend> </div> </div> <div class=container ng-if=$ctrl.recommend> <banner class=\"banner-simple banner-2-col\" close-button=false><ng-include src=\"\'app/views/shareMaterialBanner.html\'\"></ng-include></banner> <material-finish-recommend material-id=$ctrl.id></material-finish-recommend> </div> </div> </div>");
$templateCache.put("app/components/koran/_extra.html","<h1 class=text-center>{{ \'materials_sura_name\' | translate: $ctrl.sura }}</h1> <p class=\"text-center text-muted\">{{\'found_muslimator_materials_number\'|translate:{number:$ctrl.sura.materials_count}:\'messageformat\'}}</p> <br> <div class=text-center ng-if=\"$ctrl.loading && !$ctrl.pagination.totalCount\"><div class=loading></div></div> <material-list items=$ctrl.materials ng-if=$ctrl.pagination.totalCount></material-list> <div class=text-center-tablet ng-if=\"$ctrl.pagination.totalCount > 0\"> <button class=\"btn btn-primary btn-block-phone\" ng-if=\"$ctrl.pagination.currentPage < $ctrl.pagination.pageCount\" ng-click=$ctrl.load($ctrl.pagination.currentPage+1) loading-overlay=$ctrl.loading loading-hide-content=true loading-class=loading-white>{{ \'show_more\' | translate }}</button> </div> <banner class=\"banner-simple banner-2-col\" close-button=false><ng-include src=\"\'app/views/shareProjectBanner.html\'\"></ng-include></banner>");
$templateCache.put("app/components/koran/_suraDesktop.html","<div class=\"container container-page-responsive\"> <div class=\"page-header sura-page-header\"> <button type=button class=close ui-sref=koran.index><i class=icon-close></i></button> <h1>{{::$ctrl.sura.number}}. {{::\'sura_name\'|translate:$ctrl.sura}}</h1> <div class=page-actions><!-- <a ng-click=\"\">\r\n				<i class=\"icon-share\"></i>\r\n				<span>{{\'share\'|translate}}</span>\r\n			</a>--> <report-button ng-if=\"$ctrl.accessService.can(\'report\')\" report-variants=$ctrl.reportOptions.variants report-input-label=$ctrl.reportOptions.inputLabel report-input-required=true></report-button> <favorite-button ng-if=$root.isLoggedIn() resource=sura resource-id=$ctrl.sura.id></favorite-button> </div> </div> <div class=sura hover-target ng-class=\"{active:$ctrl.allPlayIndex !== null}\"> <div class=sura-title ng-show=$ctrl.showTitle() ng-class=\"{active:$ctrl.allPlayIndex === 0}\"> <span audio-popover=::$ctrl.getTitleAudio() audio-text=::$ctrl.sura.title hover-behavior on-play=\"$ctrl.vgapiAll.pause(); $ctrl.allPlayIndex = null;\"><span ng-bind-html=::$ctrl.sura.arab_title></span></span> </div> <div class=sura-content> <span class=ayat ng-repeat=\"ayat in $ctrl.ayatListPage track by ayat.id\" audio-popover=::ayat.audio_text_url audio-text=::ayat.text hover-behavior on-play=\"$ctrl.vgapiAll.pause(); $ctrl.allPlayIndex = null;\" ng-class=\"{active:$ctrl.allPlayIndex === $ctrl.fixAudioIndex($index)}\"> <span class=text>{{::ayat.arab_text}}</span> <span class=number>{{::ayat.number|arabNumber}}</span><!-- <span class=\"text\">{{::ayat.arab_text|withoutLastWord}}</span>\r\n				<span style=\"white-space:nowrap;\">\r\n					<span class=\"text\">{{::ayat.arab_text|lastWord}}</span>\r\n					<span class=\"number\">{{::ayat.number|arabNumber}}</span>\r\n				</span> --> </span> </div> <div class=sura-actions> <div class=pull-left> <button ng-click=$ctrl.pageDoneRead() loading-overlay=$ctrl.pageDoneReadLoading loading-hide-content=true class=\"btn btn-default btn-done-points\"> <i class=\"icon-angle-left icon-success\"></i> <span class=divider></span> <span class=text> <span class=done>{{::\'done_read\'|translate}}</span> <span class=points>+{{::\'points_number\'|translate:{number:(\'points.suraRead\'|config)}:\'messageformat\'}}</span> </span> </button> <audio-button src-list=::$ctrl.pagePlayList pause-on-stop=true on-play=\"$ctrl.allPlayIndex = index\" on-stop=\"$ctrl.allPlayIndex = null\" on-ready=\"$ctrl.vgapiAll = $API\"></audio-button> </div> <div class=\"pull-right nav-buttons\"> <button ng-click=$ctrl.nextPage() ng-disabled=!$ctrl.nextPageAvail() class=\"btn btn-default btn-page\" uib-tooltip=\"{{::\'next_page\'|translate}}\"> <i class=icon-angle-left></i> </button> <button ng-click=$ctrl.prevPage() ng-disabled=!$ctrl.prevPageAvail() class=\"btn btn-default btn-page\" uib-tooltip=\"{{::\'prev_page\'|translate}}\"> <i class=icon-angle-right></i> </button> </div> <form class=\"form-inline form-select-page\" name=form novalidate> <div class=form-group ng-class=\"{\'has-error\':form.page.$invalid}\"> {{::\'page\'|translate}} <input class=form-control type=number name=page ng-model=$ctrl.selectorPage ng-model-options=\"{updateOn:\'change\'}\" ng-change=$ctrl.changeCurrentPage() min=1 max={{::$ctrl.sura.total_pages}} required autocomplete=off> {{ ::\'of_count\'|translate:{count:$ctrl.sura.total_pages} }} </div> </form> </div> </div> </div>");
$templateCache.put("app/components/koran/_suraItemDesktop.html","<div ui-sref=koran.view({id:sura.id}) id=sura-item-{{::sura.id}} class=\"sura-item sura-item-{{::sura.number}}\"> <favorite-button-small resource=sura resource-id=sura.id></favorite-button-small> <div class=row> <div class=\"col-xs-4 col-padded\"> <a href class=name>{{::sura.number}}. {{::sura.name}}</a> <div class=meta-row> <span> <i class=icon-book></i> {{\'pages_number\'|translate:{number:sura.total_pages}:\'messageformat\'}} </span> <span> <i class=icon-eye></i> {{$ctrl.lastReadMoment(sura.id)}} </span> </div> </div> <div class=\"col-xs-2 col-padded\"> <div class=arab-name>{{::sura.arab_name}}</div> </div> <div class=col-xs-3> <div ng-if=!sura.materials_count class=\"col-img-link extra\"> <img src=/assets/images/extra.png alt=\"\"><br> {{\'extra\'|translate}} <div class=comment>{{\'no_materials\'|translate}}</div> </div> <a ng-if=\"sura.materials_count > 0\" class=\"col-img-link extra\" ui-sref=koran.extra.index({id:sura.id}) ng-click=$event.stopPropagation();> <img src=/assets/images/extra.png alt=\"\"><br> {{\'extra\'|translate}} <div class=comment>{{\'materials_number\'|translate:{number:sura.materials_count}:\'messageformat\'}}</div> </a> </div> <div class=\"col-xs-3 bl\"> <a ui-sref=koran.training.index({id:sura.id}) class=\"col-img-link training\" ng-click=$event.stopPropagation();> <img src=/assets/images/training.png alt=\"\"><br> {{::\'start_training\'|translate}} <div class=comment>{{$ctrl.lastTrainingMoment(sura.id)}}</div> </a> </div> </div> </div>");
$templateCache.put("app/components/koran/_suraItemMobile.html","<div ui-sref=koran.view({id:sura.id}) id=sura-item-{{::sura.id}} class=\"sura-item sura-item-{{::sura.number}} sura-item-mobile\"> <favorite-button-small resource=sura resource-id=sura.id></favorite-button-small> <div class=sura-item-main> <a href class=name>{{::sura.number}}. {{::sura.name}}</a> <div class=arab-name>{{::sura.arab_name}}</div> <div class=meta-row> <span> <i class=icon-book></i> {{\'pages_number\'|translate:{number:sura.total_pages}:\'messageformat\'}} </span> <span> <i class=icon-eye></i> {{$ctrl.lastReadMoment(sura.id)}} </span> </div> </div> <div class=sura-item-extra> <div ng-if=!sura.materials_count class=\"col-img-link extra\"> {{\'extra\'|translate}} <div class=comment>{{\'no_materials\'|translate}}</div> </div> <a ng-if=\"sura.materials_count > 0\" class=\"col-img-link extra\" ui-sref=koran.extra.index({id:sura.id}) ng-click=$event.stopPropagation();> {{\'extra\'|translate}} <div class=comment>{{\'materials_number\'|translate:{number:sura.materials_count}:\'messageformat\'}}</div> </a> </div> <div class=sura-item-extra> <a ui-sref=koran.training.index({id:sura.id}) class=\"col-img-link training\" ng-click=$event.stopPropagation();> {{::\'start_training\'|translate}} <div class=comment>{{$ctrl.lastTrainingMoment(sura.id)}}</div> </a> </div> </div>");
$templateCache.put("app/components/koran/_suraMobile.html","<div class=container-page-responsive> <div class=\"actions-bar top bb\"> <a class=\"td-none pull-right hidden-phone\" ui-sref=koran.view({id:$ctrl.sura.nextSura.id}) ng-if=::$ctrl.sura.nextSura>{{::\'next_sura_name\'|translate:$ctrl.sura.nextSura}} &nbsp;<i class=icon-arrow-right></i></a> <a class=td-none ui-sref=koran.index><i class=icon-arrow-left></i>&nbsp; {{::\'koran_sura_list\'|translate}}</a> </div> <div class=\"page-header sura-page-header\"> <h1>{{::$ctrl.sura.number}}. {{::\'sura_name\'|translate:$ctrl.sura}}</h1> <div class=page-actions><!-- <a ng-click=\"\">\r\n				<i class=\"icon-share\"></i>\r\n				<span>{{\'share\'|translate}}</span>\r\n			</a>--> <report-button ng-if=\"::$ctrl.accessService.can(\'report\')\" report-variants=::$ctrl.reportOptions.variants report-input-label=::$ctrl.reportOptions.inputLabel report-input-required=true></report-button> <favorite-button ng-if=$root.isLoggedIn() resource=sura resource-id=$ctrl.sura.id></favorite-button> </div> </div> <div class=\"actions-bar bt text-center\"> <a href class=td-none ng-click=$ctrl.startReadMode()> <i class=icon-book></i> {{::\'goto_read_mode\'|translate}} </a> </div> <div class=sura hover-target ng-class=\"{active:$ctrl.allPlayIndex !== null || $ctrl.readModeText, \'sura-read-mode\': $ctrl.readMode}\" ng-click=\"$ctrl.readModeSrc = null; $ctrl.readModeText = null;\"> <div class=sura-title ng-show=$ctrl.showTitle() ng-class=\"{active:$ctrl.allPlayIndex === 0 || $ctrl.readModeText == $ctrl.sura.title}\"> <span ng-click=\"$ctrl.toggleReadMode($ctrl.getTitleAudio(), $ctrl.sura.title); $ctrl.vgapiAll.pause(); $ctrl.allPlayIndex = null; $event.stopPropagation();\"><span ng-bind-html=$ctrl.sura.arab_title></span></span> </div> <div class=sura-content> <span class=ayat ng-repeat=\"ayat in $ctrl.ayatListPage track by ayat.id\" ng-click=\"$ctrl.toggleReadMode(ayat.audio_text_url, ayat.text); $ctrl.vgapiAll.pause(); $ctrl.allPlayIndex = null; $event.stopPropagation();\" ng-class=\"{active:$ctrl.allPlayIndex === $ctrl.fixAudioIndex($index) || $ctrl.readModeText == ayat.text}\"> <span class=text>{{::ayat.arab_text}}</span> <span class=number>{{::ayat.number|arabNumber}}</span><!-- <span class=\"text\">{{::ayat.arab_text|withoutLastWord}}</span>\r\n				<span style=\"white-space:nowrap;\">\r\n					<span class=\"text\">{{::ayat.arab_text|lastWord}}</span>\r\n					<span class=\"number\">{{::ayat.number|arabNumber}}</span>\r\n				</span> --> </span> </div> <div class=sura-actions-top ng-if=$ctrl.readMode ng-click=$event.stopPropagation();> <div class=col-close><button type=button class=close ng-click=$ctrl.stopReadMode()><i class=icon-close></i></button></div> <div class=col-title>{{::\'sura_name\'|translate:$ctrl.sura}}</div> <div class=\"text-right visible-phone\" ng-if=\"::$ctrl.sura.total_pages > 1\"> <a href class=td-none ng-click=$ctrl.pageModal()>{{::\'pg\'|translate}} {{$ctrl.selectorPage}} {{ ::\'of_count\'|translate:{count:$ctrl.sura.total_pages} }} &nbsp;<i class=icon-angle-down></i></a> </div> <div class=\"text-right visible-phone\" ng-if=\"::$ctrl.sura.total_pages == 1\"> {{::\'page\'|translate}} {{$ctrl.selectorPage}} <span translate=of_count translate-value-count={{::$ctrl.sura.total_pages}}></span> </div> <div class=\"text-right hidden-phone\"> <a class=td-none ui-sref=\"::[\'Sura\',{id:$ctrl.sura.nextSura.id}]\" ng-if=::$ctrl.sura.nextSura>{{::\'next_sura_name\'|translate:$ctrl.sura.nextSura}} &nbsp;<i class=icon-arrow-right></i></a> </div> </div> <div class=sura-actions ng-click=$event.stopPropagation();> <div class=\"actions-bar bb text-center\" ng-if=\"$ctrl.readMode && $ctrl.readModeText\"> <audio-player src=$ctrl.readModeSrc text=$ctrl.readModeText></audio-player> </div> <div class=\"actions-bar bb text-center visible-phone\" ng-if=!$ctrl.readMode> <audio-button src-list=::$ctrl.pagePlayList pause-on-stop=true on-play=\"$ctrl.stopReadMode(); $ctrl.allPlayIndex = index;\" on-stop=\"$ctrl.allPlayIndex = null\" vgapi=$ctrl.vgapiAll></audio-button> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <a href class=td-none ng-click=$ctrl.pageModal()>{{::\'page\'|translate}} {{$ctrl.selectorPage}} {{ ::\'of_count\'|translate:{count:$ctrl.sura.total_pages} }} &nbsp;<i class=icon-angle-down></i></a> </div> <div class=\"col text-left\"> <button ng-click=$ctrl.pageDoneRead() loading-overlay=$ctrl.pageDoneReadLoading loading-hide-content=true class=\"btn btn-default btn-done-points\"> <i class=\"icon-angle-left icon-success\"></i> <span class=divider></span> <span class=text> <span class=done>{{::\'done_read\'|translate}}</span> <span class=points>+{{::\'points_number\'|translate:{number:(\'points.suraRead\'|config)}:\'messageformat\'}}</span> </span> </button> </div> <div class=\"col hidden-phone\"> <audio-button src-list=::$ctrl.pagePlayList pause-on-stop=true on-play=\"$ctrl.stopReadMode(); $ctrl.allPlayIndex = index;\" on-stop=\"$ctrl.allPlayIndex = null\" vgapi=$ctrl.vgapiAll></audio-button> </div> <div class=\"col hidden-phone\" ng-if=\"::$ctrl.sura.total_pages > 1\"> <a href class=td-none ng-click=$ctrl.pageModal()>{{::\'page\'|translate}} {{$ctrl.selectorPage}} {{ ::\'of_count\'|translate:{count:$ctrl.sura.total_pages} }} &nbsp;<i class=icon-angle-down></i></a> </div> <div class=\"col hidden-phone\" ng-if=\"::$ctrl.sura.total_pages == 1\"> {{::\'page\'|translate}} {{$ctrl.selectorPage}} {{ ::\'of_count\'|translate:{count:$ctrl.sura.total_pages} }} </div> <div class=\"col nav-buttons text-right\"> <button ng-click=$ctrl.prevPage() ng-disabled=!$ctrl.prevPageAvail() class=\"btn btn-default btn-page\"> <i class=icon-angle-right></i> </button> </div> </div> </div> <div class=actions-bar> <a class=td-none ui-sref=koran.index><i class=icon-arrow-left></i>&nbsp; {{::\'koran_sura_list\'|translate}}</a> </div> </div>");
$templateCache.put("app/components/koran/extra.html","<div class=\"container container-page-responsive\" ng-if=!$root.isTablet> <div class=\"row hidden-tablet\"> <div class=\"col-xs-4 text-left\"> <a class=td-none ui-sref=.({id:$ctrl.sura.prevSura.id}) ng-show=$ctrl.sura.prevSura><i class=icon-arrow-left></i>&nbsp; {{\'prev_sura_name\'|translate:$ctrl.sura.prevSura}}</a> </div> <div class=\"col-xs-4 text-center\"> <a class=td-none ui-sref=koran.index><i class=icon-bars></i>&nbsp; {{\'koran_sura_list\'|translate}}</a> </div> <div class=\"col-xs-4 text-right\"> <a class=td-none ui-sref=.({id:$ctrl.sura.nextSura.id}) ng-show=$ctrl.sura.nextSura>{{\'next_sura_name\'|translate:$ctrl.sura.nextSura}} &nbsp;<i class=icon-arrow-right></i></a> </div> </div> <ng-include src=\"\'app/components/koran/_extra.html\'\"></ng-include> </div> <div class=container-page-responsive ng-if=$root.isTablet> <div class=\"actions-bar top bb visible-tablet\"> <a class=\"td-none pull-right hidden-phone\" ui-sref=.({id:$ctrl.sura.nextSura.id}) ng-if=$ctrl.sura.nextSura>{{\'next_sura_name\'|translate:$ctrl.sura.nextSura}} &nbsp;<i class=icon-arrow-right></i></a> <a class=td-none ui-sref=koran.index><i class=icon-arrow-left></i>&nbsp; {{\'koran_sura_list\'|translate}}</a> </div> <div class=container> <ng-include src=\"\'app/components/koran/_extra.html\'\"></ng-include> </div> </div>");
$templateCache.put("app/components/koran/favorite.html","<div class=\"container container-page-responsive\"> <ng-include src=\"\'app/views/favoriteTabs.html\'\"></ng-include> <h1>{{\'koran_favorite\'|translate}} ({{$ctrl.suraList.length}})</h1> <sura-list items=$ctrl.suraList></sura-list> </div>");
$templateCache.put("app/components/koran/landing.html","<div id=koran-landing> <div class=\"section fp-auto-height-responsive splash-screen screen-1 koran-bg\"> <div class=image> <div> <img ng-if=!$root.isPhone ng-src=\"{{\'assets/images/devices@2x.png\'|langSuffix}}\" alt=\"\"> <img ng-if=$root.isPhone ng-src=\"{{\'assets/images/devices.png\'|langSuffix}}\" alt=\"\"> <a class=play href ng-click=$ctrl.play() ng-if=\"\'koran_youtube_url\'|configService\"></a> </div> </div> <div class=splash-screen-container> <div> <div class=title ng-bind-html=\"\'koran_landing_screen1_title\'|translate|trustHtml\"></div> <div class=text ng-bind-html=\"\'koran_landing_screen1_text\'|translate|trustHtml\"></div> <button class=\"btn btn-primary\" ng-if=!$root.isLoggedIn() ui-sref=auth.register>{{ \'sign_up\' | translate }}</button> <button class=\"btn btn-primary\" ng-if=$root.isLoggedIn() ui-sref=koran.index>{{ \'start_studying\' | translate }}</button> </div> </div> <div class=arrow-down> <a href ng-click=$ctrl.down()><img src=assets/images/arrow-down.png alt=\"\"></a> </div> </div> <div class=\"section fp-auto-height-responsive splash-screen screen-2\"> <div class=splash-screen-container> <div class=title ng-bind-html=\"\'koran_landing_screen2_title\'|translate|trustHtml\"></div> <div class=text ng-bind-html=\"\'koran_landing_screen2_text\'|translate|trustHtml\"></div> </div> <div class=image> <img ng-if=!$root.isPhone ng-src=\"{{\'assets/images/screenshots/koran-1@2x.png\'|langSuffix}}\" alt=\"\"> <img ng-if=$root.isPhone ng-src=\"{{\'assets/images/screenshots/koran-1.png\'|langSuffix}}\" alt=\"\"> </div> </div> <div class=\"section fp-auto-height-responsive splash-screen screen-3\"> <div class=splash-screen-container> <div> <div class=pre-title>{{\'koran_landing_screen3_pre_title\'|translate}}</div> <div class=title ng-bind-html=\"\'koran_landing_screen3_title\'|translate|trustHtml\"></div> <div class=text ng-bind-html=\"\'koran_landing_screen3_text\'|translate|trustHtml\"></div> </div> </div> <div class=image> <img ng-if=!$root.isPhone ng-src=\"{{\'assets/images/screenshots/koran-2@2x.png\'|langSuffix}}\" alt=\"\"> <img ng-if=$root.isPhone ng-src=\"{{\'assets/images/screenshots/koran-2@2x.png\'|langSuffix}}\" alt=\"\"> </div> </div> <div class=\"section fp-auto-height-responsive splash-screen screen-4\"> <div class=splash-screen-container> <div> <div class=pre-title>{{\'koran_landing_screen4_pre_title\'|translate}}</div> <div class=title ng-bind-html=\"\'koran_landing_screen4_title\'|translate|trustHtml\"></div> <div class=text ng-bind-html=\"\'koran_landing_screen4_text\'|translate|trustHtml\"></div> </div> </div> <div class=image> <img ng-if=!$root.isPhone ng-src=\"{{\'assets/images/screenshots/koran-3@2x.png\'|langSuffix}}\" alt=\"\"> <img ng-if=$root.isPhone ng-src=\"{{\'assets/images/screenshots/koran-3.png\'|langSuffix}}\" alt=\"\"> </div> </div> <div class=\"section fp-auto-height-responsive splash-screen screen-5\"> <div class=splash-screen-container> <div> <div class=pre-title>{{\'koran_landing_screen5_pre_title\'|translate}}</div> <div class=title ng-bind-html=\"\'koran_landing_screen5_title\'|translate|trustHtml\"></div> <div class=text ng-bind-html=\"\'koran_landing_screen5_text\'|translate|trustHtml\"></div> </div> </div> <div class=image> <img ng-if=!$root.isPhone ng-src=\"{{\'assets/images/screenshots/koran-4@2x.png\'|langSuffix}}\" alt=\"\"> <img ng-if=$root.isPhone ng-src=\"{{\'assets/images/screenshots/koran-4.png\'|langSuffix}}\" alt=\"\"> </div> </div> <div class=\"section fp-auto-height-responsive splash-screen screen-6\"> <div class=splash-screen-container> <div class=title ng-bind-html=\"\'koran_landing_screen6_title\'|translate|trustHtml\"></div> <div class=text ng-bind-html=\"\'koran_landing_screen6_text\'|translate|trustHtml\"></div> </div> <div class=image> <img ng-if=!$root.isPhone ng-src=\"{{\'assets/images/screenshots/koran-5@2x.png\'|langSuffix}}\" alt=\"\"> <img ng-if=$root.isPhone ng-src=\"{{\'assets/images/screenshots/koran-5.png\'|langSuffix}}\" alt=\"\"> </div> </div> <div class=\"section fp-auto-height-responsive splash-screen screen-7 koran-bg\"> <div class=splash-screen-container> <div class=title ng-bind-html=\"\'koran_landing_screen7_title\'|translate|trustHtml\"></div> <div class=free> <a ng-href=\"{{\'why_free_url\'|configService}}\" target=_blank>{{\'why_free\'|translate}}</a> </div> <div class=button> <button class=\"btn btn-primary\" ng-if=!$root.isLoggedIn() ui-sref=auth.register>{{ \'sign_up\' | translate }}</button> <button class=\"btn btn-primary\" ng-if=$root.isLoggedIn() ui-sref=koran.index>{{ \'start_studying\' | translate }}</button> </div> <div class=\"text share\"> {{\'share_with_friends\'|translate}} <br> <a href socialshare socialshare-provider=facebook socialshare-type=share socialshare-via=\"{{\'facebookAppId\'|config}}\" socialshare-title=\"{{\'site_share_title\'|configService}}\" socialshare-description=\"{{\'site_share_description\'|configService}}\" socialshare-media=\"{{\'http://shakird.com/assets/images/devices@2x.png\'|langSuffix}}\" socialshare-url=https://shakird.com/{{$root.languageService.currentLanguage}}> <img src=assets/images/social/facebook-lg.png alt=\"\">Facebook </a> <a href socialshare socialshare-provider=twitter socialshare-text=\"{{\'site_share_title\'|configService}}\" socialshare-url=https://shakird.com/{{$root.languageService.currentLanguage}}> <img src=assets/images/social/twitter-lg.png alt=\"\">Twitter </a> <a href socialshare socialshare-provider=google socialshare-text=\"{{\'site_share_title\'|configService}}\" socialshare-url=https://shakird.com/{{$root.languageService.currentLanguage}}> <img src=assets/images/social/google-lg.png alt=\"\">Google+ </a> </div> </div> </div> </div>");
$templateCache.put("app/components/koran/pageSelectorModal.html","<div class=modal-header> <button type=button class=close ng-click=$ctrl.dismiss()><i class=icon-close></i></button> <h2 class=modal-title>{{\'select_page\'|translate}}</h2> </div> <div class=\"modal-body button-grid\"> <button class=\"btn btn-default btn-sm btn-hover-primary\" style=\"flex-basis: 40px\" ng-repeat=\"i in $ctrl.range() track by $index\" ng-click=$ctrl.select($index+1)>{{$index+1}}</button> </div>");
$templateCache.put("app/components/koran/sura.html","<div class=\"container-page-responsive text-center\" ng-if=$ctrl.loading><div class=loading></div></div> <div ng-if=!$ctrl.loading> <ng-include src=\"\'app/components/koran/_suraDesktop.html\'\" ng-if=$root.isDesktop></ng-include> <ng-include src=\"\'app/components/koran/_suraMobile.html\'\" ng-if=$root.isTablet></ng-include> </div>");
$templateCache.put("app/components/koran/suraIndex.html","<div class=container-page-responsive ng-class=\"{\'container\':!$root.isDesktop}\"> <banner-top position=koran class=bg-2></banner-top> <div ng-class=\"{\'container\':$root.isDesktop}\"> <banner id=sura-list-banner class=banner-simple close-button=true ng-if=\"\'sura_list_banner\'|configService\"><span ng-bind-html=\"\'sura_list_banner\'|configService\"></span></banner> <form> <div class=\"form-group form-group-icon-right\"> <input class=form-control type=text ng-model=q placeholder=\"{{\'sura_search\'|translate}}\"> <i class=\"icon icon-search icon-gray\"></i> </div> </form> <div class=total-sura-number translate=total_sura_number translate-value-number={{$ctrl.suraList.length}} translate-interpolation=messageformat></div> <div class=sura-list-wrap> <sura-list items=::$ctrl.suraList filter=q> <div class=loading></div> </sura-list> <div class=\"sura-number-links affix\" ng-hide=q> <div class=title>{{\'suras\'|translate}}</div> <div class=num ng-repeat=\"s in ::$ctrl.numbers\"> <a href ng-click=$ctrl.scrollToNumber(s.number)>{{::s.text}}</a> </div> </div> </div> </div> </div>");
$templateCache.put("app/components/koran/suraList.html","<div ng-repeat=\"sura in $ctrl.items | filter:{numberedName:$ctrl.filter} as result track by sura.id\"> <ng-include src=\"\'app/components/koran/_suraItemDesktop.html\'\" ng-if=$root.isDesktop></ng-include> <ng-include src=\"\'app/components/koran/_suraItemMobile.html\'\" ng-if=$root.isTablet></ng-include> <banner ng-if=\"$index == result.length-1\" class=banner-simple id=sura-list-share-banner close-button=false><ng-include src=\"\'app/views/shareProjectBanner.html\'\"></ng-include></banner> </div> <div ng-if=!result.length>{{\'nothing_found\'|translate}}</div>");
$templateCache.put("app/components/settings/notification.html","<form> <div class=checkbox> <label class=bold> <input type=checkbox ng-model=$ctrl.data.email_subscription ng-change=$ctrl.save()> {{ \'email_subscription\' | translate }} </label> </div> <p>{{ \'email_subscription_about\' | translate }}</p> <br> <div class=checkbox> <label class=bold> <input type=checkbox ng-model=$ctrl.data.email_notification ng-change=$ctrl.save()> {{ \'email_notification\' | translate }} </label> </div> <p>{{ \'email_notification_about\' | translate }}</p> </form>");
$templateCache.put("app/components/settings/plan.html","<h2 class=text-center style=\"margin-top: 0\"> {{ \'activity_plan_title_1\' | translate }} <br> {{ \'activity_plan_title_2\' | translate }} </h2> <form class=center-block style=\"max-width: 430px\"> <rzslider rz-slider-model=$ctrl.data.points_plan rz-slider-options=$ctrl.sliderOptions></rzslider> <div class=slider-legend> <div class=pull-left>{{ \'points_number\'|translate:{number:$ctrl.sliderOptions.floor}:\'messageformat\' }}</div> <div class=pull-right>{{$ctrl.sliderOptions.ceil}}</div> </div> </form> <br> <p class=text-center>{{ \'activity_plan_choose\' | translate }}</p> <div class=plan-variants> <div class=\"plan-variant plan-variant-1\" ng-click=$ctrl.setPlan(50)> <div class=img></div> <div class=title ng-bind-html=\"\'plan_title_1\'|translate|trustHtml\"></div> <div class=cols> <div class=col> <div class=number>30</div> <div class=comment>{{ \'min_day\' | translate }}</div> </div> <div class=col> <div class=number>50</div> <div class=comment>{{ \'of_points\' | translate }}</div> </div> </div> </div> <div class=\"plan-variant plan-variant-2\" ng-click=$ctrl.setPlan(100)> <div class=title ng-bind-html=\"\'plan_title_2\'|translate|trustHtml\"></div> <div class=cols> <div class=col> <div class=number>60</div> <div class=comment>{{ \'min_day\' | translate }}</div> </div> <div class=col> <div class=number>100</div> <div class=comment>{{ \'of_points\' | translate }}</div> </div> </div> </div> <div class=\"plan-variant plan-variant-3\" ng-click=$ctrl.setPlan(200)> <div class=title ng-bind-html=\"\'plan_title_3\'|translate|trustHtml\"></div> <div class=cols> <div class=col> <div class=number>120</div> <div class=comment>{{ \'min_day\' | translate }}</div> </div> <div class=col> <div class=number>200</div> <div class=comment>{{ \'of_points\' | translate }}</div> </div> </div> </div> </div>");
$templateCache.put("app/components/settings/profile.html","<div class=row> <div class=col-xs-12 ng-class=\"{\'col-lg-7 col-md-8\':!$root.isTablet}\"> <form novalidate name=form ng-submit=$ctrl.onSubmit(form) role=form> <div class=\"flex flex-start flex-center-tablet flex-column-phone flex-vcenter flex-wrap\" style=\"margin:0 -10px\"> <div style=\"width:150px;margin:0 10px 10px\"> <div class=avatar-preview loading-overlay=$ctrl.avatarLoading delete-overlay=$ctrl.data.avatar delete-action=$ctrl.avatarDelete() delete-icon-class=icon-delete-circle> <img ng-src={{$ctrl.data.avatar|avatar}} alt=\"\"> </div> </div><!--\r\n				--><div class=\"text-left text-center-phone\" style=\"max-width:200px;margin:0 10px\"> <p class=\"text-muted small\">{{ \'change_photo_hint\' | translate }}</p> <file-upload-button uploader-config=$ctrl.avatarUploaderConfig upload-url=$ctrl.avatarUploadUrl btn-class=\"btn-primary btn-invert\" on-success=$ctrl.avatarUploaded(file) uploading=$ctrl.avatarLoading images-only=true>{{ \'select_file\' | translate }}</file-upload-button> </div> </div> <br> <div class=row> <div class=col-sm-6> <form-group-minimal name=name fg-class=\"{{$ctrl.nameSuccess && \'has-success\'}}\" tooltip=\"$ctrl.nameSuccess && \'nickname_is_free\'\"> <input type=text ng-required=true ng-model=$ctrl.data.name name=name placeholder=\"{{\'nickname\'|translate}}\"> </form-group-minimal> </div> <div class=col-sm-6> <form-group-minimal name=email> <input type=email ng-pattern=\"\'emailPattern\'|config\" ng-model=$ctrl.data.email name=email ng-disabled=true placeholder=\"{{\'email_text\'|translate}}\"> </form-group-minimal> </div> </div> <div class=row> <div class=col-xs-6> <div moment-picker=$ctrl.data.birthday> <form-group-minimal name=birthday fg-class=form-group-icon-left> <i class=\"icon icon-gray icon-calendar\"></i> <input type=text ng-required=false ng-model=$ctrl.data.birthday ng-model-options=\"{ updateOn: \'change blur\' }\" name=birthday placeholder=\"{{\'birthday\'|translate}}\"> </form-group-minimal> </div> </div> <div class=col-xs-6> <form-group-minimal name=gender> <ui-select ng-model=$ctrl.data.gender name=gender ng-required=false search-enabled=true> <ui-select-match placeholder=\"{{\'gender\'|translate}}\">{{$select.selected.text|translate}}</ui-select-match> <ui-select-choices repeat=\"item.value as item in $ctrl.gendersSelect|filter:{text:$select.search}\">{{item.text|translate}}</ui-select-choices> </ui-select> </form-group-minimal> </div> </div> <div class=row> <div class=col-sm-6> <form-group-minimal name=country> <input type=text ng-required=false ng-model=$ctrl.data.country name=country placeholder=\"{{\'country\'|translate}}\"> </form-group-minimal> </div> <div class=col-sm-6> <form-group-minimal name=city> <input type=text ng-required=false ng-model=$ctrl.data.city name=city placeholder=\"{{\'city\'|translate}}\"> </form-group-minimal> </div> </div> <div class=row> <div class=\"col-xs-12 fz-16-phone\" style=\"margin-top: 10px;margin-bottom: 20px\"> {{\'timezone\'|translate}}: <a href ng-click=$ctrl.timezoneModal()>{{$ctrl.data.timezone}} <i class=icon-angle-down></i></a> </div> </div> <div class=row> <div class=col-sm-6> <form-group-minimal name=old_password> <input type=password ng-required=!!$ctrl.data.new_password ng-model=$ctrl.data.old_password ng-change=\"$ctrl.errors.old_password=false\" name=old_password placeholder=\"{{\'old_password\'|translate}}\"> </form-group-minimal> </div> <div class=col-sm-6> <form-group-minimal name=new_password> <input type=password ng-model=$ctrl.data.new_password ng-change=form.old_password.$setDirty(true) name=new_password placeholder=\"{{\'new_password\'|translate}}\"> </form-group-minimal> </div> </div> <div class=form-actions> <button type=submit ng-disabled=\"form.$invalid || $ctrl.dataLoading\" class=\"btn btn-primary\" loading-overlay=$ctrl.dataLoading loading-class=loading-white loading-hide-content=true>{{ \'save_changes\' | translate }}</button> </div> </form> </div> </div>");
$templateCache.put("app/components/settings/settings.html","<div class=container-page-responsive> <div class=\"actions-bar bb top text-center\" ng-if=$root.isPhone> <a href class=td-none ng-click=\"$ctrl.showMenu = !$ctrl.showMenu\">{{$ctrl.getTitle()|translate}} &nbsp;<i class=icon-angle-down ng-if=!$ctrl.showMenu></i><i class=icon-angle-up ng-if=$ctrl.showMenu></i></a> <div ng-if=$ctrl.showMenu style=\"padding-top: 20px\"> <p> <a ui-sref=settings.plan ng-click=\"$ctrl.showMenu = false\">{{ \'day_plan\' | translate }}</a> </p> <p> <a ui-sref=my.log ng-click=\"$ctrl.showMenu = false\">{{ \'my_activity_log\' | translate }}</a> </p> <p> <a ui-sref=settings.notifications ng-click=\"$ctrl.showMenu = false\">{{ \'notifications\' | translate }}</a> </p> <p> <a ui-sref=settings.profile ng-click=\"$ctrl.showMenu = false\">{{ \'settings\' | translate }}</a> </p> </div> </div> <ul class=\"nav nav-tabs top nav-center\" ng-if=\"$root.isTablet && !$root.isPhone\"> <li ui-sref-active=active> <a ui-sref=settings.plan>{{ \'day_plan\' | translate }}</a> </li> <li ui-sref-active=active> <a ui-sref=my.log>{{ \'my_activity_log\' | translate }}</a> </li> <li ui-sref-active=active> <a ui-sref=settings.notifications>{{ \'notifications\' | translate }}</a> </li> <li ui-sref-active=active> <a ui-sref=settings.profile>{{ \'settings\' | translate }}</a> </li> </ul> <div class=container> <div ng-if=!$root.isTablet> <h1>{{$ctrl.getTitle()|translate}}</h1> <br> </div> <div class=\"row column-container\"> <div class=\"col-xs-3 column bordered padded\" ng-if=!$root.isTablet> <ul class=\"nav nav-list nav-stacked\"> <li ui-sref-active=active> <a ui-sref=settings.plan>{{ \'day_plan\' | translate }}</a> </li> <li ui-sref-active=active> <a ui-sref=my.log>{{ \'my_activity_log\' | translate }}</a> </li> <li ui-sref-active=active> <a ui-sref=settings.notifications>{{ \'notifications\' | translate }}</a> </li> <li ui-sref-active=active> <a ui-sref=settings.profile>{{ \'settings\' | translate }}</a> </li> </ul> </div> <div class=column ng-class=\"{\'col-xs-9 column-grow bordered padded\':!$root.isTablet}\"> <ui-view></ui-view> </div> </div> </div> </div>");
$templateCache.put("app/components/user/activity.html","<div class=\"container container-page-responsive\"> <button type=button class=\"close close-side\" ng-click=$ctrl.close()><i class=icon-close></i></button> <user-preview-profile user-id=$ctrl.id></user-preview-profile> <br> <ul class=\"nav nav-tabs nav-center\"><!-- <li ui-sref-active=\"active\">\r\n            <a ui-sref=\".diagram\">{{ \'activity_diagram\' | translate }}</a>\r\n        </li> --> <li ui-sref-active=active> <a ui-sref=.log>{{ \'activity_log\' | translate }}</a> </li> </ul> <ui-view></ui-view> </div>");
$templateCache.put("app/components/user/activityLog.html","<log data=$ctrl.log timezone=$ctrl.ps.timezone></log> <hr> <div class=text-center-tablet> <button class=\"btn btn-primary btn-block-phone\" ng-if=\"$ctrl.pagination.currentPage < $ctrl.pagination.pageCount\" ng-click=$ctrl.load($ctrl.pagination.currentPage+1)>{{ \'show_more\' | translate }}</button> </div>");
$templateCache.put("app/components/user/diagram.html","<br> <p ng-if=$ctrl.you class=text-right><small><a ui-sref=settings.plan>{{\'plan_settings\'|translate}}</a></small></p> <div class=\"panel panel-default\"> <div class=panel-body> <div class=row> <div class=\"col-sm-3 hidden-xs\"> <div class=profile-progress> <div class=level>{{$ctrl.user.level}}</div> <div class=\"text-success text-lowercase\">{{ \'for_today\' | translate }}</div> <div class=points> <span class=today>{{$ctrl.user.today_points}}</span> <span class=plan ng-if=\"$ctrl.user.points_plan > 0\">/ {{$ctrl.user.points_plan}}</span> </div> <div class=text-muted><small>{{\'next_level_points\'|translate:{level:$ctrl.nextLevel(),points:$ctrl.nextLevelExp()-$ctrl.currentExp()}:\'messageformat\'}}</small></div> <div class=progress> <div class=\"progress-bar progress-bar-success\" style=\"width:{{ ($ctrl.currentExp() / $ctrl.nextLevelExp())*100 }}%\"></div> </div> </div> </div> <div class=col-sm-9> <div class=text-right> <small class=text-success>{{\'planned_results\'|translate}}</small> &nbsp; <small class=text-warning>{{\'real_results\'|translate}}</small> </div> <div class=ct-chart></div> </div> </div> </div> </div> <br> <help-qa category=\"\'diagram\'\"></help-qa>");
$templateCache.put("app/components/sprint/friendsSearchForm.html","<form ng-submit=$ctrl.submit()> <div class=\"form-group form-group-icon-right\"> <input class=form-control type=text ng-model=$ctrl.params.name placeholder=\"{{\'keyword\'|translate}}\"> <i class=\"icon icon-search icon-gray\" style=\"cursor: pointer\" ng-click=$ctrl.submit()></i> </div> <div class=search-actions> <span uib-dropdown class=action> <a href uib-dropdown-toggle class=td-none> {{ $ctrl.params.gender != null && $ctrl.getGenderText($ctrl.params.gender) || \'\' }} {{ $ctrl.params.gender == null && (\'gender\'|translate) || \'\' }} <i class=icon-angle-down></i> </a> <ul uib-dropdown-menu> <li ng-repeat=\"o in $ctrl.genderOptions\"><a href ng-click=\"$ctrl.params.gender = o.value; $ctrl.submit();\">{{o.text|translate}}</a></li> </ul> </span> <a href uib-popover-template=\"\'ageRange.html\'\" popover-class=noarrow popover-trigger=\"\'outsideClick\'\" popover-placement=\"auto bottom-left\" class=\"td-none action\"> {{ $ctrl.params.age_from && (\'from\'|translate|lowercase)+\' \'+$ctrl.params.age_from || \'\' }} {{ $ctrl.params.age_to && (\'to\'|translate|lowercase)+\' \'+$ctrl.params.age_to || \'\' }} {{ !$ctrl.params.age_from && !$ctrl.params.age_to && (\'age\'|translate) || \'\' }} <i class=icon-angle-down></i> </a> </div> </form> <script type=text/ng-template id=ageRange.html><form class=\"form-inline text-muted text-nowrap\">\r\n        <input type=\"number\" min=\"0\" class=\"form-control input-sm\" style=\"width:70px;display:inline-block;\" placeholder=\"{{\'from\'|translate|lowercase}}\" ng-model=\"$ctrl.params.age_from\" ng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }\" ng-change=\"$ctrl.submit()\">\r\n        &mdash;\r\n        <input type=\"number\" min=\"0\" class=\"form-control input-sm\" style=\"width:70px;display:inline-block;\" placeholder=\"{{\'to\'|translate|lowercase}}\" ng-model=\"$ctrl.params.age_to\" ng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 500, \'blur\': 0 } }\" ng-change=\"$ctrl.submit()\">\r\n    </form></script>");
$templateCache.put("app/components/sprint/sprintFriendsOuter.html","<div class=page-header> <button type=button class=close ui-sref=sprint.index><i class=icon-close></i></button> <h1>{{\'added_you_in_sprint\'|translate}} ({{$ctrl.sprinters.length + 0}})</h1> </div> <div loading-replace=$ctrl.loading> <div class=\"user-items row\"> <div class=col-md-6 ng-repeat=\"s in $ctrl.sprinters\" ng-class={inactive:$ctrl.isAdded(s.user_id)}> <div class=row> <div class=\"col-xs-7 vcenter\"> <user-preview-short user-id=s.user_id></user-preview-short> </div><!--\r\n				--><div class=\"col-xs-5 vcenter text-right\"> <button ng-if=!$ctrl.isAdded(s.user_id) class=\"btn btn-primary btn-invert btn-block btn-wrap\" ng-click=$ctrl.add(s.user_id)>{{\'add_to_sprint\'|translate}}</button> <button ng-if=$ctrl.isAdded(s.user_id) class=\"btn btn-success btn-block btn-wrap\">{{\'added_to_sprint\'|translate}}</button> </div> </div> </div> </div> </div> <sprint-friends-search hide-close=true></sprint-friends-search>");
$templateCache.put("app/components/sprint/sprintFriendsOwn.html","<div class=page-header> <button type=button class=close ui-sref=sprint.index><i class=icon-close></i></button> <h1>{{\'in_your_sprint\'|translate}} ({{$ctrl.sprinters.length + 0}})</h1> </div> <div loading-replace=$ctrl.loading> <div class=\"user-items row\"> <div class=col-md-6 ng-repeat=\"s in $ctrl.sprinters\" ng-class={inactive:$ctrl.isRemoved(s.sprinter_id)}> <div class=row> <div class=\"col-xs-7 vcenter\"> <user-preview-short user-id=s.sprinter_id></user-preview-short> </div><!--\r\n				--><div class=\"col-xs-5 vcenter text-center\"> <a href ng-if=!$ctrl.isRemoved(s.sprinter_id) class=link-action ng-click=$ctrl.removeSprinter(s.sprinter_id)>{{\'remove_from_sprint\'|translate}}</a> <span ng-if=$ctrl.isRemoved(s.sprinter_id) class=text-muted><b>{{\'removed_from_sprint\'|translate}}</b></span> </div> </div> </div> </div> </div> <sprint-friends-search hide-close=true></sprint-friends-search>");
$templateCache.put("app/components/sprint/sprintFriendsSearch.html","<div class=page-header> <button type=button ng-if=!$ctrl.hideClose class=close ui-sref=sprint.index><i class=icon-close></i></button> <h1>{{\'friends_search\'|translate}}</h1> </div> <friends-search-form params=$ctrl.params on-submit=\"$ctrl.params = params\"></friends-search-form> <user-search-result params=$ctrl.params exclude=$ctrl.ps.currentUser.id sprint=true cols=2></user-search-result>");
$templateCache.put("app/components/sprint/sprintIndex.html","<div class=row> <div class=col-md-8> <div loading-replace=$ctrl.loadingLeader> <div class=page-header> <h1 ng-if=$ctrl.leader> {{ $ctrl.leader.id == $ctrl.ps.currentUser.id ? (\'today_leader_is_you\'|translate) : (\'today_leader\'|translate)+\' \'+$ctrl.leader.name }} &nbsp;<img ng-src=assets/images/icon-cup.png alt=\"\" style=\"vertical-align: baseline\"> </h1> <h1 ng-if=!$ctrl.leader>{{\'no_leader\'|translate}}</h1> </div> <div class=\"border-block flex hidden-phone\"> <div class=flex-grow> <user-preview-short user=$ctrl.leader></user-preview-short> </div> <div class=\"text-center text-success\"> {{\'for_today\'|translate}} <div class=text-lg>{{$ctrl.leader.today_points + 0}}</div> </div> </div> <div class=visible-phone> <user-preview user=$ctrl.leader></user-preview> <div class=\"text-center text-success\"> {{\'for_today\'|translate}} <div class=text-lg>{{$ctrl.leader.today_points + 0}}</div> </div> </div> </div> <h1>{{\'activity_log\'|translate}}</h1> <log data=$ctrl.log timezone=$ctrl.ps.timezone show-user=true></log> <hr> <div class=text-center-tablet> <button class=\"btn btn-primary btn-block-phone\" ng-if=\"$ctrl.pagination.currentPage < $ctrl.pagination.pageCount\" ng-click=$ctrl.load($ctrl.pagination.currentPage+1) loading-overlay=$ctrl.loadingLog loading-hide-content=true loading-class=loading-white>{{ \'show_more\' | translate }}</button> </div> <br> <br> </div> <div class=\"col-md-4 hidden-sm hidden-xs\"> <div class=\"border-block text-center\"> <p> <user-preview></user-preview> </p> <progress-today user=$ctrl.ps.currentUser ui-sref=my.log ng-click=$ctrl.closeSidebarRight()></progress-today><!-- <progress-today user=\"$ctrl.ps.currentUser\" ui-sref=\"my.diagram\" ng-click=\"$ctrl.closeSidebarRight()\"></progress-today> --> <sprint-count></sprint-count> </div> <div class=\"border-block text-center\"> <h4>{{\'friends_search\'|translate}}</h4> <friends-search-form on-submit=$ctrl.search(params)></friends-search-form> </div> <div class=\"border-block text-center\"><!-- <ng-include src=\"\'app/views/share.html\'\"></ng-include> --> <fb-friends></fb-friends> </div> </div> </div> <div class=\"visible-sm-block visible-xs-block\"> <div class=border-block> <h4>{{\'friends_search\'|translate}}</h4> <friends-search-form on-submit=$ctrl.search(params)></friends-search-form> </div> <div class=\"border-block text-center\"><!-- <ng-include src=\"\'app/views/share.html\'\"></ng-include> --> <fb-friends></fb-friends> </div> </div>");
$templateCache.put("app/components/_partials/audioButton/audioButton.html","<div class=audio> <videogular vg-player-ready=\"$ctrl.vgapi = $API; $ctrl.onReady({$API:$API});\" class=hidden> <vg-media vg-src=$ctrl.src vg-type=audio></vg-media> </videogular> <a class=vg-button ng-if=\"$ctrl.vgapi.currentState!=\'play\'\" ng-click=$ctrl.play()><i class=icon-play-circle></i>&nbsp; {{\'listen\'|translate}}</a> <a class=vg-button ng-if=\"$ctrl.vgapi.currentState==\'play\'\" ng-click=$ctrl.stop()><i class=icon-pause-circle></i>&nbsp; {{\'listen\'|translate}}</a> </div>");
$templateCache.put("app/components/_partials/addMaterialRequestModal/addMaterialRequestModal.html","<div class=modal-header> <button type=button class=close ng-click=$ctrl.dismiss()><i class=icon-close></i></button> <h2 class=modal-title>{{\'add_material_request\'|translate}}</h2> </div> <div class=modal-body> <p>{{\'add_material_request_text\' | translate}}</p> <p class=text-danger>{{\'all_fields_required_error\' | translate}}</p> <form novalidate name=form role=form ng-submit=$ctrl.submit()> <div class=row> <div class=col-sm-9> <form-group-minimal name=first_name> <input type=text ng-required=true ng-model=$ctrl.data.first_name name=first_name placeholder=\"{{\'first_name\'|translate}}\"> </form-group-minimal> <form-group-minimal name=last_name> <input type=text ng-required=true ng-model=$ctrl.data.last_name name=last_name placeholder=\"{{\'last_name\'|translate}}\"> </form-group-minimal> <form-group-minimal name=email> <input type=email ng-pattern=\"\'emailPattern\'|config\" ng-model=$ctrl.data.email name=email ng-required=true ng-change=\"form.email.$setValidity(\'wrong_email\',true)\" placeholder=\"{{\'email_text\'|translate}}\"> </form-group-minimal> <form-group-minimal name=phone> <input type=text ng-required=true ng-model=$ctrl.data.phone name=phone placeholder=\"{{\'mobile_phone\'|translate}}\"> </form-group-minimal> </div> </div> <form-group-minimal name=message> <textarea name=message ng-model=$ctrl.data.message placeholder=\"{{\'your_message\'|translate}}\" ng-required=true msd-elastic></textarea> </form-group-minimal> <div class=\"form-group form-group-minimal\" ng-class=\"{ \'has-error\': form.agreement.$dirty && form.agreement.$invalid }\" tooltip-error=agreement> <div class=checkbox> <label> <input type=checkbox name=agreement ng-model=$ctrl.data.agreement required> <div translate=accept_materials_agreement></div> </label> </div> </div> <div class=form-actions> <button type=submit ng-disabled=\"form.$invalid || $ctrl.dataLoading\" loading-replace=$ctrl.dataLoading loading-class=loading-white class=\"btn btn-primary btn-block\">{{ \'send_request\' | translate }}</button> </div> </form> </div>");
$templateCache.put("app/components/_partials/bannerTop/bannerTop.html","<div class=banner-top ng-if=\"$ctrl.banners.length > 0\"> <div class=slides> <div ng-repeat=\"b in $ctrl.banners\" ng-if=\"$ctrl.current == $index\"> <div class=icon ng-if=\"b.type == \'video\'\" ng-click=$ctrl.playVideo(b.url)><img src=assets/images/play-small.png alt=\"\"></div> <div class=title ng-if=b.title ng-bind-html=b.title></div> <div ng-if=b.text ng-bind-html=b.text></div> </div> </div> <div class=arrows ng-if=\"$ctrl.banners.length > 1\"> <div class=left ng-click=\"$ctrl.stop(); $ctrl.prev();\"> <i class=icon-arrow-left></i> </div> <div class=right ng-click=\"$ctrl.stop(); $ctrl.next();\"> <i class=icon-arrow-right></i> </div> </div> <div class=navigation ng-if=\"$ctrl.banners.length > 1\"> <div ng-repeat=\"b in $ctrl.banners\" ng-click=\"$ctrl.stop(); $ctrl.current = $index;\" ng-class=\"{active: $ctrl.current == $index}\"></div> </div> </div>");
$templateCache.put("app/components/_partials/confirmAuthModal/confirmAuthModal.html","<div class=modal-header> <button type=button class=close ng-click=$ctrl.close({$value:false})><i class=icon-close></i></button> <h2 class=modal-title>{{\'authorization_confirm_title\'|translate}}</h2> </div> <div class=modal-body> <p> {{\'authorization_confirm_text\'|translate}} </p> <button class=\"btn btn-primary hidden-phone\" type=button ng-click=$ctrl.close({$value:true})>{{\'authorize\'|translate}}</button> <button class=\"btn btn-primary btn-invert hidden-phone\" type=button ng-click=$ctrl.close({$value:false})>{{\'later\'|translate}}</button> <button class=\"btn btn-primary btn-block visible-phone\" type=button ng-click=$ctrl.close({$value:true})>{{\'authorize\'|translate}}</button> <button class=\"btn btn-primary btn-invert btn-block visible-phone\" type=button ng-click=$ctrl.close({$value:false})>{{\'later\'|translate}}</button> </div>");
$templateCache.put("app/components/_partials/courseBest/courseBest.html","<div class=page-header> <h1>{{\'best_courses\'|translate}}</h1> </div> <div ng-if=\"$ctrl.pagination.totalCount > 0\"> <course-list items=$ctrl.items></course-list> </div> <div class=text-center-tablet ng-if=\"$ctrl.pagination.totalCount > 0\"> <button class=\"btn btn-primary btn-block-phone\" ng-if=\"$ctrl.pagination.currentPage < $ctrl.pagination.pageCount\" ng-click=$ctrl.load($ctrl.pagination.currentPage+1) loading-overlay=$ctrl.loading loading-hide-content=true loading-class=loading-white>{{ \'show_more\' | translate }}</button> </div> <div ng-if=\"$ctrl.pagination.totalCount == 0\"> {{\'nothing_found\'|translate}} </div>");
$templateCache.put("app/components/_partials/courseDetailsForm/courseDetailsForm.html","<div class=row> <div class=\"col-xs-12 col-md-8\"> <div class=row> <div class=col-sm-6> <form-group-minimal name=category_id> <ui-select ng-model=$ctrl.data.category_id name=category_id ng-required=true search-enabled=true> <ui-select-match placeholder=\"{{\'type\'|translate}}\">{{$select.selected.text|translate}}</ui-select-match> <ui-select-choices repeat=\"item.value as item in $ctrl.categories|filter:{text:$select.search}\">{{item.text|translate}}</ui-select-choices> </ui-select> </form-group-minimal> </div> <div class=col-sm-6> <form-group-minimal name=subject_id> <ui-select ng-model=$ctrl.data.subject_id name=subject_id ng-required=true search-enabled=true> <ui-select-match placeholder=\"{{\'subject\'|translate}}\">{{$select.selected.text|translate}}</ui-select-match> <ui-select-choices repeat=\"item.value as item in $ctrl.subjects|filter:{text:$select.search}\">{{item.text|translate}}</ui-select-choices> </ui-select> </form-group-minimal> </div> </div> <div class=row> <div class=col-xs-12> <form-group-minimal maxlength=100 name=title> <textarea name=title ng-model=$ctrl.data.title placeholder=\"{{\'course_title\'|translate}}\" ng-required=true ng-maxlength=100 rows=1 msd-elastic></textarea> </form-group-minimal> </div> <div class=col-xs-12> <form-group-minimal maxlength=1000 name=descr> <textarea name=descr ng-model=$ctrl.data.descr placeholder=\"{{\'course_descr\'|translate}}\" ng-required=true ng-maxlength=1000 rows=1 msd-elastic></textarea> </form-group-minimal> </div> </div> </div> <div class=\"col-xs-12 col-md-4\"> <div class=image-preview loading-overlay=$ctrl.imageLoading delete-overlay=$ctrl.data.image delete-action=$ctrl.imageDelete() delete-icon-class=icon-delete-circle><!-- <img ng-if=\"$ctrl.data.image\" ng-src=\"{{$ctrl.data.image}}\" alt=\"\"> --> <div ng-if=$ctrl.data.image class=img style=\"background-image: url(\'{{$ctrl.data.image}}\')\"></div> <div ng-if=\"!$ctrl.data.image && !$ctrl.imageLoading\" class=button-overlay> <file-upload-button uploader-config=$ctrl.imageUploaderConfig on-success=$ctrl.imageUploaded(file) on-before-upload=\"$ctrl.imageLoading = true\" on-complete=\"$ctrl.imageLoading = false\" btn-class=\"btn-primary btn-invert\" images-only=true>{{ \'select_file\' | translate }}</file-upload-button> </div> </div><!-- <br> --> <div class=\"text-center text-muted\">{{\'add_course_image_text\' | translate}}</div> </div> </div>");
$templateCache.put("app/components/_partials/courseList/courseList.html","<div class=course-list> <div ng-class=\"{finished:c.status == \'finished\',\'course-item\':c.title,\'course-item-not-found course-not-found\':!c.title}\" ng-repeat=\"c in $ctrl.items | filter:{title:$ctrl.filter} as result track by c.id\"> <div ng-if=c.title ui-sref=^.view({id:c.id})> <div class=img> <img ng-if=c.image ng-src={{c.image}} alt=\"\"> <div class=content-info> <table> <tr> <td ng-if=\"c.length_video > 0\"> <i class=\"icon-play-circle icon-lg\"></i> <br> <span>{{c.length_video_text}}</span> </td> <td ng-if=\"c.length_video > 0 && c.length_audio > 0\" style=opacity:0.5>+</td> <td ng-if=\"c.length_audio > 0\"> <i class=\"icon-music-circle icon-lg\"></i> <br> <span>{{c.length_audio_text}}</span> </td> <td ng-if=\"c.length_audio > 0 && c.length_text > 0\" style=opacity:0.5>+</td> <td ng-if=\"c.length_text > 0\"> <i class=\"icon-text-circle icon-lg\"></i> <br> <span>{{c.length_text_text}}</span> </td> </tr> </table> </div> <div ng-if=\"c.status == \'finished\' && !c.draft && c.published\" class=\"overlay overlay-white\"></div> <div ng-if=\"c.status == \'finished\' && !c.draft && c.published\" class=status-text><i class=\"icon-accept-bold icon-sm\"></i>&nbsp; {{ \'status_finished\' | translate }}</div> <div ng-if=c.draft class=status-text>{{ \'draft\' | translate }}</div> <div ng-if=\"!c.published && !c.draft\" class=status-text>{{ \'on_moderation\' | translate }}</div> <div ng-if=\"c.status == \'in_progress\' && !c.draft && c.published\" class=bookmark></div> </div> <div class=details> <div class=title>{{c.title}}</div> <div class=meta-row> <span><i class=icon-eye></i> {{c.views}}</span> <span><i class=icon-calendar></i> {{c.date|dateMoment:\'ll\':$ctrl.ps.timezone}}</span> <span><i class=icon-thumbs-up></i> {{c.likes}}</span> </div> <div class=details-link> <a ui-sref=^.view({id:c.id}) ng-click=$event.stopPropagation()>{{ \'course_contents\' | translate }} ({{c.materials_count}})</a> </div> </div> <favorite-button-small-2 ng-if=$root.isDesktop resource=course resource-id=c.id></favorite-button-small-2> <favorite-button-small ng-if=!$root.isDesktop resource=course resource-id=c.id></favorite-button-small> <user-preview-avatar ng-if=c.user_id user=c.user></user-preview-avatar> </div> <div ng-if=!c.title> <div class=img> <img src=assets/images/ghost.png alt=\"\"> <div class=title>{{ \'course_not_found\' | translate }}</div> {{ \'course_not_found_text\' | translate }} </div> <div class=details></div> <favorite-button-small-2 ng-if=$root.isDesktop resource=course resource-id=c.id></favorite-button-small-2> <favorite-button-small ng-if=!$root.isDesktop resource=course resource-id=c.id></favorite-button-small> </div> </div> <div class=course-item-zero-height></div> <div class=course-item-zero-height></div> </div> <div class=text-center-tablet ng-if=!result.length>{{\'nothing_found\'|translate}}</div>");
$templateCache.put("app/components/_partials/courseList/courseListShort.html","<div class=course-list-short> <div ng-repeat=\"c in $ctrl.items | filter:{title:$ctrl.filter} as result track by $index\"> <a ui-sref=courses.view({id:c.id})> <span> <i ng-if=\"c.type == \'video\'\" class=icon-play-circle></i> <i ng-if=\"c.type == \'audio\'\" class=icon-music-circle></i> <i ng-if=\"c.type == \'text\'\" class=icon-text-circle></i> </span> &nbsp; {{c.title}} &nbsp; <span> <i class=icon-thumbs-up></i> {{c.likes}} </span> </a> </div> </div> <div ng-if=!result.length>{{\'nothing_found\'|translate}}</div>");
$templateCache.put("app/components/_partials/courseMaterialsForm/courseMaterialsForm.html","<h2>{{ \'course_program\' | translate }}</h2> <p> <a class=\"btn btn-primary btn-invert\" ui-sref=.new>{{ \'add_new_material\' | translate }}</a> &nbsp; <span class=text-lowercase> {{ \'or\' | translate }} <a ui-sref=.search>{{ \'choose_material\' | translate }}</a> </span> </p> <br> <div ng-if=\"$ctrl.materials.length > 0\" ui-tree=$ctrl.dragOptions data-empty-placeholder-enabled=false> <div class=course-program ui-tree-nodes ng-model=$ctrl.materials> <div ng-repeat=\"m in $ctrl.materials\" ui-tree-node> <div class=item> <div class=icon><i ui-tree-handle class=icon-bars></i></div> <div class=number>{{$index+1}}.</div> <div class=icon> <i ng-if=\"m.type == \'video\'\" class=icon-play-circle></i> <i ng-if=\"m.type == \'audio\'\" class=icon-music-circle></i> <i ng-if=\"m.type == \'text\'\" class=icon-text-circle></i> </div> <div class=title>{{m.title}}</div> <div> <a ng-if=!$ctrl.materialTrainings[m.id].length ui-sref=\".training.new({materialId: m.id})\">{{ \'add_test\' | translate }}</a> <span ng-if=$ctrl.materialTrainings[m.id].length class=text-muted>{{ \'test_added\' | translate }}</span> </div> <div class=action> <span style=cursor:pointer ng-click=$ctrl.delete($index) confirm=\"{{\'delete_course_material_confirm\' | translate}}\" confirm-ok=\"{{\'yes_delete\' | translate}}\" confirm-cancel=\"{{\'cancel_delete\' | translate}}\" confirm-title=\"{{\'delete_confirmation\' | translate}}\"><i class=icon-close></i></span> </div> </div> <div class=item ng-if=$ctrl.materialTrainings[m.id].length ng-repeat=\"t in $ctrl.materialTrainings[m.id]\"> <div class=icon></div> <div class=number></div> <div class=icon></div> <div class=title>{{ \'test\' | translate }} ({{t.questions_count}})</div> <div> <a ui-sref=\".training.update({materialId: m.id, trainingId: t.id})\">{{ \'update_test\' | translate }}</a> </div> <div class=action> <span style=cursor:pointer ng-click=$ctrl.deleteTraining(t.id) confirm=\"{{\'delete_course_test_confirm\' | translate}}\" confirm-ok=\"{{\'yes_delete\' | translate}}\" confirm-cancel=\"{{\'cancel_delete\' | translate}}\" confirm-title=\"{{\'delete_confirmation\' | translate}}\"><i class=icon-close></i></span> </div> </div> </div> </div> </div> <div ng-if=\"$ctrl.materials.length < 5\"> {{ \'course_materials_not_found\' | translate }} </div>");
$templateCache.put("app/components/_partials/courseProgram/courseProgram.html","<div class=course-program> <div ng-repeat=\"m in $ctrl.materials\"> <div class=item> <div class=number>{{$index+1}}.</div> <div class=icon> <i ng-if=\"m.type == \'video\'\" class=icon-play-circle></i> <i ng-if=\"m.type == \'audio\'\" class=icon-music-circle></i> <i ng-if=\"m.type == \'text\'\" class=icon-text-circle></i> </div> <div class=title> <a ui-sref=\"^.view({materialId: m.id})\">{{m.title}}</a> </div> <div class=status> <div class=circle ng-class=\"{\'status-finished\':m.course_status == \'finished\',\'status-in-progress\':m.course_status == \'in_progress\'}\"></div> </div> </div> <div class=item ng-repeat=\"t in $ctrl.materialTrainings[m.id]\"> <div class=number></div> <div class=icon></div> <div class=title> <a ng-if=\"t.status != \'finished\'\" ui-sref=\"^.training({trainingId: t.id})\" class=\"text-muted td-none\">{{ \'test\' | translate }} ({{t.questions_count}})</a> <a ng-if=\"t.status == \'finished\'\" ui-sref=\"^.training({trainingId: t.id})\" class=\"text-muted td-none\">{{ \'test\' | translate }} &mdash; <span class=\"text-success text-lowercase\">{{t.result}} {{ \'correct\' | translate }}</span>, <span class=\"text-danger text-lowercase\">{{t.questions_count-t.result}} {{ \'wrong\' | translate }}</span></a> </div> <div class=status> <div class=circle ng-class=\"{\'status-finished\':t.status == \'finished\',\'status-in-progress\':t.status == \'in_progress\'}\"></div> </div> </div> </div> </div>");
$templateCache.put("app/components/_partials/courseRecommend/courseRecommend.html","<div ng-if=\"$ctrl.pagination.totalCount > 0 && $ctrl.show\"> <div class=page-header> <h1>{{\'recommended_courses\'|translate}}</h1> </div> <course-list items=$ctrl.items></course-list> <div class=text-center-tablet ng-if=\"$ctrl.pagination.totalCount > 0\"> <button class=\"btn btn-primary btn-block-phone\" ng-if=\"$ctrl.pagination.currentPage < $ctrl.pagination.pageCount\" ng-click=$ctrl.load($ctrl.pagination.currentPage+1) loading-overlay=$ctrl.loading loading-hide-content=true loading-class=loading-white>{{ \'show_more\' | translate }}</button> </div> <div ng-if=\"$ctrl.pagination.totalCount == 0\"> {{\'nothing_found\'|translate}} </div> </div>");
$templateCache.put("app/components/_partials/embedContent/embedContent.html","<div ng-if=\"$ctrl.service == \'facebook\'\" class=center-block> <div class=fb-post data-href=\"{{ $ctrl.url }}\"></div> </div> <div ng-if=\"$ctrl.service == \'youtube\'\" class=\"embed-responsive embed-responsive-16by9\"> <iframe ng-src=\"{{ (\'https://www.youtube.com/embed/\' + $ctrl.code + \'?rel=0&autoplay=\' + ($ctrl.autoplay ? 1 : 0))|trustUrl }}\" frameborder=0 allowfullscreen></iframe> <div class=loading></div> </div> <div ng-if=\"$ctrl.service == \'vimeo\'\" class=\"embed-responsive embed-responsive-16by9\"> <iframe ng-src=\"{{ (\'https://player.vimeo.com/video/\' + $ctrl.code + \'?title=0&byline=0&portrait=0\')|trustUrl }}\" frameborder=0 webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe> <div class=loading></div> </div> <div ng-if=\"$ctrl.service == \'soundcloud\'\" class=\"embed-responsive embed-responsive-16by9\"> <iframe width=100% height=450 scrolling=no frameborder=no ng-src=\"{{ (\'https://w.soundcloud.com/player/?url=\' + $ctrl.url + \'&amp;auto_play=\' + ($ctrl.autoplay ? \'true\' : \'false\') + \'&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;visual=true\')|trustUrl }}\"></iframe> <div class=loading></div> </div>");
$templateCache.put("app/components/_partials/favoriteButton/favoriteButton.html","<a class=fav-link ng-click=$ctrl.toggleFavorite() uib-tooltip=\"{{(!$ctrl.favorite ? \'add_to_favorites\' : \'remove_from_favorites\')|translate}}\" tooltip-enable=$root.isDesktop> <i ng-if=!$ctrl.favorite class=icon-star></i> <i ng-if=$ctrl.favorite class=icon-star-filled></i> <span>{{(!$ctrl.favorite ? \'to_favorites\' : \'in_favorites\')|translate}}</span> </a>");
$templateCache.put("app/components/_partials/favoriteButton/favoriteButtonSmall.html","<a ng-click=\"$ctrl.toggleFavorite(); $event.stopPropagation();\" class=favorite-button ng-class={active:$ctrl.favorite} uib-tooltip=\"{{ !$ctrl.favorite ? \'add_to_favorites\' : \'remove_from_favorites\' | translate }}\" tooltip-enable=$root.isDesktop><i class=\"icon-circle icon-star-filled icon-lg\"></i></a>");
$templateCache.put("app/components/_partials/favoriteButton/favoriteButtonSmall2.html","<a ng-click=\"$ctrl.toggleFavorite(); $event.stopPropagation();\" class=favorite-button ng-class={active:$ctrl.favorite} uib-tooltip=\"{{ !$ctrl.favorite ? \'add_to_favorites\' : \'remove_from_favorites\' | translate }}\" tooltip-enable=$root.isDesktop><i class=\"icon-circle icon-circle-bold icon-lg\" ng-class=\"{\'icon-star\':!$ctrl.favorite, \'icon-star-filled\':$ctrl.favorite}\"></i></a>");
$templateCache.put("app/components/_partials/fbFriends/fbFriends.html","<h4>{{\'invite_friends_title\'|translate}}</h4> <div ng-if=\"$ctrl.pagination.totalCount > 0\"> <b>{{ \'fb_friends_count\' | translate:{count:$ctrl.pagination.totalCount}:\'messageformat\' }}</b> <hr> </div> <div class=\"user-items row\" ng-if=\"$ctrl.pagination.totalCount > 0\"> <div class=\"col-md-12 col-sm-6\" ng-repeat=\"u in $ctrl.users track by $index\" ng-class={inactive:$ctrl.isAdded(u.id)}> <user-preview-facebook user=u></user-preview-facebook> </div> </div> <p class=text-center ng-if=\"$ctrl.pagination.totalCount > 0\"> <button class=\"btn btn-primary btn-block btn-inline-block-tablet btn-block-phone\" ng-if=\"$ctrl.pagination.currentPage < $ctrl.pagination.pageCount\" ng-click=$ctrl.load($ctrl.pagination.currentPage+1) loading-overlay=$ctrl.loading loading-hide-content=true loading-class=loading-white>{{ \'show_more\' | translate }}</button> </p> <p class=text-center ng-if=\"!$ctrl.pagination || $ctrl.pagination.totalCount == 0\"> {{\'fb_friends_not_found\'|translate}} </p> <p class=text-center ng-if=!$ctrl.fbConnected> <button class=\"btn btn-invert btn-primary btn-block btn-inline-block-tablet btn-block-phone\" ng-click=$ctrl.fbConnect()>{{ \'connect_fb\' | translate }}</button> </p> <p class=text-center ng-if=$ctrl.fbConnected> <button class=\"btn btn-invert btn-primary btn-block btn-inline-block-tablet btn-block-phone\" socialshare socialshare-provider=facebook socialshare-type=share socialshare-via=\"{{\'facebookAppId\'|config}}\" socialshare-title=\"{{\'site_share_title\'|configService}}\" socialshare-description=\"{{\'site_share_description\'|configService}}\" socialshare-media=\"{{\'https://shakird.com/assets/images/devices@2x.png\'|langSuffix}}\" socialshare-url=https://shakird.com/{{$root.languageService.currentLanguage}}>{{ ($ctrl.pagination.totalCount ? \'invite_more_friends\' : \'invite_friends\') | translate }}</button> </p>");
$templateCache.put("app/components/_partials/followModal/followModal.html","<div class=modal-header> <button type=button class=close ng-click=$ctrl.dismiss()><i class=icon-close></i></button> <h2 class=modal-title ng-bind-html=\"\'follow_us_long\'|translate\"></h2> </div> <div class=modal-body> <div class=row> <div class=col-md-6> <div style=\"background: #F7F9FA; border-radius: 4px; font-size: 14px; padding: 20px; text-align: center; margin-bottom: 10px\"> <div><b>{{\'follow_us_facebook\'|translate}}</b></div> <br> <iframe ng-src={{$ctrl.facebookIframeSrc|trustUrl}} height=90 style=border:none;overflow:hidden scrolling=no frameborder=0 allowtransparency=true></iframe> </div> </div> <div class=col-md-6> <div style=\"background: #F7F9FA; border-radius: 4px; font-size: 14px; padding: 20px; text-align: center; margin-bottom: 10px\"> <div><b>{{\'follow_us_youtube\'|translate}}</b></div> <br> <div class=g-ytsubscribe data-channelid=\"{{(\'youtube_url\'|configService).split(\'/\')[4]}}\" data-layout=full data-count=default></div> </div> </div> </div> </div>");
$templateCache.put("app/components/_partials/guide/guide.html","<div class=guide-bg ng-if=$ctrl.show> <div class=target-placeholder ng-style=$ctrl.placeholderStyle uib-popover-template=\"$ctrl.currentStep().template || $ctrl.stepTemplate\" popover-is-open=$ctrl.open popover-placement={{$ctrl.currentStep().placement}} popover-trigger=\"\'none\'\" popover-animation=false popover-class=guide-popover></div> <div class=\"btn btn-primary btn-rounded btn-sm skip-guide\" ng-click=$ctrl.close()>{{\'skip_guide\'|translate}} &nbsp; <i class=\"icon-close icon-sm\"></i></div> </div>");
$templateCache.put("app/components/_partials/guide/guideStep.html","<div class=guide-step> <div class=points><div ng-repeat=\"(i,s) in $ctrl.steps\" ng-class=\"{active:i==$ctrl.stepNum}\" ng-click=$ctrl.goToStep(i)></div></div> <div ng-bind-html=$ctrl.currentStep().text></div> <button ng-if=\"$ctrl.stepNum < $ctrl.steps.length-1\" class=\"btn btn-link btn-sm btn-bold\" ng-click=$ctrl.next()>{{\'continue\'|translate}}</button> <div ng-if=\"$ctrl.stepNum == $ctrl.steps.length-1\"> <br> <button class=\"btn btn-link btn-sm btn-bold pull-left\" style=\"padding-left: 0\" ng-click=$ctrl.goToStep(0)>{{\'repeat_guide\'|translate}}</button> <button class=\"btn btn-primary btn-sm btn-bold pull-right\" ng-click=$ctrl.close()>{{\'start\'|translate}}</button> <div class=clearfix></div> </div> </div>");
$templateCache.put("app/components/_partials/guide/guideStepReg.html","<div class=\"guide-step guide-step-reg\"> <div ng-bind-html=$ctrl.currentStep().text></div> <br> <button class=\"btn btn-link btn-sm btn-bold pull-left\" style=\"padding-left: 0px\" ng-click=$ctrl.close()>{{\'skip\'|translate}}</button> <button class=\"btn btn-primary btn-sm btn-bold pull-right\" ng-click=$ctrl.goToStep(0)>{{\'start_guide\'|translate}}</button> <div class=clearfix></div> </div>");
$templateCache.put("app/components/_partials/helpQa/helpQa.html","<div ng-repeat=\"h in $ctrl.qa\"> <div class=question ng-class=\"{opened:$ctrl.open==h.id}\" ng-click=$ctrl.toggle(h)>{{h.title}}</div> <div class=\"answer animation-slide\" ng-if=$ctrl.show(h) ng-bind-html=h.body></div> </div>");
$templateCache.put("app/components/_partials/likesCounter/likesCounter.html","<div class=likes-counter ng-class=\"{liked:$ctrl.liked, disliked:$ctrl.disliked}\"> <div class=\"btn btn-like\" ng-click=$ctrl.like() uib-tooltip=\"{{\'like\'|translate}}\" tooltip-enable=$root.isDesktop><i class=icon-thumbs-up></i></div><!--\r\n    --><div class=count>{{$ctrl.value}}</div><!--\r\n	--><div class=\"btn btn-dislike\" ng-click=$ctrl.dislike() uib-tooltip=\"{{\'dislike\'|translate}}\" tooltip-enable=$root.isDesktop><i class=icon-thumbs-down></i></div> </div>");
$templateCache.put("app/components/_partials/log/log.html","<div class=activity-log ng-class=\"{\'activity-log-user\':$ctrl.showUser}\"> <div ng-repeat=\"l in $ctrl.log track by $index\"> <hr ng-if=\"$ctrl.showUser && $index > 0 && l.user_id != $ctrl.log[$index-1].user_id && l.date == $ctrl.log[$index-1].date\"> <div class=date ng-if=\"l.date != $ctrl.log[$index-1].date\">{{l.date}}</div> <user-preview-short user-id=l.user_id ng-if=\"$ctrl.showUser && (l.user_id != $ctrl.log[$index-1].user_id || l.date != $ctrl.log[$index-1].date)\"></user-preview-short> <div class=item ng-switch=l.resource> <div ng-switch-when=sura ng-switch=l.category> <div ng-switch-when=read> <i class=icon-book></i> <span class=text> {{\'activity_read_sura\'|translate:{gender:l.gender}:\'messageformat\'}} <span ng-repeat=\"li in l.items\"> <a ui-sref=\"koran.view({id: li.resource_id})\">{{li.title}}</a>{{ $last ? \'\' : \', \' }} </span> </span> </div> <div ng-switch-when=training> <i class=icon-book></i> <span class=text> {{\'activity_start_training_name\'|translate:{gender:l.gender}:\'messageformat\'}} <span ng-repeat=\"li in l.items\"> <a ui-sref=\"koran.training.index({id: li.resource_id})\"> <span ng-switch=li.action> <span ng-switch-when=start_training_ayat_translation>{{\'t_ayat_translation\'|translate}}</span> <span ng-switch-when=start_training_translation_ayat>{{\'t_translation_ayat\'|translate}}</span> <span ng-switch-when=start_training_ayat_listening>{{\'t_ayat_listening\'|translate}}</span> <span ng-switch-when=start_training_ayat_constructor>{{\'t_ayat_constructor\'|translate}}</span> <span ng-switch-when=start_training_ayat_speed>{{\'t_ayat_speed\'|translate}}</span> <span ng-switch-when=start_training_ayat_cards>{{\'t_ayat_cards\'|translate}}</span> <span ng-switch-when=start_training_next_ayat>{{\'t_next_ayat\'|translate}}</span> <span ng-switch-when=start_training_missed_ayat>{{\'t_missed_ayat\'|translate}}</span> </span> {{(\'of_sura\'|translate)+\' \'}} {{li.title}}</a>{{ $last ? \'\' : \', \' }} </span> </span> </div> </div> <div ng-switch-when=user ng-switch=l.category> <div ng-switch-when=sprint_add_user> <i class=icon-friends></i> <span class=text> {{\'activity_sprint_add_user\'|translate:{gender:l.gender}:\'messageformat\'}} <span ng-repeat=\"li in l.items\"> <a ui-sref=\"user.log({id: li.resource_id})\">{{li.title}}</a>{{ $last ? \'\' : \', \' }} </span> </span> </div> </div> <div ng-switch-when=level ng-switch=l.category> <div ng-switch-when=new_level> <i class=icon-levelup-circle></i> <span class=text> {{\'activity_new_level\'|translate:{gender:l.gender}:\'messageformat\'}} <span ng-repeat=\"li in l.items\">{{ $last ? li.resource_id : \'\' }}</span> </span> </div> </div> <div ng-switch-when=material ng-switch=l.category> <div ng-switch-when=start_video> <i class=icon-play-circle></i> <span class=text> {{\'activity_material_start_video\'|translate:{gender:l.gender}:\'messageformat\'}} <span ng-repeat=\"li in l.items\"> <a ui-sref=\"muslimator.view({materialId: li.resource_id})\">{{li.title}}</a>{{ $last ? \'\' : \', \' }} </span> </span> </div> <div ng-switch-when=finish_video> <i class=icon-play-circle></i> <span class=text> {{\'activity_material_finish_video\'|translate:{gender:l.gender}:\'messageformat\'}} <span ng-repeat=\"li in l.items\"> <a ui-sref=\"muslimator.view({materialId: li.resource_id})\">{{li.title}}</a>{{ $last ? \'\' : \', \' }} </span> </span> </div> <div ng-switch-when=start_audio> <i class=icon-music-circle></i> <span class=text> {{\'activity_material_start_audio\'|translate:{gender:l.gender}:\'messageformat\'}} <span ng-repeat=\"li in l.items\"> <a ui-sref=\"muslimator.view({materialId: li.resource_id})\">{{li.title}}</a>{{ $last ? \'\' : \', \' }} </span> </span> </div> <div ng-switch-when=finish_audio> <i class=icon-music-circle></i> <span class=text> {{\'activity_material_finish_audio\'|translate:{gender:l.gender}:\'messageformat\'}} <span ng-repeat=\"li in l.items\"> <a ui-sref=\"muslimator.view({materialId: li.resource_id})\">{{li.title}}</a>{{ $last ? \'\' : \', \' }} </span> </span> </div> <div ng-switch-when=start_text> <i class=icon-text-circle></i> <span class=text> {{\'activity_material_start_text\'|translate:{gender:l.gender}:\'messageformat\'}} <span ng-repeat=\"li in l.items\"> <a ui-sref=\"muslimator.view({materialId: li.resource_id})\">{{li.title}}</a>{{ $last ? \'\' : \', \' }} </span> </span> </div> <div ng-switch-when=finish_text> <i class=icon-text-circle></i> <span class=text> {{\'activity_material_finish_text\'|translate:{gender:l.gender}:\'messageformat\'}} <span ng-repeat=\"li in l.items\"> <a ui-sref=\"muslimator.view({materialId: li.resource_id})\">{{li.title}}</a>{{ $last ? \'\' : \', \' }} </span> </span> </div> <div ng-switch-when=upload> <i class=icon-upload-circle></i> <span class=text> {{\'activity_material_upload\'|translate:{gender:l.gender}:\'messageformat\'}} <span ng-repeat=\"li in l.items\"> <a ui-sref=\"muslimator.view({materialId: li.resource_id})\">{{li.title}}</a>{{ $last ? \'\' : \', \' }} </span> </span> </div> </div> <div ng-switch-when=course ng-switch=l.category> <div ng-switch-when=start_course> <i class=icon-bars></i> <span class=text> {{\'activity_course_start\'|translate:{gender:l.gender}:\'messageformat\'}} <span ng-repeat=\"li in l.items\"> <a ui-sref=\"courses.view({id: li.resource_id})\">{{li.title}}</a>{{ $last ? \'\' : \', \' }} </span> </span> </div> <div ng-switch-when=finish_course> <i class=icon-bars></i> <span class=text> {{\'activity_course_finish\'|translate:{gender:l.gender}:\'messageformat\'}} <span ng-repeat=\"li in l.items\"> <a ui-sref=\"courses.view({id: li.resource_id})\">{{li.title}}</a>{{ $last ? \'\' : \', \' }} </span> </span> </div> <div ng-switch-when=upload> <i class=icon-upload-circle></i> <span class=text> {{\'activity_course_upload\'|translate:{gender:l.gender}:\'messageformat\'}} <span ng-repeat=\"li in l.items\"> <a ui-sref=\"courses.view({id: li.resource_id})\">{{li.title}}</a>{{ $last ? \'\' : \', \' }} </span> </span> </div> </div> </div> </div> </div>");
$templateCache.put("app/components/_partials/materialFinishRecommend/materialFinishRecommend.html","<div class=page-header> <h1>{{ $ctrl.forceTitle || (\'recommended_for_material\' | translate) }}</h1> </div> <div ng-if=\"$ctrl.pagination.totalCount > 0\"> <material-list items=$ctrl.items></material-list> </div> <div class=text-center-tablet ng-if=\"$ctrl.pagination.totalCount > 0\"> <button class=\"btn btn-primary btn-block-phone\" ng-if=\"$ctrl.pagination.currentPage < $ctrl.pagination.pageCount\" ng-click=$ctrl.load($ctrl.pagination.currentPage+1) loading-overlay=$ctrl.loading loading-hide-content=true loading-class=loading-white>{{ \'show_more\' | translate }}</button> </div> <div ng-if=\"$ctrl.pagination.totalCount == 0\"> {{\'nothing_found\'|translate}} </div>");
$templateCache.put("app/components/_partials/materialForm/materialForm.html","<ul class=\"nav nav-tabs\"> <li ng-class=\"{active: $ctrl.data.type == \'video\'}\"> <a ng-click=\"$ctrl.data.type = \'video\';\">{{\'video\'|translate}}</a> </li> <li ng-class=\"{active: $ctrl.data.type == \'audio\'}\"> <a ng-click=\"$ctrl.data.type = \'audio\';\">{{\'audio\'|translate}}</a> </li> <li ng-class=\"{active: $ctrl.data.type == \'text\'}\"> <a ng-click=\"$ctrl.data.type = \'text\';\">{{\'text\'|translate}}</a> </li> </ul> <br> <div> <form novalidate name=form ng-submit=$ctrl.submit() role=form> <div class=row> <div class=\"col-xs-12 col-md-8\"> <div class=row> <div class=col-sm-4> <form-group-minimal name=category_id> <ui-select ng-model=$ctrl.data.category_id name=category_id ng-required=true search-enabled=true> <ui-select-match placeholder=\"{{\'type\'|translate}}\">{{$select.selected.text|translate}}</ui-select-match> <ui-select-choices repeat=\"item.value as item in $ctrl.categories|filter:{text:$select.search}\">{{item.text|translate}}</ui-select-choices> </ui-select> </form-group-minimal> </div> <div class=col-sm-4> <form-group-minimal name=subject_id> <ui-select ng-model=$ctrl.data.subject_id name=subject_id ng-required=true search-enabled=true> <ui-select-match placeholder=\"{{\'subject\'|translate}}\">{{$select.selected.text|translate}}</ui-select-match> <ui-select-choices repeat=\"item.value as item in $ctrl.subjects|filter:{text:$select.search}\">{{item.text|translate}}</ui-select-choices> </ui-select> </form-group-minimal> </div> <div class=col-sm-4> <form-group-minimal name=source_id> <ui-select ng-model=$ctrl.data.source_id name=source_id search-enabled=true> <ui-select-match placeholder=\"{{\'source\'|translate}}\">{{$select.selected.text|translate}}</ui-select-match> <ui-select-choices repeat=\"item.value as item in $ctrl.sources|filter:{text:$select.search}\">{{item.text|translate}}</ui-select-choices> </ui-select> </form-group-minimal> </div> </div> <div class=row> <div class=col-xs-12> <form-group-minimal maxlength=60 name=title> <textarea name=title ng-model=$ctrl.data.title placeholder=\"{{\'material_title\'|translate}}\" ng-required=true ng-maxlength=60 rows=1 msd-elastic></textarea> </form-group-minimal> </div> <div class=col-xs-12> <form-group-minimal maxlength=200 name=descr> <textarea name=descr ng-model=$ctrl.data.descr placeholder=\"{{\'description\'|translate}}\" ng-required=true ng-maxlength=200 rows=1 msd-elastic></textarea> </form-group-minimal> </div> <div class=\"col-xs-12 radio\"> <label><input type=radio name=embed_type ng-model=$ctrl.data.embed_type value=url> {{ \'embed_url\' | translate }}</label> &nbsp;&nbsp; <label><input type=radio name=embed_type ng-model=$ctrl.data.embed_type value=code> {{ \'embed_code\' | translate }}</label> &nbsp;&nbsp; <label ng-if=\"$ctrl.data.type == \'text\'\"><input type=radio name=embed_type ng-model=$ctrl.data.embed_type value=text> {{ \'text\' | translate }}</label> </div> <div ng-if=\"$ctrl.data.embed_type == \'url\'\" class=col-xs-12> <form-group-minimal ng-if=\"$ctrl.data.type == \'video\'\" name=url tooltip=\"form.url.$error.material_url && \'wrong_material_url_\'+$ctrl.data.type || form.url.$error.material_url_busy && \'wrong_material_url_busy\' || form.url.$error.material_url_work && \'wrong_material_url_work\'\"> <input type=url ng-required=true ng-model=$ctrl.data.url ng-model-options={debounce:100} ng-change=$ctrl.onUrlChange(form.url) name=url placeholder=\"{{$ctrl.data.type+\'_embed_url\'|translate}}\" material-url-check=$ctrl.data.type material-url-check-current-id=$ctrl.data.id> </form-group-minimal> <form-group-minimal ng-if=\"$ctrl.data.type == \'audio\'\" name=url tooltip=\"form.url.$error.material_url && \'wrong_material_url_\'+$ctrl.data.type || form.url.$error.material_url_busy && \'wrong_material_url_busy\' || form.url.$error.material_url_work && \'wrong_material_url_work\'\"> <input type=url ng-required=true ng-model=$ctrl.data.url ng-model-options={debounce:100} ng-change=$ctrl.onUrlChange(form.url) name=url placeholder=\"{{$ctrl.data.type+\'_embed_url\'|translate}}\" material-url-check=$ctrl.data.type material-url-check-current-id=$ctrl.data.id> </form-group-minimal> <form-group-minimal ng-if=\"$ctrl.data.type == \'text\'\" name=url tooltip=\"form.url.$error.material_url && \'wrong_material_url_\'+$ctrl.data.type || form.url.$error.material_url_busy && \'wrong_material_url_busy\' || form.url.$error.material_url_work && \'wrong_material_url_work\'\"> <input type=url ng-required=true ng-model=$ctrl.data.url ng-model-options={debounce:100} ng-change=$ctrl.onUrlChange(form.url) name=url placeholder=\"{{$ctrl.data.type+\'_embed_url\'|translate}}\" material-url-check=$ctrl.data.type material-url-check-current-id=$ctrl.data.id> </form-group-minimal> </div> <div ng-if=\"$ctrl.data.embed_type == \'code\'\" class=col-xs-12> <form-group-minimal name=code tooltip=\"form.code.$error.embed_code && \'wrong_embed_code\'\"> <textarea name=code ng-model=$ctrl.data.code placeholder=\"{{\'field_embed_code\'|translate}}\" ng-required=true ng-maxlength=2000 rows=3 embed-code-check></textarea> </form-group-minimal> </div> <div ng-if=\"$ctrl.data.embed_type == \'text\'\" class=col-xs-12> <text-angular ng-model=$ctrl.data.text></text-angular> </div> <div class=\"col-xs-12 col-sm-4\" ng-if=\"$ctrl.data.type != \'text\'\"> <br> <div class=text-muted>{{\'content_length\' | translate}}:</div> <div class=col-time-elem> <form-group-minimal name=lengthHours> <input type=text ng-required=true ng-maxlength=2 ng-model=$ctrl.lengthData.hours ng-model-options=\"{updateOn:\'blur\'}\" name=lengthHours placeholder=\"{{\'hh\'|translate}}\"> </form-group-minimal> </div> : <div class=col-time-elem> <form-group-minimal name=lengthMinutes> <input type=text ng-required=true ng-maxlength=2 ng-model=$ctrl.lengthData.minutes ng-model-options=\"{updateOn:\'blur\'}\" name=lengthMinutes placeholder=\"{{\'mm\'|translate}}\"> </form-group-minimal> </div> : <div class=col-time-elem> <form-group-minimal name=lengthSeconds> <input type=text ng-required=true ng-maxlength=2 ng-model=$ctrl.lengthData.seconds ng-model-options=\"{updateOn:\'blur\'}\" name=lengthSeconds placeholder=\"{{\'ss\'|translate}}\"> </form-group-minimal> </div> </div><!-- <div class=\"col-xs-12 col-sm-4\" ng-if=\"$ctrl.data.type == \'text\'\">\r\n						<form-group-minimal name=\"length\">\r\n							<input type=\"text\" ng-required=\"true\" ng-model=\"$ctrl.data.length\" name=\"length\" placeholder=\"{{\'text_content_length\'|translate}}\">\r\n						</form-group-minimal>\r\n					</div> --> </div> </div> <div class=\"col-xs-12 col-md-4\"> <div class=image-preview loading-overlay=$ctrl.imageLoading delete-overlay=$ctrl.data.image delete-action=$ctrl.imageDelete() delete-icon-class=icon-delete-circle><!-- <img ng-if=\"$ctrl.data.image\" ng-src=\"{{$ctrl.data.image}}\" alt=\"\"> --> <div ng-if=$ctrl.data.image class=img style=\"background-image: url(\'{{$ctrl.data.image}}\')\"></div> <div ng-if=\"!$ctrl.data.image && !$ctrl.imageLoading\" class=button-overlay> <file-upload-button uploader-config=$ctrl.imageUploaderConfig on-success=$ctrl.imageUploaded(file) on-before-upload=\"$ctrl.imageLoading = true\" on-complete=\"$ctrl.imageLoading = false\" btn-class=\"btn-primary btn-invert\" images-only=true>{{ \'select_file\' | translate }}</file-upload-button> </div> </div><!-- <br> --> <div class=\"text-center text-muted\">{{\'add_material_image_text\' | translate}}</div> </div> </div> <br> <div class=form-actions> <button type=submit ng-disabled=\"form.$invalid || $ctrl.loading\" class=\"btn btn-primary\" loading-overlay=$ctrl.loading loading-class=loading-white loading-hide-content=true>{{ \'save_changes\' | translate }}</button> </div> </form> </div>");
$templateCache.put("app/components/_partials/materialBest/materialBest.html","<div class=page-header> <h1>{{\'best_materials\'|translate}}</h1> </div> <div ng-if=\"$ctrl.pagination.totalCount > 0\"> <material-list items=$ctrl.items></material-list> </div> <div class=text-center-tablet ng-if=\"$ctrl.pagination.totalCount > 0\"> <button class=\"btn btn-primary btn-block-phone\" ng-if=\"$ctrl.pagination.currentPage < $ctrl.pagination.pageCount\" ng-click=$ctrl.load($ctrl.pagination.currentPage+1) loading-overlay=$ctrl.loading loading-hide-content=true loading-class=loading-white>{{ \'show_more\' | translate }}</button> </div> <div ng-if=\"$ctrl.pagination.totalCount == 0\"> {{\'nothing_found\'|translate}} </div>");
$templateCache.put("app/components/_partials/materialList/materialList.html","<div class=material-list> <div ng-class=\"{finished:m.status == \'finished\',\'material-item\':m.title,\'material-item-not-found material-not-found\':!m.title}\" ng-repeat=\"m in $ctrl.items | filter:{title:$ctrl.filter} as result track by m.id\"> <div ng-if=m.title ui-sref=^.view({materialId:m.id})> <div class=img> <img ng-if=m.image ng-src={{m.image}} alt=\"\"> <div class=content-info> <i ng-if=\"m.type == \'video\'\" class=\"icon-play-circle icon-lg\"></i> <i ng-if=\"m.type == \'audio\'\" class=\"icon-music-circle icon-lg\"></i> <i ng-if=\"m.type == \'text\'\" class=\"icon-text-circle icon-lg\"></i> <br> <span>{{m.length_text}}</span> </div> <div ng-if=\"!$ctrl.addToCourse && m.status == \'finished\' && m.published\" class=\"overlay overlay-white\"></div> <div ng-if=$ctrl.addToCourse class=\"overlay overlay-white\"> <button ng-if=!$ctrl.inCourse(m) class=\"btn btn-primary btn-center\" ng-click=\"$ctrl.onAddToCourse({model:m}); $event.stopPropagation();\">{{ \'add_to_course\' | translate }}</button> <button ng-if=$ctrl.inCourse(m) class=\"btn btn-info btn-center\" ng-click=$event.stopPropagation()>{{ \'added\' | translate }}</button> </div> <div ng-if=m.course_number class=course-number>{{m.course_number}}</div> </div> <favorite-button-small resource=material resource-id=m.id></favorite-button-small> <user-preview-avatar ng-if=m.user_id user=m.user></user-preview-avatar> <div ng-if=\"m.status == \'in_progress\' && m.published\" class=bookmark></div> <div ng-if=\"m.status == \'finished\' && m.published\" class=status-text> <div ng-if=\"m.type == \'video\'\">{{\'status_viewed\' | translate}}</div> <div ng-if=\"m.type == \'audio\'\">{{\'status_listened\' | translate}}</div> <div ng-if=\"m.type == \'text\'\">{{\'status_read\' | translate}}</div> </div> <div ng-if=!m.published class=status-text>{{ \'on_moderation\' | translate }}</div> <div class=title>{{m.title}}</div> <div class=meta-row> <span><i class=icon-eye></i> {{m.views}}</span> <span><i class=icon-calendar></i> {{m.date|dateMoment:\'ll\':$ctrl.ps.timezone}}</span> <span><i class=icon-thumbs-up></i> {{m.likes}}</span> </div> </div> <div ng-if=!m.title> <div class=img> <img src=assets/images/ghost.png alt=\"\"> <div class=title>{{ \'material_not_found\' | translate }}</div> {{ \'material_not_found_text\' | translate }} </div> <favorite-button-small resource=material resource-id=m.id></favorite-button-small> </div> </div> <div class=material-item-zero-height></div> <div class=material-item-zero-height></div> </div> <div class=text-center-tablet ng-if=!result.length>{{\'nothing_found\'|translate}}</div>");
$templateCache.put("app/components/_partials/materialList/materialListShort.html","<div class=material-list-short> <div ng-repeat=\"m in $ctrl.items | filter:{title:$ctrl.filter} as result track by $index\"> <a ui-sref=muslimator.view({materialId:m.id})> <span> <i ng-if=\"m.type == \'video\'\" class=icon-play-circle></i> <i ng-if=\"m.type == \'audio\'\" class=icon-music-circle></i> <i ng-if=\"m.type == \'text\'\" class=icon-text-circle></i> </span> &nbsp; {{m.title}} &nbsp; <span> <i class=icon-thumbs-up></i> {{m.likes}} </span> </a> </div> </div> <div ng-if=!result.length>{{\'nothing_found\'|translate}}</div>");
$templateCache.put("app/components/_partials/materialRecommend/materialRecommend.html","<div ng-if=\"$ctrl.pagination.totalCount > 0 && $ctrl.show\"> <div class=page-header> <h1>{{\'recommended\'|translate}}</h1> </div> <material-list items=$ctrl.items></material-list> <div class=text-center-tablet ng-if=\"$ctrl.pagination.totalCount > 0\"> <button class=\"btn btn-primary btn-block-phone\" ng-if=\"$ctrl.pagination.currentPage < $ctrl.pagination.pageCount\" ng-click=$ctrl.load($ctrl.pagination.currentPage+1) loading-overlay=$ctrl.loading loading-hide-content=true loading-class=loading-white>{{ \'show_more\' | translate }}</button> </div> <div ng-if=\"$ctrl.pagination.totalCount == 0\"> {{\'nothing_found\'|translate}} </div> </div>");
$templateCache.put("app/components/_partials/materialSearchForm/autocomplete.html","<div id=materials-autocomplete-results> <div class=title>{{ \'materials\' | translate }} ({{$ctrl.searchResults.materials_count}})</div> <material-list-short items=$ctrl.searchResults.materials></material-list-short> <br> <div class=title>{{ \'people\' | translate }} ({{$ctrl.searchResults.usersCount}})</div> <user-list items=$ctrl.searchResults.users></user-list> <div class=bottom-panel> <a href ng-click=$ctrl.applySearchQuery()>{{ \'show_all_results\' | translate }}</a> </div> </div>");
$templateCache.put("app/components/_partials/materialSearchForm/materialSearchForm.$desktop.html","<form> <div class=\"form-group form-group-icon-right\"> <input ng-if=$ctrl.autocomplete class=form-control id=materials-autocomplete-input type=text autocomplete=off ng-model=$ctrl.searchQueryResults ng-model-options={debounce:500,getterSetter:true} placeholder=\"{{\'search\'|translate}}\" uib-popover-template=\"\'app/components/_partials/materialSearchForm/autocomplete.html\'\" popover-is-open=$ctrl.searchOpen popover-class=materials-autocomplete popover-placement=bottom-left popover-trigger=\"\'none\'\" popover-append-to-body=false ng-keyup=$ctrl.searchKeyUp($event)> <input ng-if=!$ctrl.autocomplete class=form-control type=text ng-model=$ctrl.searchQuery ng-model-options={debounce:500,getterSetter:true} placeholder=\"{{\'search\'|translate}}\"> </div> <div class=search-actions> <div class=pull-left> <label class=action><input type=checkbox checklist-model=\"$ctrl.params[\'type[]\']\" checklist-value=\"\'video\'\"> {{ \'video\' | translate }}</label> <label class=action><input type=checkbox checklist-model=\"$ctrl.params[\'type[]\']\" checklist-value=\"\'audio\'\"> {{ \'audio\' | translate }}</label> <label class=action><input type=checkbox checklist-model=\"$ctrl.params[\'type[]\']\" checklist-value=\"\'text\'\"> {{ \'text\' | translate }}</label> </div> <div class=pull-right> <span uib-dropdown class=action> <a href uib-dropdown-toggle class=td-none> {{ $ctrl.currentSubjects.length && $ctrl.currentSubjects[0].text || (\'subject\'|translate) || \'\' }} <i class=icon-angle-down></i> </a> <ul uib-dropdown-menu> <li><a href ng-click=\"$ctrl.params[\'subject_id[]\'] = null\">{{\'all\'|translate}}</a></li> <li ng-repeat=\"s in $ctrl.subjects\"><a href ng-click=\"$ctrl.params[\'subject_id[]\'] = [s.value]\">{{s.text|translate}}</a></li> </ul> </span> <span uib-dropdown class=action> <a href uib-dropdown-toggle class=td-none> {{ $ctrl.currentCategories.length && $ctrl.currentCategories[0].text || (\'type\'|translate) || \'\' }} <i class=icon-angle-down></i> </a> <ul uib-dropdown-menu> <li><a href ng-click=\"$ctrl.params[\'category_id[]\'] = null\">{{\'all\'|translate}}</a></li> <li ng-repeat=\"c in $ctrl.categories\"><a href ng-click=\"$ctrl.params[\'category_id[]\'] = [c.value]\">{{c.text|translate}}</a></li> </ul> </span> <span uib-dropdown class=action> <a href uib-dropdown-toggle class=td-none> {{ $ctrl.currentSources.length && $ctrl.currentSources[0].text || (\'source\'|translate) || \'\' }} <i class=icon-angle-down></i> </a> <ul uib-dropdown-menu> <li><a href ng-click=\"$ctrl.params[\'source_id[]\'] = null\">{{\'all\'|translate}}</a></li> <li ng-repeat=\"s in $ctrl.sources\"><a href ng-click=\"$ctrl.params[\'source_id[]\'] = [s.value]\">{{s.text|translate}}</a></li> </ul> </span> <span uib-dropdown class=action> <a href uib-dropdown-toggle class=td-none> {{ $ctrl.currentRating && ($ctrl.currentRating.text|translate) || (\'rating\'|translate) || \'\' }} <i class=icon-angle-down></i> </a> <ul uib-dropdown-menu> <li ng-repeat=\"r in $ctrl.sortRatingOptions\"><a href ng-click=\"$ctrl.params.sort_rating = r.value\">{{r.text|translate}}</a></li> <li><a href ng-click=\"$ctrl.params.sort_rating = null\">{{\'no_rating\'|translate}}</a></li> </ul> </span> <span ng-if=$root.isLoggedIn() uib-dropdown class=action> <a href uib-dropdown-toggle class=td-none> {{ \'more\' | translate }} <i class=icon-angle-down></i> </a> <ul uib-dropdown-menu> <li><a href ng-click=\"$ctrl.params.not_finished = $ctrl.params.not_finished ? null : 1\"> <input type=checkbox ng-checked=\"$ctrl.params.not_finished == 1\"> {{\'hide_finished\'|translate}} </a></li> </ul> </span> </div> <div class=clearfix></div> </div> </form>");
$templateCache.put("app/components/_partials/materialSearchForm/materialSearchForm.$mobile.html","<form ng-if=!$ctrl.paramsCount> <div class=\"form-group form-group-icon-right\"> <input class=form-control type=text ng-model=$ctrl.searchQuery ng-model-options={debounce:500,getterSetter:true} placeholder=\"{{\'search\'|translate}}\" ng-click=$ctrl.openModalSearch()> <i class=\"icon icon-search icon-gray\"></i> </div> </form> <div ng-if=\"$ctrl.paramsCount > 0\"> <p class=text-center-tablet ng-if=\"$ctrl.params[\'title[]\']\">{{ \'query_results\' | translate }}: <span class=text-primary><i>«{{ $ctrl.params[\'title[]\'].join(\' \') }}»</i></span></p> <div class=row> <div class=col-xs-6> <button class=\"btn btn-primary btn-invert btn-block\" ng-click=\"$ctrl.searchReset(); $ctrl.openModalSearch();\">{{ \'new_search\' | translate }}</button> </div> <div class=col-xs-6> <button class=\"btn btn-success btn-invert btn-block\" ng-click=$ctrl.openModalSearch()><i class=icon-accept-bold></i> {{ \'filter\' | translate }} ({{ $ctrl.paramsCount }})</button> </div> </div> <br> </div>");
$templateCache.put("app/components/_partials/materialSearchForm/searchModal.html","<div class=material-search-modal-grid> <div class=modal-header> <button type=button class=close ng-click=$ctrl.close()><i class=icon-close></i></button> <h1 class=modal-title>{{\'search\'|translate}}</h1> </div> <div> <ul class=\"nav nav-tabs nav-center\"> <li class=active> <a href>{{ \'materials\' | translate }}</a> </li> </ul> </div> <div class=column-container> <div class=\"column padded\"> <div class=\"form-group form-group-icon-right\" style=margin-bottom:0><input class=\"form-control ng-pristine ng-valid ng-empty ng-touched\" type=text id=search-modal-query ng-model=$root.materialSearchFormCtrl.searchQuery ng-model-options={debounce:500,getterSetter:true} placeholder=\"{{ \'search\' | translate }}\"> <i class=\"icon icon-search icon-gray\" style=\"cursor: pointer\" ng-click=$ctrl.submit()></i></div> </div> </div> <div class=\"column-container main\"> <div class=\"column bordered list\"> <ul class=\"nav nav-check\"> <li ng-click=\"$ctrl.active = \'format\'\" ng-class=\"{active: $ctrl.active == \'format\', checked: $root.materialSearchFormCtrl.params[\'type[]\'].length}\">{{ \'format\' | translate }}</li> <li ng-click=\"$ctrl.active = \'category\'\" ng-class=\"{active: $ctrl.active == \'category\', checked: $root.materialSearchFormCtrl.params[\'category_id[]\'].length}\">{{ \'type\' | translate }}</li> <li ng-click=\"$ctrl.active = \'subject\'\" ng-class=\"{active: $ctrl.active == \'subject\', checked: $root.materialSearchFormCtrl.params[\'subject_id[]\'].length}\">{{ \'subject\' | translate }}</li> <li ng-click=\"$ctrl.active = \'source\'\" ng-class=\"{active: $ctrl.active == \'source\', checked: $root.materialSearchFormCtrl.params[\'source_id[]\'].length}\">{{ \'source\' | translate }}</li> <li ng-click=\"$ctrl.active = \'rating\'\" ng-class=\"{active: $ctrl.active == \'rating\', checked: $root.materialSearchFormCtrl.params.sort_rating}\">{{ \'rating\' | translate }}</li> <li ng-if=$root.isLoggedIn() ng-click=\"$ctrl.active = \'finished\'\" ng-class=\"{active: $ctrl.active == \'finished\', checked: $root.materialSearchFormCtrl.params.not_finished}\">{{ \'finished\' | translate }}</li> </ul> </div> <div class=\"column padded bordered list\"> <ul ng-if=\"$ctrl.active == \'format\'\" class=list-check> <li ng-class=\"{checked: $root.materialSearchFormCtrl.params[\'type[]\'] && $root.materialSearchFormCtrl.params[\'type[]\'].indexOf(\'video\')!=-1}\"> <label>{{ \'video\' | translate }}<input class=hidden checklist-model=\"$root.materialSearchFormCtrl.params[\'type[]\']\" value=video type=checkbox></label> </li> <li ng-class=\"{checked: $root.materialSearchFormCtrl.params[\'type[]\'] && $root.materialSearchFormCtrl.params[\'type[]\'].indexOf(\'audio\')!=-1}\"> <label>{{ \'audio\' | translate }}<input class=hidden checklist-model=\"$root.materialSearchFormCtrl.params[\'type[]\']\" value=audio type=checkbox></label> </li> <li ng-class=\"{checked: $root.materialSearchFormCtrl.params[\'type[]\'] && $root.materialSearchFormCtrl.params[\'type[]\'].indexOf(\'text\')!=-1}\"> <label>{{ \'text\' | translate }}<input class=hidden checklist-model=\"$root.materialSearchFormCtrl.params[\'type[]\']\" value=text type=checkbox></label> </li> </ul> <ul ng-if=\"$ctrl.active == \'category\'\" class=list-check> <li ng-repeat=\"c in $root.materialSearchFormCtrl.categories\" ng-class=\"{checked: $root.materialSearchFormCtrl.params[\'category_id[]\'] && $root.materialSearchFormCtrl.params[\'category_id[]\'].indexOf(c.value)!=-1}\"> <label>{{ c.text }}<input class=hidden checklist-model=\"$root.materialSearchFormCtrl.params[\'category_id[]\']\" checklist-value=c.value type=checkbox></label> </li> </ul> <ul ng-if=\"$ctrl.active == \'subject\'\" class=list-check> <li ng-repeat=\"s in $root.materialSearchFormCtrl.subjects\" ng-class=\"{checked: $root.materialSearchFormCtrl.params[\'subject_id[]\'] && $root.materialSearchFormCtrl.params[\'subject_id[]\'].indexOf(s.value)!=-1}\"> <label>{{ s.text }}<input class=hidden checklist-model=\"$root.materialSearchFormCtrl.params[\'subject_id[]\']\" checklist-value=s.value type=checkbox></label> </li> </ul> <ul ng-if=\"$ctrl.active == \'source\'\" class=list-check> <li ng-repeat=\"s in $root.materialSearchFormCtrl.sources\" ng-class=\"{checked: $root.materialSearchFormCtrl.params[\'source_id[]\'] && $root.materialSearchFormCtrl.params[\'source_id[]\'].indexOf(s.value)!=-1}\"> <label>{{ s.text }}<input class=hidden checklist-model=\"$root.materialSearchFormCtrl.params[\'source_id[]\']\" checklist-value=s.value type=checkbox></label> </li> </ul> <ul ng-if=\"$ctrl.active == \'rating\'\" class=list-check> <li ng-repeat=\"r in $root.materialSearchFormCtrl.sortRatingOptions\" ng-class=\"{checked: $root.materialSearchFormCtrl.params.sort_rating == r.value}\"> <label>{{ r.text | translate }}<input class=hidden ng-click=\"$root.materialSearchFormCtrl.params.sort_rating = r.value\" type=checkbox></label> </li> <li ng-class=\"{checked: !$root.materialSearchFormCtrl.params.sort_rating}\"> <label>{{ \'no_rating\' | translate }}<input class=hidden ng-click=\"$root.materialSearchFormCtrl.params.sort_rating = null\" type=checkbox></label> </li> </ul> <ul ng-if=\"$ctrl.active == \'finished\'\" class=list-check> <li ng-class=\"{checked: $root.materialSearchFormCtrl.params.not_finished}\"> <label>{{ \'hide_finished\' | translate }}<input class=hidden ng-click=\"$root.materialSearchFormCtrl.params.not_finished = $root.materialSearchFormCtrl.params.not_finished ? null : 1\" type=checkbox></label> </li> </ul> </div> </div> <div class=actions> <button class=\"btn btn-primary btn-invert\" type=button ng-click=\"$root.materialSearchFormCtrl.searchReset(); $ctrl.submit();\">{{\'clear_all\'|translate}}</button> <button class=\"btn btn-primary\" type=button ng-click=$ctrl.submit(); loading-overlay=$root.materialSearchFormCtrl.loading loading-hide-content=true loading-class=loading-white>{{\'show\'|translate}} ({{ $root.materialSearchFormCtrl.totalCount || 0 }})</button> </div> </div>");
$templateCache.put("app/components/_partials/materialSearchResult/materialSearchResult.html","<div class=text-center ng-if=\"$ctrl.loading && !$ctrl.pagination.totalCount\"><div class=loading></div></div> <div ng-if=\"!$ctrl.loading || $ctrl.pagination.totalCount\"> <h1>{{ \'materials\' | translate }} ({{$ctrl.pagination.totalCount+0}})</h1> <div class=search-tags ng-if=$root.isDesktop> <button class=\"btn btn-xs btn-primary\" ng-repeat=\"s in $ctrl.currentSubjects\" delete-overlay=true ng-click=\"$ctrl.unsetParam(\'subject_id[]\', s.value)\">{{ s.text }}</button> <button class=\"btn btn-xs btn-primary\" ng-repeat=\"s in $ctrl.currentCategories\" delete-overlay=true ng-click=\"$ctrl.unsetParam(\'category_id[]\', s.value)\">{{ s.text }}</button> <button class=\"btn btn-xs btn-primary\" ng-repeat=\"s in $ctrl.currentSources\" delete-overlay=true ng-click=\"$ctrl.unsetParam(\'source_id[]\', s.value)\">{{ s.text }}</button> <button class=\"btn btn-xs btn-primary\" ng-repeat=\"s in $ctrl.params[\'title[]\']\" delete-overlay=true ng-click=\"$ctrl.searchQueryDelete(s); $ctrl.applySearchQuery();\">{{ s }}</button> <button class=\"btn btn-xs btn-primary\" ng-if=$ctrl.params.sort_rating delete-overlay=true ng-click=\"$ctrl.params.sort_rating = null\"> {{ $ctrl.currentRating.text | translate }} </button> <button class=\"btn btn-xs btn-primary\" ng-if=$ctrl.params.not_finished delete-overlay=true ng-click=\"$ctrl.params.not_finished = null\"> {{ \'hide_finished\' | translate }} </button> </div> <material-list items=$ctrl.materials add-to-course=$ctrl.addToCourse on-add-to-course=$ctrl.onAddToCourse({model:model}) course-materials=$ctrl.courseMaterials></material-list> </div> <div class=text-center-tablet ng-if=\"$ctrl.pagination.totalCount > 0\"> <button class=\"btn btn-primary btn-block-phone\" ng-if=\"$ctrl.pagination.currentPage < $ctrl.pagination.pageCount\" ng-click=$ctrl.load($ctrl.pagination.currentPage+1) loading-overlay=$ctrl.loading loading-hide-content=true loading-class=loading-white>{{ \'show_more\' | translate }}</button> </div>");
$templateCache.put("app/components/_partials/progressToday/progressToday.html","<div class=text>{{ \'for_today\' | translate }}</div> <div class=points> <span class=today>{{$ctrl.user.today_points}}</span> <span class=plan ng-if=\"$ctrl.user.points_plan > 0\">/ {{$ctrl.user.points_plan}}</span> </div> <div class=progress ng-if=\"$ctrl.user.points_plan > 0\"> <div class=\"progress-bar progress-bar-success\" style=\"width:{{ ($ctrl.user.today_points / $ctrl.user.points_plan)*100 }}%\"></div> </div>");
$templateCache.put("app/components/_partials/oauth/oauth.html","<div class=row-buttons> <button class=\"btn btn-grow btn-social btn-google\" ng-click=\"$ctrl.authenticate(\'google\')\" ng-disabled=$ctrl.dataLoading><span class=\"fa fa-google\"></span> {{\'sign_in_with_google\'|translate}}</button> <button class=\"btn btn-grow btn-social btn-facebook\" ng-click=\"$ctrl.authenticate(\'facebook\')\" ng-disabled=$ctrl.dataLoading><span class=\"fa fa-facebook\"></span> {{\'sign_in_with_facebook\'|translate}}</button> </div>");
$templateCache.put("app/components/_partials/reportButton/reportButtonModal.html","<div class=modal-header> <button type=button class=close ng-click=$ctrl.close()><i class=icon-close></i></button> <h2 class=modal-title>{{\'choose\'|translate}}:</h2> </div> <div class=\"modal-body report-form\"> <div class=variant-checkbox-list> <div class=variant ng-repeat=\"v in $ctrl.variants\" ng-click=$ctrl.selectVariant(v) ng-class=\"{selected: $ctrl.selectedVariant == v}\"> <div class=circle-checkbox></div> <div class=text>{{v.text|translate}}</div> </div> </div> <form name=form novalidate> <div class=form-group> <input name=text type=text ng-model=$ctrl.text class=form-control placeholder={{$ctrl.inputLabel|translate}} ng-required=$ctrl.inputRequired> </div> <button class=\"btn btn-primary btn-block\" type=button ng-disabled=\"!$ctrl.selectedVariant || !form.text.$valid\" ng-click=\"$ctrl.send(); $ctrl.close();\">{{\'send\'|translate}}</button> </form> </div>");
$templateCache.put("app/components/_partials/reportButton/reportButtonPopover.html","<div class=\"report-popover report-form\"> <button type=button class=\"close visible-phone\" ng-click=\"$ctrl.isOpen = false\"><i class=icon-close></i></button> <div class=variant-list> <a class=variant ng-repeat=\"v in $ctrl.variants\" ng-click=$ctrl.selectVariant(v) ng-class=\"{selected: $ctrl.selectedVariant == v}\">{{v.text|translate}}</a> </div> <form name=form novalidate> <div class=input-group> <input name=text type=text ng-model=$ctrl.text class=\"form-control input-sm\" placeholder={{$ctrl.inputLabel|translate}} ng-required=$ctrl.inputRequired> <span class=input-group-btn> <button class=\"btn btn-primary btn-sm\" type=button ng-disabled=\"!$ctrl.selectedVariant || !form.text.$valid\" ng-click=$ctrl.send()>{{\'send\'|translate}}</button> </span> </div> </form> </div>");
$templateCache.put("app/components/_partials/sprintCount/sprintCount.html","<div class=\"sprint-count split-block\"> <a ui-sref=sprint.friends.own class=text-center> <div class=text-lg><b>{{$ctrl.ownCount()}}</b></div> <div class=\"text-muted text-lowercase small\">{{\'in_your_sprint\'|translate}}</div> </a> <a ui-sref=sprint.friends.outer class=text-center> <div class=text-lg><b>{{$ctrl.outerCount()}}</b></div> <div class=\"text-muted text-lowercase small\">{{\'added_you_in_sprint\'|translate}}</div> </a> </div>");
$templateCache.put("app/components/_partials/sprintLeader/sprintLeader.html","<div class=sprint-leader loading-replace=$ctrl.loading> <div ng-if=$ctrl.user hover-target> <p><img ng-src=assets/images/icon-cup.png alt=\"\"></p> <p> </p><div ng-click=$ctrl.onNavigate() class=\"user-preview-short vertical\"> <a ui-sref=user.log({id:$ctrl.user.id}) class=avatar hover-behavior> <img ng-src={{$ctrl.user.avatar|avatar}} alt=\"\"> <div class=level>{{$ctrl.user.level}}</div> <div class=border-overlay></div> </a> <div class=avatar-name> <a ui-sref=user.log({id:$ctrl.user.id}) hover-behavior>{{ $ctrl.user.id == $ctrl.you ? (\'today_leader_is_you\'|translate) : $ctrl.user.name }}</a> </div> </div> <p></p> </div> <div ng-if=!$ctrl.user> <p><img ng-src=assets/images/icon-cup.png alt=\"\"></p> <p> </p><div ng-click=$ctrl.onNavigate() class=\"user-preview-short vertical\"> <div class=avatar> <img ng-src=\"{{\'\'|avatar}}\" alt=\"\"> <div class=level></div> </div> <div class=avatar-name>{{\'no_leader\'|translate}}</div> </div> <p></p> </div><!-- <h4 ng-if=\"!$ctrl.user\">{{\'no_leader\'|translate}}</h4> --> <div class=\"border-block border-block-sm text-success\"> {{\'for_today\'|translate}} <div class=text-lg>{{$ctrl.user.today_points + 0}}</div> </div> </div>");
$templateCache.put("app/components/_partials/timezoneModal/timezoneModal.html","<div class=modal-header> <button type=button class=close ng-click=$ctrl.dismiss()><i class=icon-close></i></button> <h2 class=modal-title>{{\'timezone\'|translate}}</h2> </div> <div class=modal-body> <form> <div class=\"form-group form-group-icon-right\"> <input class=\"form-control search\" type=text ng-model=q ng-model-options=\"{ updateOn: \'default blur\', debounce: { \'default\': 200, \'blur\': 0 } }\" placeholder=\"{{\'search\'|translate}}\"> <i class=\"icon icon-search icon-gray\"></i> </div> </form> <div class=text-center ng-if=$ctrl.loading> <div class=loading></div> </div> <div class=\"button-grid list\" style=\"max-height: 55vh; overflow-y: auto; overflow-x: hidden\" ng-if=!$ctrl.loading> <button class=\"btn btn-default btn-sm btn-hover-primary\" ng-class=\"{\'btn-primary selected\':t.value == $ctrl.resolve.selected}\" style=\"flex-basis: 100%; text-align: left\" ng-repeat=\"t in $ctrl.timezones|filter:{text:q} track by t.value\" ng-click=$ctrl.select(t.value)>{{::t.text}}</button> </div> </div>");
$templateCache.put("app/components/_partials/userList/userList.html","<div class=\"user-list row\"> <div class={{$ctrl.class}} ng-repeat=\"u in $ctrl.items | filter:{name:$ctrl.filter} as result track by $index\"> <user-preview-short user=u></user-preview-short> </div> </div> <div class=text-center-tablet ng-if=!result.length>{{\'nothing_found\'|translate}}</div>");
$templateCache.put("app/components/_partials/userList/userListSprint.html","<div class=\"user-list row\"> <div class={{$ctrl.class}} ng-repeat=\"u in $ctrl.items | filter:{name:$ctrl.filter} as result track by $index\" ng-class={inactive:$ctrl.isAdded(u.id)}> <div class=row> <div class=\"col-xs-7 vcenter\"> <user-preview-short user=u></user-preview-short> </div><!--\r\n            --><div class=\"col-xs-5 vcenter text-right\"> <button ng-if=!$ctrl.isAdded(u.id) class=\"btn btn-primary btn-invert btn-block btn-wrap\" ng-click=$ctrl.add(u.id)>{{\'add_to_sprint\'|translate}}</button> <button ng-if=$ctrl.isAdded(u.id) class=\"btn btn-success btn-block btn-wrap\">{{\'added_to_sprint\'|translate}}</button> </div> </div> </div> </div> <div class=text-center-tablet ng-if=!result.length>{{\'nothing_found\'|translate}}</div>");
$templateCache.put("app/components/_partials/userPreview/userPreview.html","<div hover-target> <div class=user-preview> <a class=\"avatar-preview center-block\" ui-sref=user.log({id:$ctrl.user.id}) hover-behavior> <img ng-src={{$ctrl.user.avatar|avatar}} alt=\"\"> <div class=level>{{$ctrl.user.level}}</div> <div class=border-overlay></div> </a> <div class=avatar-name> <a ui-sref=user.log({id:$ctrl.user.id}) hover-behavior>{{$ctrl.user.name}}</a> </div> <div class=avatar-meta>{{$ctrl.userCity($ctrl.user)}}</div> </div> </div>");
$templateCache.put("app/components/_partials/userPreview/userPreviewAvatar.html","<div hover-target> <div class=user-preview> <a class=\"avatar-preview center-block\" ui-sref=user.log({id:$ctrl.user.id}) hover-behavior ng-click=$event.stopPropagation()> <img ng-src={{$ctrl.user.avatar|avatar}} alt=\"\"> <div class=level>{{$ctrl.user.level}}</div> <div class=border-overlay></div> </a> </div> </div>");
$templateCache.put("app/components/_partials/userPreview/userPreviewFacebook.html","<div hover-target> <div class=\"user-preview-short facebook\"> <a class=avatar ui-sref=user.log({id:$ctrl.user.id}) hover-behavior> <img ng-src={{$ctrl.user.avatar|avatar}} alt=\"\"> <div class=border-overlay></div> </a> <div class=avatar-name><a ui-sref=user.log({id:$ctrl.user.id}) hover-behavior>{{$ctrl.user.name}}</a></div> <div class=avatar-meta> <a href ng-if=!$ctrl.isAdded($ctrl.userId) ng-click=$ctrl.add($ctrl.userId)><b>{{\'add_to_sprint\'|translate}}</b></a> <span ng-if=$ctrl.isAdded($ctrl.userId) class=text-success><b>{{\'added_to_sprint\'|translate}}</b></span> </div> </div> </div>");
$templateCache.put("app/components/_partials/userPreview/userPreviewProfile.html","<div class=\"user-preview-profile flex flex-justify flex-vcenter\"> <div ng-if=!$root.isPhone class=\"flex-grow text-center\"> <div ng-if=!$ctrl.you> <progress-today user=$ctrl.user ui-sref=user.log({id:$ctrl.userId})></progress-today><!-- <progress-today user=\"$ctrl.user\" ui-sref=\"user.diagram({id:$ctrl.userId})\"></progress-today> --> </div> </div> <div class=\"flex-grow text-center\"> <p> </p><div class=\"avatar-preview center-block\"> <img ng-src={{$ctrl.user.avatar|avatar}} alt=\"\"> <a ng-if=$ctrl.you ui-sref=settings.profile class=settings><i class=icon-settings></i></a> <div class=level>{{$ctrl.user.level}}</div> </div> <div class=avatar-name> {{$ctrl.user.name}} </div> <div class=avatar-meta>{{$ctrl.userMeta($ctrl.user)}}</div> <p></p> </div> <div ng-if=!$root.isPhone class=\"flex-grow text-center\"> <div ng-if=!$ctrl.you> <button ng-if=!$ctrl.isAdded($ctrl.userId) class=\"btn btn-primary btn-invert\" ng-click=$ctrl.add($ctrl.userId)>{{\'add_to_sprint\'|translate}}</button> <button ng-if=$ctrl.isAdded($ctrl.userId) class=\"btn btn-success\">{{\'added_to_sprint\'|translate}}</button> </div> </div> </div> <div ng-if=\"$root.isPhone && !$ctrl.you\" class=text-center> <progress-today user=$ctrl.user ui-sref=user.log({id:$ctrl.userId})></progress-today><!-- <progress-today user=\"$ctrl.user\" ui-sref=\"user.diagram({id:$ctrl.userId})\"></progress-today> --> </div> <div ng-if=\"$root.isPhone && !$ctrl.you\" class=text-center> <button ng-if=!$ctrl.isAdded($ctrl.userId) class=\"btn btn-primary btn-invert btn-block\" ng-click=$ctrl.add($ctrl.userId)>{{\'add_to_sprint\'|translate}}</button> <button ng-if=$ctrl.isAdded($ctrl.userId) class=\"btn btn-success btn-block\">{{\'added_to_sprint\'|translate}}</button> </div>");
$templateCache.put("app/components/_partials/userPreview/userPreviewShort.html","<a class=user-preview-short ui-sref=user.log({id:$ctrl.user.id})> <div class=avatar> <img ng-src={{$ctrl.user.avatar|avatar}} alt=\"\"> <div class=level>{{$ctrl.user.level}}</div> <div class=border-overlay></div> </div> <div class=avatar-name>{{$ctrl.user.name}}</div> <div class=avatar-meta>{{$ctrl.userCity($ctrl.user)}}</div> </a>");
$templateCache.put("app/components/_partials/userSearchResult/userSearchResult.html","<div class=page-header> <h1>{{\'people\'|translate}} ({{$ctrl.pagination.totalCount + 0}})</h1> <div class=search-tags> <button class=\"btn btn-xs btn-primary\" ng-if=\"$ctrl.params.gender != null\" delete-overlay=true ng-click=\"$ctrl.params.gender = null; $ctrl.load();\"> {{ $ctrl.getGenderText($ctrl.params.gender) }} </button> <button class=\"btn btn-xs btn-primary\" ng-if=\"$ctrl.params.age_from || $ctrl.params.age_to\" delete-overlay=true ng-click=\"$ctrl.params.age_from = null; $ctrl.params.age_to = null; $ctrl.load();\"> {{ $ctrl.params.age_from && (\'from\'|translate|lowercase)+\' \'+$ctrl.params.age_from || \'\' }} {{ $ctrl.params.age_to && (\'to\'|translate|lowercase)+\' \'+$ctrl.params.age_to || \'\' }} </button> </div> </div> <div ng-if=\"$ctrl.pagination.totalCount > 0\"> <user-list-sprint ng-if=$ctrl.sprint items=$ctrl.users cols=$ctrl.cols></user-list-sprint> <user-list ng-if=!$ctrl.sprint items=$ctrl.users cols=$ctrl.cols></user-list> </div> <div class=text-center-tablet ng-if=\"$ctrl.pagination.totalCount > 0\"> <button class=\"btn btn-primary btn-block-phone\" ng-if=\"$ctrl.pagination.currentPage < $ctrl.pagination.pageCount\" ng-click=$ctrl.load($ctrl.pagination.currentPage+1) loading-overlay=$ctrl.loading loading-hide-content=true loading-class=loading-white>{{ \'show_more\' | translate }}</button> </div> <div ng-if=\"$ctrl.pagination.totalCount == 0\"> {{\'nothing_found_filter\'|translate}} </div>");
$templateCache.put("app/components/koran/training/_index.html","<h1 class=text-center>{{ \'training_sura_name\' | translate: $ctrl.sura }}</h1> <p class=\"text-center text-muted\">{{\'train_number_avail\'|translate:{number:6}:\'messageformat\'}}</p> <br> <banner id=sura-training-list-banner class=banner-simple close-button=true ng-if=\"\'sura_training_list_banner\'|configService\"><span ng-bind-html=\"\'sura_training_list_banner\'|configService\"></span></banner> <div class=training-list> <div ng-click=\"$ctrl.openTraining({sura:$ctrl.sura,training:\'missedAyat\'})\" class=training-item> <div class=img><img src=/assets/images/training-missed-phrase.png alt=\"\"></div> <div class=title>{{\'t_missed_ayat\'|translate}}</div> <div class=descr>{{\'t_descr_missed_ayat\'|translate}}</div> </div> <div ng-click=\"$ctrl.openTraining({sura:$ctrl.sura,training:\'nextAyat\'})\" class=training-item> <div class=img><img src=/assets/images/training-next-phrase.png alt=\"\"></div> <div class=title>{{\'t_next_ayat\'|translate}}</div> <div class=descr>{{\'t_descr_next_ayat\'|translate}}</div> </div> <div ng-click=\"$ctrl.openTraining({sura:$ctrl.sura,training:\'ayatTranslation\'})\" class=training-item> <div class=img><img src=/assets/images/training-phrase-translation.png alt=\"\"></div> <div class=title>{{\'t_ayat_translation\'|translate}}</div> <div class=descr>{{\'t_descr_ayat_translation\'|translate}}</div> </div> <div ng-click=\"$ctrl.openTraining({sura:$ctrl.sura,training:\'translationAyat\'})\" class=training-item> <div class=img><img src=/assets/images/training-translation-phrase.png alt=\"\"></div> <div class=title>{{\'t_translation_ayat\'|translate}}</div> <div class=descr>{{\'t_descr_translation_ayat\'|translate}}</div> </div> <div ng-click=\"$ctrl.openTraining({sura:$ctrl.sura,training:\'constructor\'})\" class=training-item> <div class=img><img src=/assets/images/training-phrase-constructor.png alt=\"\"></div> <div class=title>{{\'t_ayat_constructor\'|translate}}</div> <div class=descr>{{\'t_descr_ayat_constructor\'|translate}}</div> </div> <div ng-click=\"$ctrl.openTraining({sura:$ctrl.sura,training:\'listening\'})\" class=training-item> <div class=img><img src=/assets/images/training-listening.png alt=\"\"></div> <div class=title>{{\'t_ayat_listening\'|translate}}</div> <div class=descr>{{\'t_descr_ayat_listening\'|translate}}</div> </div> <div ng-click=\"$ctrl.openTraining({sura:$ctrl.sura,training:\'speed\'})\" class=training-item> <div class=img><img src=/assets/images/training-speed.png alt=\"\"></div> <div class=title>{{\'t_ayat_speed\'|translate}}</div> <div class=descr>{{\'t_descr_ayat_speed\'|translate}}</div> </div> <div ng-click=\"$ctrl.openTraining({sura:$ctrl.sura,training:\'cards\'})\" class=training-item> <div class=img><img src=/assets/images/training-phrase-cards.png alt=\"\"></div> <div class=title>{{\'t_ayat_cards\'|translate}}</div> <div class=descr>{{\'t_descr_ayat_cards\'|translate}}</div> </div> <div style=\"flex: 1 0 280px;margin:0 12px 25px\"></div> </div> <banner class=\"banner-simple banner-2-col\" close-button=false><ng-include src=\"\'app/views/shareProjectBanner.html\'\"></ng-include></banner>");
$templateCache.put("app/components/koran/training/ayatSelectorModal.html","<div class=modal-header> <button type=button class=close ng-click=$ctrl.dismiss()><i class=icon-close></i></button> <h2 class=modal-title>{{ \'select_ayats_training_name\' | translate:$ctrl.sura }}</h2> </div> <div class=\"modal-body button-grid\"> <button class=\"btn btn-default btn-sm btn-hover-primary\" ng-repeat=\"i in $ctrl.intervals\" ng-click=$ctrl.select(i.start,i.end)>{{i.start}} &mdash; {{i.end}}</button> </div>");
$templateCache.put("app/components/koran/training/ayatTranslation.html","<div class=\"container container-page-responsive training-page\" ng-if=!$ctrl.showResult> <button type=button class=close ui-sref=koran.training.index({id:$ctrl.sura.id})><i class=icon-close></i></button> <div ng-click=\"$ctrl.showExample = false\"> <div class=task-title>{{\'training_ayat_translation_sura_name\'|translate:$ctrl.sura}}</div> <div class=task-source-selector ng-if=\"$ctrl.sura.ayats_count > 10\"><a ng-click=\"$ctrl.openTraining({sura:$ctrl.sura,training:\'ayatTranslation\'})\"><span>{{ \'ayats_interval\'|translate:$ctrl }}</span><i class=icon-angle-down></i></a></div> <div class=\"task-source-selector text-muted\" ng-if=\"$ctrl.sura.ayats_count <= 10\">{{ \'ayats_interval\'|translate:$ctrl }}</div> <phrase-translation descr=\"\'t_descr2_ayat_translation\'|translate\" data=$ctrl.data on-finish=\"$ctrl.onFinish(correct, wrong)\" on-result=\"$ctrl.onResult(correct, wrong)\" on-active-task=\"$ctrl.activeTask = index; $ctrl.answered = false;\" on-answer=\"$ctrl.answered = true\" ng-if=\"$ctrl.data.length>0\"></phrase-translation> <div ng-if=$ctrl.answered class=training-example ng-click=$event.stopPropagation()> <div class=\"title hidden-phone\">{{\'ayat_placement\'|translate}}</div> <div class=text-center> <a href ng-click=\"$ctrl.showExample = !$ctrl.showExample\" class=\"td-none visible-phone\">{{\'ayat_placement\'|translate}} &nbsp;<i class=icon-angle-down ng-show=!$ctrl.showExample></i><i class=icon-angle-up ng-show=$ctrl.showExample></i></a> </div> <div class=\"example arab\" ng-show=\"$ctrl.showExample || !$root.isPhone\"> <span class=ayat ng-repeat=\"ayat in $ctrl.ayats\" ng-class=\"{active: $ctrl.activeTask == $index}\"> <span class=text>{{ayat.arab_text}}</span> <span class=number>{{ayat.number|arabNumber}}</span><!-- <span class=\"text\">{{ayat.arab_text|withoutLastWord}}</span>\r\n					<span style=\"white-space:nowrap;\">\r\n						<span class=\"text\">{{ayat.arab_text|lastWord}}</span>\r\n						<span class=\"number\">{{ayat.number|arabNumber}}</span>\r\n					</span> --> </span> </div> </div> </div> </div> <div class=\"container-page-responsive result-page\" ng-if=$ctrl.showResult> <div class=\"actions-bar top bb visible-tablet\"> <a class=td-none ui-sref=koran.training.index({id:$ctrl.sura.id})><i class=icon-arrow-left></i>&nbsp; {{\'goto_another_trainings\'|translate}}</a> </div> <div class=container> <button type=button class=\"close hidden-tablet\" ui-sref=koran.training.index({id:$ctrl.sura.id})><i class=icon-close></i></button> <div class=row> <div class=\"col-sm-10 col-sm-offset-1\"> <training-result title=$ctrl.resultTitle() training=\"\'t_ayat_translation\'|translate\" correct=$ctrl.result.correct wrong=$ctrl.result.wrong points=$ctrl.result.points></training-result> <p class=\"actions text-center\"> <button class=\"btn btn-primary\" ng-click=\"$ctrl.openTraining({sura:$ctrl.sura,training:\'ayatTranslation\'})\">{{\'continue_training\'|translate}} &nbsp;<i class=icon-arrow-right></i></button> </p> <p class=\"text-center hidden-tablet\"> <button class=\"btn btn-link\" ui-sref=koran.training.index({id:$ctrl.sura.id})>{{\'goto_another_trainings\'|translate}}</button> </p> <br> <banner class=\"banner-simple hidden-phone\" close-button=false><ng-include src=\"\'app/views/shareProjectBanner.html\'\"></ng-include></banner> </div> </div> </div> </div>");
$templateCache.put("app/components/koran/training/cards.html","<div class=\"container container-page-responsive training-page\" ng-if=!$ctrl.showResult> <button type=button class=close ui-sref=koran.training.index({id:$ctrl.sura.id})><i class=icon-close></i></button> <div> <div class=task-title>{{\'training_ayat_cards_sura_name\'|translate:$ctrl.sura}}</div> <div class=task-source-selector ng-if=\"$ctrl.sura.ayats_count > 10\"><a ng-click=\"$ctrl.openTraining({sura:$ctrl.sura,training:\'cards\'})\"><span>{{ \'ayats_interval\'|translate:$ctrl }}</span><i class=icon-angle-down></i></a></div> <div class=\"task-source-selector text-muted\" ng-if=\"$ctrl.sura.ayats_count <= 10\">{{ \'ayats_interval\'|translate:$ctrl }}</div> <phrase-cards descr=\"\'t_descr2_ayat_cards\'|translate\" data=$ctrl.data on-finish=\"$ctrl.onFinish(correct, wrong)\" on-result=\"$ctrl.onResult(correct, wrong)\" on-active-task=\"$ctrl.activeTask = index\" ng-if=\"$ctrl.data.length>0\"></phrase-cards> </div> </div> <div class=\"container-page-responsive result-page\" ng-if=$ctrl.showResult> <div class=\"actions-bar top bb visible-tablet\"> <a class=td-none ui-sref=koran.training.index({id:$ctrl.sura.id})><i class=icon-arrow-left></i>&nbsp; {{\'goto_another_trainings\'|translate}}</a> </div> <div class=container> <button type=button class=\"close hidden-tablet\" ui-sref=koran.training.index({id:$ctrl.sura.id})><i class=icon-close></i></button> <div class=row> <div class=\"col-sm-10 col-sm-offset-1\"> <training-result title=$ctrl.resultTitle() training=\"\'t_ayat_cards\'|translate\" correct=$ctrl.result.correct wrong=$ctrl.result.wrong points=$ctrl.result.points></training-result> <p class=\"actions text-center\"> <button class=\"btn btn-primary\" ng-click=\"$ctrl.openTraining({sura:$ctrl.sura,training:\'cards\'})\">{{\'continue_training\'|translate}} &nbsp;<i class=icon-arrow-right></i></button> </p> <p class=\"text-center hidden-tablet\"> <button class=\"btn btn-link\" ui-sref=koran.training.index({id:$ctrl.sura.id})>{{\'goto_another_trainings\'|translate}}</button> </p> <br> <banner class=\"banner-simple hidden-phone\" close-button=false><ng-include src=\"\'app/views/shareProjectBanner.html\'\"></ng-include></banner> </div> </div> </div> </div>");
$templateCache.put("app/components/koran/training/constructor.html","<div class=\"container container-page-responsive training-page\" ng-if=!$ctrl.showResult> <button type=button class=close ui-sref=koran.training.index({id:$ctrl.sura.id})><i class=icon-close></i></button> <div ng-click=\"$ctrl.showExample = false\"> <div class=task-title>{{\'training_ayat_constructor_sura_name\'|translate:$ctrl.sura}}</div> <div class=task-source-selector ng-if=\"$ctrl.sura.ayats_count > 10\"><a ng-click=\"$ctrl.openTraining({sura:$ctrl.sura,training:\'constructor\'})\"><span>{{ \'ayats_interval\'|translate:$ctrl }}</span><i class=icon-angle-down></i></a></div> <div class=\"task-source-selector text-muted\" ng-if=\"$ctrl.sura.ayats_count <= 10\">{{ \'ayats_interval\'|translate:$ctrl }}</div> <phrase-constructor descr=\"\'t_descr2_ayat_constructor\'|translate\" data=$ctrl.data on-finish=\"$ctrl.onFinish(correct, wrong)\" on-result=\"$ctrl.onResult(correct, wrong)\" on-active-task=\"$ctrl.activeTask = index; $ctrl.answered = false;\" on-answer=\"$ctrl.answered = true; $ctrl.curTask = task;\" ng-if=\"$ctrl.data.length>0\"></phrase-constructor> <div ng-if=$ctrl.answered class=\"training-example visible-phone\" ng-click=$event.stopPropagation()> <div class=text-center> <a href ng-click=\"$ctrl.showExample = !$ctrl.showExample\" class=td-none>{{\'correct_answer\'|translate}} &nbsp;<i class=icon-angle-down ng-show=!$ctrl.showExample></i><i class=icon-angle-up ng-show=$ctrl.showExample></i></a> </div> <div class=\"example text-center\" ng-show=\"$ctrl.showExample || !$root.isPhone\"> <p class=arab>{{$ctrl.curTask.corA}}</p> <div ng-if=$ctrl.curTask.audio> <audio-button src=\"[{src:$ctrl.curTask.audio,type:\'audio/mpeg\'}]\" on-ready=\"$ctrl.vgapi = $API\"></audio-button> </div> </div> </div> </div> </div> <div class=\"container-page-responsive result-page\" ng-if=$ctrl.showResult> <div class=\"actions-bar top bb visible-tablet\"> <a class=td-none ui-sref=koran.training.index({id:$ctrl.sura.id})><i class=icon-arrow-left></i>&nbsp; {{\'goto_another_trainings\'|translate}}</a> </div> <div class=container> <button type=button class=\"close hidden-tablet\" ui-sref=koran.training.index({id:$ctrl.sura.id})><i class=icon-close></i></button> <div class=row> <div class=\"col-sm-10 col-sm-offset-1\"> <training-result title=$ctrl.resultTitle() training=\"\'t_ayat_constructor\'|translate\" correct=$ctrl.result.correct wrong=$ctrl.result.wrong points=$ctrl.result.points></training-result> <p class=\"actions text-center\"> <button class=\"btn btn-primary\" ng-click=\"$ctrl.openTraining({sura:$ctrl.sura,training:\'constructor\'})\">{{\'continue_training\'|translate}} &nbsp;<i class=icon-arrow-right></i></button> </p> <p class=\"text-center hidden-tablet\"> <button class=\"btn btn-link\" ui-sref=koran.training.index({id:$ctrl.sura.id})>{{\'goto_another_trainings\'|translate}}</button> </p> <br> <banner class=\"banner-simple hidden-phone\" close-button=false><ng-include src=\"\'app/views/shareProjectBanner.html\'\"></ng-include></banner> </div> </div> </div> </div>");
$templateCache.put("app/components/koran/training/index.html","<div class=\"container container-page-responsive\" ng-if=!$root.isTablet> <div class=\"row hidden-tablet\"> <div class=\"col-xs-4 text-left\"> <a class=td-none ui-sref=.({id:$ctrl.sura.prevSura.id}) ng-show=$ctrl.sura.prevSura><i class=icon-arrow-left></i>&nbsp; {{\'prev_sura_name\'|translate:$ctrl.sura.prevSura}}</a> </div> <div class=\"col-xs-4 text-center\"> <a class=td-none ui-sref=koran.index><i class=icon-bars></i>&nbsp; {{\'koran_sura_list\'|translate}}</a> </div> <div class=\"col-xs-4 text-right\"> <a class=td-none ui-sref=.({id:$ctrl.sura.nextSura.id}) ng-show=$ctrl.sura.nextSura>{{\'next_sura_name\'|translate:$ctrl.sura.nextSura}} &nbsp;<i class=icon-arrow-right></i></a> </div> </div> <ng-include src=\"\'app/components/koran/training/_index.html\'\"></ng-include> </div> <div class=container-page-responsive ng-if=$root.isTablet> <div class=\"actions-bar top bb visible-tablet\"> <a class=\"td-none pull-right hidden-phone\" ui-sref=.({id:$ctrl.sura.nextSura.id}) ng-if=$ctrl.sura.nextSura>{{\'next_sura_name\'|translate:$ctrl.sura.nextSura}} &nbsp;<i class=icon-arrow-right></i></a> <a class=td-none ui-sref=koran.index><i class=icon-arrow-left></i>&nbsp; {{\'koran_sura_list\'|translate}}</a> </div> <div class=container> <ng-include src=\"\'app/components/koran/training/_index.html\'\"></ng-include> </div> </div>");
$templateCache.put("app/components/koran/training/listening.html","<div class=\"container container-page-responsive training-page\" ng-if=!$ctrl.showResult> <button type=button class=close ui-sref=koran.training.index({id:$ctrl.sura.id})><i class=icon-close></i></button> <div> <div class=task-title>{{\'training_ayat_listening_sura_name\'|translate:$ctrl.sura}}</div> <div class=task-source-selector ng-if=\"$ctrl.sura.ayats_count > 10\"><a ng-click=\"$ctrl.openTraining({sura:$ctrl.sura,training:\'listening\'})\"><span>{{ \'ayats_interval\'|translate:$ctrl }}</span><i class=icon-angle-down></i></a></div> <div class=\"task-source-selector text-muted\" ng-if=\"$ctrl.sura.ayats_count <= 10\">{{ \'ayats_interval\'|translate:$ctrl }}</div> <listening descr=\"\'t_descr2_ayat_listening\'|translate\" data=$ctrl.data on-finish=\"$ctrl.onFinish(correct, wrong)\" on-result=\"$ctrl.onResult(correct, wrong)\" on-active-task=\"$ctrl.activeTask = index\" ng-if=\"$ctrl.data.length>0\"></listening> </div> </div> <div class=\"container-page-responsive result-page\" ng-if=$ctrl.showResult> <div class=\"actions-bar top bb visible-tablet\"> <a class=td-none ui-sref=koran.training.index({id:$ctrl.sura.id})><i class=icon-arrow-left></i>&nbsp; {{\'goto_another_trainings\'|translate}}</a> </div> <div class=container> <button type=button class=\"close hidden-tablet\" ui-sref=koran.training.index({id:$ctrl.sura.id})><i class=icon-close></i></button> <div class=row> <div class=\"col-sm-10 col-sm-offset-1\"> <training-result title=$ctrl.resultTitle() training=\"\'t_ayat_listening\'|translate\" correct=$ctrl.result.correct wrong=$ctrl.result.wrong points=$ctrl.result.points></training-result> <p class=\"actions text-center\"> <button class=\"btn btn-primary\" ng-click=\"$ctrl.openTraining({sura:$ctrl.sura,training:\'listening\'})\">{{\'continue_training\'|translate}} &nbsp;<i class=icon-arrow-right></i></button> </p> <p class=\"text-center hidden-tablet\"> <button class=\"btn btn-link\" ui-sref=koran.training.index({id:$ctrl.sura.id})>{{\'goto_another_trainings\'|translate}}</button> </p> <br> <banner class=\"banner-simple hidden-phone\" close-button=false><ng-include src=\"\'app/views/shareProjectBanner.html\'\"></ng-include></banner> </div> </div> </div> </div>");
$templateCache.put("app/components/koran/training/missedAyat.html","<div class=\"container container-page-responsive training-page\" ng-if=!$ctrl.showResult> <button type=button class=close ui-sref=koran.training.index({id:$ctrl.sura.id})><i class=icon-close></i></button> <div> <div class=task-title>{{\'training_missed_ayat_sura_name\'|translate:$ctrl.sura}}</div> <div class=task-source-selector ng-if=\"$ctrl.sura.ayats_count > 10\"><a ng-click=\"$ctrl.openTraining({sura:$ctrl.sura,training:\'missedAyat\'})\"><span>{{ \'ayats_interval\'|translate:$ctrl }}</span><i class=icon-angle-down></i></a></div> <div class=\"task-source-selector text-muted\" ng-if=\"$ctrl.sura.ayats_count <= 10\">{{ \'ayats_interval\'|translate:$ctrl }}</div> <missed-phrase descr=\"\'t_descr2_missed_ayat\'|translate\" data=$ctrl.data on-finish=\"$ctrl.onFinish(correct, wrong)\" on-result=\"$ctrl.onResult(correct, wrong)\" on-active-task=\"$ctrl.activeTask = index; $ctrl.answered = false;\" on-answer=\"$ctrl.answered = true\" ng-if=\"$ctrl.data.length>0\"></missed-phrase> </div> </div> <div class=\"container-page-responsive result-page\" ng-if=$ctrl.showResult> <div class=\"actions-bar bb visible-tablet\"> <a class=td-none ui-sref=koran.training.index({id:$ctrl.sura.id})><i class=icon-arrow-left></i>&nbsp; {{\'goto_another_trainings\'|translate}}</a> </div> <div class=container> <button type=button class=\"close hidden-tablet\" ui-sref=koran.training.index({id:$ctrl.sura.id})><i class=icon-close></i></button> <div class=row> <div class=\"col-sm-10 col-sm-offset-1\"> <training-result title=$ctrl.resultTitle() training=\"\'t_missed_ayat\'|translate\" correct=$ctrl.result.correct wrong=$ctrl.result.wrong points=$ctrl.result.points></training-result> <p class=\"actions text-center\"> <button class=\"btn btn-primary\" ng-click=\"$ctrl.openTraining({sura:$ctrl.sura,training:\'missedAyat\'})\">{{\'continue_training\'|translate}} &nbsp;<i class=icon-arrow-right></i></button> </p> <p class=\"text-center hidden-tablet\"> <button class=\"btn btn-link\" ui-sref=koran.training.index({id:$ctrl.sura.id})>{{\'goto_another_trainings\'|translate}}</button> </p> <br> <banner class=\"banner-simple hidden-phone\" close-button=false><ng-include src=\"\'app/views/shareProjectBanner.html\'\"></ng-include></banner> </div> </div> </div> </div>");
$templateCache.put("app/components/koran/training/nextAyat.html","<div class=\"container container-page-responsive training-page\" ng-if=!$ctrl.showResult> <button type=button class=close ui-sref=koran.training.index({id:$ctrl.sura.id})><i class=icon-close></i></button> <div> <div class=task-title>{{\'training_next_ayat_sura_name\'|translate:$ctrl.sura}}</div> <div class=task-source-selector ng-if=\"$ctrl.sura.ayats_count > 10\"><a ng-click=\"$ctrl.openTraining({sura:$ctrl.sura,training:\'nextAyat\'})\"><span>{{ \'ayats_interval\'|translate:$ctrl }}</span><i class=icon-angle-down></i></a></div> <div class=\"task-source-selector text-muted\" ng-if=\"$ctrl.sura.ayats_count <= 10\">{{ \'ayats_interval\'|translate:$ctrl }}</div> <next-phrase descr=\"\'t_descr2_next_ayat\'|translate\" data=$ctrl.data on-finish=\"$ctrl.onFinish(correct, wrong)\" on-result=\"$ctrl.onResult(correct, wrong)\" on-active-task=\"$ctrl.activeTask = index; $ctrl.answered = false;\" on-answer=\"$ctrl.answered = true\" ng-if=\"$ctrl.data.length>0\"></next-phrase> </div> </div> <div class=\"container-page-responsive result-page\" ng-if=$ctrl.showResult> <div class=\"actions-bar top bb visible-tablet\"> <a class=td-none ui-sref=koran.training.index({id:$ctrl.sura.id})><i class=icon-arrow-left></i>&nbsp; {{\'goto_another_trainings\'|translate}}</a> </div> <div class=container> <button type=button class=\"close hidden-tablet\" ui-sref=koran.training.index({id:$ctrl.sura.id})><i class=icon-close></i></button> <div class=row> <div class=\"col-sm-10 col-sm-offset-1\"> <training-result title=$ctrl.resultTitle() training=\"\'t_next_ayat\'|translate\" correct=$ctrl.result.correct wrong=$ctrl.result.wrong points=$ctrl.result.points></training-result> <p class=\"actions text-center\"> <button class=\"btn btn-primary\" ng-click=\"$ctrl.openTraining({sura:$ctrl.sura,training:\'nextAyat\'})\">{{\'continue_training\'|translate}} &nbsp;<i class=icon-arrow-right></i></button> </p> <p class=\"text-center hidden-tablet\"> <button class=\"btn btn-link\" ui-sref=koran.training.index({id:$ctrl.sura.id})>{{\'goto_another_trainings\'|translate}}</button> </p> <br> <banner class=\"banner-simple hidden-phone\" close-button=false><ng-include src=\"\'app/views/shareProjectBanner.html\'\"></ng-include></banner> </div> </div> </div> </div>");
$templateCache.put("app/components/koran/training/speed.html","<div class=\"container container-page-responsive training-page speed\" ng-if=!$ctrl.showResult> <button type=button class=close ui-sref=koran.training.index({id:$ctrl.sura.id})><i class=icon-close></i></button> <div> <div class=task-title>{{\'training_ayat_speed_sura_name\'|translate:$ctrl.sura}}</div> <div class=task-source-selector ng-if=\"$ctrl.sura.ayats_count > 10\"><a ng-click=\"$ctrl.openTraining({sura:$ctrl.sura,training:\'speed\'})\"><span>{{ \'ayats_interval\'|translate:$ctrl }}</span><i class=icon-angle-down></i></a></div> <div class=\"task-source-selector text-muted\" ng-if=\"$ctrl.sura.ayats_count <= 10\">{{ \'ayats_interval\'|translate:$ctrl }}</div> <speed-check descr=\"\'t_descr2_ayat_speed\'|translate\" data=$ctrl.data on-finish=\"$ctrl.onFinish(correct, wrong)\" on-result=\"$ctrl.onResult(correct, wrong)\" on-active-task=\"\" ng-if=\"$ctrl.data.length>0\"></speed-check> </div> </div> <div class=\"container-page-responsive result-page\" ng-if=$ctrl.showResult> <div class=\"actions-bar top bb visible-tablet\"> <a class=td-none ui-sref=koran.training.index({id:$ctrl.sura.id})><i class=icon-arrow-left></i>&nbsp; {{\'goto_another_trainings\'|translate}}</a> </div> <div class=container> <button type=button class=\"close hidden-tablet\" ui-sref=koran.training.index({id:$ctrl.sura.id})><i class=icon-close></i></button> <div class=row> <div class=\"col-sm-10 col-sm-offset-1\"> <training-result title=$ctrl.resultTitle() training=\"\'t_ayat_speed\'|translate\" correct=$ctrl.result.correct best=$ctrl.best points=$ctrl.result.points></training-result> <p class=\"actions text-center\"> <button class=\"btn btn-primary\" ng-click=\"$ctrl.openTraining({sura:$ctrl.sura,training:\'speed\'})\">{{\'continue_training\'|translate}} &nbsp;<i class=icon-arrow-right></i></button> </p> <p class=\"text-center hidden-tablet\"> <button class=\"btn btn-link\" ui-sref=koran.training.index({id:$ctrl.sura.id})>{{\'goto_another_trainings\'|translate}}</button> </p> <br> <banner class=\"banner-simple hidden-phone\" close-button=false><ng-include src=\"\'app/views/shareProjectBanner.html\'\"></ng-include></banner> </div> </div> </div> </div>");
$templateCache.put("app/components/koran/training/translationAyat.html","<div class=\"container container-page-responsive training-page\" ng-if=!$ctrl.showResult> <button type=button class=close ui-sref=koran.training.index({id:$ctrl.sura.id})><i class=icon-close></i></button> <div ng-click=\"$ctrl.showExample = false\"> <div class=task-title>{{\'training_translation_ayat_sura_name\'|translate:$ctrl.sura}}</div> <div class=task-source-selector ng-if=\"$ctrl.sura.ayats_count > 10\"><a ng-click=\"$ctrl.openTraining({sura:$ctrl.sura,training:\'translationAyat\'})\"><span>{{ \'ayats_interval\'|translate:$ctrl }}</span><i class=icon-angle-down></i></a></div> <div class=\"task-source-selector text-muted\" ng-if=\"$ctrl.sura.ayats_count <= 10\">{{ \'ayats_interval\'|translate:$ctrl }}</div> <translation-phrase descr=\"\'t_descr2_translation_ayat\'|translate\" data=$ctrl.data on-finish=\"$ctrl.onFinish(correct, wrong)\" on-result=\"$ctrl.onResult(correct, wrong)\" on-active-task=\"$ctrl.activeTask = index; $ctrl.answered = false;\" on-answer=\"$ctrl.answered = true\" ng-if=\"$ctrl.data.length>0\"></translation-phrase> <div ng-if=$ctrl.answered class=training-example ng-click=$event.stopPropagation()> <div class=\"title hidden-phone\">{{\'ayat_placement\'|translate}}</div> <div class=text-center> <a href ng-click=\"$ctrl.showExample = !$ctrl.showExample\" class=\"td-none visible-phone\">{{\'ayat_placement\'|translate}} &nbsp;<i class=icon-angle-down ng-show=!$ctrl.showExample></i><i class=icon-angle-up ng-show=$ctrl.showExample></i></a> </div> <div class=\"example arab\" ng-show=\"$ctrl.showExample || !$root.isPhone\"> <span class=ayat ng-repeat=\"ayat in $ctrl.ayats\" ng-class=\"{active: $ctrl.activeTask == $index}\"> <span class=text>{{ayat.arab_text}}</span> <span class=number>{{ayat.number|arabNumber}}</span><!-- <span class=\"text\">{{ayat.arab_text|withoutLastWord}}</span>\r\n					<span style=\"white-space:nowrap;\">\r\n						<span class=\"text\">{{ayat.arab_text|lastWord}}</span>\r\n						<span class=\"number\">{{ayat.number|arabNumber}}</span>\r\n					</span> --> </span> </div> </div> </div> </div> <div class=\"container-page-responsive result-page\" ng-if=$ctrl.showResult> <div class=\"actions-bar top bb visible-tablet\"> <a class=td-none ui-sref=koran.training.index({id:$ctrl.sura.id})><i class=icon-arrow-left></i>&nbsp; {{\'goto_another_trainings\'|translate}}</a> </div> <div class=container> <button type=button class=\"close hidden-tablet\" ui-sref=koran.training.index({id:$ctrl.sura.id})><i class=icon-close></i></button> <div class=row> <div class=\"col-sm-10 col-sm-offset-1\"> <training-result title=$ctrl.resultTitle() training=\"\'t_translation_ayat\'|translate\" correct=$ctrl.result.correct wrong=$ctrl.result.wrong points=$ctrl.result.points></training-result> <p class=\"actions text-center\"> <button class=\"btn btn-primary\" ng-click=\"$ctrl.openTraining({sura:$ctrl.sura,training:\'translationAyat\'})\">{{\'continue_training\'|translate}} &nbsp;<i class=icon-arrow-right></i></button> </p> <p class=\"text-center hidden-tablet\"> <button class=\"btn btn-link\" ui-sref=koran.training.index({id:$ctrl.sura.id})>{{\'goto_another_trainings\'|translate}}</button> </p> <br> <banner class=\"banner-simple hidden-phone\" close-button=false><ng-include src=\"\'app/views/shareProjectBanner.html\'\"></ng-include></banner> </div> </div> </div> </div>");
$templateCache.put("app/components/_partials/training/confirmModal/confirmModal.html","<div class=modal-header> <button type=button class=close ng-click=$ctrl.close({$value:false})><i class=icon-close></i></button> <h2 class=modal-title>{{\'training_not_completed\'|translate}}</h2> </div> <div class=modal-body> <p> {{\'training_confirm_text_1\'|translate}} <br> {{\'training_confirm_text_2\'|translate}} </p> <button class=\"btn btn-primary hidden-phone\" type=button ng-click=$ctrl.close({$value:true})>{{\'yes_exit\'|translate}}</button> <button class=\"btn btn-primary btn-invert hidden-phone\" type=button ng-click=$ctrl.close({$value:false})>{{\'continue_training\'|translate}}</button> <button class=\"btn btn-primary btn-block visible-phone\" type=button ng-click=$ctrl.close({$value:true})>{{\'yes_exit\'|translate}}</button> <button class=\"btn btn-primary btn-invert btn-block visible-phone\" type=button ng-click=$ctrl.close({$value:false})>{{\'continue_training\'|translate}}</button> </div>");
$templateCache.put("app/components/_partials/training/phraseCards/phraseCards.html","<div class=task-progress> <div ng-repeat=\"t in $ctrl.tasks\" ng-class=\"{ active: $index==$ctrl.currentTask-1, correct: t.correct===true, wrong: t.correct===false }\"></div> </div> <hr class=visible-phone> <div class=task-descr> <div class=number>{{\'task\'|translate}} {{$ctrl.currentTask}}/{{$ctrl.tasks.length}}</div> <div class=descr ng-if=$ctrl.descr>{{$ctrl.descr}}</div> </div> <div class=task-main> <div class=\"question well\"> <div class=\"text small\" ng-if=\"$ctrl.getTask().answer!==undefined\">{{$ctrl.getTask().translation}}</div> <div class=\"text arab\">{{$ctrl.getTask().phrase}}</div> <audio-button ng-if=$ctrl.getTask().audio src=\"[{src:$ctrl.getTask().audio,type:\'audio/mpeg\'}]\" on-ready=\"$ctrl.vgapi = $API\"></audio-button> </div> <div class=variants> <div class=\"center compact\" ng-click=\"$ctrl.checkAnswer($ctrl.getTask(), true)\" ng-class=\"{ select: $ctrl.getTask().answer===undefined, correct: $ctrl.getTask().answer===true }\"><div class=circle></div><div class=text>{{\'i_know\'|translate}}</div></div> <div class=\"center compact\" ng-click=\"$ctrl.checkAnswer($ctrl.getTask(), false)\" ng-class=\"{ select: $ctrl.getTask().answer===undefined, wrong: $ctrl.getTask().answer===false }\"><div class=circle></div><div class=text>{{\'i_dont_know\'|translate}}</div></div> </div> </div> <div class=\"actions text-right\"><!-- <button ng-click=\"$ctrl.prevTask()\">{{\'prev_task\'|translate}}</button> --> <button class=\"btn btn-primary\" ng-if=\"$ctrl.currentTask < $ctrl.tasks.length\" ng-click=\"$ctrl.vgapi && $ctrl.vgapi.stop(); $ctrl.nextTask();\" ng-disabled=\"$ctrl.getTask().answer===undefined\">{{\'next_task\'|translate}} &nbsp; <i class=icon-arrow-right></i></button> <button class=\"btn btn-primary\" ng-if=\"$ctrl.currentTask >= $ctrl.tasks.length\" ng-click=\"$ctrl.vgapi && $ctrl.vgapi.stop(); $ctrl.seeResult();\" ng-disabled=\"$ctrl.getTask().answer===undefined\">{{\'see_result\'|translate}} &nbsp; <i class=icon-arrow-right></i></button> </div>");
$templateCache.put("app/components/_partials/training/listening/listening.html","<div class=task-progress> <div ng-repeat=\"t in $ctrl.tasks\" ng-class=\"{ active: $index==$ctrl.currentTask-1, correct: t.correct===true, wrong: t.correct===false }\"></div> </div> <hr class=visible-phone> <div class=task-descr> <div class=number>{{\'task\'|translate}} {{$ctrl.currentTask}}/{{$ctrl.tasks.length}}</div> <div class=descr ng-if=$ctrl.descr>{{$ctrl.descr}}</div> </div> <div class=task-main> <div class=\"question bg\" ng-if=$ctrl.getTask().audio> <div class=row> <div class=\"col-sm-offset-2 col-sm-8\"> <videogular vg-player-ready=\"$ctrl.vgapi = $API\"> <vg-media vg-src=\"[{src:$ctrl.getTask().audio,type:\'audio/mpeg\'}]\" vg-type=audio></vg-media> <vg-controls> <vg-play-pause-button></vg-play-pause-button> <div class=space></div> <vg-time-display>{{ currentTime | date:\'mm:ss\' }}</vg-time-display> <vg-scrub-bar> <vg-scrub-bar-current-time></vg-scrub-bar-current-time> </vg-scrub-bar> <vg-time-display>{{ timeLeft | date:\'mm:ss\' }}</vg-time-display> <div class=\"space hidden-tablet\"></div> <vg-volume class=hidden-tablet> <i class=icon-volume-down ng-click=$ctrl.vgapi.setVolume(0)></i> <vg-volume-bar-custom></vg-volume-bar-custom> <i class=icon-volume-up ng-click=$ctrl.vgapi.setVolume(1)></i> </vg-volume> </vg-controls> </videogular> </div> </div> </div> <div class=variants> <div ng-repeat=\"variant in $ctrl.getTask().variants\" ng-click=\"$ctrl.checkAnswer($ctrl.getTask(), variant)\" ng-class=\"{ select: $ctrl.getTask().answer===undefined, correct: $ctrl.getTask().answer!=null && $ctrl.getTask().corA==variant, wrong: $ctrl.getTask().answer==variant && $ctrl.getTask().correct===false}\"><div class=circle></div><div class=text>{{variant}}</div></div> </div> </div> <div class=\"actions text-right\"><!-- <button ng-click=\"$ctrl.prevTask()\">{{\'prev_task\'|translate}}</button> --> <button class=\"btn btn-primary\" ng-if=\"$ctrl.currentTask < $ctrl.tasks.length\" ng-click=\"$ctrl.vgapi && $ctrl.vgapi.stop(); $ctrl.nextTask();\" ng-disabled=\"$ctrl.getTask().answer===undefined\">{{\'next_task\'|translate}} &nbsp; <i class=icon-arrow-right></i></button> <button class=\"btn btn-primary\" ng-if=\"$ctrl.currentTask >= $ctrl.tasks.length\" ng-click=\"$ctrl.vgapi && $ctrl.vgapi.stop(); $ctrl.seeResult();\" ng-disabled=\"$ctrl.getTask().answer===undefined\">{{\'see_result\'|translate}} &nbsp; <i class=icon-arrow-right></i></button> </div>");
$templateCache.put("app/components/_partials/training/missedPhrase/missedPhrase.html","<div class=task-progress> <div ng-repeat=\"t in $ctrl.tasks\" ng-class=\"{ active: $index==$ctrl.currentTask-1, correct: t.correct===true, wrong: t.correct===false }\"></div> </div> <hr class=visible-phone> <div class=task-descr> <div class=number>{{\'task\'|translate}} {{$ctrl.currentTask}}/{{$ctrl.tasks.length}}</div> <div class=descr ng-if=$ctrl.descr>{{$ctrl.descr}}</div> </div> <div class=task-main> <div class=\"question well\"> <div class=\"text arab\"> {{$ctrl.getTask().prevPhrase}} <span class=number>?</span> {{$ctrl.getTask().nextPhrase}} </div> </div> <div class=variants> <div class=arab ng-repeat=\"variant in $ctrl.getTask().variants\" ng-click=\"$ctrl.checkAnswer($ctrl.getTask(), variant)\" ng-class=\"{ select: $ctrl.getTask().answer===undefined, correct: $ctrl.getTask().answer!=null && $ctrl.getTask().corA==variant, wrong: $ctrl.getTask().answer==variant && $ctrl.getTask().correct===false}\"><div class=circle></div><div class=text>{{variant}}</div></div> </div> </div> <div class=\"actions row\"> <div class=\"col-sm-4 text-left\"></div> <div class=\"col-sm-4 text-center\"> </div> <div class=\"col-sm-4 text-right\"> <button class=\"btn btn-primary\" ng-if=\"$ctrl.currentTask < $ctrl.tasks.length\" ng-click=\"$ctrl.vgapi && $ctrl.vgapi.stop(); $ctrl.nextTask();\" ng-disabled=\"$ctrl.getTask().answer===undefined\">{{\'next_task\'|translate}} &nbsp; <i class=icon-arrow-right></i></button> <button class=\"btn btn-primary\" ng-if=\"$ctrl.currentTask >= $ctrl.tasks.length\" ng-click=\"$ctrl.vgapi && $ctrl.vgapi.stop(); $ctrl.seeResult();\" ng-disabled=\"$ctrl.getTask().answer===undefined\">{{\'see_result\'|translate}} &nbsp; <i class=icon-arrow-right></i></button> </div> </div>");
$templateCache.put("app/components/_partials/training/nextPhrase/nextPhrase.html","<div class=task-progress> <div ng-repeat=\"t in $ctrl.tasks\" ng-class=\"{ active: $index==$ctrl.currentTask-1, correct: t.correct===true, wrong: t.correct===false }\"></div> </div> <hr class=visible-phone> <div class=task-descr> <div class=number>{{\'task\'|translate}} {{$ctrl.currentTask}}/{{$ctrl.tasks.length}}</div> <div class=descr ng-if=$ctrl.descr>{{$ctrl.descr}}</div> </div> <div class=task-main> <div class=question> <div class=\"text arab\">{{$ctrl.getTask().phrase}}</div> <audio-button ng-if=$ctrl.getTask().audio src=\"[{src:$ctrl.getTask().audio,type:\'audio/mpeg\'}]\" on-ready=\"$ctrl.vgapi = $API\"></audio-button> </div> <div class=variants> <div class=arab ng-repeat=\"variant in $ctrl.getTask().variants\" ng-click=\"$ctrl.checkAnswer($ctrl.getTask(), variant)\" ng-class=\"{ select: $ctrl.getTask().answer===undefined, correct: $ctrl.getTask().answer!=null && $ctrl.getTask().corA==variant, wrong: $ctrl.getTask().answer==variant && $ctrl.getTask().correct===false}\"><div class=circle></div><div class=text>{{variant}}</div></div> </div> </div> <div class=\"actions row\"> <div class=\"col-sm-4 text-left\"></div> <div class=\"col-sm-4 text-center\"> </div> <div class=\"col-sm-4 text-right\"> <button class=\"btn btn-primary\" ng-if=\"$ctrl.currentTask < $ctrl.tasks.length\" ng-click=\"$ctrl.vgapi && $ctrl.vgapi.stop(); $ctrl.nextTask();\" ng-disabled=\"$ctrl.getTask().answer===undefined\">{{\'next_task\'|translate}} &nbsp; <i class=icon-arrow-right></i></button> <button class=\"btn btn-primary\" ng-if=\"$ctrl.currentTask >= $ctrl.tasks.length\" ng-click=\"$ctrl.vgapi && $ctrl.vgapi.stop(); $ctrl.seeResult();\" ng-disabled=\"$ctrl.getTask().answer===undefined\">{{\'see_result\'|translate}} &nbsp; <i class=icon-arrow-right></i></button> </div> </div>");
$templateCache.put("app/components/_partials/training/phraseConstructor/phraseConstructor.html","<div class=task-progress> <div ng-repeat=\"t in $ctrl.tasks\" ng-class=\"{ active: $index==$ctrl.currentTask-1, correct: t.correct===true, wrong: t.correct===false }\"></div> </div> <hr class=visible-phone> <div class=task-descr> <div class=number>{{\'task\'|translate}} {{$ctrl.currentTask}}/{{$ctrl.tasks.length}}</div> <div class=descr ng-if=$ctrl.descr>{{$ctrl.descr}}</div> </div> <div class=task-main> <div class=question> <div class=text>«{{$ctrl.getTask().translation}}»</div> </div> <div class=constructor ng-if=!$root.isTablet> <div class=\"constructed well\"> <div class=\"btn btn-default part\" ng-repeat=\"c in $ctrl.getTask().constructed track by $index\" ng-click=\"$ctrl.getTask().parts.push(c); $ctrl.getTask().constructed.splice($index, 1);\"><i class=icon-drug></i> {{c}}</div> </div> <div class=parts ng-if=\"$ctrl.getTask().parts.length > 0 && $ctrl.getTask().answer===undefined\"> <div class=\"btn btn-default part\" ng-repeat=\"p in $ctrl.getTask().parts track by $index\" ng-click=\"$ctrl.getTask().constructed.push(p); $ctrl.getTask().parts.splice($index, 1);\"><i class=icon-drug></i> {{p}}</div> </div> <div class=\"panel panel-default answer\" ng-if=\"$ctrl.getTask().answer!==undefined && $ctrl.getTask().correct===false\"> <div class=panel-body> <div class=row> <div class=\"col-sm-2 text-left\"></div> <div class=\"col-sm-8 text-center\"> <p class=text-success>{{\'correct_answer\'|translate}}:</p> <p class=arab>{{$ctrl.getTask().corA}}</p> </div> <div class=\"col-sm-2 text-right\" ng-if=$ctrl.getTask().audio> <audio-button src=\"[{src:$ctrl.getTask().audio,type:\'audio/mpeg\'}]\" on-ready=\"$ctrl.vgapi = $API\"></audio-button> </div> </div> </div> </div> <div class=\"panel panel-default answer\" ng-if=\"$ctrl.getTask().answer!==undefined && $ctrl.getTask().correct===true && $ctrl.getTask().audio\"> <div class=\"panel-body text-center\"> <div class=audio> <videogular vg-player-ready=\"$ctrl.vgapi = $API\" class=hidden> <vg-media vg-src=\"[{src:$ctrl.getTask().audio,type:\'audio/mpeg\'}]\" vg-type=audio></vg-media> </videogular> <a class=\"btn btn-link vg-button\" ng-if=\"$ctrl.vgapi.currentState!=\'play\'\" ng-click=$ctrl.vgapi.play()><i class=icon-play-circle></i>&nbsp; {{\'listen\'|translate}}</a> <a class=\"btn btn-link vg-button\" ng-if=\"$ctrl.vgapi.currentState==\'play\'\" ng-click=$ctrl.vgapi.stop()><i class=icon-pause-circle></i>&nbsp; {{\'listen\'|translate}}</a> </div> </div> </div> </div> <div class=constructor ng-if=$root.isTablet> <div class=row> <div class=\"col-sm-offset-2 col-sm-8\"> <div class=parts-mobile> <div ng-repeat=\"p in $ctrl.getTask().parts track by $index\"> {{p}} <a href class=down ng-if=\"$index+1 < $ctrl.getTask().parts.length\" ng-click=\"$ctrl.getTask().parts.splice($index, 1); $ctrl.getTask().parts.splice($index+1, 0, p);\"><i class=icon-arrow-down></i></a> <a href class=up ng-if=\"$index > 0\" ng-click=\"$ctrl.getTask().parts.splice($index, 1); $ctrl.getTask().parts.splice($index-1, 0, p);\"><i class=icon-arrow-up></i></a> </div> </div> <div class=buttons-row> <button class=\"btn btn-primary btn-invert visible-phone\" ng-disabled=\"$ctrl.getTask().answer !== undefined\" ng-click=\"$ctrl.checkAnswer($ctrl.getTask(), false)\">{{\'i_dont_know\'|translate}}</button> <button class=\"btn btn-primary btn-invert\" ng-if=\"$ctrl.getTask().answer === undefined\" ng-click=\"$ctrl.checkAnswer($ctrl.getTask(), $ctrl.getTask().parts && $ctrl.getTask().parts.join(\' \'))\">{{\'check\'|translate}}</button> <div class=\"btn btn-success btn-invert btn-answer-status correct\" ng-if=\"$ctrl.getTask().correct === true\"><div class=circle></div> {{\'correct\'|translate}}</div> <div class=\"btn btn-danger btn-invert btn-answer-status wrong\" ng-if=\"$ctrl.getTask().correct === false && $ctrl.getTask().answer !== false\"><div class=circle></div> {{\'wrong\'|translate}}</div> <div class=\"btn btn-danger btn-invert btn-answer-status wrong\" ng-if=\"$ctrl.getTask().correct === false && $ctrl.getTask().answer === false\"><div class=circle></div> {{\'i_dont_know\'|translate}}</div> </div> <div class=\"panel panel-default answer hidden-phone\" ng-if=\"$ctrl.getTask().answer!==undefined && $ctrl.getTask().correct===false\"> <div class=\"panel-body text-center\"> <p class=text-success>{{\'correct_answer\'|translate}}:</p> <p class=arab>{{$ctrl.getTask().corA}}</p> <div ng-if=$ctrl.getTask().audio> <audio-button src=\"[{src:$ctrl.getTask().audio,type:\'audio/mpeg\'}]\" on-ready=\"$ctrl.vgapi = $API\"></audio-button> </div> </div> </div> <div class=\"panel panel-default answer hidden-phone\" ng-if=\"$ctrl.getTask().answer!==undefined && $ctrl.getTask().correct===true && $ctrl.getTask().audio\"> <div class=\"panel-body text-center\"> <div class=audio> <videogular vg-player-ready=\"$ctrl.vgapi = $API\" class=hidden> <vg-media vg-src=\"[{src:$ctrl.getTask().audio,type:\'audio/mpeg\'}]\" vg-type=audio></vg-media> </videogular> <a class=\"btn btn-link vg-button\" ng-if=\"$ctrl.vgapi.currentState!=\'play\'\" ng-click=$ctrl.vgapi.play()><i class=icon-play-circle></i>&nbsp; {{\'listen\'|translate}}</a> <a class=\"btn btn-link vg-button\" ng-if=\"$ctrl.vgapi.currentState==\'play\'\" ng-click=$ctrl.vgapi.stop()><i class=icon-pause-circle></i>&nbsp; {{\'listen\'|translate}}</a> </div> </div> </div> </div> </div> </div> </div> <div class=\"actions row\" ng-if=!$root.isTablet> <div class=\"col-sm-4 text-left\"></div> <div class=\"col-sm-4 text-center\"> <button class=\"btn btn-link\" ng-if=\"$ctrl.getTask().parts.length > 0 && $ctrl.getTask().answer === undefined\" ng-click=\"$ctrl.checkAnswer($ctrl.getTask(), false)\">{{\'i_dont_know\'|translate}}</button> <button class=\"btn btn-primary btn-invert\" ng-if=\"$ctrl.getTask().parts.length == 0 && $ctrl.getTask().answer === undefined\" ng-click=\"$ctrl.checkAnswer($ctrl.getTask(), $ctrl.getTask().constructed && $ctrl.getTask().constructed.join(\' \'))\">{{\'check\'|translate}}</button> <div class=\"btn btn-success btn-invert btn-answer-status correct\" ng-if=\"$ctrl.getTask().correct === true\"><div class=circle></div> {{\'correct\'|translate}}</div> <div class=\"btn btn-danger btn-invert btn-answer-status wrong\" ng-if=\"$ctrl.getTask().correct === false && $ctrl.getTask().answer !== false\"><div class=circle></div> {{\'wrong\'|translate}}</div> <div class=\"btn btn-danger btn-invert btn-answer-status wrong\" ng-if=\"$ctrl.getTask().correct === false && $ctrl.getTask().answer === false\"><div class=circle></div> {{\'i_dont_know\'|translate}}</div> </div> <div class=\"col-sm-4 text-right\"> <button class=\"btn btn-primary\" ng-if=\"$ctrl.currentTask < $ctrl.tasks.length\" ng-click=\"$ctrl.vgapi && $ctrl.vgapi.stop(); $ctrl.nextTask();\" ng-disabled=\"$ctrl.getTask().answer===undefined\">{{\'next_task\'|translate}} &nbsp; <i class=icon-arrow-right></i></button> <button class=\"btn btn-primary\" ng-if=\"$ctrl.currentTask >= $ctrl.tasks.length\" ng-click=\"$ctrl.vgapi && $ctrl.vgapi.stop(); $ctrl.seeResult();\" ng-disabled=\"$ctrl.getTask().answer===undefined\">{{\'see_result\'|translate}} &nbsp; <i class=icon-arrow-right></i></button> </div> </div> <div class=\"actions row\" ng-if=$root.isTablet> <div class=\"col-sm-4 text-left\"></div> <div class=\"col-sm-4 text-center\"> <button class=\"btn btn-link hidden-phone\" ng-if=\"$ctrl.getTask().answer === undefined\" ng-click=\"$ctrl.checkAnswer($ctrl.getTask(), false)\">{{\'i_dont_know\'|translate}}</button> </div> <div class=\"col-sm-4 text-right\"> <button class=\"btn btn-primary\" ng-if=\"$ctrl.currentTask < $ctrl.tasks.length\" ng-click=\"$ctrl.vgapi && $ctrl.vgapi.stop(); $ctrl.nextTask();\" ng-disabled=\"$ctrl.getTask().answer===undefined\">{{\'next_task\'|translate}} &nbsp; <i class=icon-arrow-right></i></button> <button class=\"btn btn-primary\" ng-if=\"$ctrl.currentTask >= $ctrl.tasks.length\" ng-click=\"$ctrl.vgapi && $ctrl.vgapi.stop(); $ctrl.seeResult();\" ng-disabled=\"$ctrl.getTask().answer===undefined\">{{\'see_result\'|translate}} &nbsp; <i class=icon-arrow-right></i></button> </div> </div>");
$templateCache.put("app/components/_partials/training/questionAnswer/questionAnswer.html","<div class=task-progress> <div ng-repeat=\"t in $ctrl.tasks\" ng-class=\"{ active: $index==$ctrl.currentTask-1, correct: t.correct===true, wrong: t.correct===false }\"></div> </div> <hr class=visible-phone> <div class=task-descr> <div class=number>{{\'question\'|translate}} {{$ctrl.currentTask}} {{ \'of_count\'|translate:{count:$ctrl.tasks.length} }}</div> <div class=descr ng-if=$ctrl.descr>{{$ctrl.descr}}</div> </div> <div class=task-main> <div class=question> <div class=text>{{$ctrl.getTask().question}}</div> <div class=image ng-if=$ctrl.getTask().image> <img ng-src={{$ctrl.getTask().image}}> </div> </div> <div class=variants> <div ng-repeat=\"variant in $ctrl.getTask().variants\" ng-click=\"$ctrl.checkAnswer($ctrl.getTask(), variant)\" ng-class=\"{ select: $ctrl.getTask().answer===undefined, correct: $ctrl.getTask().answer!=null && $ctrl.getTask().corA==variant, wrong: $ctrl.getTask().answer==variant && $ctrl.getTask().correct===false}\"><div class=circle></div><div class=text>{{variant}}</div></div> </div> </div> <div class=\"actions text-right\"> <button class=\"btn btn-link btn-link-narrow td-none pull-left\" ng-click=$ctrl.prevTask()><i class=icon-arrow-left></i> &nbsp; {{\'prev_question\'|translate}}</button> <button class=\"btn btn-primary\" ng-if=\"$ctrl.currentTask < $ctrl.tasks.length\" ng-click=$ctrl.nextTask(); ng-disabled=\"$ctrl.getTask().answer===undefined\">{{\'next_question\'|translate}} &nbsp; <i class=icon-arrow-right></i></button> <button class=\"btn btn-primary\" ng-if=\"$ctrl.currentTask >= $ctrl.tasks.length\" ng-click=$ctrl.seeResult(); ng-disabled=\"$ctrl.getTask().answer===undefined\">{{\'see_result\'|translate}} &nbsp; <i class=icon-arrow-right></i></button> </div>");
$templateCache.put("app/components/_partials/training/phraseTranslation/phraseTranslation.html","<div class=task-progress> <div ng-repeat=\"t in $ctrl.tasks\" ng-class=\"{ active: $index==$ctrl.currentTask-1, correct: t.correct===true, wrong: t.correct===false }\"></div> </div> <hr class=visible-phone> <div class=task-descr> <div class=number>{{\'task\'|translate}} {{$ctrl.currentTask}}/{{$ctrl.tasks.length}}</div> <div class=descr ng-if=$ctrl.descr>{{$ctrl.descr}}</div> </div> <div class=task-main> <div class=question> <div class=\"text arab\">{{$ctrl.getTask().phrase}}</div> <audio-button ng-if=$ctrl.getTask().audio src=\"[{src:$ctrl.getTask().audio,type:\'audio/mpeg\'}]\" on-ready=\"$ctrl.vgapi = $API\"></audio-button> </div> <div class=variants> <div ng-repeat=\"variant in $ctrl.getTask().variants\" ng-click=\"$ctrl.checkAnswer($ctrl.getTask(), variant)\" ng-class=\"{ select: $ctrl.getTask().answer===undefined, correct: $ctrl.getTask().answer!=null && $ctrl.getTask().corA==variant, wrong: $ctrl.getTask().answer==variant && $ctrl.getTask().correct===false}\"><div class=circle></div><div class=text>{{variant}}</div></div> </div> </div> <div class=\"actions text-right\"><!-- <button ng-click=\"$ctrl.prevTask()\">{{\'prev_task\'|translate}}</button> --> <button class=\"btn btn-primary\" ng-if=\"$ctrl.currentTask < $ctrl.tasks.length\" ng-click=\"$ctrl.vgapi && $ctrl.vgapi.stop(); $ctrl.nextTask();\" ng-disabled=\"$ctrl.getTask().answer===undefined\">{{\'next_task\'|translate}} &nbsp; <i class=icon-arrow-right></i></button> <button class=\"btn btn-primary\" ng-if=\"$ctrl.currentTask >= $ctrl.tasks.length\" ng-click=\"$ctrl.vgapi && $ctrl.vgapi.stop(); $ctrl.seeResult();\" ng-disabled=\"$ctrl.getTask().answer===undefined\">{{\'see_result\'|translate}} &nbsp; <i class=icon-arrow-right></i></button> </div>");
$templateCache.put("app/components/_partials/training/speedCheck/speedCheck.html","<div class=task-descr> <div class=\"number visible-tablet\">{{\'task\'|translate}} {{$ctrl.currentTask}}</div> <div class=descr ng-if=$ctrl.descr>{{$ctrl.descr}}</div> </div> <div class=task-main> <div class=\"time text-success\"><i class=icon-time></i> {{$ctrl.getTimer()}}</div> <div class=\"question well\"> <div class=progress><div class=\"progress-bar progress-bar-success\" style=\"width: {{$ctrl.getTimerPercent()}}%\"></div></div> <div class=\"text small\">{{$ctrl.getTask().translation}}</div> <div class=\"text arab\">{{$ctrl.getTask().phrase}}</div> <audio-button ng-if=$ctrl.getTask().audio src=\"[{src:$ctrl.getTask().audio,type:\'audio/mpeg\'}]\" on-ready=\"$ctrl.vgapi = $API\"></audio-button> </div> <div class=variants> <div class=\"center compact\" ng-click=\"$ctrl.vgapi && $ctrl.vgapi.stop(); $ctrl.checkAnswer($ctrl.getTask(), true)\" ng-class=\"{ select: $ctrl.getTask().answer===undefined, correct: $ctrl.getTask().answer===true && $ctrl.getTask().correct===true || $ctrl.getTask().answer===false && $ctrl.getTask().correct===false, wrong: $ctrl.getTask().answer===true && $ctrl.getTask().correct===false}\"><div class=circle></div><div class=text>{{\'correct\'|translate}}</div></div> <div class=\"center compact\" ng-click=\"$ctrl.vgapi && $ctrl.vgapi.stop(); $ctrl.checkAnswer($ctrl.getTask(), false)\" ng-class=\"{ select: $ctrl.getTask().answer===undefined, correct: $ctrl.getTask().answer===false && $ctrl.getTask().correct===true || $ctrl.getTask().answer===true && $ctrl.getTask().correct===false, wrong: $ctrl.getTask().answer===false && $ctrl.getTask().correct===false}\"><div class=circle></div><div class=text>{{\'wrong\'|translate}}</div></div> </div> <p class=text-center>{{\'correct_answers_rp\'|translate}}: {{$ctrl.result.correct}}</p> </div>");
$templateCache.put("app/components/_partials/training/result/result.html","<div class=panel ng-class=\"{\'panel-success\':$ctrl.isGood(),\'panel-danger\':$ctrl.isBad(),\'panel-brand\':$ctrl.isDefault()}\"> <div class=\"panel-heading text-center\"> <div ng-if=!$ctrl.isBest()>{{\'your_result\'|translate}}</div> <div ng-if=$ctrl.isBest()>{{\'this_is_your_best_result\'|translate}}!</div> <div ng-if=$ctrl.training class=comment>{{\'training_name_completed\'|translate:{name:$ctrl.training} }}</div> <div ng-if=!$ctrl.training class=comment>{{\'training_completed\'|translate }}</div> </div> <div class=\"panel-body text-center\"> <div class=text-info><b>{{$ctrl.title}}</b></div> <div ng-class=\"{\'text-success\':$ctrl.isGood() || $ctrl.wrong===undefined, \'text-danger\':$ctrl.isBad()}\" ng-if=\"$ctrl.points > 0\"><b>{{\'gained\'|translate:{number:$ctrl.points}:\'messageformat\'}} +{{\'points_number\'|translate:{number:$ctrl.points}:\'messageformat\' }}</b></div> <br> <div class=result-points> <div ng-if=\"$ctrl.correct!==undefined\"> <div ng-class=\"{\'text-success\':$ctrl.wrong===undefined}\">{{$ctrl.correct || 0}}</div> <div class=comment ng-if=\"$ctrl.wrong!==undefined\">{{\'correct\'|translate}}</div> <div class=comment ng-if=\"$ctrl.wrong===undefined\">{{\'correct_answers_rp\'|translate}}</div> </div> <div ng-if=\"$ctrl.wrong!==undefined\"> <div>{{$ctrl.wrong || 0}}</div> <div class=comment>{{\'wrong\'|translate}}</div> </div> <div ng-if=\"$ctrl.best!==undefined && $ctrl.correct <= $ctrl.best\"> <div>{{$ctrl.best || 0}}</div> <div class=comment>{{\'your_best_result\'|translate}}</div> </div> </div> </div> </div>");
$templateCache.put("app/components/_partials/training/translationPhrase/translationPhrase.html","<div class=task-progress> <div ng-repeat=\"t in $ctrl.tasks\" ng-class=\"{ active: $index==$ctrl.currentTask-1, correct: t.correct===true, wrong: t.correct===false }\"></div> </div> <hr class=visible-phone> <div class=task-descr> <div class=number>{{\'task\'|translate}} {{$ctrl.currentTask}}/{{$ctrl.tasks.length}}</div> <div class=descr ng-if=$ctrl.descr>{{$ctrl.descr}}</div> </div> <div class=task-main> <div class=question> <div class=text>{{$ctrl.getTask().translation}}</div> </div> <div class=variants> <div class=arab ng-repeat=\"variant in $ctrl.getTask().variants\" ng-click=\"$ctrl.checkAnswer($ctrl.getTask(), variant)\" ng-class=\"{ select: $ctrl.getTask().answer===undefined, correct: $ctrl.getTask().answer!=null && $ctrl.getTask().corA==variant, wrong: $ctrl.getTask().answer==variant && $ctrl.getTask().correct===false}\"><div class=circle></div><div class=text>{{variant}}</div></div> </div> </div> <div class=\"actions row\"> <div class=\"col-sm-4 text-left\"></div> <div class=\"col-sm-4 text-center\"> <audio-button ng-if=\"$ctrl.getTask().answer!==undefined && $ctrl.getTask().audio\" src=\"[{src:$ctrl.getTask().audio,type:\'audio/mpeg\'}]\" on-ready=\"$ctrl.vgapi = $API\"></audio-button> </div> <div class=\"col-sm-4 text-right\"> <button class=\"btn btn-primary\" ng-if=\"$ctrl.currentTask < $ctrl.tasks.length\" ng-click=\"$ctrl.vgapi && $ctrl.vgapi.stop(); $ctrl.nextTask();\" ng-disabled=\"$ctrl.getTask().answer===undefined\">{{\'next_task\'|translate}} &nbsp; <i class=icon-arrow-right></i></button> <button class=\"btn btn-primary\" ng-if=\"$ctrl.currentTask >= $ctrl.tasks.length\" ng-click=\"$ctrl.vgapi && $ctrl.vgapi.stop(); $ctrl.seeResult();\" ng-disabled=\"$ctrl.getTask().answer===undefined\">{{\'see_result\'|translate}} &nbsp; <i class=icon-arrow-right></i></button> </div> </div>");}]);